(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire708f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire708f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzVqu", function(module, exports) {
module.exports = $;

});

parcelRegister("bNuNE", function(module, exports) {
/*!
 * jQuery TextChange Plugin
 * http://www.zurb.com/playground/jquery-text-change-custom-event
 *
 * Copyright 2010, ZURB
 * Released under the MIT License
 */ (function($) {
    $.event.special.textchange = {
        setup: function(data, namespaces) {
            $(this).data('lastValue', this.contentEditable === 'true' ? $(this).html() : $(this).val());
            $(this).bind('keyup.textchange', $.event.special.textchange.handler);
            $(this).bind('cut.textchange paste.textchange input.textchange', $.event.special.textchange.delayedHandler);
        },
        teardown: function(namespaces) {
            $(this).unbind('.textchange');
        },
        handler: function(event) {
            $.event.special.textchange.triggerIfChanged($(this));
        },
        delayedHandler: function(event) {
            var element = $(this);
            setTimeout(function() {
                $.event.special.textchange.triggerIfChanged(element);
            }, 25);
        },
        triggerIfChanged: function(element) {
            var current = element[0].contentEditable === 'true' ? element.html() : element.val();
            if (current !== element.data('lastValue')) {
                element.trigger('textchange', [
                    element.data('lastValue')
                ]);
                element.data('lastValue', current);
            }
        }
    };
    $.event.special.hastext = {
        setup: function(data, namespaces) {
            $(this).bind('textchange', $.event.special.hastext.handler);
        },
        teardown: function(namespaces) {
            $(this).unbind('textchange', $.event.special.hastext.handler);
        },
        handler: function(event, lastValue) {
            if (lastValue === '' && lastValue !== $(this).val()) $(this).trigger('hastext');
        }
    };
    $.event.special.notext = {
        setup: function(data, namespaces) {
            $(this).bind('textchange', $.event.special.notext.handler);
        },
        teardown: function(namespaces) {
            $(this).unbind('textchange', $.event.special.notext.handler);
        },
        handler: function(event, lastValue) {
            if ($(this).val() === '' && $(this).val() !== lastValue) $(this).trigger('notext');
        }
    };
})(jQuery);

});

parcelRegister("6YELt", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b53f3acbb2f106$export$2e2bcd8739ae039);
const $20b53f3acbb2f106$var$END_FE = '}';
const $20b53f3acbb2f106$var$START_FE = '{';
const $20b53f3acbb2f106$var$QUOTE = "'";
class $20b53f3acbb2f106$var$StringReader {
    constructor(input){
        this.input = input || '';
        this.index = 0;
    }
    advance() {
        if (this.hasMore()) this.index++;
    }
    /**
     * @param {RegExp} test
     * @returns {boolean}
     */ expectNextR(test) {
        if (this.index >= this.input.length - 1) return false;
        return test.test(this.input.charAt(this.index + 1));
    }
    /**
     * @param {String} test
     * @returns {boolean}
     */ expectNext(test) {
        if (this.index >= this.input.length - 1) return false;
        return test === this.input.charAt(this.index + 1);
    }
    hasMore() {
        return this.index < this.input.length;
    }
    getChar() {
        return this.input.charAt(this.index);
    }
    /**
     * @param re
     * @returns string
     */ readWhileR(re) {
        let result = '';
        while(this.hasMore()){
            if (!re.test(this.getChar())) break;
            result += this.getChar();
            this.advance();
        }
        return result;
    }
    /**
     * @param {RegExp} re
     * @returns string
     */ readUnlessR(re) {
        let result = '';
        while(this.hasMore()){
            const next = this.getChar();
            if (re.test(next)) break;
            result += next;
            this.advance();
        }
        return result;
    }
    /**
     * @param {String} re
     * @returns string
     */ readUnless(re) {
        let result = '';
        while(this.hasMore()){
            const next = this.getChar();
            if (re === next) break;
            result += next;
            this.advance();
        }
        return result;
    }
    /**
     * @param re
     * @returns string
     */ skipWhileR(re) {
        while(this.hasMore()){
            if (!re.test(this.getChar())) break;
            this.advance();
        }
    }
    getRest() {
        return this.input.substring(this.index);
    }
    /**
     * @param {Function} contentTest
     * @param {Boolean} keepQuotedString set true, if your want original quoted string, without unescape
     * @returns {String}
     */ readBraces(contentTest, keepQuotedString) {
        let mark = this.index;
        if (typeof contentTest !== 'function') contentTest = ()=>true;
        if (typeof keepQuotedString === "undefined") keepQuotedString = false;
        let content = '';
        let deep = 1;
        this.advance();
        const fail = ()=>{
            this.index = mark;
            return null;
        };
        while(this.hasMore()){
            switch(this.getChar()){
                case $20b53f3acbb2f106$var$QUOTE:
                    const quotedString = this.readQuoted();
                    content += keepQuotedString ? quotedString.raw : quotedString.value;
                    continue;
                case $20b53f3acbb2f106$var$START_FE:
                    deep++;
                    break;
                case $20b53f3acbb2f106$var$END_FE:
                    if (deep === 1) {
                        if (contentTest(content)) {
                            this.advance();
                            return content;
                        } else return fail();
                    } else deep--;
            }
            content += this.getChar();
            this.advance();
        }
        return fail();
    }
    /**
     * @returns {QuotedString}
     */ readQuoted() {
        let raw = this.getChar();
        this.advance();
        if (this.hasMore() && this.getChar() === $20b53f3acbb2f106$var$QUOTE) {
            raw += this.getChar();
            this.advance();
            return new $20b53f3acbb2f106$var$QuotedString($20b53f3acbb2f106$var$QUOTE, raw);
        }
        let value = '';
        while(this.hasMore()){
            raw += this.getChar();
            if (this.getChar() === $20b53f3acbb2f106$var$QUOTE) {
                this.advance();
                if (this.getChar() === $20b53f3acbb2f106$var$QUOTE) raw += this.getChar();
                else return new $20b53f3acbb2f106$var$QuotedString(value, raw);
            }
            value += this.getChar();
            this.advance();
        }
        return new $20b53f3acbb2f106$var$QuotedString(value, raw);
    }
}
class $20b53f3acbb2f106$var$QuotedString {
    constructor(value, raw){
        this.value = value;
        this.raw = raw;
    }
}
const $20b53f3acbb2f106$var$ICUMessageFormats = {
    'default': (ordinal)=>{
        return (texter, args)=>args[ordinal];
    },
    'plural': (ordinal, options)=>{
        const optionsReader = new $20b53f3acbb2f106$var$StringReader(options);
        const model = {};
        while(optionsReader.hasMore()){
            const state = optionsReader.readUnless($20b53f3acbb2f106$var$START_FE).trim();
            if (state === '') break;
            model[state] = optionsReader.readBraces();
        }
        return (texter, args)=>{
            const argsValue = args[ordinal];
            const number = typeof argsValue === "number" ? Math.floor(argsValue) : parseInt(argsValue);
            let state = null;
            if (!isNaN(number)) state = texter.numberPlural(number);
            if (state in model) return model[state];
            return model['other'];
        };
    }
};
/**
 * Javascript port for com.rico.rubd.support.icu.ICUMessageFormat
 */ class $20b53f3acbb2f106$var$ICUMessageFormat {
    constructor(pattern){
        this.formats = [];
        this.parsePattern(pattern, (token)=>this.formats.push(()=>token), (ordinal, spec, options)=>this.formats.push(this.createFormatter(ordinal, spec, options)));
    }
    /**
     * @param {String} pattern
     * @param {Function} textReceiver
     * @param {Function} formatReceiver
     * @private
     */ parsePattern(pattern, textReceiver, formatReceiver) {
        const reader = new $20b53f3acbb2f106$var$StringReader(pattern);
        let token = '';
        function panic() {
            throw new Error(`invalid pattern ${pattern}`);
        }
        const argumentComplete = (content)=>{
            if (!content.length) return;
            const tokenReader = new $20b53f3acbb2f106$var$StringReader(content);
            tokenReader.skipWhileR(/[\s]/);
            const ordinal = parseInt(tokenReader.readWhileR(/\d+/).trim());
            if (isNaN(ordinal)) panic();
            tokenReader.skipWhileR(/[\s,]/);
            const spec = tokenReader.readUnlessR(/,/).trim();
            tokenReader.skipWhileR(/[\s,]/);
            let options = tokenReader.getRest().trim();
            formatReceiver(ordinal, spec, options);
        };
        const textComplete = (token)=>{
            if (token.length) textReceiver(token);
        };
        const FE_ORDINAL_TEST = /^\s*\d/;
        while(reader.hasMore()){
            switch(reader.getChar()){
                case $20b53f3acbb2f106$var$START_FE:
                    textComplete(token);
                    token = '';
                    const braces = reader.readBraces(FE_ORDINAL_TEST.test.bind(FE_ORDINAL_TEST), true);
                    if (braces == null) break;
                    argumentComplete(braces);
                    continue;
                case $20b53f3acbb2f106$var$QUOTE:
                    token += reader.readQuoted().value;
                    continue;
            }
            token += reader.getChar();
            reader.advance();
        }
        textComplete(token);
    }
    /**
     * @param {int} ordinal parameter index
     * @param {string} spec formatter class
     * @param {string} options other parameters
     * @private
     */ createFormatter(ordinal, spec, options) {
        const factory = spec in $20b53f3acbb2f106$var$ICUMessageFormats ? $20b53f3acbb2f106$var$ICUMessageFormats[spec] : $20b53f3acbb2f106$var$ICUMessageFormats.default;
        return factory(ordinal, options);
    }
    format(texter, args) {
        switch(this.formats.length){
            case 0:
                return '';
            case 1:
                return this.formats[0](texter, args);
            default:
                return this.formats.map((f)=>f(texter, args)).join('');
        }
    }
}
/**
 * https://www.unicode.org/cldr/charts/34/supplemental/language_plural_rules.html
 */ const $20b53f3acbb2f106$var$TexterSpec = {
    defaults: {
        pluralRule: function(n) {
            if (n === 1) return 'one';
            return 'many';
        }
    },
    'ru': {
        pluralRule: function(n) {
            const rem10 = n % 10;
            const rem100 = n % 100;
            if (rem10 === 1 && rem100 !== 11) return 'one';
            if ((rem10 === 2 || rem10 === 3 || rem10 === 4) && rem100 !== 12 && rem100 !== 13 && rem100 !== 14) return 'few';
            return 'many';
        }
    }
};
class $20b53f3acbb2f106$export$2e2bcd8739ae039 {
    static create(l18n) {
        return l18n instanceof $20b53f3acbb2f106$export$2e2bcd8739ae039 ? l18n : new $20b53f3acbb2f106$export$2e2bcd8739ae039(l18n);
    }
    constructor(texts){
        this.texts = texts || [];
        this.cache = {};
        this.locale = 'en';
        let spec = null;
        if ('_language' in this.texts) spec = $20b53f3acbb2f106$var$TexterSpec[this.texts['_language']];
        this.spec = !!spec ? spec : $20b53f3acbb2f106$var$TexterSpec.defaults;
    }
    /**
     * @param key
     * @returns {String}
     * @private
     */ getText(key) {
        return key in this.texts ? this.texts[key] : key;
    }
    /**
     * @param key
     * @returns {ICUMessageFormat}
     * @private
     */ getOrCompileFormatter(key) {
        const cached = this.cache[key];
        if (cached) return cached;
        const pattern = key in this.texts ? this.texts[key] : key;
        return this.cache[key] = new $20b53f3acbb2f106$var$ICUMessageFormat(pattern);
    }
    /**
     * @param key
     * @param args
     * @returns {String}
     */ get(key, ...args) {
        if (args.length === 0) return this.getText(key);
        const formatter = this.getOrCompileFormatter(key);
        return formatter.format(this, args);
    }
    put(key, value) {
        this.texts[key] = value;
    }
    numberPlural(n) {
        return this.spec.pluralRule(n);
    }
}

});

parcelRegister("fJMvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b750b06edf3eaa42$export$2e2bcd8739ae039);
$parcel$export(module.exports, "textareaAutoresizeOne", () => $b750b06edf3eaa42$export$e3d7c39fd6fa5460);
function $b750b06edf3eaa42$var$doResize(node, offset) {
    node.style.height = 'auto';
    node.style.height = node.scrollHeight + offset + 'px';
}
function $b750b06edf3eaa42$export$2e2bcd8739ae039() {
    document.querySelectorAll('[data-autoresize]').forEach(function(el) {
        const element = el;
        element.style.boxSizing = 'border-box';
        const offset = element.offsetHeight - element.clientHeight;
        element.addEventListener('input', function(event) {
            $b750b06edf3eaa42$var$doResize(event.target, offset);
        });
        $b750b06edf3eaa42$var$doResize(element, offset);
        element.removeAttribute('data-autoresize');
    });
}
function $b750b06edf3eaa42$export$e3d7c39fd6fa5460(el) {
    const jqel = $(el);
    let offset = jqel.data('autoresize-init');
    if (offset === null || offset === undefined) {
        el.style.boxSizing = 'border-box';
        offset = el.offsetHeight - el.clientHeight;
        jqel.data('autoresize-init', offset);
    }
    $b750b06edf3eaa42$var$doResize(el, offset);
}

});

parcelRegister("3Cbif", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1dae50e25b71de$export$2e2bcd8739ae039);
class $2a1dae50e25b71de$export$2e2bcd8739ae039 {
    constructor(el){
        this.el = $(el);
    }
    set progress(val) {
        this.el.toggleClass('btn-in-progress', val).prop('disabled', val);
    }
}

});

parcelRegister("6WhLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8123876e1733f002$export$2e2bcd8739ae039);

var $6YELt = parcelRequire("6YELt");

var $3Cbif = parcelRequire("3Cbif");

var $j7etR = parcelRequire("j7etR");

var $hjwzV = parcelRequire("hjwzV");

(parcelRequire("8eOm5"))($);
class $8123876e1733f002$export$2e2bcd8739ae039 {
    constructor(opts){
        this.opts = opts || {};
        this.l18n = (0, $6YELt.default).create(opts.l18n);
        this.result = null;
    }
    execute() {
        (0, $j7etR.default).showRemote(`${Flashcards.root}/new-collection-modal`, (modal)=>{
            const form = modal.content.find('form');
            modal.setTitle(this.l18n.get('collectionForm.modal.title'));
            modal.centerFooterButtons();
            modal.addFooterButton(this.l18n.get("button.save"), "btn btn-primary btn-ok", function() {
                form.submit();
            });
            modal.addFooterButton(this.l18n.get('button.cancel'), "btn btn-secondary btn-cancel", function() {
                modal.close();
            });
            modal.setCloseHandler(()=>{
                ($.isFunction(this.opts.onComplete) ? this.opts.onComplete : $.noop)(this);
            });
            const btnOk = new (0, $3Cbif.default)(modal.content.find('.btn-ok'));
            form.ajaxForm({
                beforeSubmit: function(arr, $form, options) {
                    btnOk.progress = true;
                    new (0, $hjwzV.default)($form).clearErrors();
                },
                error: function(jqXHR, textStatus, error, $form) {
                    const json = jqXHR.responseJSON;
                    if (json && json.message === 'bad request') new (0, $hjwzV.default)($form).bindErrors(json.bindingErrors);
                    btnOk.progress = false;
                },
                success: (data, textStatus, jqXHR, $form)=>{
                    if (data.success) {
                        this.result = data;
                        modal.close();
                        btnOk.progress = false;
                    }
                }
            });
        });
    }
}

});
parcelRegister("j7etR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea9e755be8de100$export$2e2bcd8739ae039);

var $6CQqh = parcelRequire("6CQqh");

var $2p6hs = parcelRequire("2p6hs");
class $dea9e755be8de100$export$2e2bcd8739ae039 {
    constructor(content){
        this.closeHandler = null;
        this.modalOpts = {};
        this.content = $(content);
        this.addHideListener(()=>{
            this.content.remove();
        });
        this.addHideListener(()=>{
            if (this.closeHandler) this.closeHandler();
        });
    }
    addShowListener(listener) {
        this.content.one('shown.bs.modal', ()=>{
            listener(this);
        });
    }
    addHideListener(listener) {
        this.content.one('hidden.bs.modal', ()=>{
            listener(this);
        });
    }
    show(callback) {
        if (this.modalOpts.noHide) {
            this.modalOpts.backdrop = 'static';
            this.modalOpts.keyboard = false;
            this.content.find('.modal-header button[data-dismiss=modal]').remove();
        }
        this.content.one('shown.bs.modal', ()=>{
            if (typeof callback === "function") callback(this);
        });
        this.content.modal(this.modalOpts);
    }
    close() {
        this.content.modal('hide');
        this.content.remove();
    }
    setCloseHandler(handler) {
        this.closeHandler = handler;
    }
    addFooterLink(title, classes, href) {
        const footer = this.content.find('.modal-footer');
        $('<a class="' + classes + '"></a>').attr('href', href).text(title).appendTo(footer);
        footer.show();
    }
    /**
     * @return button jquery instance
     * */ addFooterButton(title, classes, handler) {
        const footer = this.content.find('.modal-footer');
        const button = $('<button class="' + classes + '"></button>').text(title).on('click', function() {
            handler();
            return false;
        }).appendTo(footer);
        footer.show();
        return button;
    }
    setTitle(title) {
        const header = this.content.find('.modal-header');
        header.find('.modal-title').text(title);
        header.show();
    }
    disableHide() {
        this.modalOpts.noHide = true;
    }
    centerFooterButtons() {
        this.content.find('.modal-footer').addClass('modal-footer-text-center');
    }
    center() {
        this.content.find('.modal-dialog').addClass('modal-dialog-centered');
    }
    addDialogClass(className) {
        this.content.find('.modal-dialog').addClass(className);
    }
    addBodyClass(className) {
        this.content.find('.modal-body').addClass(className);
    }
    handleUpdate() {
        this.content.modal('handleUpdate');
    }
    static showRemote(href, modallerCallback, failureCallback) {
        if (!failureCallback) failureCallback = (0, $6CQqh.noop);
        return (0, $2p6hs.aPromise)($.get(href)).then((html)=>{
            return $dea9e755be8de100$export$2e2bcd8739ae039.showLocal(html, modallerCallback);
        }, (error)=>{
            if (failureCallback) failureCallback(error);
        });
    }
    static showLocal(body, modallerCallback) {
        if (!modallerCallback) modallerCallback = (0, $6CQqh.noop);
        const template = `
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="display: none;">
        <h5 class="modal-title"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="far fa-times-circle"></span>
        </button>
      </div>
      <div class="modal-body">${body}</div>
      <div class="modal-footer modal-footer-modaller" style="display: none;"></div>
    </div>
  </div>
</div>
        `;
        return new Promise((resolve, reject)=>{
            const modaller = new $dea9e755be8de100$export$2e2bcd8739ae039(template);
            modallerCallback(modaller);
            modaller.show();
            modaller.addHideListener(()=>{
                resolve(modaller);
            });
        });
    }
    static showForbidden(l18n, titleKey, noticeKey) {
        var buttonPre = 'packPage.dialogs.forbidden.alert';
        const template = `
    <p class="text-center">${l18n.get(noticeKey)}</p>
    <p class="text-center"><span style="margin-right: 1em;">${l18n.get(buttonPre)}</span><a href="/login" class="btn btn-primary">${l18n.get('packPage.dialogs.login')}</a></p>
`;
        $dea9e755be8de100$export$2e2bcd8739ae039.showLocal(template, (modaller)=>{
            modaller.setTitle(l18n.get(titleKey));
        });
    }
    static showPrompt(options) {
        const html = `
<div class="modal-prompt">
    <p class="modal-prompt__text">${options.text}</p>
    <div class="modal-prompt__buttons text-center">
        <button class="btn btn-sm btn-primary" type="button" data-click="ok">${options.ok}</button>    
        <button class="btn btn-sm btn-light" type="button" data-click="cancel">${options.cancel}</button>    
    </div>
</div>        
`;
        let ok = false;
        return $dea9e755be8de100$export$2e2bcd8739ae039.showLocal(html, (modaller)=>{
            if (options.element) {
                modaller.content.addClass('modal-popover');
                modaller.content.one('shown.bs.modal', ()=>{
                    const windowWidth = $(window).outerWidth();
                    const windowHeight = $(window).outerHeight();
                    if (windowWidth && windowHeight) {
                        const viewPosition = options.element.getBoundingClientRect();
                        const modalCss = {
                            position: 'fixed',
                            right: windowWidth - viewPosition.right,
                            bottom: windowHeight - viewPosition.top
                        };
                        modaller.content.find('.modal-dialog').css(modalCss);
                    }
                });
            } else modaller.center();
            modaller.content.find('.modal-prompt__buttons button[data-click=ok]').click((e)=>{
                ok = true;
                modaller.close();
            });
            modaller.content.find('.modal-prompt__buttons button[data-click=cancel]').click((e)=>{
                modaller.close();
            });
        }).then((modaller)=>{
            return new Promise((resolve, reject)=>{
                (ok ? resolve : reject)(modaller);
            });
        }, (0, $6CQqh.noop));
    }
}

});
parcelRegister("6CQqh", function(module, exports) {

$parcel$export(module.exports, "just", () => $4d2ef4c2d41fb32a$export$4cc3e71b83557584);
$parcel$export(module.exports, "noop", () => $4d2ef4c2d41fb32a$export$8793edee2d425525);
/**
 * функция просто чтобы вернуть объект. чтобы не писать много скобок в лямбдах
 */ function $4d2ef4c2d41fb32a$export$4cc3e71b83557584(o) {
    return o;
}
function $4d2ef4c2d41fb32a$export$8793edee2d425525(...anyArgs) {}
function $4d2ef4c2d41fb32a$export$2eef8d24ed7a471(enumClass) {
    return Object.keys(enumClass).map((key)=>$4d2ef4c2d41fb32a$export$4cc3e71b83557584({
            key: key,
            value: enumClass[key]
        })).filter((entry)=>/^[A-Z_]+$/.test(entry.key)).map((entry)=>entry.value);
}

});

parcelRegister("2p6hs", function(module, exports) {

$parcel$export(module.exports, "aPromise", () => $1c02c9bcca64de1b$export$65b0f688894cdf69);
/**
 * @param thenable jQuery Thenable
 * @returns {Promise<T>}
 */ function $1c02c9bcca64de1b$export$65b0f688894cdf69(thenable) {
    return new Promise((resolve, reject)=>thenable.then(resolve, reject));
}

});


parcelRegister("hjwzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1c96151c4d551e$export$2e2bcd8739ae039);

var $hzVqu = parcelRequire("hzVqu");
class $9b1c96151c4d551e$export$2e2bcd8739ae039 {
    constructor(form){
        this.form = form;
    }
    clearErrors() {
        this.form.find('.has-error ').each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).removeClass('has-error').find('.error-text').empty().hide();
        });
    }
    bindErrors(errors) {
        const form = this.form;
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).each(errors, function() {
            if (typeof this.field === 'string' && this.field.length > 0 && typeof this.error === 'string' && this.error.length > 0) {
                const decorator = form.find('[name=' + this.field + ']').closest('.error-decorator');
                decorator.addClass('has-error').find('.error-text').text(this.error).show();
            }
        });
    }
}

});

parcelRegister("8eOm5", function(module, exports) {


/*!
 * jQuery Form Plugin
 * version: 4.2.1
 * Requires jQuery v1.7 or later
 * Copyright 2017 Kevin Morris
 * Copyright 2006 M. Alsup
 * Project repository: https://github.com/jquery-form/form
 * Dual licensed under the MIT and LGPLv3 licenses.
 * https://github.com/jquery-form/form#license
 */ /* global ActiveXObject */ /* eslint-disable */ (function(factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        'jquery'
    ], factory);
    else if (0, module.exports) // Node/CommonJS
    module.exports = function(root, jQuery1) {
        if (typeof jQuery1 === 'undefined') {
            // require('jQuery') returns a factory that requires window to build a jQuery instance, we normalize how we use modules
            // that require this pattern but the window provided is a noop if it's defined (how jquery works)
            if (typeof window !== 'undefined') jQuery1 = (parcelRequire("hzVqu"));
            else jQuery1 = (parcelRequire("hzVqu"))(root);
        }
        factory(jQuery1);
        return jQuery1;
    };
    else // Browser globals
    factory(jQuery);
})(function($) {
    /* eslint-enable */ 'use strict';
    /*
		Usage Note:
		-----------
		Do not use both ajaxSubmit and ajaxForm on the same form. These
		functions are mutually exclusive. Use ajaxSubmit if you want
		to bind your own submit handler to the form. For example,

		$(document).ready(function() {
			$('#myForm').on('submit', function(e) {
				e.preventDefault(); // <-- important
				$(this).ajaxSubmit({
					target: '#output'
				});
			});
		});

		Use ajaxForm when you want the plugin to manage all the event binding
		for you. For example,

		$(document).ready(function() {
			$('#myForm').ajaxForm({
				target: '#output'
			});
		});

		You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
		form does not have to exist when you invoke ajaxForm:

		$('#myForm').ajaxForm({
			delegation: true,
			target: '#output'
		});

		When using ajaxForm, the ajaxSubmit function will be invoked for you
		at the appropriate time.
	*/ var rCRLF = /\r?\n/g;
    /**
	 * Feature detection
	 */ var feature = {};
    feature.fileapi = $('<input type="file">').get(0).files !== undefined;
    feature.formdata = typeof window.FormData !== 'undefined';
    var hasProp = !!$.fn.prop;
    // attr2 uses prop when it can but checks the return type for
    // an expected string. This accounts for the case where a form
    // contains inputs with names like "action" or "method"; in those
    // cases "prop" returns the element
    $.fn.attr2 = function() {
        if (!hasProp) return this.attr.apply(this, arguments);
        var val = this.prop.apply(this, arguments);
        if (val && val.jquery || typeof val === 'string') return val;
        return this.attr.apply(this, arguments);
    };
    /**
	 * ajaxSubmit() provides a mechanism for immediately submitting
	 * an HTML form using AJAX.
	 *
	 * @param	{object|string}	options		jquery.form.js parameters or custom url for submission
	 * @param	{object}		data		extraData
	 * @param	{string}		dataType	ajax dataType
	 * @param	{function}		onSuccess	ajax success callback function
	 */ $.fn.ajaxSubmit = function(options, data, dataType, onSuccess) {
        // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
        if (!this.length) {
            log('ajaxSubmit: skipping submit process - no element selected');
            return this;
        }
        /* eslint consistent-this: ["error", "$form"] */ var method, action, url, $form = this;
        if (typeof options === 'function') options = {
            success: options
        };
        else if (typeof options === 'string' || options === false && arguments.length > 0) {
            options = {
                'url': options,
                'data': data,
                'dataType': dataType
            };
            if (typeof onSuccess === 'function') options.success = onSuccess;
        } else if (typeof options === 'undefined') options = {};
        method = options.method || options.type || this.attr2('method');
        action = options.url || this.attr2('action');
        url = typeof action === 'string' ? $.trim(action) : '';
        url = url || window.location.href || '';
        if (url) // clean url (don't include hash vaue)
        url = (url.match(/^([^#]+)/) || [])[1];
        options = $.extend(true, {
            url: url,
            success: $.ajaxSettings.success,
            type: method || $.ajaxSettings.type,
            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank' // eslint-disable-line no-script-url
        }, options);
        // hook for manipulating the form data before it is extracted;
        // convenient for use with rich editors like tinyMCE or FCKEditor
        var veto = {};
        this.trigger('form-pre-serialize', [
            this,
            options,
            veto
        ]);
        if (veto.veto) {
            log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
            return this;
        }
        // provide opportunity to alter form data before it is serialized
        if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
            log('ajaxSubmit: submit aborted via beforeSerialize callback');
            return this;
        }
        var traditional = options.traditional;
        if (typeof traditional === 'undefined') traditional = $.ajaxSettings.traditional;
        var elements = [];
        var qx, a = this.formToArray(options.semantic, elements, options.filtering);
        if (options.data) {
            var optionsData = $.isFunction(options.data) ? options.data(a) : options.data;
            options.extraData = optionsData;
            qx = $.param(optionsData, traditional);
        }
        // give pre-submit callback an opportunity to abort the submit
        if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
            log('ajaxSubmit: submit aborted via beforeSubmit callback');
            return this;
        }
        // fire vetoable 'validate' event
        this.trigger('form-submit-validate', [
            a,
            this,
            options,
            veto
        ]);
        if (veto.veto) {
            log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
            return this;
        }
        var q = $.param(a, traditional);
        if (qx) q = q ? q + '&' + qx : qx;
        if (options.type.toUpperCase() === 'GET') {
            options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
            options.data = null; // data is null for 'get'
        } else options.data = q; // data is the query string for 'post'
        var callbacks = [];
        if (options.resetForm) callbacks.push(function() {
            $form.resetForm();
        });
        if (options.clearForm) callbacks.push(function() {
            $form.clearForm(options.includeHidden);
        });
        // perform a load on the target only if dataType is not provided
        if (!options.dataType && options.target) {
            var oldSuccess = options.success || function() {};
            callbacks.push(function(data, textStatus, jqXHR) {
                var successArguments = arguments, fn = options.replaceTarget ? 'replaceWith' : 'html';
                $(options.target)[fn](data).each(function() {
                    oldSuccess.apply(this, successArguments);
                });
            });
        } else if (options.success) {
            if ($.isArray(options.success)) $.merge(callbacks, options.success);
            else callbacks.push(options.success);
        }
        options.success = function(data, status, xhr) {
            var context = options.context || this; // jQuery 1.4+ supports scope context
            for(var i = 0, max = callbacks.length; i < max; i++)callbacks[i].apply(context, [
                data,
                status,
                xhr || $form,
                $form
            ]);
        };
        if (options.error) {
            var oldError = options.error;
            options.error = function(xhr, status, error) {
                var context = options.context || this;
                oldError.apply(context, [
                    xhr,
                    status,
                    error,
                    $form
                ]);
            };
        }
        if (options.complete) {
            var oldComplete = options.complete;
            options.complete = function(xhr, status) {
                var context = options.context || this;
                oldComplete.apply(context, [
                    xhr,
                    status,
                    $form
                ]);
            };
        }
        // are there files to upload?
        // [value] (issue #113), also see comment:
        // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
        var fileInputs = $('input[type=file]:enabled', this).filter(function() {
            return $(this).val() !== '';
        });
        var hasFileInputs = fileInputs.length > 0;
        var mp = 'multipart/form-data';
        var multipart = $form.attr('enctype') === mp || $form.attr('encoding') === mp;
        var fileAPI = feature.fileapi && feature.formdata;
        log('fileAPI :' + fileAPI);
        var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;
        var jqxhr;
        // options.iframe allows user to force iframe mode
        // 06-NOV-09: now defaulting to iframe mode if file input is detected
        if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
            // hack to fix Safari hang (thanks to Tim Molendijk for this)
            // see: http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
            if (options.closeKeepAlive) $.get(options.closeKeepAlive, function() {
                jqxhr = fileUploadIframe(a);
            });
            else jqxhr = fileUploadIframe(a);
        } else if ((hasFileInputs || multipart) && fileAPI) jqxhr = fileUploadXhr(a);
        else jqxhr = $.ajax(options);
        $form.removeData('jqxhr').data('jqxhr', jqxhr);
        // clear element array
        for(var k = 0; k < elements.length; k++)elements[k] = null;
        // fire 'notify' event
        this.trigger('form-submit-notify', [
            this,
            options
        ]);
        return this;
        // utility fn for deep serialization
        function deepSerialize(extraData) {
            var serialized = $.param(extraData, options.traditional).split('&');
            var len = serialized.length;
            var result = [];
            var i, part;
            for(i = 0; i < len; i++){
                // #252; undo param space replacement
                serialized[i] = serialized[i].replace(/\+/g, ' ');
                part = serialized[i].split('=');
                // #278; use array instead of object storage, favoring array serializations
                result.push([
                    decodeURIComponent(part[0]),
                    decodeURIComponent(part[1])
                ]);
            }
            return result;
        }
        // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
        function fileUploadXhr(a) {
            var formdata = new FormData();
            for(var i = 0; i < a.length; i++)formdata.append(a[i].name, a[i].value);
            if (options.extraData) {
                var serializedData = deepSerialize(options.extraData);
                for(i = 0; i < serializedData.length; i++)if (serializedData[i]) formdata.append(serializedData[i][0], serializedData[i][1]);
            }
            options.data = null;
            var s = $.extend(true, {}, $.ajaxSettings, options, {
                contentType: false,
                processData: false,
                cache: false,
                type: method || 'POST'
            });
            if (options.uploadProgress) // workaround because jqXHR does not expose upload property
            s.xhr = function() {
                var xhr = $.ajaxSettings.xhr();
                if (xhr.upload) xhr.upload.addEventListener('progress', function(event) {
                    var percent = 0;
                    var position = event.loaded || event.position; /* event.position is deprecated */ 
                    var total = event.total;
                    if (event.lengthComputable) percent = Math.ceil(position / total * 100);
                    options.uploadProgress(event, position, total, percent);
                }, false);
                return xhr;
            };
            s.data = null;
            var beforeSend = s.beforeSend;
            s.beforeSend = function(xhr, o) {
                // Send FormData() provided by user
                if (options.formData) o.data = options.formData;
                else o.data = formdata;
                if (beforeSend) beforeSend.call(this, xhr, o);
            };
            return $.ajax(s);
        }
        // private function for handling file uploads (hat tip to YAHOO!)
        function fileUploadIframe(a) {
            var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
            var deferred = $.Deferred();
            // #341
            deferred.abort = function(status) {
                xhr.abort(status);
            };
            if (a) // ensure that every serialized input is still enabled
            for(i = 0; i < elements.length; i++){
                el = $(elements[i]);
                if (hasProp) el.prop('disabled', false);
                else el.removeAttr('disabled');
            }
            s = $.extend(true, {}, $.ajaxSettings, options);
            s.context = s.context || s;
            id = 'jqFormIO' + new Date().getTime();
            var ownerDocument = form.ownerDocument;
            var $body = $form.closest('body');
            if (s.iframeTarget) {
                $io = $(s.iframeTarget, ownerDocument);
                n = $io.attr2('name');
                if (!n) $io.attr2('name', id);
                else id = n;
            } else {
                $io = $('<iframe name="' + id + '" src="' + s.iframeSrc + '" />', ownerDocument);
                $io.css({
                    position: 'absolute',
                    top: '-1000px',
                    left: '-1000px'
                });
            }
            io = $io[0];
            xhr = {
                aborted: 0,
                responseText: null,
                responseXML: null,
                status: 0,
                statusText: 'n/a',
                getAllResponseHeaders: function() {},
                getResponseHeader: function() {},
                setRequestHeader: function() {},
                abort: function(status) {
                    var e = status === 'timeout' ? 'timeout' : 'aborted';
                    log('aborting upload... ' + e);
                    this.aborted = 1;
                    try {
                        if (io.contentWindow.document.execCommand) io.contentWindow.document.execCommand('Stop');
                    } catch (ignore) {}
                    $io.attr('src', s.iframeSrc); // abort op in progress
                    xhr.error = e;
                    if (s.error) s.error.call(s.context, xhr, e, status);
                    if (g) $.event.trigger('ajaxError', [
                        xhr,
                        s,
                        e
                    ]);
                    if (s.complete) s.complete.call(s.context, xhr, e);
                }
            };
            g = s.global;
            // trigger ajax global events so that activity/block indicators work like normal
            if (g && $.active++ === 0) $.event.trigger('ajaxStart');
            if (g) $.event.trigger('ajaxSend', [
                xhr,
                s
            ]);
            if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
                if (s.global) $.active--;
                deferred.reject();
                return deferred;
            }
            if (xhr.aborted) {
                deferred.reject();
                return deferred;
            }
            // add submitting element to data if we know it
            sub = form.clk;
            if (sub) {
                n = sub.name;
                if (n && !sub.disabled) {
                    s.extraData = s.extraData || {};
                    s.extraData[n] = sub.value;
                    if (sub.type === 'image') {
                        s.extraData[n + '.x'] = form.clk_x;
                        s.extraData[n + '.y'] = form.clk_y;
                    }
                }
            }
            var CLIENT_TIMEOUT_ABORT = 1;
            var SERVER_ABORT = 2;
            function getDoc(frame) {
                /* it looks like contentWindow or contentDocument do not
				 * carry the protocol property in ie8, when running under ssl
				 * frame.document is the only valid response document, since
				 * the protocol is know but not on the other two objects. strange?
				 * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
				 */ var doc = null;
                // IE8 cascading access check
                try {
                    if (frame.contentWindow) doc = frame.contentWindow.document;
                } catch (err) {
                    // IE8 access denied under ssl & missing protocol
                    log('cannot get iframe.contentWindow document: ' + err);
                }
                if (doc) return doc;
                try {
                    doc = frame.contentDocument ? frame.contentDocument : frame.document;
                } catch (err) {
                    // last attempt
                    log('cannot get iframe.contentDocument: ' + err);
                    doc = frame.document;
                }
                return doc;
            }
            // Rails CSRF hack (thanks to Yvan Barthelemy)
            var csrf_token = $('meta[name=csrf-token]').attr('content');
            var csrf_param = $('meta[name=csrf-param]').attr('content');
            if (csrf_param && csrf_token) {
                s.extraData = s.extraData || {};
                s.extraData[csrf_param] = csrf_token;
            }
            // take a breath so that pending repaints get some cpu time before the upload starts
            function doSubmit() {
                // make sure form attrs are set
                var t = $form.attr2('target'), a = $form.attr2('action'), mp = 'multipart/form-data', et = $form.attr('enctype') || $form.attr('encoding') || mp;
                // update form attrs in IE friendly way
                form.setAttribute('target', id);
                if (!method || /post/i.test(method)) form.setAttribute('method', 'POST');
                if (a !== s.url) form.setAttribute('action', s.url);
                // ie borks in some cases when setting encoding
                if (!s.skipEncodingOverride && (!method || /post/i.test(method))) $form.attr({
                    encoding: 'multipart/form-data',
                    enctype: 'multipart/form-data'
                });
                // support timout
                if (s.timeout) timeoutHandle = setTimeout(function() {
                    timedOut = true;
                    cb(CLIENT_TIMEOUT_ABORT);
                }, s.timeout);
                // look for server aborts
                function checkState() {
                    try {
                        var state = getDoc(io).readyState;
                        log('state = ' + state);
                        if (state && state.toLowerCase() === 'uninitialized') setTimeout(checkState, 50);
                    } catch (e) {
                        log('Server abort: ', e, ' (', e.name, ')');
                        cb(SERVER_ABORT); // eslint-disable-line callback-return
                        if (timeoutHandle) clearTimeout(timeoutHandle);
                        timeoutHandle = undefined;
                    }
                }
                // add "extra" data to form if provided in options
                var extraInputs = [];
                try {
                    if (s.extraData) {
                        for(var n in s.extraData)if (s.extraData.hasOwnProperty(n)) {
                            // if using the $.param format that allows for multiple values with the same name
                            if ($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) extraInputs.push($('<input type="hidden" name="' + s.extraData[n].name + '">', ownerDocument).val(s.extraData[n].value).appendTo(form)[0]);
                            else extraInputs.push($('<input type="hidden" name="' + n + '">', ownerDocument).val(s.extraData[n]).appendTo(form)[0]);
                        }
                    }
                    if (!s.iframeTarget) // add iframe to doc and submit the form
                    $io.appendTo($body);
                    if (io.attachEvent) io.attachEvent('onload', cb);
                    else io.addEventListener('load', cb, false);
                    setTimeout(checkState, 15);
                    try {
                        form.submit();
                    } catch (err) {
                        // just in case form has element with name/id of 'submit'
                        var submitFn = document.createElement('form').submit;
                        submitFn.apply(form);
                    }
                } finally{
                    // reset attrs and remove "extra" input elements
                    form.setAttribute('action', a);
                    form.setAttribute('enctype', et); // #380
                    if (t) form.setAttribute('target', t);
                    else $form.removeAttr('target');
                    $(extraInputs).remove();
                }
            }
            if (s.forceSync) doSubmit();
            else setTimeout(doSubmit, 10); // this lets dom updates render
            var data, doc, domCheckCount = 50, callbackProcessed;
            function cb(e) {
                if (xhr.aborted || callbackProcessed) return;
                doc = getDoc(io);
                if (!doc) {
                    log('cannot access response document');
                    e = SERVER_ABORT;
                }
                if (e === CLIENT_TIMEOUT_ABORT && xhr) {
                    xhr.abort('timeout');
                    deferred.reject(xhr, 'timeout');
                    return;
                } else if (e === SERVER_ABORT && xhr) {
                    xhr.abort('server abort');
                    deferred.reject(xhr, 'error', 'server abort');
                    return;
                }
                if (!doc || doc.location.href === s.iframeSrc) {
                    // response not received yet
                    if (!timedOut) return;
                }
                if (io.detachEvent) io.detachEvent('onload', cb);
                else io.removeEventListener('load', cb, false);
                var status = 'success', errMsg;
                try {
                    if (timedOut) throw 'timeout';
                    var isXml = s.dataType === 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
                    log('isXml=' + isXml);
                    if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
                        if (--domCheckCount) {
                            // in some browsers (Opera) the iframe DOM is not always traversable when
                            // the onload callback fires, so we loop a bit to accommodate
                            log('requeing onLoad callback, DOM not available');
                            setTimeout(cb, 250);
                            return;
                        }
                    }
                    // log('response detected');
                    var docRoot = doc.body ? doc.body : doc.documentElement;
                    xhr.responseText = docRoot ? docRoot.innerHTML : null;
                    xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
                    if (isXml) s.dataType = 'xml';
                    xhr.getResponseHeader = function(header) {
                        var headers = {
                            'content-type': s.dataType
                        };
                        return headers[header.toLowerCase()];
                    };
                    // support for XHR 'status' & 'statusText' emulation :
                    if (docRoot) {
                        xhr.status = Number(docRoot.getAttribute('status')) || xhr.status;
                        xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
                    }
                    var dt = (s.dataType || '').toLowerCase();
                    var scr = /(json|script|text)/.test(dt);
                    if (scr || s.textarea) {
                        // see if user embedded response in textarea
                        var ta = doc.getElementsByTagName('textarea')[0];
                        if (ta) {
                            xhr.responseText = ta.value;
                            // support for XHR 'status' & 'statusText' emulation :
                            xhr.status = Number(ta.getAttribute('status')) || xhr.status;
                            xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
                        } else if (scr) {
                            // account for browsers injecting pre around json response
                            var pre = doc.getElementsByTagName('pre')[0];
                            var b = doc.getElementsByTagName('body')[0];
                            if (pre) xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
                            else if (b) xhr.responseText = b.textContent ? b.textContent : b.innerText;
                        }
                    } else if (dt === 'xml' && !xhr.responseXML && xhr.responseText) xhr.responseXML = toXml(xhr.responseText); // eslint-disable-line no-use-before-define
                    try {
                        data = httpData(xhr, dt, s); // eslint-disable-line no-use-before-define
                    } catch (err) {
                        status = 'parsererror';
                        xhr.error = errMsg = err || status;
                    }
                } catch (err) {
                    log('error caught: ', err);
                    status = 'error';
                    xhr.error = errMsg = err || status;
                }
                if (xhr.aborted) {
                    log('upload aborted');
                    status = null;
                }
                if (xhr.status) status = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304 ? 'success' : 'error';
                // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
                if (status === 'success') {
                    if (s.success) s.success.call(s.context, data, 'success', xhr);
                    deferred.resolve(xhr.responseText, 'success', xhr);
                    if (g) $.event.trigger('ajaxSuccess', [
                        xhr,
                        s
                    ]);
                } else if (status) {
                    if (typeof errMsg === 'undefined') errMsg = xhr.statusText;
                    if (s.error) s.error.call(s.context, xhr, status, errMsg);
                    deferred.reject(xhr, 'error', errMsg);
                    if (g) $.event.trigger('ajaxError', [
                        xhr,
                        s,
                        errMsg
                    ]);
                }
                if (g) $.event.trigger('ajaxComplete', [
                    xhr,
                    s
                ]);
                if (g && !--$.active) $.event.trigger('ajaxStop');
                if (s.complete) s.complete.call(s.context, xhr, status);
                callbackProcessed = true;
                if (s.timeout) clearTimeout(timeoutHandle);
                // clean up
                setTimeout(function() {
                    if (!s.iframeTarget) $io.remove();
                    else $io.attr('src', s.iframeSrc);
                    xhr.responseXML = null;
                }, 100);
            }
            var toXml = $.parseXML || function(s, doc) {
                if (window.ActiveXObject) {
                    doc = new ActiveXObject('Microsoft.XMLDOM');
                    doc.async = 'false';
                    doc.loadXML(s);
                } else doc = new DOMParser().parseFromString(s, 'text/xml');
                return doc && doc.documentElement && doc.documentElement.nodeName !== 'parsererror' ? doc : null;
            };
            var parseJSON = $.parseJSON || function(s) {
                /* jslint evil:true */ return window['eval']('(' + s + ')'); // eslint-disable-line dot-notation
            };
            var httpData = function(xhr, type, s) {
                var ct = xhr.getResponseHeader('content-type') || '', xml = (type === 'xml' || !type) && ct.indexOf('xml') >= 0, data = xml ? xhr.responseXML : xhr.responseText;
                if (xml && data.documentElement.nodeName === 'parsererror') {
                    if ($.error) $.error('parsererror');
                }
                if (s && s.dataFilter) data = s.dataFilter(data, type);
                if (typeof data === 'string') {
                    if ((type === 'json' || !type) && ct.indexOf('json') >= 0) data = parseJSON(data);
                    else if ((type === 'script' || !type) && ct.indexOf('javascript') >= 0) $.globalEval(data);
                }
                return data;
            };
            return deferred;
        }
    };
    /**
	 * ajaxForm() provides a mechanism for fully automating form submission.
	 *
	 * The advantages of using this method instead of ajaxSubmit() are:
	 *
	 * 1: This method will include coordinates for <input type="image"> elements (if the element
	 *	is used to submit the form).
	 * 2. This method will include the submit element's name/value data (for the element that was
	 *	used to submit the form).
	 * 3. This method binds the submit() method to the form for you.
	 *
	 * The options argument for ajaxForm works exactly as it does for ajaxSubmit. ajaxForm merely
	 * passes the options argument along after properly binding events for submit elements and
	 * the form itself.
	 */ $.fn.ajaxForm = function(options, data, dataType, onSuccess) {
        if (typeof options === 'string' || options === false && arguments.length > 0) {
            options = {
                'url': options,
                'data': data,
                'dataType': dataType
            };
            if (typeof onSuccess === 'function') options.success = onSuccess;
        }
        options = options || {};
        options.delegation = options.delegation && $.isFunction($.fn.on);
        // in jQuery 1.3+ we can fix mistakes with the ready state
        if (!options.delegation && this.length === 0) {
            var o = {
                s: this.selector,
                c: this.context
            };
            if (!$.isReady && o.s) {
                log('DOM not ready, queuing ajaxForm');
                $(function() {
                    $(o.s, o.c).ajaxForm(options);
                });
                return this;
            }
            // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
            log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
            return this;
        }
        if (options.delegation) {
            $(document).off('submit.form-plugin', this.selector, doAjaxSubmit).off('click.form-plugin', this.selector, captureSubmittingElement).on('submit.form-plugin', this.selector, options, doAjaxSubmit).on('click.form-plugin', this.selector, options, captureSubmittingElement);
            return this;
        }
        return this.ajaxFormUnbind().on('submit.form-plugin', options, doAjaxSubmit).on('click.form-plugin', options, captureSubmittingElement);
    };
    // private event handlers
    function doAjaxSubmit(e) {
        /* jshint validthis:true */ var options = e.data;
        if (!e.isDefaultPrevented()) {
            e.preventDefault();
            $(e.target).closest('form').ajaxSubmit(options); // #365
        }
    }
    function captureSubmittingElement(e) {
        /* jshint validthis:true */ var target = e.target;
        var $el = $(target);
        if (!$el.is('[type=submit],[type=image]')) {
            // is this a child element of the submit el?  (ex: a span within a button)
            var t = $el.closest('[type=submit]');
            if (t.length === 0) return;
            target = t[0];
        }
        var form = target.form;
        form.clk = target;
        if (target.type === 'image') {
            if (typeof e.offsetX !== 'undefined') {
                form.clk_x = e.offsetX;
                form.clk_y = e.offsetY;
            } else if (typeof $.fn.offset === 'function') {
                var offset = $el.offset();
                form.clk_x = e.pageX - offset.left;
                form.clk_y = e.pageY - offset.top;
            } else {
                form.clk_x = e.pageX - target.offsetLeft;
                form.clk_y = e.pageY - target.offsetTop;
            }
        }
        // clear form vars
        setTimeout(function() {
            form.clk = form.clk_x = form.clk_y = null;
        }, 100);
    }
    // ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
    $.fn.ajaxFormUnbind = function() {
        return this.off('submit.form-plugin click.form-plugin');
    };
    /**
	 * formToArray() gathers form element data into an array of objects that can
	 * be passed to any of the following ajax functions: $.get, $.post, or load.
	 * Each object in the array has both a 'name' and 'value' property. An example of
	 * an array for a simple login form might be:
	 *
	 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
	 *
	 * It is this array that is passed to pre-submit callback functions provided to the
	 * ajaxSubmit() and ajaxForm() methods.
	 */ $.fn.formToArray = function(semantic, elements, filtering) {
        var a = [];
        if (this.length === 0) return a;
        var form = this[0];
        var formId = this.attr('id');
        var els = semantic || typeof form.elements === 'undefined' ? form.getElementsByTagName('*') : form.elements;
        var els2;
        if (els) els = $.makeArray(els); // convert to standard array
        // #386; account for inputs outside the form which use the 'form' attribute
        // FinesseRus: in non-IE browsers outside fields are already included in form.elements.
        if (formId && (semantic || /(Edge|Trident)\//.test(navigator.userAgent))) {
            els2 = $(':input[form="' + formId + '"]').get(); // hat tip @thet
            if (els2.length) els = (els || []).concat(els2);
        }
        if (!els || !els.length) return a;
        if ($.isFunction(filtering)) els = $.map(els, filtering);
        var i, j, n, v, el, max, jmax;
        for(i = 0, max = els.length; i < max; i++){
            el = els[i];
            n = el.name;
            if (!n || el.disabled) continue;
            if (semantic && form.clk && el.type === 'image') {
                // handle image inputs on the fly when semantic == true
                if (form.clk === el) {
                    a.push({
                        name: n,
                        value: $(el).val(),
                        type: el.type
                    });
                    a.push({
                        name: n + '.x',
                        value: form.clk_x
                    }, {
                        name: n + '.y',
                        value: form.clk_y
                    });
                }
                continue;
            }
            v = $.fieldValue(el, true);
            if (v && v.constructor === Array) {
                if (elements) elements.push(el);
                for(j = 0, jmax = v.length; j < jmax; j++)a.push({
                    name: n,
                    value: v[j]
                });
            } else if (feature.fileapi && el.type === 'file') {
                if (elements) elements.push(el);
                var files = el.files;
                if (files.length) for(j = 0; j < files.length; j++)a.push({
                    name: n,
                    value: files[j],
                    type: el.type
                });
                else // #180
                a.push({
                    name: n,
                    value: '',
                    type: el.type
                });
            } else if (v !== null && typeof v !== 'undefined') {
                if (elements) elements.push(el);
                a.push({
                    name: n,
                    value: v,
                    type: el.type,
                    required: el.required
                });
            }
        }
        if (!semantic && form.clk) {
            // input type=='image' are not found in elements array! handle it here
            var $input = $(form.clk), input = $input[0];
            n = input.name;
            if (n && !input.disabled && input.type === 'image') {
                a.push({
                    name: n,
                    value: $input.val()
                });
                a.push({
                    name: n + '.x',
                    value: form.clk_x
                }, {
                    name: n + '.y',
                    value: form.clk_y
                });
            }
        }
        return a;
    };
    /**
	 * Serializes form data into a 'submittable' string. This method will return a string
	 * in the format: name1=value1&amp;name2=value2
	 */ $.fn.formSerialize = function(semantic) {
        // hand off to jQuery.param for proper encoding
        return $.param(this.formToArray(semantic));
    };
    /**
	 * Serializes all field elements in the jQuery object into a query string.
	 * This method will return a string in the format: name1=value1&amp;name2=value2
	 */ $.fn.fieldSerialize = function(successful) {
        var a = [];
        this.each(function() {
            var n = this.name;
            if (!n) return;
            var v = $.fieldValue(this, successful);
            if (v && v.constructor === Array) for(var i = 0, max = v.length; i < max; i++)a.push({
                name: n,
                value: v[i]
            });
            else if (v !== null && typeof v !== 'undefined') a.push({
                name: this.name,
                value: v
            });
        });
        // hand off to jQuery.param for proper encoding
        return $.param(a);
    };
    /**
	 * Returns the value(s) of the element in the matched set. For example, consider the following form:
	 *
	 *	<form><fieldset>
	 *		<input name="A" type="text">
	 *		<input name="A" type="text">
	 *		<input name="B" type="checkbox" value="B1">
	 *		<input name="B" type="checkbox" value="B2">
	 *		<input name="C" type="radio" value="C1">
	 *		<input name="C" type="radio" value="C2">
	 *	</fieldset></form>
	 *
	 *	var v = $('input[type=text]').fieldValue();
	 *	// if no values are entered into the text inputs
	 *	v === ['','']
	 *	// if values entered into the text inputs are 'foo' and 'bar'
	 *	v === ['foo','bar']
	 *
	 *	var v = $('input[type=checkbox]').fieldValue();
	 *	// if neither checkbox is checked
	 *	v === undefined
	 *	// if both checkboxes are checked
	 *	v === ['B1', 'B2']
	 *
	 *	var v = $('input[type=radio]').fieldValue();
	 *	// if neither radio is checked
	 *	v === undefined
	 *	// if first radio is checked
	 *	v === ['C1']
	 *
	 * The successful argument controls whether or not the field element must be 'successful'
	 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
	 * The default value of the successful argument is true. If this value is false the value(s)
	 * for each element is returned.
	 *
	 * Note: This method *always* returns an array. If no valid value can be determined the
	 *	array will be empty, otherwise it will contain one or more values.
	 */ $.fn.fieldValue = function(successful) {
        for(var val = [], i = 0, max = this.length; i < max; i++){
            var el = this[i];
            var v = $.fieldValue(el, successful);
            if (v === null || typeof v === 'undefined' || v.constructor === Array && !v.length) continue;
            if (v.constructor === Array) $.merge(val, v);
            else val.push(v);
        }
        return val;
    };
    /**
	 * Returns the value of the field element.
	 */ $.fieldValue = function(el, successful) {
        var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
        if (typeof successful === 'undefined') successful = true;
        /* eslint-disable no-mixed-operators */ if (successful && (!n || el.disabled || t === 'reset' || t === 'button' || (t === 'checkbox' || t === 'radio') && !el.checked || (t === 'submit' || t === 'image') && el.form && el.form.clk !== el || tag === 'select' && el.selectedIndex === -1)) /* eslint-enable no-mixed-operators */ return null;
        if (tag === 'select') {
            var index = el.selectedIndex;
            if (index < 0) return null;
            var a = [], ops = el.options;
            var one = t === 'select-one';
            var max = one ? index + 1 : ops.length;
            for(var i = one ? index : 0; i < max; i++){
                var op = ops[i];
                if (op.selected && !op.disabled) {
                    var v = op.value;
                    if (!v) v = op.attributes && op.attributes.value && !op.attributes.value.specified ? op.text : op.value;
                    if (one) return v;
                    a.push(v);
                }
            }
            return a;
        }
        return $(el).val().replace(rCRLF, '\r\n');
    };
    /**
	 * Clears the form data. Takes the following actions on the form's input fields:
	 *  - input text fields will have their 'value' property set to the empty string
	 *  - select elements will have their 'selectedIndex' property set to -1
	 *  - checkbox and radio inputs will have their 'checked' property set to false
	 *  - inputs of type submit, button, reset, and hidden will *not* be effected
	 *  - button elements will *not* be effected
	 */ $.fn.clearForm = function(includeHidden) {
        return this.each(function() {
            $('input,select,textarea', this).clearFields(includeHidden);
        });
    };
    /**
	 * Clears the selected form elements.
	 */ $.fn.clearFields = $.fn.clearInputs = function(includeHidden) {
        var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
        return this.each(function() {
            var t = this.type, tag = this.tagName.toLowerCase();
            if (re.test(t) || tag === 'textarea') this.value = '';
            else if (t === 'checkbox' || t === 'radio') this.checked = false;
            else if (tag === 'select') this.selectedIndex = -1;
            else if (t === 'file') {
                if (/MSIE/.test(navigator.userAgent)) $(this).replaceWith($(this).clone(true));
                else $(this).val('');
            } else if (includeHidden) // includeHidden can be the value true, or it can be a selector string
            // indicating a special test; for example:
            // $('#myForm').clearForm('.special:hidden')
            // the above would clean hidden inputs that have the class of 'special'
            {
                if (includeHidden === true && /hidden/.test(t) || typeof includeHidden === 'string' && $(this).is(includeHidden)) this.value = '';
            }
        });
    };
    /**
	 * Resets the form data or individual elements. Takes the following actions
	 * on the selected tags:
	 * - all fields within form elements will be reset to their original value
	 * - input / textarea / select fields will be reset to their original value
	 * - option / optgroup fields (for multi-selects) will defaulted individually
	 * - non-multiple options will find the right select to default
	 * - label elements will be searched against its 'for' attribute
	 * - all others will be searched for appropriate children to default
	 */ $.fn.resetForm = function() {
        return this.each(function() {
            var el = $(this);
            var tag = this.tagName.toLowerCase();
            switch(tag){
                case 'input':
                    this.checked = this.defaultChecked;
                // fall through
                case 'textarea':
                    this.value = this.defaultValue;
                    return true;
                case 'option':
                case 'optgroup':
                    var select = el.parents('select');
                    if (select.length && select[0].multiple) {
                        if (tag === 'option') this.selected = this.defaultSelected;
                        else el.find('option').resetForm();
                    } else select.resetForm();
                    return true;
                case 'select':
                    el.find('option').each(function(i) {
                        this.selected = this.defaultSelected;
                        if (this.defaultSelected && !el[0].multiple) {
                            el[0].selectedIndex = i;
                            return false;
                        }
                    });
                    return true;
                case 'label':
                    var forEl = $(el.attr('for'));
                    var list = el.find('input,select,textarea');
                    if (forEl[0]) list.unshift(forEl[0]);
                    list.resetForm();
                    return true;
                case 'form':
                    // guard against an input with the name of 'reset'
                    // note that IE reports the reset function as an 'object'
                    if (typeof this.reset === 'function' || typeof this.reset === 'object' && !this.reset.nodeType) this.reset();
                    return true;
                default:
                    el.find('form,input,label,select,textarea').resetForm();
                    return true;
            }
        });
    };
    /**
	 * Enables or disables any matching elements.
	 */ $.fn.enable = function(b) {
        if (typeof b === 'undefined') b = true;
        return this.each(function() {
            this.disabled = !b;
        });
    };
    /**
	 * Checks/unchecks any matching checkboxes or radio buttons and
	 * selects/deselects and matching option elements.
	 */ $.fn.selected = function(select) {
        if (typeof select === 'undefined') select = true;
        return this.each(function() {
            var t = this.type;
            if (t === 'checkbox' || t === 'radio') this.checked = select;
            else if (this.tagName.toLowerCase() === 'option') {
                var $sel = $(this).parent('select');
                if (select && $sel[0] && $sel[0].type === 'select-one') // deselect all other options
                $sel.find('option').selected(false);
                this.selected = select;
            }
        });
    };
    // expose debug var
    $.fn.ajaxSubmit.debug = false;
    // helper fn for console logging
    function log() {
        if (!$.fn.ajaxSubmit.debug) return;
        var msg = '[jquery.form] ' + Array.prototype.join.call(arguments, '');
        if (window.console && window.console.log) window.console.log(msg);
        else if (window.opera && window.opera.postError) window.opera.postError(msg);
    }
});

});


parcelRegister("3zknA", function(module, exports) {

$parcel$export(module.exports, "noop", () => $10c0da8dfb629bed$export$8793edee2d425525);
$parcel$export(module.exports, "randomInt", () => $10c0da8dfb629bed$export$3c5f89dae98e900b);
$parcel$export(module.exports, "randomBool", () => $10c0da8dfb629bed$export$b3b584c8d6ffe165);
$parcel$export(module.exports, "swapInArray", () => $10c0da8dfb629bed$export$5da6d711ed0fd711);
$parcel$export(module.exports, "shuffleArray", () => $10c0da8dfb629bed$export$7ac3a88d34a76e7);
$parcel$export(module.exports, "fitText", () => $10c0da8dfb629bed$export$b94583dc679500d);
$parcel$export(module.exports, "checkWrittenAnswer", () => $10c0da8dfb629bed$export$6a06ec76c9af6d6c);
$parcel$export(module.exports, "parseBoolean", () => $10c0da8dfb629bed$export$3fb54149990fb5b5);
$parcel$export(module.exports, "scrollIntoView", () => $10c0da8dfb629bed$export$53a0910f038337bd);
$parcel$export(module.exports, "isEnterEvent", () => $10c0da8dfb629bed$export$edd1eb89fbbc58a4);
$parcel$export(module.exports, "isEscapeEvent", () => $10c0da8dfb629bed$export$27297757fabc3b9);
$parcel$export(module.exports, "callLater", () => $10c0da8dfb629bed$export$19d86ed52b89834e);
$parcel$export(module.exports, "cardTextOnly", () => $10c0da8dfb629bed$export$bdf91b169a64e21c);

var $hzVqu = parcelRequire("hzVqu");
parcelRequire("lUnw9");

var $3wPZM = parcelRequire("3wPZM");

var $jR4nF = parcelRequire("jR4nF");
const $10c0da8dfb629bed$var$log = console.log;
// const log = noop;
const $10c0da8dfb629bed$var$MONTH_DAYS = 30;
const $10c0da8dfb629bed$var$DAY_SECONDS = 86400;
const $10c0da8dfb629bed$var$HOUR_SECONDS = 3600;
function $10c0da8dfb629bed$export$8793edee2d425525() {}
function $10c0da8dfb629bed$export$3c5f89dae98e900b(endExclusive) {
    return Math.floor(Math.random() * endExclusive);
}
function $10c0da8dfb629bed$export$264f7bbef4fe8370(...values) {
    return values[$10c0da8dfb629bed$export$3c5f89dae98e900b(values.length)];
}
function $10c0da8dfb629bed$export$1894f1ed2b62f599(array) {
    return array[$10c0da8dfb629bed$export$3c5f89dae98e900b(array.length)];
}
function $10c0da8dfb629bed$export$b3b584c8d6ffe165() {
    return Math.random() >= 0.5;
}
function $10c0da8dfb629bed$export$5da6d711ed0fd711(a, from, to) {
    const x = a[from];
    a[from] = a[to];
    a[to] = x;
}
function $10c0da8dfb629bed$export$7ac3a88d34a76e7(a) {
    for(let i = a.length; i; i--){
        let j = Math.floor(Math.random() * i);
        $10c0da8dfb629bed$export$5da6d711ed0fd711(a, i - 1, j);
    }
}
function $10c0da8dfb629bed$export$b94583dc679500d(textJq, heightMinSpace) {
    textJq.fitText({
        minFontSize: '12px',
        maxFontSize: '35px',
        heightMinSpace: heightMinSpace
    });
}
function $10c0da8dfb629bed$var$fitContentImageIfNeeded(jqimg) {
    jqimg.fitImage({
        show: true
    });
}
function $10c0da8dfb629bed$var$fitContentTextIfNeeded(jqp) {
    if (jqp.is(':visible')) $10c0da8dfb629bed$export$b94583dc679500d(jqp);
}
function $10c0da8dfb629bed$export$2f0b47b0911ce698(container) {
    $10c0da8dfb629bed$var$fitContentImageIfNeeded(container.find('img[fitimage]'));
    $10c0da8dfb629bed$var$fitContentImageIfNeeded(container.find('img[data-fitimage]'));
    $10c0da8dfb629bed$var$fitContentTextIfNeeded(container.find('p[fittext], div[fittext]'));
    $10c0da8dfb629bed$var$fitContentTextIfNeeded(container.find('p[data-fittext], div[data-fittext]'));
}
const $10c0da8dfb629bed$var$TRIM_WHITESPACE = /\s+/g;
const $10c0da8dfb629bed$var$TRIM_PUNCTUATION = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]/g;
function $10c0da8dfb629bed$var$simplifyForComparison(text) {
    return text.replace($10c0da8dfb629bed$var$TRIM_WHITESPACE, '').replace($10c0da8dfb629bed$var$TRIM_PUNCTUATION, '').toLocaleLowerCase();
}
function $10c0da8dfb629bed$export$6a06ec76c9af6d6c(expected, userText, onlyFullMatch = false) {
    expected = expected.toLocaleLowerCase();
    userText = userText.toLocaleLowerCase();
    // проверяем полное совпадение
    const fullMatch = $10c0da8dfb629bed$var$simplifyForComparison(userText) === $10c0da8dfb629bed$var$simplifyForComparison(expected);
    if (onlyFullMatch || fullMatch) return fullMatch;
    const partsDelimiter = /[,/;]/;
    const expectedParts = expected.split(partsDelimiter).map((item)=>$10c0da8dfb629bed$var$simplifyForComparison(item)).filter((item)=>item.length > 0);
    const userTextParts = userText.split(partsDelimiter).map((item)=>$10c0da8dfb629bed$var$simplifyForComparison(item)).filter((item)=>item.length > 0);
    const expectedPartsFound = expectedParts.filter((userTextPart)=>{
        return userTextParts.some((expectedPart)=>expectedPart === userTextPart);
    });
    if (onlyFullMatch) return expectedPartsFound.length === expectedParts.length;
    return expectedPartsFound.length > 0;
}
function $10c0da8dfb629bed$export$3fb54149990fb5b5(text) {
    switch(String(text)){
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
}
function $10c0da8dfb629bed$export$53a0910f038337bd(el) {
    $jR4nF((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(el).get(0), {
        time: 1000,
        align: {
            top: 0.1
        },
        ease: function(value) {
            return 1 - Math.pow(1 - value, value / 5);
        }
    });
}
function $10c0da8dfb629bed$export$edd1eb89fbbc58a4(e) {
    return e.which === 13 || e.keyCode === 13;
}
function $10c0da8dfb629bed$export$27297757fabc3b9(e) {
    return e.which === 27 || e.keyCode === 27;
}
function $10c0da8dfb629bed$export$bc733b0c5cbb3e8a(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) return null;
        const days = diff / $10c0da8dfb629bed$var$DAY_SECONDS;
        if (days > $10c0da8dfb629bed$var$MONTH_DAYS) {
            const months = days / $10c0da8dfb629bed$var$MONTH_DAYS;
            return (0, $3wPZM.Numbers).toMaxDecimals(months, 1) + texter.get('packMemo.short.months');
        }
        if (days > 1) return (0, $3wPZM.Numbers).toMaxDecimals(days, 1) + texter.get('packMemo.short.days');
        const hours = diff / $10c0da8dfb629bed$var$HOUR_SECONDS;
        return (0, $3wPZM.Numbers).toMaxDecimals(hours, 1) + texter.get('packMemo.short.hours');
    }
    return null;
}
function $10c0da8dfb629bed$export$f263d6a9befe8e4a(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) return null;
        const days = Math.ceil(diff / $10c0da8dfb629bed$var$DAY_SECONDS);
        return texter.get('pl.days', days);
    }
    return null;
}
function $10c0da8dfb629bed$export$9347ed982e2a7713(jqEl) {
    if (jqEl.length) jqEl.focus().click();
}
function $10c0da8dfb629bed$export$19d86ed52b89834e(callback) {
    setTimeout(callback, 1);
}
let $10c0da8dfb629bed$var$USER_TZ = null;
function $10c0da8dfb629bed$export$f2979946b6aa2c7b() {
    if ($10c0da8dfb629bed$var$USER_TZ == null && 'Intl' in window && 'DateTimeFormat' in Intl) {
        const formatter = new Intl.DateTimeFormat();
        if ('resolvedOptions' in formatter) {
            const options = formatter.resolvedOptions();
            if ('timeZone' in options) $10c0da8dfb629bed$var$USER_TZ = options.timeZone;
        }
    }
    return $10c0da8dfb629bed$var$USER_TZ;
}
function $10c0da8dfb629bed$export$bdf91b169a64e21c(cardText, cardTextType) {
    if (cardTextType === 'html') cardText = cardText.replace(/<\/p>/g, '\n').replace(/<[^>]+>/g, '');
    return cardText;
}

});
parcelRegister("lUnw9", function(module, exports) {

$parcel$export(module.exports, "jQuery", () => $ff311208bcc4bcd7$export$1ea89ccd920d3a7, (v) => $ff311208bcc4bcd7$export$1ea89ccd920d3a7 = v);
/*global jQuery */ /*!
* Based on FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/ (function($) {
    function Dim(size, units) {
        this.size = size;
        this.units = units;
    }
    Dim.prototype = {
        multiply: function(k) {
            return new Dim(this.size * k, this.units);
        },
        plus: function(size) {
            return new Dim(this.size + size, this.units);
        },
        toString: function() {
            return '' + this.size + this.units;
        }
    };
    var parseDimRe = /([\d.]+)([\w]*)/;
    function parseDim(val) {
        var match = parseDimRe.exec(val);
        if (match) return new Dim(parseFloat(match[1]), match[2]);
        else return null;
    }
    // Resizer() resizes items based on the object width divided by the compressor * 10
    function fitText(el, parent, settings) {
        el.css('font-size', '');
        var h = el.outerHeight();
        var ph = parent.height();
        if (ph >= h) return;
        // need calculation
        var fontSize = parseDim(el.css('font-size'));
        if (fontSize === null) // cannot workout this font size
        return;
        function changeDirection() {
            if (h > ph) return -1;
            if (h / ph < settings.heightMinSpace) return 1;
            return 0;
        }
        var changeLimit = 10, changeSize = fontSize, change = fontSize.size, directionPrev = 0, direction = changeDirection();
        do {
            if (direction !== directionPrev) change /= 1.7;
            changeSize = changeSize.plus(change * direction);
            el.css('font-size', changeSize.toString());
            h = el.outerHeight();
            directionPrev = direction;
        }while (--changeLimit > 0 && (direction = changeDirection()) !== 0);
        // если мы шли вверх последний раз, то уменьшимся на полшага, на случай, если перескочили границу
        if (direction > 0) {
            changeSize = changeSize.plus(-change);
            el.css('font-size', changeSize.toString());
        }
    // $this.css('font-size', Math.max(Math.min($this.width() / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
    }
    $.fn.fitText = function(options) {
        // Setup options
        var settings = $.extend({
            minFontSize: Number.NEGATIVE_INFINITY,
            maxFontSize: Number.POSITIVE_INFINITY,
            heightMinSpace: .9
        }, options);
        return this.each(function() {
            // Store the object
            var el = $(this), parent = el.parent();
            // Call once to set.
            fitText(el, parent, settings);
        });
    };
    function fitImage(el, parent, settings) {
        var w = el.width(), pw = parent.width();
        if (w <= 0) return;
        var h = el.height(), ph = parent.height();
        if (h <= 0) return;
        var ratioW = pw / w;
        var ratioH = ph / h;
        var style = {};
        if (ratioW <= ratioH) {
            style.width = '100%';
            style.height = 'auto';
            if (settings.relativePosition) {
                style.top = 100.0 * (ph - h * ratioW) / ph / 2 + '%';
                style.position = 'relative';
            }
        } else {
            style.height = '100%';
            style.width = 'auto';
            if (settings.relativePosition) style.top = 0;
        }
        el.css(style);
        if (settings.show) el.show();
    }
    $.fn.fitImage = function(options) {
        // Setup options
        var settings = $.extend({
            heightMinSpace: .8,
            relativePosition: true,
            show: false
        }, options);
        return this.each(function() {
            // Store the object
            var el = $(this), parent = el.parent();
            var elSrc = this.src;
            if (!elSrc) return;
            el.one("load", function() {
                fitImage(el, parent, settings);
            }).each(function() {
                if (this.complete) $(this).trigger('load');
            });
        });
    };
})(jQuery || $ff311208bcc4bcd7$export$1ea89ccd920d3a7 || window.jQuery);

});

parcelRegister("3wPZM", function(module, exports) {

$parcel$export(module.exports, "Numbers", () => $e7f268f27e8b027c$export$bc00d4d99d9c6e7d);
function $e7f268f27e8b027c$var$nn(v) {
    return v !== null && v !== undefined;
}
const $e7f268f27e8b027c$var$supportsLocaleOptions = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');
let $e7f268f27e8b027c$var$_locale = undefined;
function $e7f268f27e8b027c$var$numberLocale() {
    // const _locale = Cookies.get('_locale') || undefined;
    return $e7f268f27e8b027c$var$_locale;
}
function $e7f268f27e8b027c$var$_toLocaleString(val) {
    if ($e7f268f27e8b027c$var$supportsLocaleOptions) return val.toLocaleString($e7f268f27e8b027c$var$numberLocale());
    return val.toLocaleString();
}
function $e7f268f27e8b027c$var$_toLocaleStringWithDecimalPlaces(val, minDecimalPlaces, maxDecimalPlaces) {
    if ($e7f268f27e8b027c$var$supportsLocaleOptions) {
        if (minDecimalPlaces) minDecimalPlaces = Math.min(minDecimalPlaces, 20);
        if (minDecimalPlaces) maxDecimalPlaces = Math.min(maxDecimalPlaces, 20);
        return val.toLocaleString($e7f268f27e8b027c$var$numberLocale(), {
            minimumFractionDigits: minDecimalPlaces,
            maximumFractionDigits: maxDecimalPlaces
        });
    }
    return val.toFixed(maxDecimalPlaces);
}
function $e7f268f27e8b027c$var$toLocaleString(value, options) {
    const num = Number(value);
    if (isNaN(num)) return value;
    const minDecimalPlaces = options && options.minDecimalPlaces;
    const maxDecimalPlaces = options && options.maxDecimalPlaces;
    if (minDecimalPlaces === undefined || maxDecimalPlaces === undefined) return $e7f268f27e8b027c$var$_toLocaleString(num);
    return $e7f268f27e8b027c$var$_toLocaleStringWithDecimalPlaces(num, minDecimalPlaces, maxDecimalPlaces);
}
function $e7f268f27e8b027c$var$isNumber(n) {
    return n !== null && typeof n === 'number' && !isNaN(n);
}
const $e7f268f27e8b027c$var$expPattern = new RegExp(/(\d+)\.?(\d*)e([+-]*)(\d+)/i);
const $e7f268f27e8b027c$var$fixedPattern = new RegExp(/\d+\.?(\d*)/i);
class $e7f268f27e8b027c$export$bc00d4d99d9c6e7d {
    static toLocaleString(value, options) {
        return $e7f268f27e8b027c$var$toLocaleString(value, options);
    }
    static toFixed(n) {
        const precision = $e7f268f27e8b027c$export$bc00d4d99d9c6e7d.getPrecision(n);
        if (precision === null) return null;
        let toLocaleStringOpts = undefined;
        if (precision > 0) toLocaleStringOpts = {
            minDecimalPlaces: precision,
            maxDecimalPlaces: precision
        };
        return $e7f268f27e8b027c$var$toLocaleString(n, toLocaleStringOpts);
    }
    static toPrecision(n, precision) {
        if (!$e7f268f27e8b027c$var$isNumber(n)) return '';
        return $e7f268f27e8b027c$export$bc00d4d99d9c6e7d.toFixed(Number.parseFloat(n.toPrecision(precision)));
    }
    static isNumber(n) {
        return $e7f268f27e8b027c$var$isNumber(n);
    }
    static toPerc2(value) {
        if ($e7f268f27e8b027c$var$isNumber(value)) return $e7f268f27e8b027c$var$toLocaleString(value * 100, {
            minDecimalPlaces: 2,
            maxDecimalPlaces: 2
        }) + '%';
        return '';
    }
    static toInt(value) {
        if ($e7f268f27e8b027c$var$isNumber(value)) return $e7f268f27e8b027c$var$toLocaleString(Math.round(value));
        return '';
    }
    static toDecimals(value, decimals) {
        if (!decimals) decimals = 2;
        const toLocaleStringOpts = {
            minDecimalPlaces: decimals,
            maxDecimalPlaces: decimals
        };
        return $e7f268f27e8b027c$var$toLocaleString(value, toLocaleStringOpts);
    }
    static toMaxDecimals(value, decimals) {
        const toLocaleStringOpts = {
            minDecimalPlaces: 0,
            maxDecimalPlaces: decimals
        };
        return $e7f268f27e8b027c$var$toLocaleString(value, toLocaleStringOpts);
    }
    static getPrecision(n) {
        if (!$e7f268f27e8b027c$var$nn(n)) return null;
        if (typeof n === 'string') n = parseFloat(n);
        if (!$e7f268f27e8b027c$var$isNumber(n)) return null;
        let str = n.toString();
        // https://gist.github.com/jiggzson/b5f489af9ad931e3d186
        const expMatch = $e7f268f27e8b027c$var$expPattern.exec(str);
        if (expMatch) {
            const coefficientFractionDigits = expMatch[2] !== null ? expMatch[2].length : 0;
            const mantissaFractionCorrection = (expMatch[3] === '-' ? -1 : 1) * parseInt(expMatch[4]);
            return coefficientFractionDigits - mantissaFractionCorrection;
        }
        const fixedMatch = $e7f268f27e8b027c$var$fixedPattern.exec(str);
        if (fixedMatch) return fixedMatch[1] !== null ? fixedMatch[1].length : 0;
        return 0;
    }
    static useLocale(locale) {
        $e7f268f27e8b027c$var$_locale = locale;
    }
}

});

parcelRegister("jR4nF", function(module, exports) {
var $e7465d7d1d7be601$var$COMPLETE = 'complete', $e7465d7d1d7be601$var$CANCELED = 'canceled';
function $e7465d7d1d7be601$var$raf(task) {
    if ('requestAnimationFrame' in window) return window.requestAnimationFrame(task);
    setTimeout(task, 16);
}
function $e7465d7d1d7be601$var$setElementScroll(element, x, y) {
    if (element.self === element) element.scrollTo(x, y);
    else {
        element.scrollLeft = x;
        element.scrollTop = y;
    }
}
function $e7465d7d1d7be601$var$getTargetScrollLocation(scrollSettings, parent) {
    var align = scrollSettings.align, target = scrollSettings.target, targetPosition = target.getBoundingClientRect(), parentPosition, x, y, differenceX, differenceY, targetWidth, targetHeight, leftAlign = align && align.left != null ? align.left : 0.5, topAlign = align && align.top != null ? align.top : 0.5, leftOffset = align && align.leftOffset != null ? align.leftOffset : 0, topOffset = align && align.topOffset != null ? align.topOffset : 0, leftScalar = leftAlign, topScalar = topAlign;
    if (scrollSettings.isWindow(parent)) {
        targetWidth = Math.min(targetPosition.width, parent.innerWidth);
        targetHeight = Math.min(targetPosition.height, parent.innerHeight);
        x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar;
        y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar;
        x -= leftOffset;
        y -= topOffset;
        x = scrollSettings.align.lockX ? parent.pageXOffset : x;
        y = scrollSettings.align.lockY ? parent.pageYOffset : y;
        differenceX = x - parent.pageXOffset;
        differenceY = y - parent.pageYOffset;
    } else {
        targetWidth = targetPosition.width;
        targetHeight = targetPosition.height;
        parentPosition = parent.getBoundingClientRect();
        var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
        var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
        x = offsetLeft + targetWidth * leftScalar - parent.clientWidth * leftScalar;
        y = offsetTop + targetHeight * topScalar - parent.clientHeight * topScalar;
        x -= leftOffset;
        y -= topOffset;
        x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
        y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
        x = scrollSettings.align.lockX ? parent.scrollLeft : x;
        y = scrollSettings.align.lockY ? parent.scrollTop : y;
        differenceX = x - parent.scrollLeft;
        differenceY = y - parent.scrollTop;
    }
    return {
        x: x,
        y: y,
        differenceX: differenceX,
        differenceY: differenceY
    };
}
function $e7465d7d1d7be601$var$animate(parent) {
    var scrollSettings = parent._scrollSettings;
    if (!scrollSettings) return;
    var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments;
    var location = $e7465d7d1d7be601$var$getTargetScrollLocation(scrollSettings, parent), time = Date.now() - scrollSettings.startTime, timeValue = Math.min(1 / scrollSettings.time * time, 1);
    if (scrollSettings.endIterations >= maxSynchronousAlignments) {
        $e7465d7d1d7be601$var$setElementScroll(parent, location.x, location.y);
        parent._scrollSettings = null;
        return scrollSettings.end($e7465d7d1d7be601$var$COMPLETE);
    }
    var easeValue = 1 - scrollSettings.ease(timeValue);
    $e7465d7d1d7be601$var$setElementScroll(parent, location.x - location.differenceX * easeValue, location.y - location.differenceY * easeValue);
    if (time >= scrollSettings.time) {
        scrollSettings.endIterations++;
        // Align ancestor synchronously
        scrollSettings.scrollAncestor && $e7465d7d1d7be601$var$animate(scrollSettings.scrollAncestor);
        $e7465d7d1d7be601$var$animate(parent);
        return;
    }
    $e7465d7d1d7be601$var$raf($e7465d7d1d7be601$var$animate.bind(null, parent));
}
function $e7465d7d1d7be601$var$defaultIsWindow(target) {
    return target.self === target;
}
function $e7465d7d1d7be601$var$transitionScrollTo(target, parent, settings, scrollAncestor, callback) {
    var idle = !parent._scrollSettings, lastSettings = parent._scrollSettings, now = Date.now(), cancelHandler, passiveOptions = {
        passive: true
    };
    if (lastSettings) lastSettings.end($e7465d7d1d7be601$var$CANCELED);
    function end(endType) {
        parent._scrollSettings = null;
        if (parent.parentElement && parent.parentElement._scrollSettings) parent.parentElement._scrollSettings.end(endType);
        if (settings.debug) console.log('Scrolling ended with type', endType, 'for', parent);
        callback(endType);
        if (cancelHandler) {
            parent.removeEventListener('touchstart', cancelHandler, passiveOptions);
            parent.removeEventListener('wheel', cancelHandler, passiveOptions);
        }
    }
    var maxSynchronousAlignments = settings.maxSynchronousAlignments;
    if (maxSynchronousAlignments == null) maxSynchronousAlignments = 3;
    parent._scrollSettings = {
        startTime: now,
        endIterations: 0,
        target: target,
        time: settings.time,
        ease: settings.ease,
        align: settings.align,
        isWindow: settings.isWindow || $e7465d7d1d7be601$var$defaultIsWindow,
        maxSynchronousAlignments: maxSynchronousAlignments,
        end: end,
        scrollAncestor: scrollAncestor
    };
    if (!('cancellable' in settings) || settings.cancellable) {
        cancelHandler = end.bind(null, $e7465d7d1d7be601$var$CANCELED);
        parent.addEventListener('touchstart', cancelHandler, passiveOptions);
        parent.addEventListener('wheel', cancelHandler, passiveOptions);
    }
    if (idle) $e7465d7d1d7be601$var$animate(parent);
    return cancelHandler;
}
function $e7465d7d1d7be601$var$defaultIsScrollable(element) {
    return 'pageXOffset' in element || (element.scrollHeight !== element.clientHeight || element.scrollWidth !== element.clientWidth) && getComputedStyle(element).overflow !== 'hidden';
}
function $e7465d7d1d7be601$var$defaultValidTarget() {
    return true;
}
function $e7465d7d1d7be601$var$findParentElement(el) {
    if (el.assignedSlot) return $e7465d7d1d7be601$var$findParentElement(el.assignedSlot);
    if (el.parentElement) {
        if (el.parentElement.tagName.toLowerCase() === 'body') return el.parentElement.ownerDocument.defaultView || el.parentElement.ownerDocument.ownerWindow;
        return el.parentElement;
    }
    if (el.getRootNode) {
        var parent = el.getRootNode();
        if (parent.nodeType === 11) return parent.host;
    }
}
module.exports = function(target, settings, callback) {
    if (!target) return;
    if (typeof settings === 'function') {
        callback = settings;
        settings = null;
    }
    if (!settings) settings = {};
    settings.time = isNaN(settings.time) ? 1000 : settings.time;
    settings.ease = settings.ease || function(v) {
        return 1 - Math.pow(1 - v, v / 2);
    };
    settings.align = settings.align || {};
    var parent = $e7465d7d1d7be601$var$findParentElement(target), parents = 1;
    function done(endType) {
        parents--;
        if (!parents) callback && callback(endType);
    }
    var validTarget = settings.validTarget || $e7465d7d1d7be601$var$defaultValidTarget;
    var isScrollable = settings.isScrollable;
    if (settings.debug) {
        console.log('About to scroll to', target);
        if (!parent) console.error('Target did not have a parent, is it mounted in the DOM?');
    }
    var scrollingElements = [];
    while(parent){
        if (settings.debug) console.log('Scrolling parent node', parent);
        if (validTarget(parent, parents) && (isScrollable ? isScrollable(parent, $e7465d7d1d7be601$var$defaultIsScrollable) : $e7465d7d1d7be601$var$defaultIsScrollable(parent))) {
            parents++;
            scrollingElements.push(parent);
        }
        parent = $e7465d7d1d7be601$var$findParentElement(parent);
        if (!parent) {
            done($e7465d7d1d7be601$var$COMPLETE);
            break;
        }
    }
    return scrollingElements.reduce((cancel, parent, index)=>$e7465d7d1d7be601$var$transitionScrollTo(target, parent, settings, scrollingElements[index + 1], done), null);
};

});


parcelRegister("az74n", function(module, exports) {

$parcel$export(module.exports, "normalizeSideTextHtml", () => $7b12a824f2e13341$export$8afbc6ddd7adce72);
$parcel$export(module.exports, "configureSideTextEditor", () => $7b12a824f2e13341$export$a302becd7150346f);

var $aZja8 = parcelRequire("aZja8");

var $9BoH8 = parcelRequire("9BoH8");

var $8kCkB = parcelRequire("8kCkB");

var $9KTUI = parcelRequire("9KTUI");

var $dVG9S = parcelRequire("dVG9S");

var $1Vkfg = parcelRequire("1Vkfg");

var $5RaIK = parcelRequire("5RaIK");
class $7b12a824f2e13341$var$EditCardBubbleMenu {
    constructor(){
        this.buttons = [
            {
                class: "tippy-button--bold",
                content: `<span class="fa fa-bold"></span>`,
                click: (editor)=>editor.chain().focus().toggleBold().run(),
                isActive: (editor)=>editor.isActive('bold')
            },
            {
                class: "tippy-button--italic",
                content: `<span class="fa fa-italic"></span>`,
                click: (editor)=>editor.chain().focus().toggleItalic().run(),
                isActive: (editor)=>editor.isActive('italic')
            },
            {
                class: "tippy-button--underline",
                content: `<span class="fa fa-underline"></span>`,
                click: (editor)=>editor.chain().focus().toggleUnderline().run(),
                isActive: (editor)=>editor.isActive('underline')
            },
            {
                class: "tippy-button--subscript",
                content: `x<sub>2</sub>`,
                click: (editor)=>editor.chain().focus().toggleSubscript().run(),
                isActive: (editor)=>editor.isActive('subscript')
            },
            {
                class: "tippy-button--superscript",
                content: `x<sup>2</sup>`,
                click: (editor)=>editor.chain().focus().toggleSuperscript().run(),
                isActive: (editor)=>editor.isActive('superscript')
            },
            {
                class: "tippy-button--circle",
                content: `<span class="tippy-button--circle-red"></span>`,
                click: (editor)=>editor.chain().focus().toggleTextBackground('red').run(),
                isActive: (editor)=>editor.isActive('textBackground', {
                        color: 'red'
                    })
            },
            {
                class: "tippy-button--circle",
                content: `<span class="tippy-button--circle-blue"></span>`,
                click: (editor)=>editor.chain().focus().toggleTextBackground('blue').run(),
                isActive: (editor)=>editor.isActive('textBackground', {
                        color: 'blue'
                    })
            },
            {
                class: "tippy-button--circle",
                content: `<span class="tippy-button--circle-yellow"></span>`,
                click: (editor)=>editor.chain().focus().toggleTextBackground('yellow').run(),
                isActive: (editor)=>editor.isActive('textBackground', {
                        color: 'yellow'
                    })
            },
            {
                class: "tippy-button--circle",
                content: `<span class="tippy-button--circle-green"></span>`,
                click: (editor)=>editor.chain().focus().toggleTextBackground('green').run(),
                isActive: (editor)=>editor.isActive('textBackground', {
                        color: 'green'
                    })
            },
            {
                class: "",
                content: `<span class="fal fa-remove-format"></span>`,
                click: (editor)=>editor.chain().focus().unsetAllMarks().run(),
                isActive: ()=>false
            }
        ];
    }
    create(editor) {
        const menu = document.createElement("div");
        menu.innerHTML = this.buttons.map((button, index)=>`<button type="button" class="tippy-button ${button.class}" data-menu-button="${index}">${button.content}</button>`).join("");
        menu.addEventListener('click', (ev)=>this.handleClick(ev, editor));
        return menu;
    }
    getTargetButtonFromElement(element) {
        const button = element.getAttribute('data-menu-button') || '';
        return /^\d+$/.test(button) ? this.buttons[parseInt(button)] : null;
    }
    getTargetButtonFromEvent(event) {
        let path = [];
        if ('composedPath' in event) path = event.composedPath();
        if (!path && 'deepPath' in event) path = event.deepPath;
        const buttonElement = path.filter((el, index)=>index <= 2).find((el)=>el.tagName === 'BUTTON' && el.hasAttribute("data-menu-button"));
        return buttonElement ? this.getTargetButtonFromElement(buttonElement) : null;
    }
    handleClick(ev, editor) {
        const button = this.getTargetButtonFromEvent(ev);
        if (button) button.click(editor);
    }
    update(content, editor) {
        content.querySelectorAll('button').forEach((node)=>{
            const button = this.getTargetButtonFromElement(node);
            if (button) node.classList.toggle('is-active', button.isActive(editor));
        });
    }
}
const $7b12a824f2e13341$var$editCardBubbleMenu = new $7b12a824f2e13341$var$EditCardBubbleMenu();
const $7b12a824f2e13341$var$DefaultOptions = {
    insertBefore: false
};
function $7b12a824f2e13341$export$8afbc6ddd7adce72(editor) {
    let html = editor.getHTML();
    // remove empty line from start and end
    return html.replace(/(<p><\/p>)+$/, "").replace(/^(<p><\/p>)+/, "").trim();
}
function $7b12a824f2e13341$export$a302becd7150346f(textarea, createOptions = $7b12a824f2e13341$var$DefaultOptions) {
    const createOptionsResolved = Object.assign(Object.assign({}, $7b12a824f2e13341$var$DefaultOptions), createOptions);
    const textareaParent = textarea.parentElement;
    if (!textareaParent) return;
    const textareaName = textarea.getAttribute('name');
    const textareaHasError = textarea.classList.contains('is-invalid');
    const textareaHtmlFlag = textareaParent.querySelector(`input[name="${textareaName}H"]`);
    if (!textareaHtmlFlag) return;
    const editorContent = textareaHtmlFlag.value === 'false' ? textarea.innerHTML : textarea.value;
    const editor = new (0, $aZja8.Editor)({
        element: textareaParent,
        content: editorContent,
        injectCSS: false,
        enableInputRules: false,
        enablePasteRules: false,
        extensions: [
            (0, $9BoH8.default),
            (0, $8kCkB.default),
            (0, $9KTUI.default),
            (0, $dVG9S.default),
            (0, $1Vkfg.TextBackground),
            (0, $5RaIK.BubbleLikeMenu).configure({
                updateContent: (content)=>$7b12a824f2e13341$var$editCardBubbleMenu.update(content, editor),
                createContent: ()=>$7b12a824f2e13341$var$editCardBubbleMenu.create(editor)
            })
        ],
        onCreate ({ editor: editor }) {
            // двигаем в начало
            if (textareaHasError || createOptionsResolved.insertBefore) textarea.before(editor.view.dom);
            if (textareaHasError) editor.view.dom.classList.add('is-invalid');
        },
        onUpdate ({ editor: editor }) {
            textarea.value = $7b12a824f2e13341$export$8afbc6ddd7adce72(editor);
            textareaHtmlFlag.value = 'true';
        }
    });
}

});
parcelRegister("aZja8", function(module, exports) {

$parcel$export(module.exports, "getExtensionField", () => $7ffe772c051bfcca$export$f73578b718a57eaa);
$parcel$export(module.exports, "mergeAttributes", () => $7ffe772c051bfcca$export$9f98db6234c4bd78);
$parcel$export(module.exports, "callOrReturn", () => $7ffe772c051bfcca$export$592682234826c0bd);
$parcel$export(module.exports, "Mark", () => $7ffe772c051bfcca$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "Extension", () => $7ffe772c051bfcca$export$eeddbf09bb970356);
$parcel$export(module.exports, "getTextSerializersFromSchema", () => $7ffe772c051bfcca$export$fdd92b7d22ac071c);
$parcel$export(module.exports, "isTextSelection", () => $7ffe772c051bfcca$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "getText", () => $7ffe772c051bfcca$export$c72d34660a162238);
$parcel$export(module.exports, "isNodeSelection", () => $7ffe772c051bfcca$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "posToDOMRect", () => $7ffe772c051bfcca$export$660ecae6cde71645);
$parcel$export(module.exports, "Editor", () => $7ffe772c051bfcca$export$7cda8d932e2f33c0);
$parcel$export(module.exports, "markInputRule", () => $7ffe772c051bfcca$export$9f2cb743ab9131de);
$parcel$export(module.exports, "nodeInputRule", () => $7ffe772c051bfcca$export$6ca56856dfeaf9b6);
$parcel$export(module.exports, "textblockTypeInputRule", () => $7ffe772c051bfcca$export$cc081314d3f6ffb0);
$parcel$export(module.exports, "wrappingInputRule", () => $7ffe772c051bfcca$export$f7316d89abe4e1c1);
$parcel$export(module.exports, "Node", () => $7ffe772c051bfcca$export$85c928794f8d04d4);
$parcel$export(module.exports, "NodeView", () => $7ffe772c051bfcca$export$77c6811359a01a6f);
$parcel$export(module.exports, "markPasteRule", () => $7ffe772c051bfcca$export$3845eb97abe74944);
parcelRequire("goWEd");
var $eCBI9 = parcelRequire("eCBI9");
parcelRequire("5UVCb");
var $fYi0r = parcelRequire("fYi0r");
parcelRequire("bu3v1");
var $7kaZl = parcelRequire("7kaZl");
parcelRequire("jJg9y");
var $jcs10 = parcelRequire("jcs10");
parcelRequire("optiF");
var $cMB55 = parcelRequire("cMB55");
parcelRequire("i1bXU");
var $g6HTq = parcelRequire("g6HTq");
parcelRequire("53jUT");
var $cWB7z = parcelRequire("cWB7z");
/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */ function $7ffe772c051bfcca$export$83e24c5933427696(config) {
    const { state: state, transaction: transaction } = config;
    let { selection: selection } = transaction;
    let { doc: doc } = transaction;
    let { storedMarks: storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks () {
            return storedMarks;
        },
        get selection () {
            return selection;
        },
        get doc () {
            return doc;
        },
        get tr () {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        }
    };
}
class $7ffe772c051bfcca$export$475014de15a4c342 {
    constructor(props){
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const { tr: tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            const method = (...args)=>{
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) view.dispatch(tr);
                return callback;
            };
            return [
                name,
                method
            ];
        }));
    }
    get chain() {
        return ()=>this.createChain();
    }
    get can() {
        return ()=>this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = ()=>{
            if (!hasStartTransaction && shouldDispatch && !tr.getMeta('preventDispatch') && !this.hasCustomState) view.dispatch(tr);
            return callbacks.every((callback)=>callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                const chainedCommand = (...args)=>{
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [
                    name,
                    chainedCommand
                ];
            })),
            run: run
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands: rawCommands, state: state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            return [
                name,
                (...args)=>command(...args)({
                        ...props,
                        dispatch: undefined
                    })
            ];
        }));
        return {
            ...formattedCommands,
            chain: ()=>this.createChain(tr, dispatch)
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const props = {
            tr: tr,
            editor: editor,
            view: view,
            state: $7ffe772c051bfcca$export$83e24c5933427696({
                state: state,
                transaction: tr
            }),
            dispatch: shouldDispatch ? ()=>undefined : undefined,
            chain: ()=>this.createChain(tr, shouldDispatch),
            can: ()=>this.createCan(tr),
            get commands () {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                    return [
                        name,
                        (...args)=>command(...args)(props)
                    ];
                }));
            }
        };
        return props;
    }
}
class $7ffe772c051bfcca$var$EventEmitter {
    constructor(){
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) this.callbacks[event] = [];
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) callbacks.forEach((callback)=>callback.apply(this, args));
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) this.callbacks[event] = callbacks.filter((callback)=>callback !== fn);
            else delete this.callbacks[event];
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args)=>{
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */ function $7ffe772c051bfcca$export$f73578b718a57eaa(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) return $7ffe772c051bfcca$export$f73578b718a57eaa(extension.parent, field, context);
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent ? $7ffe772c051bfcca$export$f73578b718a57eaa(extension.parent, field, context) : null
        });
        return value;
    }
    return extension.config[field];
}
function $7ffe772c051bfcca$export$36e8c2990da8266f(extensions) {
    const baseExtensions = extensions.filter((extension)=>extension.type === 'extension');
    const nodeExtensions = extensions.filter((extension)=>extension.type === 'node');
    const markExtensions = extensions.filter((extension)=>extension.type === 'mark');
    return {
        baseExtensions: baseExtensions,
        nodeExtensions: nodeExtensions,
        markExtensions: markExtensions
    };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */ function $7ffe772c051bfcca$export$6e54e3e69d60df3d(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $7ffe772c051bfcca$export$36e8c2990da8266f(extensions);
    const nodeAndMarkExtensions = [
        ...nodeExtensions,
        ...markExtensions
    ];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false
    };
    extensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions
        };
        const addGlobalAttributes = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) return;
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach((globalAttribute)=>{
            globalAttribute.types.forEach((type)=>{
                Object.entries(globalAttribute.attributes).forEach(([name, attribute])=>{
                    extensionAttributes.push({
                        type: type,
                        name: name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute
                        }
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addAttributes = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addAttributes', context);
        if (!addAttributes) return;
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object.entries(attributes).forEach(([name, attribute])=>{
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') mergedAttr.default = mergedAttr.default();
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) delete mergedAttr.default;
            extensionAttributes.push({
                type: extension.name,
                name: name,
                attribute: mergedAttr
            });
        });
    });
    return extensionAttributes;
}
function $7ffe772c051bfcca$export$d168cba70360dd3d(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}
function $7ffe772c051bfcca$export$9f98db6234c4bd78(...objects) {
    return objects.filter((item)=>!!item).reduce((items, item)=>{
        const mergedAttributes = {
            ...items
        };
        Object.entries(item).forEach(([key, value])=>{
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                const valueClasses = value ? String(value).split(' ') : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
                const insertClasses = valueClasses.filter((valueClass)=>!existingClasses.includes(valueClass));
                mergedAttributes[key] = [
                    ...existingClasses,
                    ...insertClasses
                ].join(' ');
            } else if (key === 'style') {
                const newStyles = value ? value.split(';').map((style)=>style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map((style)=>style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach((style)=>{
                    const [property, val] = style.split(':').map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach((style)=>{
                    const [property, val] = style.split(':').map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val])=>`${property}: ${val}`).join('; ');
            } else mergedAttributes[key] = value;
        });
        return mergedAttributes;
    }, {});
}
function $7ffe772c051bfcca$export$bc79d84a417d7b02(nodeOrMark, extensionAttributes) {
    return extensionAttributes.filter((attribute)=>attribute.type === nodeOrMark.type.name).filter((item)=>item.attribute.rendered).map((item)=>{
        if (!item.attribute.renderHTML) return {
            [item.name]: nodeOrMark.attrs[item.name]
        };
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    }).reduce((attributes, attribute)=>$7ffe772c051bfcca$export$9f98db6234c4bd78(attributes, attribute), {});
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $7ffe772c051bfcca$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */ function $7ffe772c051bfcca$export$592682234826c0bd(value, context, ...props) {
    if ($7ffe772c051bfcca$export$f6e2535fb5126e54(value)) {
        if (context) return value.bind(context)(...props);
        return value(...props);
    }
    return value;
}
function $7ffe772c051bfcca$export$83b788b1a3698c03(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}
function $7ffe772c051bfcca$export$3004f64547af360e(value) {
    if (typeof value !== 'string') return value;
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) return Number(value);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */ function $7ffe772c051bfcca$export$7ce6b571718439ec(parseRule, extensionAttributes) {
    if ('style' in parseRule) return parseRule;
    return {
        ...parseRule,
        getAttrs: (node)=>{
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) return false;
            const newAttributes = extensionAttributes.reduce((items, item)=>{
                const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : $7ffe772c051bfcca$export$3004f64547af360e(node.getAttribute(item.name));
                if (value === null || value === undefined) return items;
                return {
                    ...items,
                    [item.name]: value
                };
            }, {});
            return {
                ...oldAttributes,
                ...newAttributes
            };
        }
    };
}
function $7ffe772c051bfcca$var$cleanUpSchemaItem(data) {
    return Object.fromEntries(// @ts-ignore
    Object.entries(data).filter(([key, value])=>{
        if (key === 'attrs' && $7ffe772c051bfcca$export$83b788b1a3698c03(value)) return false;
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */ function $7ffe772c051bfcca$export$71bc12a97b59a858(extensions, editor) {
    var _a;
    const allAttributes = $7ffe772c051bfcca$export$6e54e3e69d60df3d(extensions);
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $7ffe772c051bfcca$export$36e8c2990da8266f(extensions);
    const topNode = (_a = nodeExtensions.find((extension)=>$7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraNodeFields = extensions.reduce((fields, e)=>{
            const extendNodeSchema = $7ffe772c051bfcca$export$f73578b718a57eaa(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...extendNodeSchema ? extendNodeSchema(extension) : {}
            };
        }, {});
        const schema = $7ffe772c051bfcca$var$cleanUpSchemaItem({
            ...extraNodeFields,
            content: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'content', context)),
            marks: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'marks', context)),
            group: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'group', context)),
            inline: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'inline', context)),
            atom: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'atom', context)),
            selectable: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'selectable', context)),
            draggable: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'draggable', context)),
            code: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'code', context)),
            whitespace: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'whitespace', context)),
            linebreakReplacement: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'linebreakReplacement', context)),
            defining: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'defining', context)),
            isolating: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'parseHTML', context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$7ffe772c051bfcca$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'renderHTML', context);
        if (renderHTML) schema.toDOM = (node)=>renderHTML({
                node: node,
                HTMLAttributes: $7ffe772c051bfcca$export$bc79d84a417d7b02(node, extensionAttributes)
            });
        const renderText = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'renderText', context);
        if (renderText) schema.toText = renderText;
        return [
            extension.name,
            schema
        ];
    }));
    const marks = Object.fromEntries(markExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraMarkFields = extensions.reduce((fields, e)=>{
            const extendMarkSchema = $7ffe772c051bfcca$export$f73578b718a57eaa(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...extendMarkSchema ? extendMarkSchema(extension) : {}
            };
        }, {});
        const schema = $7ffe772c051bfcca$var$cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'inclusive', context)),
            excludes: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'excludes', context)),
            group: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'group', context)),
            spanning: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'spanning', context)),
            code: $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'parseHTML', context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$7ffe772c051bfcca$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'renderHTML', context);
        if (renderHTML) schema.toDOM = (mark)=>renderHTML({
                mark: mark,
                HTMLAttributes: $7ffe772c051bfcca$export$bc79d84a417d7b02(mark, extensionAttributes)
            });
        return [
            extension.name,
            schema
        ];
    }));
    return new (0, $jcs10.Schema)({
        topNode: topNode,
        nodes: nodes,
        marks: marks
    });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */ function $7ffe772c051bfcca$export$ea18268b31f54e5(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}
function $7ffe772c051bfcca$export$79b791167b05aada(extension, enabled) {
    if (Array.isArray(enabled)) return enabled.some((enabledExtension)=>{
        const name = typeof enabledExtension === 'string' ? enabledExtension : enabledExtension.name;
        return name === extension.name;
    });
    return enabled;
}
function $7ffe772c051bfcca$export$d1b60002472b2c81(fragment, schema) {
    const documentFragment = (0, $jcs10.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */ const $7ffe772c051bfcca$export$a3e238086d556fa9 = ($from, maxMatch = 500)=>{
    let textBefore = '';
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index)=>{
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node: node,
            pos: pos,
            parent: parent,
            index: index
        })) || node.textContent || '%leaf%';
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};
function $7ffe772c051bfcca$export$49841c62b9eff15(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
class $7ffe772c051bfcca$export$9b55e2b000ad65f2 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $7ffe772c051bfcca$var$inputRuleMatcherHandler = (text, find)=>{
    if ($7ffe772c051bfcca$export$49841c62b9eff15(find)) return find.exec(text);
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) return null;
    const result = [
        inputRuleMatch.text
    ];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function $7ffe772c051bfcca$var$run$1(config) {
    var _a;
    const { editor: editor, from: from, to: to, text: text, rules: rules, plugin: plugin } = config;
    const { view: view } = editor;
    if (view.composing) return false;
    const $from = view.state.doc.resolve(from);
    if (// check for code node
    $from.parent.type.spec.code || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find((mark)=>mark.type.spec.code))) return false;
    let matched = false;
    const textBefore = $7ffe772c051bfcca$export$a3e238086d556fa9($from) + text;
    rules.forEach((rule)=>{
        if (matched) return;
        const match = $7ffe772c051bfcca$var$inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) return;
        const tr = view.state.tr;
        const state = $7ffe772c051bfcca$export$83e24c5933427696({
            state: view.state,
            transaction: tr
        });
        const range = {
            from: from - (match[0].length - text.length),
            to: to
        };
        const { commands: commands, chain: chain, can: can } = new $7ffe772c051bfcca$export$475014de15a4c342({
            editor: editor,
            state: state
        });
        const handler = rule.handler({
            state: state,
            range: range,
            match: match,
            commands: commands,
            chain: chain,
            can: can
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) return;
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */ function $7ffe772c051bfcca$export$f2a821f78e918151(props) {
    const { editor: editor, rules: rules } = props;
    const plugin = new (0, $eCBI9.Plugin)({
        state: {
            init () {
                return null;
            },
            apply (tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) return stored;
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta('applyInputRules');
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) setTimeout(()=>{
                    let { text: text } = simulatedInputMeta;
                    if (typeof text === 'string') text;
                    else text = $7ffe772c051bfcca$export$d1b60002472b2c81((0, $jcs10.Fragment).from(text), state.schema);
                    const { from: from } = simulatedInputMeta;
                    const to = from + text.length;
                    $7ffe772c051bfcca$var$run$1({
                        editor: editor,
                        from: from,
                        to: to,
                        text: text,
                        rules: rules,
                        plugin: plugin
                    });
                });
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                return $7ffe772c051bfcca$var$run$1({
                    editor: editor,
                    from: from,
                    to: to,
                    text: text,
                    rules: rules,
                    plugin: plugin
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const { $cursor: $cursor } = view.state.selection;
                        if ($cursor) $7ffe772c051bfcca$var$run$1({
                            editor: editor,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: '',
                            rules: rules,
                            plugin: plugin
                        });
                    });
                    return false;
                }
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown (view, event) {
                if (event.key !== 'Enter') return false;
                const { $cursor: $cursor } = view.state.selection;
                if ($cursor) return $7ffe772c051bfcca$var$run$1({
                    editor: editor,
                    from: $cursor.pos,
                    to: $cursor.pos,
                    text: '\n',
                    rules: rules,
                    plugin: plugin
                });
                return false;
            }
        },
        // @ts-ignore
        isInputRules: true
    });
    return plugin;
}
// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function $7ffe772c051bfcca$var$getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $7ffe772c051bfcca$export$53b83ca8eaab0383(value) {
    if ($7ffe772c051bfcca$var$getType(value) !== 'Object') return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function $7ffe772c051bfcca$export$dd702b3c8240390c(target, source) {
    const output = {
        ...target
    };
    if ($7ffe772c051bfcca$export$53b83ca8eaab0383(target) && $7ffe772c051bfcca$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($7ffe772c051bfcca$export$53b83ca8eaab0383(source[key]) && $7ffe772c051bfcca$export$53b83ca8eaab0383(target[key])) output[key] = $7ffe772c051bfcca$export$dd702b3c8240390c(target[key], source[key]);
        else output[key] = source[key];
    });
    return output;
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $7ffe772c051bfcca$export$c9d15bcfc6d42044 {
    constructor(config = {}){
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $7ffe772c051bfcca$export$c9d15bcfc6d42044(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $7ffe772c051bfcca$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $7ffe772c051bfcca$export$c9d15bcfc6d42044(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    static handleExit({ editor: editor, mark: mark }) {
        const { tr: tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) return false;
            const removeMark = currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) tr.removeStoredMark(removeMark);
            tr.insertText(' ', currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}
function $7ffe772c051bfcca$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ class $7ffe772c051bfcca$export$e75df4392d073e98 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $7ffe772c051bfcca$var$pasteRuleMatcherHandler = (text, find, event)=>{
    if ($7ffe772c051bfcca$export$49841c62b9eff15(find)) return [
        ...text.matchAll(find)
    ];
    const matches = find(text, event);
    if (!matches) return [];
    return matches.map((pasteRuleMatch)=>{
        const result = [
            pasteRuleMatch.text
        ];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function $7ffe772c051bfcca$var$run(config) {
    const { editor: editor, state: state, from: from, to: to, rule: rule, pasteEvent: pasteEvent, dropEvent: dropEvent } = config;
    const { commands: commands, chain: chain, can: can } = new $7ffe772c051bfcca$export$475014de15a4c342({
        editor: editor,
        state: state
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isTextblock || node.type.spec.code) return;
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = $7ffe772c051bfcca$var$pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach((match)=>{
            if (match.index === undefined) return;
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end)
            };
            const handler = rule.handler({
                state: state,
                range: range,
                match: match,
                commands: commands,
                chain: chain,
                can: can,
                pasteEvent: pasteEvent,
                dropEvent: dropEvent
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every((handler)=>handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let $7ffe772c051bfcca$var$tiptapDragFromOtherEditor = null;
const $7ffe772c051bfcca$var$createClipboardPasteEvent = (text)=>{
    var _a;
    const event = new ClipboardEvent('paste', {
        clipboardData: new DataTransfer()
    });
    (_a = event.clipboardData) === null || _a === void 0 || _a.setData('text/html', text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */ function $7ffe772c051bfcca$export$458282b0dddaaaa4(props) {
    const { editor: editor, rules: rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    } catch  {
        dropEvent = null;
    }
    const processEvent = ({ state: state, from: from, to: to, rule: rule, pasteEvt: pasteEvt })=>{
        const tr = state.tr;
        const chainableState = $7ffe772c051bfcca$export$83e24c5933427696({
            state: state,
            transaction: tr
        });
        const handler = $7ffe772c051bfcca$var$run({
            editor: editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule: rule,
            pasteEvent: pasteEvt,
            dropEvent: dropEvent
        });
        if (!handler || !tr.steps.length) return;
        try {
            dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
        } catch  {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
        return tr;
    };
    const plugins = rules.map((rule)=>{
        return new (0, $eCBI9.Plugin)({
            // we register a global drag handler to track the current drag source element
            view (view) {
                const handleDragstart = (event)=>{
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
                    if (dragSourceElement) $7ffe772c051bfcca$var$tiptapDragFromOtherEditor = editor;
                };
                const handleDragend = ()=>{
                    if ($7ffe772c051bfcca$var$tiptapDragFromOtherEditor) $7ffe772c051bfcca$var$tiptapDragFromOtherEditor = null;
                };
                window.addEventListener('dragstart', handleDragstart);
                window.addEventListener('dragend', handleDragend);
                return {
                    destroy () {
                        window.removeEventListener('dragstart', handleDragstart);
                        window.removeEventListener('dragend', handleDragend);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event)=>{
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = $7ffe772c051bfcca$var$tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor) // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                            setTimeout(()=>{
                                const selection = dragFromOtherEditor.state.selection;
                                if (selection) dragFromOtherEditor.commands.deleteRange({
                                    from: selection.from,
                                    to: selection.to
                                });
                            }, 10);
                        }
                        return false;
                    },
                    paste: (_view, event)=>{
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    }
                }
            },
            appendTransaction: (transactions, oldState, state)=>{
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta('applyPasteRules');
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) return;
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text: text } = simulatedPasteMeta;
                    if (typeof text === 'string') text;
                    else text = $7ffe772c051bfcca$export$d1b60002472b2c81((0, $jcs10.Fragment).from(text), state.schema);
                    const { from: from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = $7ffe772c051bfcca$var$createClipboardPasteEvent(text);
                    return processEvent({
                        rule: rule,
                        state: state,
                        from: from,
                        to: {
                            b: to
                        },
                        pasteEvt: pasteEvt
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!$7ffe772c051bfcca$export$7e4aa119212bc614(from) || !to || from === to.b) return;
                return processEvent({
                    rule: rule,
                    state: state,
                    from: from,
                    to: to,
                    pasteEvt: pasteEvent
                });
            }
        });
    });
    return plugins;
}
function $7ffe772c051bfcca$export$15704658c784aef1(items) {
    const filtered = items.filter((el, index)=>items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}
class $7ffe772c051bfcca$var$ExtensionManager {
    constructor(extensions, editor){
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = $7ffe772c051bfcca$var$ExtensionManager.resolve(extensions);
        this.schema = $7ffe772c051bfcca$export$71bc12a97b59a858(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */ static resolve(extensions) {
        const resolvedExtensions = $7ffe772c051bfcca$var$ExtensionManager.sort($7ffe772c051bfcca$var$ExtensionManager.flatten(extensions));
        const duplicatedNames = $7ffe772c051bfcca$export$15704658c784aef1(resolvedExtensions.map((extension)=>extension.name));
        if (duplicatedNames.length) console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item)=>`'${item}'`).join(', ')}]. This can lead to issues.`);
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */ static flatten(extensions) {
        return extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage
            };
            const addExtensions = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addExtensions', context);
            if (addExtensions) return [
                extension,
                ...this.flatten(addExtensions())
            ];
            return extension;
        })// `Infinity` will break TypeScript so we set a number that is probably high enough
        .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */ static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b)=>{
            const priorityA = $7ffe772c051bfcca$export$f73578b718a57eaa(a, 'priority') || defaultPriority;
            const priorityB = $7ffe772c051bfcca$export$f73578b718a57eaa(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) return -1;
            if (priorityA < priorityB) return 1;
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */ get commands() {
        return this.extensions.reduce((commands, extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $7ffe772c051bfcca$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const addCommands = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addCommands', context);
            if (!addCommands) return commands;
            return {
                ...commands,
                ...addCommands()
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */ get plugins() {
        const { editor: editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = $7ffe772c051bfcca$var$ExtensionManager.sort([
            ...this.extensions
        ].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $7ffe772c051bfcca$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const plugins = [];
            const addKeyboardShortcuts = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addKeyboardShortcuts', context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === 'mark' && $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'exitable', context)) defaultBindings.ArrowRight = ()=>$7ffe772c051bfcca$export$c9d15bcfc6d42044.handleExit({
                    editor: editor,
                    mark: extension
                });
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method])=>{
                    return [
                        shortcut,
                        ()=>method({
                                editor: editor
                            })
                    ];
                }));
                defaultBindings = {
                    ...defaultBindings,
                    ...bindings
                };
            }
            const keyMapPlugin = (0, $7kaZl.keymap)(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addInputRules', context);
            if ($7ffe772c051bfcca$export$79b791167b05aada(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
            const addPasteRules = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addPasteRules', context);
            if ($7ffe772c051bfcca$export$79b791167b05aada(extension, editor.options.enablePasteRules) && addPasteRules) pasteRules.push(...addPasteRules());
            const addProseMirrorPlugins = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        }).flat();
        return [
            $7ffe772c051bfcca$export$f2a821f78e918151({
                editor: editor,
                rules: inputRules
            }),
            ...$7ffe772c051bfcca$export$458282b0dddaaaa4({
                editor: editor,
                rules: pasteRules
            }),
            ...allPlugins
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */ get attributes() {
        return $7ffe772c051bfcca$export$6e54e3e69d60df3d(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */ get nodeViews() {
        const { editor: editor } = this;
        const { nodeExtensions: nodeExtensions } = $7ffe772c051bfcca$export$36e8c2990da8266f(this.extensions);
        return Object.fromEntries(nodeExtensions.filter((extension)=>!!$7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addNodeView')).map((extension)=>{
            const extensionAttributes = this.attributes.filter((attribute)=>attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $7ffe772c051bfcca$export$d168cba70360dd3d(extension.name, this.schema)
            };
            const addNodeView = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addNodeView', context);
            if (!addNodeView) return [];
            const nodeview = (node, view, getPos, decorations, innerDecorations)=>{
                const HTMLAttributes = $7ffe772c051bfcca$export$bc79d84a417d7b02(node, extensionAttributes);
                return addNodeView()({
                    node: // pass-through
                    node,
                    view: view,
                    getPos: getPos,
                    decorations: decorations,
                    innerDecorations: innerDecorations,
                    editor: // tiptap-specific
                    editor,
                    extension: extension,
                    HTMLAttributes: HTMLAttributes
                });
            };
            return [
                extension.name,
                nodeview
            ];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */ setupExtensions() {
        this.extensions.forEach((extension)=>{
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $7ffe772c051bfcca$export$ea18268b31f54e5(extension.name, this.schema)
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) this.splittableMarks.push(extension.name);
            }
            const onBeforeCreate = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onBeforeCreate', context);
            const onCreate = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onCreate', context);
            const onUpdate = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onUpdate', context);
            const onSelectionUpdate = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onSelectionUpdate', context);
            const onTransaction = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onTransaction', context);
            const onFocus = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onFocus', context);
            const onBlur = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onBlur', context);
            const onDestroy = $7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'onDestroy', context);
            if (onBeforeCreate) this.editor.on('beforeCreate', onBeforeCreate);
            if (onCreate) this.editor.on('create', onCreate);
            if (onUpdate) this.editor.on('update', onUpdate);
            if (onSelectionUpdate) this.editor.on('selectionUpdate', onSelectionUpdate);
            if (onTransaction) this.editor.on('transaction', onTransaction);
            if (onFocus) this.editor.on('focus', onFocus);
            if (onBlur) this.editor.on('blur', onBlur);
            if (onDestroy) this.editor.on('destroy', onDestroy);
        });
    }
}
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $7ffe772c051bfcca$export$eeddbf09bb970356 {
    constructor(config = {}){
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $7ffe772c051bfcca$export$eeddbf09bb970356(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $7ffe772c051bfcca$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $7ffe772c051bfcca$export$eeddbf09bb970356({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */ function $7ffe772c051bfcca$export$6e5992a7455d9ef6(startNode, range, options) {
    const { from: from, to: to } = range;
    const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
    let text = '';
    startNode.nodesBetween(from, to, (node, pos, parent, index)=>{
        var _a;
        if (node.isBlock && pos > from) text += blockSeparator;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) text += textSerializer({
                node: node,
                pos: pos,
                parent: parent,
                index: index,
                range: range
            });
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    });
    return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */ function $7ffe772c051bfcca$export$fdd92b7d22ac071c(schema) {
    return Object.fromEntries(Object.entries(schema.nodes).filter(([, node])=>node.spec.toText).map(([name, node])=>[
            name,
            node.spec.toText
        ]));
}
const $7ffe772c051bfcca$var$ClipboardTextSerializer = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'clipboardTextSerializer',
    addOptions () {
        return {
            blockSeparator: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: ()=>{
                        const { editor: editor } = this;
                        const { state: state, schema: schema } = editor;
                        const { doc: doc, selection: selection } = state;
                        const { ranges: ranges } = selection;
                        const from = Math.min(...ranges.map((range)=>range.$from.pos));
                        const to = Math.max(...ranges.map((range)=>range.$to.pos));
                        const textSerializers = $7ffe772c051bfcca$export$fdd92b7d22ac071c(schema);
                        const range = {
                            from: from,
                            to: to
                        };
                        return $7ffe772c051bfcca$export$6e5992a7455d9ef6(doc, range, {
                            ...this.options.blockSeparator !== undefined ? {
                                blockSeparator: this.options.blockSeparator
                            } : {},
                            textSerializers: textSerializers
                        });
                    }
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$blur = ()=>({ editor: editor, view: view })=>{
        requestAnimationFrame(()=>{
            var _a;
            if (!editor.isDestroyed) {
                view.dom.blur();
                // Browsers should remove the caret on blur but safari does not.
                // See: https://github.com/ueberdosis/tiptap/issues/2405
                (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 || _a.removeAllRanges();
            }
        });
        return true;
    };
const $7ffe772c051bfcca$var$clearContent = (emitUpdate = false)=>({ commands: commands })=>{
        return commands.setContent('', emitUpdate);
    };
const $7ffe772c051bfcca$var$clearNodes = ()=>({ state: state, tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { ranges: ranges } = selection;
        if (!dispatch) return true;
        ranges.forEach(({ $from: $from, $to: $to })=>{
            state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.type.isText) return;
                const { doc: doc, mapping: mapping } = tr;
                const $mappedFrom = doc.resolve(mapping.map(pos));
                const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
                const nodeRange = $mappedFrom.blockRange($mappedTo);
                if (!nodeRange) return;
                const targetLiftDepth = (0, $cMB55.liftTarget)(nodeRange);
                if (node.type.isTextblock) {
                    const { defaultType: defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                    tr.setNodeMarkup(nodeRange.start, defaultType);
                }
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
            });
        });
        return true;
    };
const $7ffe772c051bfcca$var$command = (fn)=>(props)=>{
        return fn(props);
    };
const $7ffe772c051bfcca$var$createParagraphNear = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.createParagraphNear)(state, dispatch);
    };
const $7ffe772c051bfcca$var$cut = (originRange, targetPos)=>({ editor: editor, tr: tr })=>{
        const { state: state } = editor;
        const contentSlice = state.doc.slice(originRange.from, originRange.to);
        tr.deleteRange(originRange.from, originRange.to);
        const newPos = tr.mapping.map(targetPos);
        tr.insert(newPos, contentSlice.content);
        tr.setSelection(new (0, $eCBI9.TextSelection)(tr.doc.resolve(newPos - 1)));
        return true;
    };
const $7ffe772c051bfcca$var$deleteCurrentNode = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const currentNode = selection.$anchor.node();
        // if there is content inside the current node, break out of this command
        if (currentNode.content.size > 0) return false;
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === currentNode.type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $7ffe772c051bfcca$var$deleteNode = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $7ffe772c051bfcca$var$deleteRange = (range)=>({ tr: tr, dispatch: dispatch })=>{
        const { from: from, to: to } = range;
        if (dispatch) tr.delete(from, to);
        return true;
    };
const $7ffe772c051bfcca$var$deleteSelection = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.deleteSelection)(state, dispatch);
    };
const $7ffe772c051bfcca$var$enter = ()=>({ commands: commands })=>{
        return commands.keyboardShortcut('Enter');
    };
const $7ffe772c051bfcca$var$exitCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.exitCode)(state, dispatch);
    };
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */ function $7ffe772c051bfcca$export$7aeb68f71172641d(object1, object2, options = {
    strict: true
}) {
    const keys = Object.keys(object2);
    if (!keys.length) return true;
    return keys.every((key)=>{
        if (options.strict) return object2[key] === object1[key];
        if ($7ffe772c051bfcca$export$49841c62b9eff15(object2[key])) return object2[key].test(object1[key]);
        return object2[key] === object1[key];
    });
}
function $7ffe772c051bfcca$var$findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item)=>{
        return item.type === type && $7ffe772c051bfcca$export$7aeb68f71172641d(// Only check equality for the attributes that are provided
        Object.fromEntries(Object.keys(attributes).map((k)=>[
                k,
                item.attrs[k]
            ])), attributes);
    });
}
function $7ffe772c051bfcca$var$isMarkInSet(marks, type, attributes = {}) {
    return !!$7ffe772c051bfcca$var$findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */ function $7ffe772c051bfcca$export$8ceae6d06f5c4df5(/**
 * The position to get the mark range for.
 */ $pos, /**
 * The mark type to get the range for.
 */ type, /**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */ attributes) {
    var _a;
    if (!$pos || !type) return;
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) start = $pos.parent.childBefore($pos.parentOffset);
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) return;
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = $7ffe772c051bfcca$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    if (!mark) return;
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while(startIndex > 0 && $7ffe772c051bfcca$var$isMarkInSet([
        ...$pos.parent.child(startIndex - 1).marks
    ], type, attributes)){
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while(endIndex < $pos.parent.childCount && $7ffe772c051bfcca$var$isMarkInSet([
        ...$pos.parent.child(endIndex).marks
    ], type, attributes)){
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos
    };
}
function $7ffe772c051bfcca$export$b1269d6bf6e491ec(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.marks[nameOrType];
    }
    return nameOrType;
}
const $7ffe772c051bfcca$var$extendMarkRange = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { doc: doc, selection: selection } = tr;
        const { $from: $from, from: from, to: to } = selection;
        if (dispatch) {
            const range = $7ffe772c051bfcca$export$8ceae6d06f5c4df5($from, type, attributes);
            if (range && range.from <= from && range.to >= to) {
                const newSelection = (0, $eCBI9.TextSelection).create(doc, range.from, range.to);
                tr.setSelection(newSelection);
            }
        }
        return true;
    };
const $7ffe772c051bfcca$var$first = (commands)=>(props)=>{
        const items = typeof commands === 'function' ? commands(props) : commands;
        for(let i = 0; i < items.length; i += 1){
            if (items[i](props)) return true;
        }
        return false;
    };
function $7ffe772c051bfcca$export$38b50bf35e79aaf3(value) {
    return value instanceof (0, $eCBI9.TextSelection);
}
function $7ffe772c051bfcca$export$6fb785c609d82593(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}
function $7ffe772c051bfcca$export$225b0233b78e0d61(doc, position = null) {
    if (!position) return null;
    const selectionAtStart = (0, $eCBI9.Selection).atStart(doc);
    const selectionAtEnd = (0, $eCBI9.Selection).atEnd(doc);
    if (position === 'start' || position === true) return selectionAtStart;
    if (position === 'end') return selectionAtEnd;
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') return (0, $eCBI9.TextSelection).create(doc, $7ffe772c051bfcca$export$6fb785c609d82593(0, minPos, maxPos), $7ffe772c051bfcca$export$6fb785c609d82593(doc.content.size, minPos, maxPos));
    return (0, $eCBI9.TextSelection).create(doc, $7ffe772c051bfcca$export$6fb785c609d82593(position, minPos, maxPos), $7ffe772c051bfcca$export$6fb785c609d82593(position, minPos, maxPos));
}
function $7ffe772c051bfcca$var$isAndroid() {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}
function $7ffe772c051bfcca$export$86c1a3f9ab33da5c() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}
const $7ffe772c051bfcca$var$focus = (position = null, options = {})=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        options = {
            scrollIntoView: true,
            ...options
        };
        const delayedFocus = ()=>{
            // focus within `requestAnimationFrame` breaks focus on iOS and Android
            // so we have to call this
            if ($7ffe772c051bfcca$export$86c1a3f9ab33da5c() || $7ffe772c051bfcca$var$isAndroid()) view.dom.focus();
            // For React we have to focus asynchronously. Otherwise wild things happen.
            // see: https://github.com/ueberdosis/tiptap/issues/1520
            requestAnimationFrame(()=>{
                if (!editor.isDestroyed) {
                    view.focus();
                    if (options === null || options === void 0 ? void 0 : options.scrollIntoView) editor.commands.scrollIntoView();
                }
            });
        };
        if (view.hasFocus() && position === null || position === false) return true;
        // we don’t try to resolve a NodeSelection or CellSelection
        if (dispatch && position === null && !$7ffe772c051bfcca$export$38b50bf35e79aaf3(editor.state.selection)) {
            delayedFocus();
            return true;
        }
        // pass through tr.doc instead of editor.state.doc
        // since transactions could change the editors state before this command has been run
        const selection = $7ffe772c051bfcca$export$225b0233b78e0d61(tr.doc, position) || editor.state.selection;
        const isSameSelection = editor.state.selection.eq(selection);
        if (dispatch) {
            if (!isSameSelection) tr.setSelection(selection);
            // `tr.setSelection` resets the stored marks
            // so we’ll restore them if the selection is the same as before
            if (isSameSelection && tr.storedMarks) tr.setStoredMarks(tr.storedMarks);
            delayedFocus();
        }
        return true;
    };
const $7ffe772c051bfcca$var$forEach = (items, fn)=>(props)=>{
        return items.every((item, index)=>fn(item, {
                ...props,
                index: index
            }));
    };
const $7ffe772c051bfcca$var$insertContent = (value, options)=>({ tr: tr, commands: commands })=>{
        return commands.insertContentAt({
            from: tr.selection.from,
            to: tr.selection.to
        }, value, options);
    };
const $7ffe772c051bfcca$var$removeWhitespaces = (node)=>{
    const children = node.childNodes;
    for(let i = children.length - 1; i >= 0; i -= 1){
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
        else if (child.nodeType === 1) $7ffe772c051bfcca$var$removeWhitespaces(child);
    }
    return node;
};
function $7ffe772c051bfcca$export$1b93bf03550cde01(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
    return $7ffe772c051bfcca$var$removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */ function $7ffe772c051bfcca$export$12c64e96dddaee61(content, schema, options) {
    if (content instanceof (0, $jcs10.Node) || content instanceof (0, $jcs10.Fragment)) return content;
    options = {
        slice: true,
        parseOptions: {},
        ...options
    };
    const isJSONContent = typeof content === 'object' && content !== null;
    const isTextContent = typeof content === 'string';
    if (isJSONContent) try {
        const isArrayContent = Array.isArray(content) && content.length > 0;
        // if the JSON Content is an array of nodes, create a fragment for each node
        if (isArrayContent) return (0, $jcs10.Fragment).fromArray(content.map((item)=>schema.nodeFromJSON(item)));
        const node = schema.nodeFromJSON(content);
        if (options.errorOnInvalidContent) node.check();
        return node;
    } catch (error) {
        if (options.errorOnInvalidContent) throw new Error('[tiptap error]: Invalid JSON content', {
            cause: error
        });
        console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
        return $7ffe772c051bfcca$export$12c64e96dddaee61('', schema, options);
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = '';
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new (0, $jcs10.Schema)({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: 'inline*',
                        group: 'block',
                        parseDOM: [
                            {
                                tag: '*',
                                getAttrs: (e)=>{
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === 'string' ? e : e.outerHTML;
                                    return null;
                                }
                            }
                        ]
                    }
                })
            });
            if (options.slice) (0, $jcs10.DOMParser).fromSchema(contentCheckSchema).parseSlice($7ffe772c051bfcca$export$1b93bf03550cde01(content), options.parseOptions);
            else (0, $jcs10.DOMParser).fromSchema(contentCheckSchema).parse($7ffe772c051bfcca$export$1b93bf03550cde01(content), options.parseOptions);
            if (options.errorOnInvalidContent && hasInvalidContent) throw new Error('[tiptap error]: Invalid HTML content', {
                cause: new Error(`Invalid element found: ${invalidContent}`)
            });
        }
        const parser = (0, $jcs10.DOMParser).fromSchema(schema);
        if (options.slice) return parser.parseSlice($7ffe772c051bfcca$export$1b93bf03550cde01(content), options.parseOptions).content;
        return parser.parse($7ffe772c051bfcca$export$1b93bf03550cde01(content), options.parseOptions);
    }
    return $7ffe772c051bfcca$export$12c64e96dddaee61('', schema, options);
}
// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function $7ffe772c051bfcca$export$bf93acd215057ab0(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) return;
    const step = tr.steps[last];
    if (!(step instanceof (0, $cMB55.ReplaceStep) || step instanceof (0, $cMB55.ReplaceAroundStep))) return;
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end === 0) end = newTo;
    });
    tr.setSelection((0, $eCBI9.Selection).near(tr.doc.resolve(end), bias));
}
const $7ffe772c051bfcca$var$isFragment = (nodeOrFragment)=>{
    return !('type' in nodeOrFragment);
};
const $7ffe772c051bfcca$var$insertContentAt = (position, value, options)=>({ tr: tr, dispatch: dispatch, editor: editor })=>{
        var _a;
        if (dispatch) {
            options = {
                parseOptions: editor.options.parseOptions,
                updateSelection: true,
                applyInputRules: false,
                applyPasteRules: false,
                ...options
            };
            let content;
            try {
                content = $7ffe772c051bfcca$export$12c64e96dddaee61(value, editor.schema, {
                    parseOptions: {
                        preserveWhitespace: 'full',
                        ...options.parseOptions
                    },
                    errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
                });
            } catch (e) {
                editor.emit('contentError', {
                    editor: editor,
                    error: e,
                    disableCollaboration: ()=>{
                        if (editor.storage.collaboration) editor.storage.collaboration.isDisabled = true;
                    }
                });
                return false;
            }
            let { from: from, to: to } = typeof position === 'number' ? {
                from: position,
                to: position
            } : {
                from: position.from,
                to: position.to
            };
            let isOnlyTextContent = true;
            let isOnlyBlockContent = true;
            const nodes = $7ffe772c051bfcca$var$isFragment(content) ? content : [
                content
            ];
            nodes.forEach((node)=>{
                // check if added node is valid
                node.check();
                isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
                isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
            });
            // check if we can replace the wrapping node by
            // the newly inserted content
            // example:
            // replace an empty paragraph by an inserted image
            // instead of inserting the image below the paragraph
            if (from === to && isOnlyBlockContent) {
                const { parent: parent } = tr.doc.resolve(from);
                const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
                if (isEmptyTextBlock) {
                    from -= 1;
                    to += 1;
                }
            }
            let newContent;
            // if there is only plain text we have to use `insertText`
            // because this will keep the current marks
            if (isOnlyTextContent) {
                // if value is string, we can use it directly
                // otherwise if it is an array, we have to join it
                if (Array.isArray(value)) newContent = value.map((v)=>v.text || '').join('');
                else if (value instanceof (0, $jcs10.Fragment)) {
                    let text = '';
                    value.forEach((node)=>{
                        if (node.text) text += node.text;
                    });
                    newContent = text;
                } else if (typeof value === 'object' && !!value && !!value.text) newContent = value.text;
                else newContent = value;
                tr.insertText(newContent, from, to);
            } else {
                newContent = content;
                tr.replaceWith(from, to, newContent);
            }
            // set cursor at end of inserted content
            if (options.updateSelection) $7ffe772c051bfcca$export$bf93acd215057ab0(tr, tr.steps.length - 1, -1);
            if (options.applyInputRules) tr.setMeta('applyInputRules', {
                from: from,
                text: newContent
            });
            if (options.applyPasteRules) tr.setMeta('applyPasteRules', {
                from: from,
                text: newContent
            });
        }
        return true;
    };
const $7ffe772c051bfcca$var$joinUp = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinUp)(state, dispatch);
    };
const $7ffe772c051bfcca$var$joinDown = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinDown)(state, dispatch);
    };
const $7ffe772c051bfcca$var$joinBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinBackward)(state, dispatch);
    };
const $7ffe772c051bfcca$var$joinForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinForward)(state, dispatch);
    };
const $7ffe772c051bfcca$var$joinItemBackward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $cMB55.joinPoint)(state.doc, state.selection.$from.pos, -1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $7ffe772c051bfcca$var$joinItemForward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $cMB55.joinPoint)(state.doc, state.selection.$from.pos, 1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $7ffe772c051bfcca$var$joinTextblockBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinTextblockBackward)(state, dispatch);
    };
const $7ffe772c051bfcca$var$joinTextblockForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.joinTextblockForward)(state, dispatch);
    };
function $7ffe772c051bfcca$export$6159e43e50a41987() {
    return typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
}
function $7ffe772c051bfcca$var$normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') result = ' ';
    let alt;
    let ctrl;
    let shift;
    let meta;
    for(let i = 0; i < parts.length - 1; i += 1){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($7ffe772c051bfcca$export$86c1a3f9ab33da5c() || $7ffe772c051bfcca$export$6159e43e50a41987()) meta = true;
            else ctrl = true;
        } else throw new Error(`Unrecognized modifier name: ${mod}`);
    }
    if (alt) result = `Alt-${result}`;
    if (ctrl) result = `Ctrl-${result}`;
    if (meta) result = `Meta-${result}`;
    if (shift) result = `Shift-${result}`;
    return result;
}
const $7ffe772c051bfcca$var$keyboardShortcut = (name)=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        const keys = $7ffe772c051bfcca$var$normalizeKeyName(name).split(/-(?!$)/);
        const key = keys.find((item)=>![
                'Alt',
                'Ctrl',
                'Meta',
                'Shift'
            ].includes(item));
        const event = new KeyboardEvent('keydown', {
            key: key === 'Space' ? ' ' : key,
            altKey: keys.includes('Alt'),
            ctrlKey: keys.includes('Ctrl'),
            metaKey: keys.includes('Meta'),
            shiftKey: keys.includes('Shift'),
            bubbles: true,
            cancelable: true
        });
        const capturedTransaction = editor.captureTransaction(()=>{
            view.someProp('handleKeyDown', (f)=>f(view, event));
        });
        capturedTransaction === null || capturedTransaction === void 0 || capturedTransaction.steps.forEach((step)=>{
            const newStep = step.map(tr.mapping);
            if (newStep && dispatch) tr.maybeStep(newStep);
        });
        return true;
    };
function $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, typeOrName, attributes = {}) {
    const { from: from, to: to, empty: empty } = state.selection;
    const type = typeOrName ? $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) return;
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node: node,
            from: relativeFrom,
            to: relativeTo
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges.filter((nodeRange)=>{
        if (!type) return true;
        return type.name === nodeRange.node.type.name;
    }).filter((nodeRange)=>$7ffe772c051bfcca$export$7aeb68f71172641d(nodeRange.node.attrs, attributes, {
            strict: false
        }));
    if (empty) return !!matchedNodeRanges.length;
    const range = matchedNodeRanges.reduce((sum, nodeRange)=>sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}
const $7ffe772c051bfcca$var$lift = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, type, attributes);
        if (!isActive) return false;
        return (0, $g6HTq.lift)(state, dispatch);
    };
const $7ffe772c051bfcca$var$liftEmptyBlock = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.liftEmptyBlock)(state, dispatch);
    };
const $7ffe772c051bfcca$var$liftListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $cWB7z.liftListItem)(type)(state, dispatch);
    };
const $7ffe772c051bfcca$var$newlineInCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.newlineInCode)(state, dispatch);
    };
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */ function $7ffe772c051bfcca$export$e501dfcf737a48e0(name, schema) {
    if (schema.nodes[name]) return 'node';
    if (schema.marks[name]) return 'mark';
    return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */ function $7ffe772c051bfcca$export$8694e5c03a4df8e6(obj, propOrProps) {
    const props = typeof propOrProps === 'string' ? [
        propOrProps
    ] : propOrProps;
    return Object.keys(obj).reduce((newObj, prop)=>{
        if (!props.includes(prop)) newObj[prop] = obj[prop];
        return newObj;
    }, {});
}
const $7ffe772c051bfcca$var$resetAttributes = (typeOrName, attributes)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $7ffe772c051bfcca$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === 'node') nodeType = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === 'mark') markType = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, $7ffe772c051bfcca$export$8694e5c03a4df8e6(node.attrs, attributes));
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create($7ffe772c051bfcca$export$8694e5c03a4df8e6(mark.attrs, attributes)));
                });
            });
        });
        return true;
    };
const $7ffe772c051bfcca$var$scrollIntoView = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) tr.scrollIntoView();
        return true;
    };
const $7ffe772c051bfcca$var$selectAll = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const selection = new (0, $eCBI9.AllSelection)(tr.doc);
            tr.setSelection(selection);
        }
        return true;
    };
const $7ffe772c051bfcca$var$selectNodeBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.selectNodeBackward)(state, dispatch);
    };
const $7ffe772c051bfcca$var$selectNodeForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.selectNodeForward)(state, dispatch);
    };
const $7ffe772c051bfcca$var$selectParentNode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.selectParentNode)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $7ffe772c051bfcca$var$selectTextblockEnd = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.selectTextblockEnd)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $7ffe772c051bfcca$var$selectTextblockStart = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $g6HTq.selectTextblockStart)(state, dispatch);
    };
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */ function $7ffe772c051bfcca$export$37330def6e48b4c9(content, schema, parseOptions = {}, options = {}) {
    return $7ffe772c051bfcca$export$12c64e96dddaee61(content, schema, {
        slice: false,
        parseOptions: parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent
    });
}
const $7ffe772c051bfcca$var$setContent = (content, emitUpdate = false, parseOptions = {}, options = {})=>({ editor: editor, tr: tr, dispatch: dispatch, commands: commands })=>{
        var _a, _b;
        const { doc: doc } = tr;
        // This is to keep backward compatibility with the previous behavior
        // TODO remove this in the next major version
        if (parseOptions.preserveWhitespace !== 'full') {
            const document1 = $7ffe772c051bfcca$export$37330def6e48b4c9(content, editor.schema, parseOptions, {
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
            });
            if (dispatch) tr.replaceWith(0, doc.content.size, document1).setMeta('preventUpdate', !emitUpdate);
            return true;
        }
        if (dispatch) tr.setMeta('preventUpdate', !emitUpdate);
        return commands.insertContentAt({
            from: 0,
            to: doc.content.size
        }, content, {
            parseOptions: parseOptions,
            errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
        });
    };
function $7ffe772c051bfcca$export$2cd1d0e1f861bae0(state, typeOrName) {
    const type = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
    const { from: from, to: to, empty: empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) marks.push(...state.storedMarks);
        marks.push(...state.selection.$head.marks());
    } else state.doc.nodesBetween(from, to, (node)=>{
        marks.push(...node.marks);
    });
    const mark = marks.find((markItem)=>markItem.type.name === type.name);
    if (!mark) return {};
    return {
        ...mark.attrs
    };
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */ function $7ffe772c051bfcca$export$f945f1716a5df33d(oldDoc, transactions) {
    const transform = new (0, $cMB55.Transform)(oldDoc);
    transactions.forEach((transaction)=>{
        transaction.steps.forEach((step)=>{
            transform.step(step);
        });
    });
    return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */ function $7ffe772c051bfcca$export$6133a2de0e8ac885(match) {
    for(let i = 0; i < match.edgeCount; i += 1){
        const { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $7ffe772c051bfcca$export$f94ca194e830789c(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $7ffe772c051bfcca$export$6a2a251dde98a23(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */ function $7ffe772c051bfcca$export$fe09644e3bc6166b($pos, predicate) {
    for(let i = $pos.depth; i > 0; i -= 1){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */ function $7ffe772c051bfcca$export$dc159056ffdb4c76(predicate) {
    return (selection)=>$7ffe772c051bfcca$export$fe09644e3bc6166b(selection.$from, predicate);
}
function $7ffe772c051bfcca$export$19a621270f26273c(extensions, editor) {
    const resolvedExtensions = $7ffe772c051bfcca$var$ExtensionManager.resolve(extensions);
    return $7ffe772c051bfcca$export$71bc12a97b59a858(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */ function $7ffe772c051bfcca$export$4f413073eb19378c(doc, extensions) {
    const schema = $7ffe772c051bfcca$export$19a621270f26273c(extensions);
    const contentNode = (0, $jcs10.Node).fromJSON(schema, doc);
    return $7ffe772c051bfcca$export$d1b60002472b2c81(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */ function $7ffe772c051bfcca$export$d23738d50f257f47(html, extensions) {
    const schema = $7ffe772c051bfcca$export$19a621270f26273c(extensions);
    const dom = $7ffe772c051bfcca$export$1b93bf03550cde01(html);
    return (0, $jcs10.DOMParser).fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */ function $7ffe772c051bfcca$export$c72d34660a162238(node, options) {
    const range = {
        from: 0,
        to: node.content.size
    };
    return $7ffe772c051bfcca$export$6e5992a7455d9ef6(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */ function $7ffe772c051bfcca$export$43625cf01e0b7b62(doc, extensions, options) {
    const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
    const schema = $7ffe772c051bfcca$export$19a621270f26273c(extensions);
    const contentNode = (0, $jcs10.Node).fromJSON(schema, doc);
    return $7ffe772c051bfcca$export$c72d34660a162238(contentNode, {
        blockSeparator: blockSeparator,
        textSerializers: {
            ...$7ffe772c051bfcca$export$fdd92b7d22ac071c(schema),
            ...textSerializers
        }
    });
}
function $7ffe772c051bfcca$export$e8c6736926dcac42(state, typeOrName) {
    const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
    const { from: from, to: to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        nodes.push(node);
    });
    const node = nodes.reverse().find((nodeItem)=>nodeItem.type.name === type.name);
    if (!node) return {};
    return {
        ...node.attrs
    };
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */ function $7ffe772c051bfcca$export$fe94072fee8a6976(state, typeOrName) {
    const schemaType = $7ffe772c051bfcca$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') return $7ffe772c051bfcca$export$e8c6736926dcac42(state, typeOrName);
    if (schemaType === 'mark') return $7ffe772c051bfcca$export$2cd1d0e1f861bae0(state, typeOrName);
    return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */ function $7ffe772c051bfcca$export$2e2262a44ac61957(array, by = JSON.stringify) {
    const seen = {};
    return array.filter((item)=>{
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
    });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */ function $7ffe772c051bfcca$var$simplifyChangedRanges(changes) {
    const uniqueChanges = $7ffe772c051bfcca$export$2e2262a44ac61957(changes);
    return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index)=>{
        const rest = uniqueChanges.filter((_, i)=>i !== index);
        return !rest.some((otherChange)=>{
            return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
        });
    });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */ function $7ffe772c051bfcca$export$ba396fc65ff2f439(transform) {
    const { mapping: mapping, steps: steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index)=>{
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from: from, to: to } = steps[index];
            if (from === undefined || to === undefined) return;
            ranges.push({
                from: from,
                to: to
            });
        } else stepMap.forEach((from, to)=>{
            ranges.push({
                from: from,
                to: to
            });
        });
        ranges.forEach(({ from: from, to: to })=>{
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd
                },
                newRange: {
                    from: newStart,
                    to: newEnd
                }
            });
        });
    });
    return $7ffe772c051bfcca$var$simplifyChangedRanges(changes);
}
function $7ffe772c051bfcca$export$d661e0733145fb37(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map((mark)=>{
        const output = {
            type: mark.type.name
        };
        if (Object.keys(mark.attrs).length) output.attrs = {
            ...mark.attrs
        };
        return output;
    });
    const attrs = {
        ...node.attrs
    };
    const output = {
        type: node.type.name,
        from: from,
        to: to
    };
    if (Object.keys(attrs).length) output.attrs = attrs;
    if (marks.length) output.marks = marks;
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset)=>{
            var _a;
            (_a = output.content) === null || _a === void 0 || _a.push($7ffe772c051bfcca$export$d661e0733145fb37(child, startOffset + offset + increment));
        });
    }
    if (node.text) output.text = node.text;
    return output;
}
function $7ffe772c051bfcca$export$c5fd7af7c5c1efa(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) doc.resolve(from).marks().forEach((mark)=>{
        const $pos = doc.resolve(from);
        const range = $7ffe772c051bfcca$export$8ceae6d06f5c4df5($pos, mark.type);
        if (!range) return;
        marks.push({
            mark: mark,
            ...range
        });
    });
    else doc.nodesBetween(from, to, (node, pos)=>{
        if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) return;
        marks.push(...node.marks.map((mark)=>({
                from: pos,
                to: pos + node.nodeSize,
                mark: mark
            })));
    });
    return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */ const $7ffe772c051bfcca$export$ee90757e11fae7cd = (state, typeOrName, pos, maxDepth = 20)=>{
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while(currentDepth > 0 && node === null){
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) node = currentNode;
        else currentDepth -= 1;
    }
    return [
        node,
        currentDepth
    ];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */ function $7ffe772c051bfcca$export$49b565bbca5fba3a(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object.entries(attributes).filter(([name])=>{
        const extensionAttribute = extensionAttributes.find((item)=>{
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) return false;
        return extensionAttribute.attribute.keepOnSplit;
    }));
}
function $7ffe772c051bfcca$export$72001287e2a5b413(state, typeOrName, attributes = {}) {
    const { empty: empty, ranges: ranges } = state.selection;
    const type = typeOrName ? $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema) : null;
    if (empty) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark)=>{
        if (!type) return true;
        return type.name === mark.type.name;
    }).find((mark)=>$7ffe772c051bfcca$export$7aeb68f71172641d(mark.attrs, attributes, {
            strict: false
        }));
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from: $from, $to: $to })=>{
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isText && !node.marks.length) return;
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map((mark)=>({
                    mark: mark,
                    from: relativeFrom,
                    to: relativeTo
                })));
        });
    });
    if (selectionRange === 0) return false;
    // calculate range of matched mark
    const matchedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return type.name === markRange.mark.type.name;
    }).filter((markRange)=>$7ffe772c051bfcca$export$7aeb68f71172641d(markRange.mark.attrs, attributes, {
            strict: false
        })).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    }).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}
function $7ffe772c051bfcca$export$39e04e72f972b885(state, name, attributes = {}) {
    if (!name) return $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, null, attributes) || $7ffe772c051bfcca$export$72001287e2a5b413(state, null, attributes);
    const schemaType = $7ffe772c051bfcca$export$e501dfcf737a48e0(name, state.schema);
    if (schemaType === 'node') return $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, name, attributes);
    if (schemaType === 'mark') return $7ffe772c051bfcca$export$72001287e2a5b413(state, name, attributes);
    return false;
}
const $7ffe772c051bfcca$export$6a042f9d56fb39ec = (state, nodeType)=>{
    const { $from: $from, $to: $to, $anchor: $anchor } = state.selection;
    if (nodeType) {
        const parentNode = $7ffe772c051bfcca$export$dc159056ffdb4c76((node)=>node.type.name === nodeType)(state.selection);
        if (!parentNode) return false;
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) return true;
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) return false;
    return true;
};
const $7ffe772c051bfcca$export$d0aa6c7595396956 = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) return false;
    return true;
};
function $7ffe772c051bfcca$export$ead95ff48ba53ffd(name, extensions) {
    const { nodeExtensions: nodeExtensions } = $7ffe772c051bfcca$export$36e8c2990da8266f(extensions);
    const extension = nodeExtensions.find((item)=>item.name === name);
    if (!extension) return false;
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage
    };
    const group = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'group', context));
    if (typeof group !== 'string') return false;
    return group.split(' ').includes('list');
}
/**
 * Returns true if the given prosemirror node is empty.
 */ function $7ffe772c051bfcca$export$cd58ff1081f6abe9(node, { checkChildren: checkChildren = true, ignoreWhitespace: ignoreWhitespace = false } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === 'hardBreak') // Hard breaks are considered empty
        return true;
        if (node.isText) return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
    }
    if (node.isText) return !node.text;
    if (node.isAtom || node.isLeaf) return false;
    if (node.content.childCount === 0) return true;
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach((childNode)=>{
            if (isContentEmpty === false) // Exit early for perf
            return;
            if (!$7ffe772c051bfcca$export$cd58ff1081f6abe9(childNode, {
                ignoreWhitespace: ignoreWhitespace,
                checkChildren: checkChildren
            })) isContentEmpty = false;
        });
        return isContentEmpty;
    }
    return false;
}
function $7ffe772c051bfcca$export$a8c1d2c13abf8822(value) {
    return value instanceof (0, $eCBI9.NodeSelection);
}
function $7ffe772c051bfcca$export$660ecae6cde71645(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = $7ffe772c051bfcca$export$6fb785c609d82593(from, minPos, maxPos);
    const resolvedEnd = $7ffe772c051bfcca$export$6fb785c609d82593(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        x: x,
        y: y
    };
    return {
        ...data,
        toJSON: ()=>data
    };
}
/**
 * The actual implementation of the rewriteUnknownContent function
 */ function $7ffe772c051bfcca$var$rewriteUnknownContentInner({ json: json, validMarks: validMarks, validNodes: validNodes, options: options, rewrittenContent: rewrittenContent = [] }) {
    if (json.marks && Array.isArray(json.marks)) json.marks = json.marks.filter((mark)=>{
        const name = typeof mark === 'string' ? mark : mark.type;
        if (validMarks.has(name)) return true;
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(mark)),
            unsupported: name
        });
        // Just ignore any unknown marks
        return false;
    });
    if (json.content && Array.isArray(json.content)) json.content = json.content.map((value)=>$7ffe772c051bfcca$var$rewriteUnknownContentInner({
            json: value,
            validMarks: validMarks,
            validNodes: validNodes,
            options: options,
            rewrittenContent: rewrittenContent
        }).json).filter((a)=>a !== null && a !== undefined);
    if (json.type && !validNodes.has(json.type)) {
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(json)),
            unsupported: json.type
        });
        if (json.content && Array.isArray(json.content) && (options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false) {
            // Just treat it like a paragraph and hope for the best
            json.type = 'paragraph';
            return {
                json: json,
                rewrittenContent: rewrittenContent
            };
        }
        // or just omit it entirely
        return {
            json: null,
            rewrittenContent: rewrittenContent
        };
    }
    return {
        json: json,
        rewrittenContent: rewrittenContent
    };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */ function $7ffe772c051bfcca$export$e29d20b0f4dc64ed(/**
 * The JSON content to clean of unknown nodes and marks
 */ json, /**
 * The schema to use for validation
 */ schema, /**
 * Options for the cleaning process
 */ options) {
    return $7ffe772c051bfcca$var$rewriteUnknownContentInner({
        json: json,
        validNodes: new Set(Object.keys(schema.nodes)),
        validMarks: new Set(Object.keys(schema.marks)),
        options: options
    });
}
function $7ffe772c051bfcca$var$canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection: selection } = tr;
    let cursor = null;
    if ($7ffe772c051bfcca$export$38b50bf35e79aaf3(selection)) cursor = selection.$cursor;
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark)=>mark.type.excludes(newMarkType));
    }
    const { ranges: ranges } = selection;
    return ranges.some(({ $from: $from, $to: $to })=>{
        let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent)=>{
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) return false;
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark)=>otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const $7ffe772c051bfcca$var$setMark = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        const type = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) {
            if (empty) {
                const oldAttributes = $7ffe772c051bfcca$export$2cd1d0e1f861bae0(state, type);
                tr.addStoredMark(type.create({
                    ...oldAttributes,
                    ...attributes
                }));
            } else ranges.forEach((range)=>{
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find((mark)=>mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) node.marks.forEach((mark)=>{
                        if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    });
                    else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                });
            });
        }
        return $7ffe772c051bfcca$var$canSetMark(state, tr, type);
    };
const $7ffe772c051bfcca$var$setMeta = (key, value)=>({ tr: tr })=>{
        tr.setMeta(key, value);
        return true;
    };
const $7ffe772c051bfcca$var$setNode = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch, chain: chain })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        // TODO: use a fallback like insertContent?
        if (!type.isTextblock) {
            console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
            return false;
        }
        return chain()// try to convert node to default node if needed
        .command(({ commands: commands })=>{
            const canSetBlock = (0, $g6HTq.setBlockType)(type, {
                ...attributesToCopy,
                ...attributes
            })(state);
            if (canSetBlock) return true;
            return commands.clearNodes();
        }).command(({ state: updatedState })=>{
            return (0, $g6HTq.setBlockType)(type, {
                ...attributesToCopy,
                ...attributes
            })(updatedState, dispatch);
        }).run();
    };
const $7ffe772c051bfcca$var$setNodeSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const from = $7ffe772c051bfcca$export$6fb785c609d82593(position, 0, doc.content.size);
            const selection = (0, $eCBI9.NodeSelection).create(doc, from);
            tr.setSelection(selection);
        }
        return true;
    };
const $7ffe772c051bfcca$var$setTextSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const { from: from, to: to } = typeof position === 'number' ? {
                from: position,
                to: position
            } : position;
            const minPos = (0, $eCBI9.TextSelection).atStart(doc).from;
            const maxPos = (0, $eCBI9.TextSelection).atEnd(doc).to;
            const resolvedFrom = $7ffe772c051bfcca$export$6fb785c609d82593(from, minPos, maxPos);
            const resolvedEnd = $7ffe772c051bfcca$export$6fb785c609d82593(to, minPos, maxPos);
            const selection = (0, $eCBI9.TextSelection).create(doc, resolvedFrom, resolvedEnd);
            tr.setSelection(selection);
        }
        return true;
    };
const $7ffe772c051bfcca$var$sinkListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $cWB7z.sinkListItem)(type)(state, dispatch);
    };
function $7ffe772c051bfcca$var$ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) {
        const filteredMarks = marks.filter((mark)=>splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const $7ffe772c051bfcca$var$splitBlock = ({ keepMarks: keepMarks = true } = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        const { selection: selection, doc: doc } = tr;
        const { $from: $from, $to: $to } = selection;
        const extensionAttributes = editor.extensionManager.attributes;
        const newAttributes = $7ffe772c051bfcca$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        if (selection instanceof (0, $eCBI9.NodeSelection) && selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $cMB55.canSplit)(doc, $from.pos)) return false;
            if (dispatch) {
                if (keepMarks) $7ffe772c051bfcca$var$ensureMarks(state, editor.extensionManager.splittableMarks);
                tr.split($from.pos).scrollIntoView();
            }
            return true;
        }
        if (!$from.parent.isBlock) return false;
        const atEnd = $to.parentOffset === $to.parent.content.size;
        const deflt = $from.depth === 0 ? undefined : $7ffe772c051bfcca$export$6133a2de0e8ac885($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        let types = atEnd && deflt ? [
            {
                type: deflt,
                attrs: newAttributes
            }
        ] : undefined;
        let can = (0, $cMB55.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types && !can && (0, $cMB55.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
            {
                type: deflt
            }
        ] : undefined)) {
            can = true;
            types = deflt ? [
                {
                    type: deflt,
                    attrs: newAttributes
                }
            ] : undefined;
        }
        if (dispatch) {
            if (can) {
                if (selection instanceof (0, $eCBI9.TextSelection)) tr.deleteSelection();
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                    const first = tr.mapping.map($from.before());
                    const $first = tr.doc.resolve(first);
                    if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            if (keepMarks) $7ffe772c051bfcca$var$ensureMarks(state, editor.extensionManager.splittableMarks);
            tr.scrollIntoView();
        }
        return can;
    };
const $7ffe772c051bfcca$var$splitListItem = (typeOrName, overrideAttrs = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        var _a;
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        const { $from: $from, $to: $to } = state.selection;
        // @ts-ignore
        // eslint-disable-next-line
        const node = state.selection.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== type) return false;
        const extensionAttributes = editor.extensionManager.attributes;
        if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $jcs10.Fragment).empty;
                // eslint-disable-next-line
                const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1)wrap = (0, $jcs10.Fragment).from($from.node(d).copy(wrap));
                // eslint-disable-next-line
                const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                const newNextTypeAttributes = {
                    ...$7ffe772c051bfcca$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
                    ...overrideAttrs
                };
                const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
                wrap = wrap.append((0, $jcs10.Fragment).from(type.createAndFill(null, nextType) || undefined));
                const start = $from.before($from.depth - (depthBefore - 1));
                tr.replace(start, $from.after(-depthAfter), new (0, $jcs10.Slice)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos)=>{
                    if (sel > -1) return false;
                    if (n.isTextblock && n.content.size === 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $eCBI9.TextSelection).near(tr.doc.resolve(sel)));
                tr.scrollIntoView();
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const newTypeAttributes = {
            ...$7ffe772c051bfcca$export$49b565bbca5fba3a(extensionAttributes, grandParent.type.name, grandParent.attrs),
            ...overrideAttrs
        };
        const newNextTypeAttributes = {
            ...$7ffe772c051bfcca$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
            ...overrideAttrs
        };
        tr.delete($from.pos, $to.pos);
        const types = nextType ? [
            {
                type: type,
                attrs: newTypeAttributes
            },
            {
                type: nextType,
                attrs: newNextTypeAttributes
            }
        ] : [
            {
                type: type,
                attrs: newTypeAttributes
            }
        ];
        if (!(0, $cMB55.canSplit)(tr.doc, $from.pos, 2)) return false;
        if (dispatch) {
            const { selection: selection, storedMarks: storedMarks } = state;
            const { splittableMarks: splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            tr.split($from.pos, 2, types).scrollIntoView();
            if (!marks || !dispatch) return true;
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
        }
        return true;
    };
const $7ffe772c051bfcca$var$joinListBackwards = (tr, listType)=>{
    const list = $7ffe772c051bfcca$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) return true;
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && (0, $cMB55.canJoin)(tr.doc, list.pos);
    if (!canJoinBackwards) return true;
    tr.join(list.pos);
    return true;
};
const $7ffe772c051bfcca$var$joinListForwards = (tr, listType)=>{
    const list = $7ffe772c051bfcca$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) return true;
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && (0, $cMB55.canJoin)(tr.doc, after);
    if (!canJoinForwards) return true;
    tr.join(after);
    return true;
};
const $7ffe772c051bfcca$var$toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {})=>({ editor: editor, tr: tr, state: state, dispatch: dispatch, chain: chain, commands: commands, can: can })=>{
        const { extensions: extensions, splittableMarks: splittableMarks } = editor.extensionManager;
        const listType = $7ffe772c051bfcca$export$d168cba70360dd3d(listTypeOrName, state.schema);
        const itemType = $7ffe772c051bfcca$export$d168cba70360dd3d(itemTypeOrName, state.schema);
        const { selection: selection, storedMarks: storedMarks } = state;
        const { $from: $from, $to: $to } = selection;
        const range = $from.blockRange($to);
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (!range) return false;
        const parentList = $7ffe772c051bfcca$export$dc159056ffdb4c76((node)=>$7ffe772c051bfcca$export$ead95ff48ba53ffd(node.type.name, extensions))(selection);
        if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
            // remove list
            if (parentList.node.type === listType) return commands.liftListItem(itemType);
            // change list type
            if ($7ffe772c051bfcca$export$ead95ff48ba53ffd(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) return chain().command(()=>{
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            }).command(()=>$7ffe772c051bfcca$var$joinListBackwards(tr, listType)).command(()=>$7ffe772c051bfcca$var$joinListForwards(tr, listType)).run();
        }
        if (!keepMarks || !marks || !dispatch) return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$7ffe772c051bfcca$var$joinListBackwards(tr, listType)).command(()=>$7ffe772c051bfcca$var$joinListForwards(tr, listType)).run();
        return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$7ffe772c051bfcca$var$joinListBackwards(tr, listType)).command(()=>$7ffe772c051bfcca$var$joinListForwards(tr, listType)).run();
    };
const $7ffe772c051bfcca$var$toggleMark = (typeOrName, attributes = {}, options = {})=>({ state: state, commands: commands })=>{
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const type = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const isActive = $7ffe772c051bfcca$export$72001287e2a5b413(state, type, attributes);
        if (isActive) return commands.unsetMark(type, {
            extendEmptyMarkRange: extendEmptyMarkRange
        });
        return commands.setMark(type, attributes);
    };
const $7ffe772c051bfcca$var$toggleNode = (typeOrName, toggleTypeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        const toggleType = $7ffe772c051bfcca$export$d168cba70360dd3d(toggleTypeOrName, state.schema);
        const isActive = $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, type, attributes);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        if (isActive) return commands.setNode(toggleType, attributesToCopy);
        // If the node is not active, we want to set the new node type with the given attributes
        // Copying over the attributes from the current node if the selection is pointing to a node of the same type
        return commands.setNode(type, {
            ...attributesToCopy,
            ...attributes
        });
    };
const $7ffe772c051bfcca$var$toggleWrap = (typeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $7ffe772c051bfcca$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.lift(type);
        return commands.wrapIn(type, attributes);
    };
const $7ffe772c051bfcca$var$undoInputRule = ()=>({ state: state, dispatch: dispatch })=>{
        const plugins = state.plugins;
        for(let i = 0; i < plugins.length; i += 1){
            const plugin = plugins[i];
            let undoable;
            // @ts-ignore
            // eslint-disable-next-line
            if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
                if (dispatch) {
                    const tr = state.tr;
                    const toUndo = undoable.transform;
                    for(let j = toUndo.steps.length - 1; j >= 0; j -= 1)tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                    if (undoable.text) {
                        const marks = tr.doc.resolve(undoable.from).marks();
                        tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                    } else tr.delete(undoable.from, undoable.to);
                }
                return true;
            }
        }
        return false;
    };
const $7ffe772c051bfcca$var$unsetAllMarks = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        if (empty) return true;
        if (dispatch) ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
        return true;
    };
const $7ffe772c051bfcca$var$unsetMark = (typeOrName, options = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        var _a;
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const { selection: selection } = tr;
        const type = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { $from: $from, empty: empty, ranges: ranges } = selection;
        if (!dispatch) return true;
        if (empty && extendEmptyMarkRange) {
            let { from: from, to: to } = selection;
            const attrs = (_a = $from.marks().find((mark)=>mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
            const range = $7ffe772c051bfcca$export$8ceae6d06f5c4df5($from, type, attrs);
            if (range) {
                from = range.from;
                to = range.to;
            }
            tr.removeMark(from, to, type);
        } else ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
        tr.removeStoredMark(type);
        return true;
    };
const $7ffe772c051bfcca$var$updateAttributes = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $7ffe772c051bfcca$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === 'node') nodeType = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === 'mark') markType = $7ffe772c051bfcca$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) state.doc.nodesBetween(from, to, (node, pos)=>{
                if (nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
            });
            else state.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos < from && nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
                if (pos >= from && pos <= to) {
                    if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        ...attributes
                    });
                    if (markType && node.marks.length) node.marks.forEach((mark)=>{
                        if (markType === mark.type) {
                            const trimmedFrom2 = Math.max(pos, from);
                            const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                            tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                ...mark.attrs,
                                ...attributes
                            }));
                        }
                    });
                }
            });
            if (lastNode) {
                if (lastPos !== undefined) tr.setNodeMarkup(lastPos, undefined, {
                    ...lastNode.attrs,
                    ...attributes
                });
                if (markType && lastNode.marks.length) lastNode.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(trimmedFrom, trimmedTo, markType.create({
                        ...mark.attrs,
                        ...attributes
                    }));
                });
            }
        });
        return true;
    };
const $7ffe772c051bfcca$var$wrapIn = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $g6HTq.wrapIn)(type, attributes)(state, dispatch);
    };
const $7ffe772c051bfcca$var$wrapInList = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $7ffe772c051bfcca$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $cWB7z.wrapInList)(type, attributes)(state, dispatch);
    };
var $7ffe772c051bfcca$var$commands = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blur: $7ffe772c051bfcca$var$blur,
    clearContent: $7ffe772c051bfcca$var$clearContent,
    clearNodes: $7ffe772c051bfcca$var$clearNodes,
    command: $7ffe772c051bfcca$var$command,
    createParagraphNear: $7ffe772c051bfcca$var$createParagraphNear,
    cut: $7ffe772c051bfcca$var$cut,
    deleteCurrentNode: $7ffe772c051bfcca$var$deleteCurrentNode,
    deleteNode: $7ffe772c051bfcca$var$deleteNode,
    deleteRange: $7ffe772c051bfcca$var$deleteRange,
    deleteSelection: $7ffe772c051bfcca$var$deleteSelection,
    enter: $7ffe772c051bfcca$var$enter,
    exitCode: $7ffe772c051bfcca$var$exitCode,
    extendMarkRange: $7ffe772c051bfcca$var$extendMarkRange,
    first: $7ffe772c051bfcca$var$first,
    focus: $7ffe772c051bfcca$var$focus,
    forEach: $7ffe772c051bfcca$var$forEach,
    insertContent: $7ffe772c051bfcca$var$insertContent,
    insertContentAt: $7ffe772c051bfcca$var$insertContentAt,
    joinBackward: $7ffe772c051bfcca$var$joinBackward,
    joinDown: $7ffe772c051bfcca$var$joinDown,
    joinForward: $7ffe772c051bfcca$var$joinForward,
    joinItemBackward: $7ffe772c051bfcca$var$joinItemBackward,
    joinItemForward: $7ffe772c051bfcca$var$joinItemForward,
    joinTextblockBackward: $7ffe772c051bfcca$var$joinTextblockBackward,
    joinTextblockForward: $7ffe772c051bfcca$var$joinTextblockForward,
    joinUp: $7ffe772c051bfcca$var$joinUp,
    keyboardShortcut: $7ffe772c051bfcca$var$keyboardShortcut,
    lift: $7ffe772c051bfcca$var$lift,
    liftEmptyBlock: $7ffe772c051bfcca$var$liftEmptyBlock,
    liftListItem: $7ffe772c051bfcca$var$liftListItem,
    newlineInCode: $7ffe772c051bfcca$var$newlineInCode,
    resetAttributes: $7ffe772c051bfcca$var$resetAttributes,
    scrollIntoView: $7ffe772c051bfcca$var$scrollIntoView,
    selectAll: $7ffe772c051bfcca$var$selectAll,
    selectNodeBackward: $7ffe772c051bfcca$var$selectNodeBackward,
    selectNodeForward: $7ffe772c051bfcca$var$selectNodeForward,
    selectParentNode: $7ffe772c051bfcca$var$selectParentNode,
    selectTextblockEnd: $7ffe772c051bfcca$var$selectTextblockEnd,
    selectTextblockStart: $7ffe772c051bfcca$var$selectTextblockStart,
    setContent: $7ffe772c051bfcca$var$setContent,
    setMark: $7ffe772c051bfcca$var$setMark,
    setMeta: $7ffe772c051bfcca$var$setMeta,
    setNode: $7ffe772c051bfcca$var$setNode,
    setNodeSelection: $7ffe772c051bfcca$var$setNodeSelection,
    setTextSelection: $7ffe772c051bfcca$var$setTextSelection,
    sinkListItem: $7ffe772c051bfcca$var$sinkListItem,
    splitBlock: $7ffe772c051bfcca$var$splitBlock,
    splitListItem: $7ffe772c051bfcca$var$splitListItem,
    toggleList: $7ffe772c051bfcca$var$toggleList,
    toggleMark: $7ffe772c051bfcca$var$toggleMark,
    toggleNode: $7ffe772c051bfcca$var$toggleNode,
    toggleWrap: $7ffe772c051bfcca$var$toggleWrap,
    undoInputRule: $7ffe772c051bfcca$var$undoInputRule,
    unsetAllMarks: $7ffe772c051bfcca$var$unsetAllMarks,
    unsetMark: $7ffe772c051bfcca$var$unsetMark,
    updateAttributes: $7ffe772c051bfcca$var$updateAttributes,
    wrapIn: $7ffe772c051bfcca$var$wrapIn,
    wrapInList: $7ffe772c051bfcca$var$wrapInList
});
const $7ffe772c051bfcca$var$Commands = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'commands',
    addCommands () {
        return {
            ...$7ffe772c051bfcca$var$commands
        };
    }
});
const $7ffe772c051bfcca$var$Drop = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'drop',
    addProseMirrorPlugins () {
        return [
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('tiptapDrop'),
                props: {
                    handleDrop: (_, e, slice, moved)=>{
                        this.editor.emit('drop', {
                            editor: this.editor,
                            event: e,
                            slice: slice,
                            moved: moved
                        });
                    }
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$Editable = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'editable',
    addProseMirrorPlugins () {
        return [
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('editable'),
                props: {
                    editable: ()=>this.editor.options.editable
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$focusEventsPluginKey = new (0, $eCBI9.PluginKey)('focusEvents');
const $7ffe772c051bfcca$var$FocusEvents = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'focusEvents',
    addProseMirrorPlugins () {
        const { editor: editor } = this;
        return [
            new (0, $eCBI9.Plugin)({
                key: $7ffe772c051bfcca$var$focusEventsPluginKey,
                props: {
                    handleDOMEvents: {
                        focus: (view, event)=>{
                            editor.isFocused = true;
                            const transaction = editor.state.tr.setMeta('focus', {
                                event: event
                            }).setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event)=>{
                            editor.isFocused = false;
                            const transaction = editor.state.tr.setMeta('blur', {
                                event: event
                            }).setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        }
                    }
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$Keymap = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'keymap',
    addKeyboardShortcuts () {
        const handleBackspace = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.undoInputRule(),
                    // maybe convert first text block node to default node
                    ()=>commands.command(({ tr: tr })=>{
                            const { selection: selection, doc: doc } = tr;
                            const { empty: empty, $anchor: $anchor } = selection;
                            const { pos: pos, parent: parent } = $anchor;
                            const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                            const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                            const parentPos = $anchor.pos - $anchor.parentOffset;
                            const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : (0, $eCBI9.Selection).atStart(doc).from === pos;
                            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === 'paragraph' // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                            ) return false;
                            return commands.clearNodes();
                        }),
                    ()=>commands.deleteSelection(),
                    ()=>commands.joinBackward(),
                    ()=>commands.selectNodeBackward()
                ]);
        const handleDelete = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.deleteSelection(),
                    ()=>commands.deleteCurrentNode(),
                    ()=>commands.joinForward(),
                    ()=>commands.selectNodeForward()
                ]);
        const handleEnter = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.newlineInCode(),
                    ()=>commands.createParagraphNear(),
                    ()=>commands.liftEmptyBlock(),
                    ()=>commands.splitBlock()
                ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': ()=>this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': ()=>this.editor.commands.selectAll()
        };
        const pcKeymap = {
            ...baseKeymap
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': ()=>this.editor.commands.selectTextblockStart(),
            'Ctrl-e': ()=>this.editor.commands.selectTextblockEnd()
        };
        if ($7ffe772c051bfcca$export$86c1a3f9ab33da5c() || $7ffe772c051bfcca$export$6159e43e50a41987()) return macKeymap;
        return pcKeymap;
    },
    addProseMirrorPlugins () {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('clearDocument'),
                appendTransaction: (transactions, oldState, newState)=>{
                    if (transactions.some((tr)=>tr.getMeta('composition'))) return;
                    const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some((transaction)=>transaction.getMeta('preventClearDocument'));
                    if (!docChanges || ignoreTr) return;
                    const { empty: empty, from: from, to: to } = oldState.selection;
                    const allFrom = (0, $eCBI9.Selection).atStart(oldState.doc).from;
                    const allEnd = (0, $eCBI9.Selection).atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) return;
                    const isEmpty = $7ffe772c051bfcca$export$cd58ff1081f6abe9(newState.doc);
                    if (!isEmpty) return;
                    const tr = newState.tr;
                    const state = $7ffe772c051bfcca$export$83e24c5933427696({
                        state: newState,
                        transaction: tr
                    });
                    const { commands: commands } = new $7ffe772c051bfcca$export$475014de15a4c342({
                        editor: this.editor,
                        state: state
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) return;
                    return tr;
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$Paste = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'paste',
    addProseMirrorPlugins () {
        return [
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('tiptapPaste'),
                props: {
                    handlePaste: (_view, e, slice)=>{
                        this.editor.emit('paste', {
                            editor: this.editor,
                            event: e,
                            slice: slice
                        });
                    }
                }
            })
        ];
    }
});
const $7ffe772c051bfcca$var$Tabindex = $7ffe772c051bfcca$export$eeddbf09bb970356.create({
    name: 'tabindex',
    addProseMirrorPlugins () {
        return [
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('tabindex'),
                props: {
                    attributes: ()=>this.editor.isEditable ? {
                            tabindex: '0'
                        } : {}
                }
            })
        ];
    }
});
var $7ffe772c051bfcca$export$cc3e2d3244e01b7f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ClipboardTextSerializer: $7ffe772c051bfcca$var$ClipboardTextSerializer,
    Commands: $7ffe772c051bfcca$var$Commands,
    Drop: $7ffe772c051bfcca$var$Drop,
    Editable: $7ffe772c051bfcca$var$Editable,
    FocusEvents: $7ffe772c051bfcca$var$FocusEvents,
    Keymap: $7ffe772c051bfcca$var$Keymap,
    Paste: $7ffe772c051bfcca$var$Paste,
    Tabindex: $7ffe772c051bfcca$var$Tabindex,
    focusEventsPluginKey: $7ffe772c051bfcca$var$focusEventsPluginKey
});
class $7ffe772c051bfcca$export$50c0270e74640068 {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null){
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can\u{2019}t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({
            from: from,
            to: to
        }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) return this.pos;
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to
        };
    }
    get to() {
        if (this.isBlock) return this.pos + this.size;
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) return null;
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new $7ffe772c051bfcca$export$50c0270e74640068($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.from - 3);
        return new $7ffe772c051bfcca$export$50c0270e74640068($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.to + 3);
        return new $7ffe772c051bfcca$export$50c0270e74640068($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset)=>{
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) return;
            const childNodePos = new $7ffe772c051bfcca$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) childNodePos.actualDepth = this.depth + 1;
            children.push(new $7ffe772c051bfcca$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while(currentNode && !node){
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for(let index = 0; index < attrKeys.length; index += 1){
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) break;
                    }
                } else node = currentNode;
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) return nodes;
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */ this.children.forEach((childPos)=>{
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) return;
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every((key)=>attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) nodes.push(childPos);
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) return;
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr: tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes
        });
        this.editor.view.dispatch(tr);
    }
}
const $7ffe772c051bfcca$var$style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function $7ffe772c051bfcca$export$48321b481dd8a36(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ''}]`);
    if (tiptapStyleTag !== null) return tiptapStyleTag;
    const styleNode = document.createElement('style');
    if (nonce) styleNode.setAttribute('nonce', nonce);
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ''}`, '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}
class $7ffe772c051bfcca$export$7cda8d932e2f33c0 extends $7ffe772c051bfcca$var$EventEmitter {
    constructor(options = {}){
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */ this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            onBeforeCreate: ()=>null,
            onCreate: ()=>null,
            onUpdate: ()=>null,
            onSelectionUpdate: ()=>null,
            onTransaction: ()=>null,
            onFocus: ()=>null,
            onBlur: ()=>null,
            onDestroy: ()=>null,
            onContentError: ({ error: error })=>{
                throw error;
            },
            onPaste: ()=>null,
            onDrop: ()=>null
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', {
            editor: this
        });
        this.on('contentError', this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        this.on('drop', ({ event: event, slice: slice, moved: moved })=>this.options.onDrop(event, slice, moved));
        this.on('paste', ({ event: event, slice: slice })=>this.options.onPaste(event, slice));
        window.setTimeout(()=>{
            if (this.isDestroyed) return;
            this.commands.focus(this.options.autofocus);
            this.emit('create', {
                editor: this
            });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */ get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */ get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */ chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */ can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */ injectCSS() {
        if (this.options.injectCSS && document) this.css = $7ffe772c051bfcca$export$48321b481dd8a36($7ffe772c051bfcca$var$style, this.options.injectNonce);
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */ setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options
        };
        if (!this.view || !this.state || this.isDestroyed) return;
        if (this.options.editorProps) this.view.setProps(this.options.editorProps);
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */ setEditable(editable, emitUpdate = true) {
        this.setOptions({
            editable: editable
        });
        if (emitUpdate) this.emit('update', {
            editor: this,
            transaction: this.state.tr
        });
    }
    /**
     * Returns whether the editor is editable.
     */ get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */ get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */ registerPlugin(plugin, handlePlugins) {
        const plugins = $7ffe772c051bfcca$export$f6e2535fb5126e54(handlePlugins) ? handlePlugins(plugin, [
            ...this.state.plugins
        ]) : [
            ...this.state.plugins,
            plugin
        ];
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */ unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) return undefined;
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach((nameOrPluginKey)=>{
            // @ts-ignore
            const name = typeof nameOrPluginKey === 'string' ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = prevPlugins.filter((plugin)=>!plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) // No plugin was removed, so we don’t need to update the state
        return undefined;
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */ createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            $7ffe772c051bfcca$var$Editable,
            $7ffe772c051bfcca$var$ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
            }),
            $7ffe772c051bfcca$var$Commands,
            $7ffe772c051bfcca$var$FocusEvents,
            $7ffe772c051bfcca$var$Keymap,
            $7ffe772c051bfcca$var$Tabindex,
            $7ffe772c051bfcca$var$Drop,
            $7ffe772c051bfcca$var$Paste
        ].filter((ext)=>{
            if (typeof this.options.enableCoreExtensions === 'object') return this.options.enableCoreExtensions[ext.name] !== false;
            return true;
        }) : [];
        const allExtensions = [
            ...coreExtensions,
            ...this.options.extensions
        ].filter((extension)=>{
            return [
                'extension',
                'node',
                'mark'
            ].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new $7ffe772c051bfcca$var$ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */ createCommandManager() {
        this.commandManager = new $7ffe772c051bfcca$export$475014de15a4c342({
            editor: this
        });
    }
    /**
     * Creates a ProseMirror schema.
     */ createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */ createView() {
        var _a;
        let doc;
        try {
            doc = $7ffe772c051bfcca$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: this.options.enableContentCheck
            });
        } catch (e) {
            if (!(e instanceof Error) || ![
                '[tiptap error]: Invalid JSON content',
                '[tiptap error]: Invalid HTML content'
            ].includes(e.message)) // Not the content error we were expecting
            throw e;
            this.emit('contentError', {
                editor: this,
                error: e,
                disableCollaboration: ()=>{
                    if (this.storage.collaboration) this.storage.collaboration.isDisabled = true;
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter((extension)=>extension.name !== 'collaboration');
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                }
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = $7ffe772c051bfcca$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: false
            });
        }
        const selection = $7ffe772c051bfcca$export$225b0233b78e0d61(doc, this.options.autofocus);
        this.view = new (0, $fYi0r.EditorView)(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: 'textbox',
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: (0, $eCBI9.EditorState).create({
                doc: doc,
                selection: selection || undefined
            })
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */ createNodeViews() {
        if (this.view.isDestroyed) return;
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews
        });
    }
    /**
     * Prepend class name to element.
     */ prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */ dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) return;
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach((step)=>{
                var _a;
                return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
            });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit('beforeTransaction', {
            editor: this,
            transaction: transaction,
            nextState: state
        });
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction: transaction
        });
        if (selectionHasChanged) this.emit('selectionUpdate', {
            editor: this,
            transaction: transaction
        });
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) this.emit('focus', {
            editor: this,
            event: focus.event,
            transaction: transaction
        });
        if (blur) this.emit('blur', {
            editor: this,
            event: blur.event,
            transaction: transaction
        });
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) return;
        this.emit('update', {
            editor: this,
            transaction: transaction
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */ getAttributes(nameOrType) {
        return $7ffe772c051bfcca$export$fe94072fee8a6976(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
        return $7ffe772c051bfcca$export$39e04e72f972b885(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */ getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */ getHTML() {
        return $7ffe772c051bfcca$export$d1b60002472b2c81(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */ getText(options) {
        const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
        return $7ffe772c051bfcca$export$c72d34660a162238(this.state.doc, {
            blockSeparator: blockSeparator,
            textSerializers: {
                ...$7ffe772c051bfcca$export$fdd92b7d22ac071c(this.schema),
                ...textSerializers
            }
        });
    }
    /**
     * Check if there is no content.
     */ get isEmpty() {
        return $7ffe772c051bfcca$export$cd58ff1081f6abe9(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */ getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */ destroy() {
        this.emit('destroy');
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) delete dom.editor;
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */ get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new $7ffe772c051bfcca$export$50c0270e74640068($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $7ffe772c051bfcca$export$9f2cb743ab9131de(config) {
    return new $7ffe772c051bfcca$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $7ffe772c051bfcca$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $7ffe772c051bfcca$export$6ca56856dfeaf9b6(config) {
    return new $7ffe772c051bfcca$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const { tr: tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) matchStart = end;
                else end = matchStart + match[1].length;
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            } else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        }
    });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $7ffe772c051bfcca$export$cc081314d3f6ffb0(config) {
    return new $7ffe772c051bfcca$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const $start = state.doc.resolve(range.from);
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) return null;
            state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
        }
    });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $7ffe772c051bfcca$export$3ba5a5a15d18a35c(config) {
    return new $7ffe772c051bfcca$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $7ffe772c051bfcca$export$f7316d89abe4e1c1(config) {
    return new $7ffe772c051bfcca$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match, chain: chain })=>{
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && (0, $cMB55.findWrapping)(blockRange, config.type, attributes);
            if (!wrapping) return null;
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection: selection, storedMarks: storedMarks } = state;
                const { splittableMarks: splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                if (marks) {
                    const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */ const nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before && before.type === config.type && (0, $cMB55.canJoin)(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) tr.join(range.from - 1);
        }
    });
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $7ffe772c051bfcca$export$85c928794f8d04d4 {
    constructor(config = {}){
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $7ffe772c051bfcca$export$85c928794f8d04d4(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $7ffe772c051bfcca$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $7ffe772c051bfcca$export$85c928794f8d04d4(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $7ffe772c051bfcca$export$592682234826c0bd($7ffe772c051bfcca$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */ class $7ffe772c051bfcca$export$77c6811359a01a6f {
    constructor(component, props, options){
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view: view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]') : target.closest('[data-drag-handle]');
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) return;
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        const clonedNode = this.dom.cloneNode(true);
        (_g = event.dataTransfer) === null || _g === void 0 || _g.setDragImage(clonedNode, x, y);
        const pos = this.getPos();
        if (typeof pos !== 'number') return;
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = (0, $eCBI9.NodeSelection).create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) return false;
        if (typeof this.options.stopEvent === 'function') return this.options.stopEvent({
            event: event
        });
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) return false;
        const isDragEvent = event.type.startsWith('drag');
        const isDropEvent = event.type === 'drop';
        const isInput = [
            'INPUT',
            'BUTTON',
            'SELECT',
            'TEXTAREA'
        ].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) return true;
        const { isEditable: isEditable } = this.editor;
        const { isDragging: isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = (0, $eCBI9.NodeSelection).isSelectable(this.node);
        const isCopyEvent = event.type === 'copy';
        const isPasteEvent = event.type === 'paste';
        const isCutEvent = event.type === 'cut';
        const isClickEvent = event.type === 'mousedown';
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) event.preventDefault();
        if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest('[data-drag-handle]');
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener('dragend', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener('drop', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener('mouseup', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
            }
        }
        // these events are handled by prosemirror
        if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */ ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) return true;
        if (typeof this.options.ignoreMutation === 'function') return this.options.ignoreMutation({
            mutation: mutation
        });
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) return true;
        // ProseMirror should handle any selections
        if (mutation.type === 'selection') return false;
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target) && mutation.type === 'childList' && ($7ffe772c051bfcca$export$86c1a3f9ab33da5c() || $7ffe772c051bfcca$var$isAndroid()) && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes)
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every((node)=>node.isContentEditable)) return false;
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === 'attributes') return true;
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) return false;
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */ updateAttributes(attributes) {
        this.editor.commands.command(({ tr: tr })=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return false;
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */ deleteNode() {
        const from = this.getPos();
        if (typeof from !== 'number') return;
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({
            from: from,
            to: to
        });
    }
}
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $7ffe772c051bfcca$export$3845eb97abe74944(config) {
    return new $7ffe772c051bfcca$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match, pasteEvent: pasteEvent })=>{
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $7ffe772c051bfcca$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
// source: https://stackoverflow.com/a/6969486
function $7ffe772c051bfcca$export$d3f82eb9fcc60fbc(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function $7ffe772c051bfcca$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $7ffe772c051bfcca$export$3cb77ada4d0e5bd5(config) {
    return new $7ffe772c051bfcca$export$e75df4392d073e98({
        find: config.find,
        handler ({ match: match, chain: chain, range: range, pasteEvent: pasteEvent }) {
            const attributes = $7ffe772c051bfcca$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            const content = $7ffe772c051bfcca$export$592682234826c0bd(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) return null;
            const node = {
                type: config.type.name,
                attrs: attributes
            };
            if (content) node.content = content;
            if (match.input) chain().deleteRange(range).insertContentAt(range.from, node);
        }
    });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $7ffe772c051bfcca$export$1aff23e8795559fa(config) {
    return new $7ffe772c051bfcca$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
class $7ffe772c051bfcca$export$254d9747e34ddc90 {
    constructor(transaction){
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps.slice(this.currentStep).reduce((newPosition, step)=>{
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) deleted = true;
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted: deleted
        };
    }
}

});
parcelRegister("goWEd", function(module, exports) {
$parcel$export(module.exports, "AllSelection", () => (parcelRequire("eCBI9")).AllSelection);
$parcel$export(module.exports, "EditorState", () => (parcelRequire("eCBI9")).EditorState);
$parcel$export(module.exports, "NodeSelection", () => (parcelRequire("eCBI9")).NodeSelection);
$parcel$export(module.exports, "Plugin", () => (parcelRequire("eCBI9")).Plugin);
$parcel$export(module.exports, "PluginKey", () => (parcelRequire("eCBI9")).PluginKey);
$parcel$export(module.exports, "Selection", () => (parcelRequire("eCBI9")).Selection);
$parcel$export(module.exports, "TextSelection", () => (parcelRequire("eCBI9")).TextSelection);
// state/index.ts
parcelRequire("eCBI9");

});
parcelRegister("eCBI9", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $aa51ddf2f1c9f916$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $aa51ddf2f1c9f916$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $aa51ddf2f1c9f916$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $aa51ddf2f1c9f916$export$e2940151ac854c0b);
$parcel$export(module.exports, "EditorState", () => $aa51ddf2f1c9f916$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $aa51ddf2f1c9f916$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $aa51ddf2f1c9f916$export$1692d8b0e89cecc3);

var $jcs10 = parcelRequire("jcs10");

var $cMB55 = parcelRequire("cMB55");
const $aa51ddf2f1c9f916$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $aa51ddf2f1c9f916$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $aa51ddf2f1c9f916$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $jcs10.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $jcs10.Slice).empty : content);
            if (i == 0) $aa51ddf2f1c9f916$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $aa51ddf2f1c9f916$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $aa51ddf2f1c9f916$export$c2b25f346d19bcbb($pos) : $aa51ddf2f1c9f916$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $aa51ddf2f1c9f916$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $aa51ddf2f1c9f916$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $aa51ddf2f1c9f916$var$findSelectionIn(doc, doc, 0, 0, 1) || new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $aa51ddf2f1c9f916$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $aa51ddf2f1c9f916$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $aa51ddf2f1c9f916$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $aa51ddf2f1c9f916$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $aa51ddf2f1c9f916$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$aa51ddf2f1c9f916$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $aa51ddf2f1c9f916$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $aa51ddf2f1c9f916$var$warnedAboutTextSelection = false;
function $aa51ddf2f1c9f916$var$checkTextSelection($pos) {
    if (!$aa51ddf2f1c9f916$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $aa51ddf2f1c9f916$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $aa51ddf2f1c9f916$export$c2b25f346d19bcbb extends $aa51ddf2f1c9f916$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $aa51ddf2f1c9f916$var$checkTextSelection($anchor);
        $aa51ddf2f1c9f916$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $aa51ddf2f1c9f916$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $aa51ddf2f1c9f916$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $jcs10.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $jcs10.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $aa51ddf2f1c9f916$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $aa51ddf2f1c9f916$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $aa51ddf2f1c9f916$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $aa51ddf2f1c9f916$export$52baac22726c72bf.findFrom($head, bias, true) || $aa51ddf2f1c9f916$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $aa51ddf2f1c9f916$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($aa51ddf2f1c9f916$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $aa51ddf2f1c9f916$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $aa51ddf2f1c9f916$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$aa51ddf2f1c9f916$export$52baac22726c72bf.jsonID("text", $aa51ddf2f1c9f916$export$c2b25f346d19bcbb);
class $aa51ddf2f1c9f916$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $aa51ddf2f1c9f916$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $aa51ddf2f1c9f916$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $aa51ddf2f1c9f916$export$e2940151ac854c0b extends $aa51ddf2f1c9f916$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $aa51ddf2f1c9f916$export$52baac22726c72bf.near($pos);
        return new $aa51ddf2f1c9f916$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $aa51ddf2f1c9f916$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $aa51ddf2f1c9f916$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $aa51ddf2f1c9f916$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $aa51ddf2f1c9f916$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$aa51ddf2f1c9f916$export$e2940151ac854c0b.prototype.visible = false;
$aa51ddf2f1c9f916$export$52baac22726c72bf.jsonID("node", $aa51ddf2f1c9f916$export$e2940151ac854c0b);
class $aa51ddf2f1c9f916$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $aa51ddf2f1c9f916$var$TextBookmark(pos, pos) : new $aa51ddf2f1c9f916$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $aa51ddf2f1c9f916$export$e2940151ac854c0b.isSelectable(node)) return new $aa51ddf2f1c9f916$export$e2940151ac854c0b($pos);
        return $aa51ddf2f1c9f916$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95 extends $aa51ddf2f1c9f916$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $jcs10.Slice).empty) {
        if (content == (0, $jcs10.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $aa51ddf2f1c9f916$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $aa51ddf2f1c9f916$var$AllBookmark;
    }
}
$aa51ddf2f1c9f916$export$52baac22726c72bf.jsonID("all", $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95);
const $aa51ddf2f1c9f916$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $aa51ddf2f1c9f916$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $aa51ddf2f1c9f916$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $aa51ddf2f1c9f916$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $aa51ddf2f1c9f916$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $aa51ddf2f1c9f916$export$e2940151ac854c0b.isSelectable(child)) return $aa51ddf2f1c9f916$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $aa51ddf2f1c9f916$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $cMB55.ReplaceStep) || step instanceof (0, $cMB55.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($aa51ddf2f1c9f916$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $aa51ddf2f1c9f916$var$UPDATED_SEL = 1, $aa51ddf2f1c9f916$var$UPDATED_MARKS = 2, $aa51ddf2f1c9f916$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $aa51ddf2f1c9f916$export$febc5573c75cefb0 extends (0, $cMB55.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $aa51ddf2f1c9f916$var$UPDATED_SEL) & ~$aa51ddf2f1c9f916$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $aa51ddf2f1c9f916$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $aa51ddf2f1c9f916$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $jcs10.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $aa51ddf2f1c9f916$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$aa51ddf2f1c9f916$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $jcs10.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($aa51ddf2f1c9f916$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $aa51ddf2f1c9f916$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $aa51ddf2f1c9f916$var$UPDATED_SCROLL) > 0;
    }
}
function $aa51ddf2f1c9f916$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $aa51ddf2f1c9f916$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $aa51ddf2f1c9f916$var$bind(desc.init, self);
        this.apply = $aa51ddf2f1c9f916$var$bind(desc.apply, self);
    }
}
const $aa51ddf2f1c9f916$var$baseFields = [
    new $aa51ddf2f1c9f916$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $aa51ddf2f1c9f916$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $aa51ddf2f1c9f916$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $aa51ddf2f1c9f916$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $aa51ddf2f1c9f916$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $aa51ddf2f1c9f916$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $aa51ddf2f1c9f916$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $aa51ddf2f1c9f916$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $aa51ddf2f1c9f916$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $aa51ddf2f1c9f916$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $aa51ddf2f1c9f916$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $aa51ddf2f1c9f916$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $aa51ddf2f1c9f916$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $aa51ddf2f1c9f916$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $aa51ddf2f1c9f916$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $aa51ddf2f1c9f916$var$Configuration(config.schema, config.plugins);
        let instance = new $aa51ddf2f1c9f916$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $jcs10.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $aa51ddf2f1c9f916$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $aa51ddf2f1c9f916$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $aa51ddf2f1c9f916$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $aa51ddf2f1c9f916$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $aa51ddf2f1c9f916$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $aa51ddf2f1c9f916$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $aa51ddf2f1c9f916$var$keys = Object.create(null);
function $aa51ddf2f1c9f916$var$createKey(name) {
    if (name in $aa51ddf2f1c9f916$var$keys) return name + "$" + ++$aa51ddf2f1c9f916$var$keys[name];
    $aa51ddf2f1c9f916$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $aa51ddf2f1c9f916$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $aa51ddf2f1c9f916$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("jcs10", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $dfa4de91dd2bb60a$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $dfa4de91dd2bb60a$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $dfa4de91dd2bb60a$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "NodeRange", () => $dfa4de91dd2bb60a$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $dfa4de91dd2bb60a$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $dfa4de91dd2bb60a$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $dfa4de91dd2bb60a$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $dfa4de91dd2bb60a$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $dfa4de91dd2bb60a$export$3476b78f8f5a8b72);

var $5xrVZ = parcelRequire("5xrVZ");
function $dfa4de91dd2bb60a$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $dfa4de91dd2bb60a$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $dfa4de91dd2bb60a$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $dfa4de91dd2bb60a$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $dfa4de91dd2bb60a$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $dfa4de91dd2bb60a$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $dfa4de91dd2bb60a$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $dfa4de91dd2bb60a$var$retIndex(0, pos);
        if (pos == this.size) return $dfa4de91dd2bb60a$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $dfa4de91dd2bb60a$var$retIndex(i + 1, end);
                return $dfa4de91dd2bb60a$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty;
        if (nodes instanceof $dfa4de91dd2bb60a$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $dfa4de91dd2bb60a$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty = new $dfa4de91dd2bb60a$export$ffb0004e005737fa([], 0);
const $dfa4de91dd2bb60a$var$found = {
    index: 0,
    offset: 0
};
function $dfa4de91dd2bb60a$var$retIndex(index, offset) {
    $dfa4de91dd2bb60a$var$found.index = index;
    $dfa4de91dd2bb60a$var$found.offset = offset;
    return $dfa4de91dd2bb60a$var$found;
}
function $dfa4de91dd2bb60a$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$dfa4de91dd2bb60a$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$dfa4de91dd2bb60a$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $dfa4de91dd2bb60a$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $dfa4de91dd2bb60a$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
        if (marks instanceof $dfa4de91dd2bb60a$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $dfa4de91dd2bb60a$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $dfa4de91dd2bb60a$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e($dfa4de91dd2bb60a$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e($dfa4de91dd2bb60a$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e.empty = new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e($dfa4de91dd2bb60a$export$ffb0004e005737fa.empty, 0, 0);
function $dfa4de91dd2bb60a$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($dfa4de91dd2bb60a$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $dfa4de91dd2bb60a$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $dfa4de91dd2bb60a$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $dfa4de91dd2bb60a$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $dfa4de91dd2bb60a$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $dfa4de91dd2bb60a$export$6de0e778727af3f2("Inconsistent open depths");
    return $dfa4de91dd2bb60a$var$replaceOuter($from, $to, slice, 0);
}
function $dfa4de91dd2bb60a$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $dfa4de91dd2bb60a$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $dfa4de91dd2bb60a$var$close(node, $dfa4de91dd2bb60a$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $dfa4de91dd2bb60a$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $dfa4de91dd2bb60a$var$prepareSliceForReplace(slice, $from);
        return $dfa4de91dd2bb60a$var$close(node, $dfa4de91dd2bb60a$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $dfa4de91dd2bb60a$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $dfa4de91dd2bb60a$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $dfa4de91dd2bb60a$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $dfa4de91dd2bb60a$var$checkJoin(node, $after.node(depth));
    return node;
}
function $dfa4de91dd2bb60a$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $dfa4de91dd2bb60a$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $dfa4de91dd2bb60a$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$dfa4de91dd2bb60a$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $dfa4de91dd2bb60a$var$addNode($end.nodeBefore, target);
}
function $dfa4de91dd2bb60a$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $dfa4de91dd2bb60a$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $dfa4de91dd2bb60a$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $dfa4de91dd2bb60a$var$joinable($end, $to, depth + 1);
    let content = [];
    $dfa4de91dd2bb60a$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $dfa4de91dd2bb60a$var$checkJoin(openStart, openEnd);
        $dfa4de91dd2bb60a$var$addNode($dfa4de91dd2bb60a$var$close(openStart, $dfa4de91dd2bb60a$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $dfa4de91dd2bb60a$var$addNode($dfa4de91dd2bb60a$var$close(openStart, $dfa4de91dd2bb60a$var$replaceTwoWay($from, $start, depth + 1)), content);
        $dfa4de91dd2bb60a$var$addRange($start, $end, depth, content);
        if (openEnd) $dfa4de91dd2bb60a$var$addNode($dfa4de91dd2bb60a$var$close(openEnd, $dfa4de91dd2bb60a$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $dfa4de91dd2bb60a$var$addRange($to, null, depth, content);
    return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(content);
}
function $dfa4de91dd2bb60a$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $dfa4de91dd2bb60a$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $dfa4de91dd2bb60a$var$joinable($from, $to, depth + 1);
        $dfa4de91dd2bb60a$var$addNode($dfa4de91dd2bb60a$var$close(type, $dfa4de91dd2bb60a$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $dfa4de91dd2bb60a$var$addRange($to, null, depth, content);
    return new $dfa4de91dd2bb60a$export$ffb0004e005737fa(content);
}
function $dfa4de91dd2bb60a$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($dfa4de91dd2bb60a$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $dfa4de91dd2bb60a$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $dfa4de91dd2bb60a$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $dfa4de91dd2bb60a$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $dfa4de91dd2bb60a$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $dfa4de91dd2bb60a$var$resolveCache.set(doc, cache = new $dfa4de91dd2bb60a$var$ResolveCache);
        let result = cache.elts[cache.i] = $dfa4de91dd2bb60a$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $dfa4de91dd2bb60a$var$resolveCacheSize;
        return result;
    }
}
class $dfa4de91dd2bb60a$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $dfa4de91dd2bb60a$var$resolveCacheSize = 12, $dfa4de91dd2bb60a$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $dfa4de91dd2bb60a$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $dfa4de91dd2bb60a$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $dfa4de91dd2bb60a$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $dfa4de91dd2bb60a$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $dfa4de91dd2bb60a$var$emptyAttrs) && $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $dfa4de91dd2bb60a$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $dfa4de91dd2bb60a$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $dfa4de91dd2bb60a$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $dfa4de91dd2bb60a$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $dfa4de91dd2bb60a$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $dfa4de91dd2bb60a$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $dfa4de91dd2bb60a$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$dfa4de91dd2bb60a$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $dfa4de91dd2bb60a$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$dfa4de91dd2bb60a$export$85c928794f8d04d4.prototype.text = undefined;
class $dfa4de91dd2bb60a$var$TextNode extends $dfa4de91dd2bb60a$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $dfa4de91dd2bb60a$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $dfa4de91dd2bb60a$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $dfa4de91dd2bb60a$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $dfa4de91dd2bb60a$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $dfa4de91dd2bb60a$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $dfa4de91dd2bb60a$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $dfa4de91dd2bb60a$export$364ed450558d7ec4.empty;
        let expr = $dfa4de91dd2bb60a$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $dfa4de91dd2bb60a$var$dfa($dfa4de91dd2bb60a$var$nfa(expr));
        $dfa4de91dd2bb60a$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $dfa4de91dd2bb60a$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $dfa4de91dd2bb60a$export$364ed450558d7ec4.empty = new $dfa4de91dd2bb60a$export$364ed450558d7ec4(true);
class $dfa4de91dd2bb60a$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $dfa4de91dd2bb60a$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($dfa4de91dd2bb60a$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $dfa4de91dd2bb60a$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($dfa4de91dd2bb60a$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $dfa4de91dd2bb60a$var$parseExprSubscript(stream) {
    let expr = $dfa4de91dd2bb60a$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $dfa4de91dd2bb60a$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $dfa4de91dd2bb60a$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $dfa4de91dd2bb60a$var$parseExprRange(stream, expr) {
    let min = $dfa4de91dd2bb60a$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $dfa4de91dd2bb60a$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $dfa4de91dd2bb60a$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $dfa4de91dd2bb60a$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $dfa4de91dd2bb60a$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $dfa4de91dd2bb60a$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $dfa4de91dd2bb60a$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $dfa4de91dd2bb60a$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $dfa4de91dd2bb60a$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($dfa4de91dd2bb60a$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $dfa4de91dd2bb60a$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($dfa4de91dd2bb60a$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $dfa4de91dd2bb60a$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $dfa4de91dd2bb60a$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($dfa4de91dd2bb60a$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $dfa4de91dd2bb60a$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $dfa4de91dd2bb60a$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $dfa4de91dd2bb60a$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $dfa4de91dd2bb60a$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $dfa4de91dd2bb60a$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $dfa4de91dd2bb60a$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $dfa4de91dd2bb60a$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $dfa4de91dd2bb60a$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $dfa4de91dd2bb60a$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $dfa4de91dd2bb60a$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $dfa4de91dd2bb60a$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $dfa4de91dd2bb60a$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $dfa4de91dd2bb60a$export$ffb0004e005737fa.from(content), $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $dfa4de91dd2bb60a$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $dfa4de91dd2bb60a$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $dfa4de91dd2bb60a$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($dfa4de91dd2bb60a$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $dfa4de91dd2bb60a$export$85c928794f8d04d4(this, attrs, content.append(after), $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $dfa4de91dd2bb60a$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $dfa4de91dd2bb60a$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $dfa4de91dd2bb60a$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $dfa4de91dd2bb60a$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $dfa4de91dd2bb60a$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $dfa4de91dd2bb60a$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $dfa4de91dd2bb60a$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $dfa4de91dd2bb60a$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $dfa4de91dd2bb60a$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $dfa4de91dd2bb60a$export$c9d15bcfc6d42044(this, $dfa4de91dd2bb60a$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $dfa4de91dd2bb60a$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $dfa4de91dd2bb60a$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $dfa4de91dd2bb60a$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $5xrVZ.default).from(spec.nodes), instanceSpec.marks = (0, $5xrVZ.default).from(spec.marks || {}), this.nodes = $dfa4de91dd2bb60a$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $dfa4de91dd2bb60a$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $dfa4de91dd2bb60a$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $dfa4de91dd2bb60a$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $dfa4de91dd2bb60a$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $dfa4de91dd2bb60a$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $dfa4de91dd2bb60a$var$TextNode(type, type.defaultAttrs, text, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $dfa4de91dd2bb60a$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $dfa4de91dd2bb60a$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $dfa4de91dd2bb60a$var$isTagRule(rule) {
    return rule.tag != null;
}
function $dfa4de91dd2bb60a$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $dfa4de91dd2bb60a$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($dfa4de91dd2bb60a$var$isTagRule(rule)) this.tags.push(rule);
            else if ($dfa4de91dd2bb60a$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $dfa4de91dd2bb60a$var$ParseContext(this, options, false);
        context.addAll(dom, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $dfa4de91dd2bb60a$var$ParseContext(this, options, true);
        context.addAll(dom, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $dfa4de91dd2bb60a$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($dfa4de91dd2bb60a$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $dfa4de91dd2bb60a$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $dfa4de91dd2bb60a$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $dfa4de91dd2bb60a$export$1059c6e7d2ce5669(schema, $dfa4de91dd2bb60a$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $dfa4de91dd2bb60a$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $dfa4de91dd2bb60a$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $dfa4de91dd2bb60a$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS = 1, $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS_FULL = 2, $dfa4de91dd2bb60a$var$OPT_OPEN_LEFT = 4;
function $dfa4de91dd2bb60a$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS | $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS_FULL : base & ~$dfa4de91dd2bb60a$var$OPT_OPEN_LEFT;
}
class $dfa4de91dd2bb60a$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $dfa4de91dd2bb60a$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($dfa4de91dd2bb60a$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $dfa4de91dd2bb60a$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($dfa4de91dd2bb60a$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$dfa4de91dd2bb60a$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $dfa4de91dd2bb60a$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $dfa4de91dd2bb60a$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $dfa4de91dd2bb60a$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $dfa4de91dd2bb60a$var$NodeContext(topNode.type, topNode.attrs, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $dfa4de91dd2bb60a$var$NodeContext(null, null, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $dfa4de91dd2bb60a$var$NodeContext(parser.schema.topNodeType, null, $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($dfa4de91dd2bb60a$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $dfa4de91dd2bb60a$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $dfa4de91dd2bb60a$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($dfa4de91dd2bb60a$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $dfa4de91dd2bb60a$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $dfa4de91dd2bb60a$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $dfa4de91dd2bb60a$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $dfa4de91dd2bb60a$var$OPT_OPEN_LEFT;
        let applyMarks = $dfa4de91dd2bb60a$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $dfa4de91dd2bb60a$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $dfa4de91dd2bb60a$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $dfa4de91dd2bb60a$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $dfa4de91dd2bb60a$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $dfa4de91dd2bb60a$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $dfa4de91dd2bb60a$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $dfa4de91dd2bb60a$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $dfa4de91dd2bb60a$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $dfa4de91dd2bb60a$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $dfa4de91dd2bb60a$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $dfa4de91dd2bb60a$var$renderSpec($dfa4de91dd2bb60a$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $dfa4de91dd2bb60a$var$renderSpec($dfa4de91dd2bb60a$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $dfa4de91dd2bb60a$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $dfa4de91dd2bb60a$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $dfa4de91dd2bb60a$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $dfa4de91dd2bb60a$var$gatherToDOM(schema.marks);
    }
}
function $dfa4de91dd2bb60a$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $dfa4de91dd2bb60a$var$doc(options) {
    return options.document || window.document;
}
const $dfa4de91dd2bb60a$var$suspiciousAttributeCache = new WeakMap();
function $dfa4de91dd2bb60a$var$suspiciousAttributes(attrs) {
    let value = $dfa4de91dd2bb60a$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $dfa4de91dd2bb60a$var$suspiciousAttributeCache.set(attrs, value = $dfa4de91dd2bb60a$var$suspiciousAttributesInner(attrs));
    return value;
}
function $dfa4de91dd2bb60a$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $dfa4de91dd2bb60a$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $dfa4de91dd2bb60a$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $dfa4de91dd2bb60a$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("5xrVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4085b4019cc2fafc$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $4085b4019cc2fafc$var$OrderedMap(content) {
    this.content = content;
}
$4085b4019cc2fafc$var$OrderedMap.prototype = {
    constructor: $4085b4019cc2fafc$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $4085b4019cc2fafc$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $4085b4019cc2fafc$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $4085b4019cc2fafc$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $4085b4019cc2fafc$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $4085b4019cc2fafc$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $4085b4019cc2fafc$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $4085b4019cc2fafc$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $4085b4019cc2fafc$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $4085b4019cc2fafc$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $4085b4019cc2fafc$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$4085b4019cc2fafc$var$OrderedMap.from = function(value) {
    if (value instanceof $4085b4019cc2fafc$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $4085b4019cc2fafc$var$OrderedMap(content);
};
var $4085b4019cc2fafc$export$2e2bcd8739ae039 = $4085b4019cc2fafc$var$OrderedMap;

});


parcelRegister("cMB55", function(module, exports) {

$parcel$export(module.exports, "Mapping", () => $94e6bb3ff13c8c95$export$f5f785078011b62);
$parcel$export(module.exports, "ReplaceStep", () => $94e6bb3ff13c8c95$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $94e6bb3ff13c8c95$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $94e6bb3ff13c8c95$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $94e6bb3ff13c8c95$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $94e6bb3ff13c8c95$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $94e6bb3ff13c8c95$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $94e6bb3ff13c8c95$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "dropPoint", () => $94e6bb3ff13c8c95$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $94e6bb3ff13c8c95$export$ed6ac67359824afd);
$parcel$export(module.exports, "Transform", () => $94e6bb3ff13c8c95$export$563a914cafbdc389);

var $jcs10 = parcelRequire("jcs10");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $94e6bb3ff13c8c95$var$lower16 = 0xffff;
const $94e6bb3ff13c8c95$var$factor16 = Math.pow(2, 16);
function $94e6bb3ff13c8c95$var$makeRecover(index, offset) {
    return index + offset * $94e6bb3ff13c8c95$var$factor16;
}
function $94e6bb3ff13c8c95$var$recoverIndex(value) {
    return value & $94e6bb3ff13c8c95$var$lower16;
}
function $94e6bb3ff13c8c95$var$recoverOffset(value) {
    return (value - (value & $94e6bb3ff13c8c95$var$lower16)) / $94e6bb3ff13c8c95$var$factor16;
}
const $94e6bb3ff13c8c95$var$DEL_BEFORE = 1, $94e6bb3ff13c8c95$var$DEL_AFTER = 2, $94e6bb3ff13c8c95$var$DEL_ACROSS = 4, $94e6bb3ff13c8c95$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $94e6bb3ff13c8c95$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $94e6bb3ff13c8c95$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($94e6bb3ff13c8c95$var$DEL_BEFORE | $94e6bb3ff13c8c95$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($94e6bb3ff13c8c95$var$DEL_AFTER | $94e6bb3ff13c8c95$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $94e6bb3ff13c8c95$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $94e6bb3ff13c8c95$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty) return $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $94e6bb3ff13c8c95$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $94e6bb3ff13c8c95$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $94e6bb3ff13c8c95$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $94e6bb3ff13c8c95$var$DEL_AFTER : pos == end ? $94e6bb3ff13c8c95$var$DEL_BEFORE : $94e6bb3ff13c8c95$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $94e6bb3ff13c8c95$var$DEL_SIDE;
                return new $94e6bb3ff13c8c95$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $94e6bb3ff13c8c95$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $94e6bb3ff13c8c95$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $94e6bb3ff13c8c95$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty : new $94e6bb3ff13c8c95$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty = new $94e6bb3ff13c8c95$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $94e6bb3ff13c8c95$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(maps, /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps ? maps.length : 0){
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */ get maps() {
        return this._maps;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $94e6bb3ff13c8c95$export$f5f785078011b62(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $94e6bb3ff13c8c95$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $94e6bb3ff13c8c95$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $94e6bb3ff13c8c95$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $94e6bb3ff13c8c95$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $94e6bb3ff13c8c95$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $94e6bb3ff13c8c95$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $94e6bb3ff13c8c95$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $94e6bb3ff13c8c95$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $94e6bb3ff13c8c95$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $jcs10.ReplaceError)) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $94e6bb3ff13c8c95$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($94e6bb3ff13c8c95$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $jcs10.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $94e6bb3ff13c8c95$export$d24ba56b0e3464a9 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $94e6bb3ff13c8c95$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $94e6bb3ff13c8c95$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $94e6bb3ff13c8c95$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $94e6bb3ff13c8c95$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("addMark", $94e6bb3ff13c8c95$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $94e6bb3ff13c8c95$export$94150db1311f67a9 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $94e6bb3ff13c8c95$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $94e6bb3ff13c8c95$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $94e6bb3ff13c8c95$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $94e6bb3ff13c8c95$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("removeMark", $94e6bb3ff13c8c95$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $94e6bb3ff13c8c95$export$adefd16c402fee4e extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $94e6bb3ff13c8c95$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $94e6bb3ff13c8c95$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $94e6bb3ff13c8c95$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $94e6bb3ff13c8c95$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("addNodeMark", $94e6bb3ff13c8c95$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $94e6bb3ff13c8c95$export$fdf7d1dc10724da2 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $94e6bb3ff13c8c95$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $94e6bb3ff13c8c95$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("removeNodeMark", $94e6bb3ff13c8c95$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $94e6bb3ff13c8c95$export$5c860b2e74034756 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $94e6bb3ff13c8c95$var$contentBetween(doc, this.from, this.to)) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $94e6bb3ff13c8c95$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $94e6bb3ff13c8c95$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $94e6bb3ff13c8c95$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $94e6bb3ff13c8c95$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $jcs10.Slice).empty : new (0, $jcs10.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $94e6bb3ff13c8c95$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $jcs10.Slice).empty : new (0, $jcs10.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $94e6bb3ff13c8c95$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$5c860b2e74034756(json.from, json.to, (0, $jcs10.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("replace", $94e6bb3ff13c8c95$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $94e6bb3ff13c8c95$export$444ba800d6024a98 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($94e6bb3ff13c8c95$var$contentBetween(doc, this.from, this.gapFrom) || $94e6bb3ff13c8c95$var$contentBetween(doc, this.gapTo, this.to))) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $94e6bb3ff13c8c95$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $94e6bb3ff13c8c95$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $94e6bb3ff13c8c95$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $jcs10.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("replaceAround", $94e6bb3ff13c8c95$export$444ba800d6024a98);
function $94e6bb3ff13c8c95$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $94e6bb3ff13c8c95$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $94e6bb3ff13c8c95$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $94e6bb3ff13c8c95$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $94e6bb3ff13c8c95$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $jcs10.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $94e6bb3ff13c8c95$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $94e6bb3ff13c8c95$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $94e6bb3ff13c8c95$export$5c860b2e74034756(cur, end, (0, $jcs10.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $94e6bb3ff13c8c95$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $94e6bb3ff13c8c95$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $jcs10.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $jcs10.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $94e6bb3ff13c8c95$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $94e6bb3ff13c8c95$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$94e6bb3ff13c8c95$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $94e6bb3ff13c8c95$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $jcs10.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $jcs10.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $jcs10.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $jcs10.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $94e6bb3ff13c8c95$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $jcs10.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $94e6bb3ff13c8c95$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $94e6bb3ff13c8c95$var$findWrappingOutside(range, nodeType);
    let inner = around && $94e6bb3ff13c8c95$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($94e6bb3ff13c8c95$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($94e6bb3ff13c8c95$var$withAttrs));
}
function $94e6bb3ff13c8c95$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $94e6bb3ff13c8c95$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $94e6bb3ff13c8c95$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $94e6bb3ff13c8c95$var$wrap(tr, range, wrappers) {
    let content = (0, $jcs10.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $jcs10.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $94e6bb3ff13c8c95$export$444ba800d6024a98(start, end, start, end, new (0, $jcs10.Slice)(content, 0, 0), wrappers.length, true));
}
function $94e6bb3ff13c8c95$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $94e6bb3ff13c8c95$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $94e6bb3ff13c8c95$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $94e6bb3ff13c8c95$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $94e6bb3ff13c8c95$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $94e6bb3ff13c8c95$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $94e6bb3ff13c8c95$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $94e6bb3ff13c8c95$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $94e6bb3ff13c8c95$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $94e6bb3ff13c8c95$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $94e6bb3ff13c8c95$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $94e6bb3ff13c8c95$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $94e6bb3ff13c8c95$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $jcs10.Fragment).empty, after = (0, $jcs10.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $jcs10.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $jcs10.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $94e6bb3ff13c8c95$export$5c860b2e74034756(pos, pos, new (0, $jcs10.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $94e6bb3ff13c8c95$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $94e6bb3ff13c8c95$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $94e6bb3ff13c8c95$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $94e6bb3ff13c8c95$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $94e6bb3ff13c8c95$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $94e6bb3ff13c8c95$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $94e6bb3ff13c8c95$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $94e6bb3ff13c8c95$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $94e6bb3ff13c8c95$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $94e6bb3ff13c8c95$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $94e6bb3ff13c8c95$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $jcs10.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $94e6bb3ff13c8c95$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $94e6bb3ff13c8c95$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $94e6bb3ff13c8c95$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $94e6bb3ff13c8c95$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $jcs10.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($94e6bb3ff13c8c95$var$fitsTrivially($from, $to, slice)) return new $94e6bb3ff13c8c95$export$5c860b2e74034756(from, to, slice);
    return new $94e6bb3ff13c8c95$var$Fitter($from, $to, slice).fit();
}
function $94e6bb3ff13c8c95$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $94e6bb3ff13c8c95$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $jcs10.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $jcs10.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $jcs10.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $94e6bb3ff13c8c95$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $94e6bb3ff13c8c95$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $94e6bb3ff13c8c95$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $jcs10.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $94e6bb3ff13c8c95$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $jcs10.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $94e6bb3ff13c8c95$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($94e6bb3ff13c8c95$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $94e6bb3ff13c8c95$var$addToFragment(this.placed, frontierDepth, (0, $jcs10.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $jcs10.Slice).empty : new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$94e6bb3ff13c8c95$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $94e6bb3ff13c8c95$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $94e6bb3ff13c8c95$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $94e6bb3ff13c8c95$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $94e6bb3ff13c8c95$var$addToFragment(this.placed, this.depth, (0, $jcs10.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $jcs10.Fragment).empty, true);
        if (add.childCount) this.placed = $94e6bb3ff13c8c95$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $94e6bb3ff13c8c95$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($94e6bb3ff13c8c95$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $94e6bb3ff13c8c95$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($94e6bb3ff13c8c95$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $94e6bb3ff13c8c95$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $94e6bb3ff13c8c95$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $94e6bb3ff13c8c95$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $jcs10.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $94e6bb3ff13c8c95$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$94e6bb3ff13c8c95$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $94e6bb3ff13c8c95$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $94e6bb3ff13c8c95$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $94e6bb3ff13c8c95$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($94e6bb3ff13c8c95$var$fitsTrivially($from, $to, slice)) return tr.step(new $94e6bb3ff13c8c95$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $94e6bb3ff13c8c95$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $94e6bb3ff13c8c95$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $jcs10.Slice)($94e6bb3ff13c8c95$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $94e6bb3ff13c8c95$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($94e6bb3ff13c8c95$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $jcs10.Fragment).empty, true));
    }
    return fragment;
}
function $94e6bb3ff13c8c95$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $94e6bb3ff13c8c95$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(node), 0, 0));
}
function $94e6bb3ff13c8c95$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $94e6bb3ff13c8c95$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $94e6bb3ff13c8c95$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $94e6bb3ff13c8c95$export$626399c38172f669 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $94e6bb3ff13c8c95$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $94e6bb3ff13c8c95$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("attr", $94e6bb3ff13c8c95$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $94e6bb3ff13c8c95$export$f50707b396300ac9 extends $94e6bb3ff13c8c95$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $94e6bb3ff13c8c95$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $94e6bb3ff13c8c95$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $94e6bb3ff13c8c95$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $94e6bb3ff13c8c95$export$f50707b396300ac9(json.attr, json.value);
    }
}
$94e6bb3ff13c8c95$export$fd55ce593607084a.jsonID("docAttr", $94e6bb3ff13c8c95$export$f50707b396300ac9);
/**
@internal
*/ let $94e6bb3ff13c8c95$export$88cc3a1dfce48dd3 = class extends Error {
};
$94e6bb3ff13c8c95$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$94e6bb3ff13c8c95$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$94e6bb3ff13c8c95$export$88cc3a1dfce48dd3.prototype.constructor = $94e6bb3ff13c8c95$export$88cc3a1dfce48dd3;
$94e6bb3ff13c8c95$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $94e6bb3ff13c8c95$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $94e6bb3ff13c8c95$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $94e6bb3ff13c8c95$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $jcs10.Slice).empty) {
        let step = $94e6bb3ff13c8c95$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $jcs10.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $94e6bb3ff13c8c95$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $94e6bb3ff13c8c95$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $94e6bb3ff13c8c95$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $94e6bb3ff13c8c95$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $94e6bb3ff13c8c95$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $94e6bb3ff13c8c95$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $94e6bb3ff13c8c95$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $94e6bb3ff13c8c95$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $94e6bb3ff13c8c95$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $94e6bb3ff13c8c95$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $94e6bb3ff13c8c95$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $jcs10.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $94e6bb3ff13c8c95$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */ split(pos, depth = 1, typesAfter) {
        $94e6bb3ff13c8c95$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $94e6bb3ff13c8c95$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $94e6bb3ff13c8c95$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $94e6bb3ff13c8c95$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("5UVCb", function(module, exports) {
$parcel$export(module.exports, "EditorView", () => (parcelRequire("fYi0r")).EditorView);
// view/index.ts
parcelRequire("fYi0r");

});
parcelRegister("fYi0r", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $ba0a6d3ab524c08a$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $ba0a6d3ab524c08a$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $ba0a6d3ab524c08a$export$eece2fccabbb77c5);

var $eCBI9 = parcelRequire("eCBI9");

var $jcs10 = parcelRequire("jcs10");

var $cMB55 = parcelRequire("cMB55");
const $ba0a6d3ab524c08a$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $ba0a6d3ab524c08a$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $ba0a6d3ab524c08a$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $ba0a6d3ab524c08a$var$textRange = function(node, from, to) {
    let range = $ba0a6d3ab524c08a$var$reusedRange || ($ba0a6d3ab524c08a$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $ba0a6d3ab524c08a$var$clearReusedRange = function() {
    $ba0a6d3ab524c08a$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $ba0a6d3ab524c08a$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($ba0a6d3ab524c08a$var$scanFor(node, off, targetNode, targetOff, -1) || $ba0a6d3ab524c08a$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $ba0a6d3ab524c08a$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $ba0a6d3ab524c08a$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $ba0a6d3ab524c08a$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $ba0a6d3ab524c08a$var$hasBlockDesc(node) || $ba0a6d3ab524c08a$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $ba0a6d3ab524c08a$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $ba0a6d3ab524c08a$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $ba0a6d3ab524c08a$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $ba0a6d3ab524c08a$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $ba0a6d3ab524c08a$var$nodeSize(node);
        } else if (node.parentNode && !$ba0a6d3ab524c08a$var$hasBlockDesc(node)) {
            offset = $ba0a6d3ab524c08a$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $ba0a6d3ab524c08a$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$ba0a6d3ab524c08a$var$hasBlockDesc(node)) {
            offset = $ba0a6d3ab524c08a$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $ba0a6d3ab524c08a$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $ba0a6d3ab524c08a$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $ba0a6d3ab524c08a$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $ba0a6d3ab524c08a$var$nodeSize(node);
    }
}
function $ba0a6d3ab524c08a$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $ba0a6d3ab524c08a$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $ba0a6d3ab524c08a$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $ba0a6d3ab524c08a$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $ba0a6d3ab524c08a$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $ba0a6d3ab524c08a$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($ba0a6d3ab524c08a$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($ba0a6d3ab524c08a$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $ba0a6d3ab524c08a$var$nav = typeof navigator != "undefined" ? navigator : null;
const $ba0a6d3ab524c08a$var$doc = typeof document != "undefined" ? document : null;
const $ba0a6d3ab524c08a$var$agent = $ba0a6d3ab524c08a$var$nav && $ba0a6d3ab524c08a$var$nav.userAgent || "";
const $ba0a6d3ab524c08a$var$ie_edge = /Edge\/(\d+)/.exec($ba0a6d3ab524c08a$var$agent);
const $ba0a6d3ab524c08a$var$ie_upto10 = /MSIE \d/.exec($ba0a6d3ab524c08a$var$agent);
const $ba0a6d3ab524c08a$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($ba0a6d3ab524c08a$var$agent);
const $ba0a6d3ab524c08a$var$ie = !!($ba0a6d3ab524c08a$var$ie_upto10 || $ba0a6d3ab524c08a$var$ie_11up || $ba0a6d3ab524c08a$var$ie_edge);
const $ba0a6d3ab524c08a$var$ie_version = $ba0a6d3ab524c08a$var$ie_upto10 ? document.documentMode : $ba0a6d3ab524c08a$var$ie_11up ? +$ba0a6d3ab524c08a$var$ie_11up[1] : $ba0a6d3ab524c08a$var$ie_edge ? +$ba0a6d3ab524c08a$var$ie_edge[1] : 0;
const $ba0a6d3ab524c08a$var$gecko = !$ba0a6d3ab524c08a$var$ie && /gecko\/(\d+)/i.test($ba0a6d3ab524c08a$var$agent);
$ba0a6d3ab524c08a$var$gecko && (/Firefox\/(\d+)/.exec($ba0a6d3ab524c08a$var$agent) || [
    0,
    0
])[1];
const $ba0a6d3ab524c08a$var$_chrome = !$ba0a6d3ab524c08a$var$ie && /Chrome\/(\d+)/.exec($ba0a6d3ab524c08a$var$agent);
const $ba0a6d3ab524c08a$var$chrome = !!$ba0a6d3ab524c08a$var$_chrome;
const $ba0a6d3ab524c08a$var$chrome_version = $ba0a6d3ab524c08a$var$_chrome ? +$ba0a6d3ab524c08a$var$_chrome[1] : 0;
const $ba0a6d3ab524c08a$var$safari = !$ba0a6d3ab524c08a$var$ie && !!$ba0a6d3ab524c08a$var$nav && /Apple Computer/.test($ba0a6d3ab524c08a$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $ba0a6d3ab524c08a$var$ios = $ba0a6d3ab524c08a$var$safari && (/Mobile\/\w+/.test($ba0a6d3ab524c08a$var$agent) || !!$ba0a6d3ab524c08a$var$nav && $ba0a6d3ab524c08a$var$nav.maxTouchPoints > 2);
const $ba0a6d3ab524c08a$var$mac = $ba0a6d3ab524c08a$var$ios || ($ba0a6d3ab524c08a$var$nav ? /Mac/.test($ba0a6d3ab524c08a$var$nav.platform) : false);
const $ba0a6d3ab524c08a$var$windows = $ba0a6d3ab524c08a$var$nav ? /Win/.test($ba0a6d3ab524c08a$var$nav.platform) : false;
const $ba0a6d3ab524c08a$var$android = /Android \d/.test($ba0a6d3ab524c08a$var$agent);
const $ba0a6d3ab524c08a$var$webkit = !!$ba0a6d3ab524c08a$var$doc && "webkitFontSmoothing" in $ba0a6d3ab524c08a$var$doc.documentElement.style;
const $ba0a6d3ab524c08a$var$webkit_version = $ba0a6d3ab524c08a$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $ba0a6d3ab524c08a$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $ba0a6d3ab524c08a$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $ba0a6d3ab524c08a$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $ba0a6d3ab524c08a$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $ba0a6d3ab524c08a$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $ba0a6d3ab524c08a$var$windowRect(doc) : $ba0a6d3ab524c08a$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $ba0a6d3ab524c08a$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $ba0a6d3ab524c08a$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $ba0a6d3ab524c08a$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $ba0a6d3ab524c08a$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $ba0a6d3ab524c08a$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $ba0a6d3ab524c08a$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $ba0a6d3ab524c08a$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $ba0a6d3ab524c08a$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $ba0a6d3ab524c08a$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $ba0a6d3ab524c08a$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $ba0a6d3ab524c08a$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $ba0a6d3ab524c08a$var$scrollStack(view.dom)
    };
}
function $ba0a6d3ab524c08a$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $ba0a6d3ab524c08a$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $ba0a6d3ab524c08a$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $ba0a6d3ab524c08a$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $ba0a6d3ab524c08a$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $ba0a6d3ab524c08a$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $ba0a6d3ab524c08a$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($ba0a6d3ab524c08a$var$preventScrollSupported) return dom.focus($ba0a6d3ab524c08a$var$preventScrollSupported);
    let stored = $ba0a6d3ab524c08a$var$scrollStack(dom);
    dom.focus($ba0a6d3ab524c08a$var$preventScrollSupported == null ? {
        get preventScroll () {
            $ba0a6d3ab524c08a$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$ba0a6d3ab524c08a$var$preventScrollSupported) {
        $ba0a6d3ab524c08a$var$preventScrollSupported = false;
        $ba0a6d3ab524c08a$var$restoreScrollStack(stored, 0);
    }
}
function $ba0a6d3ab524c08a$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $ba0a6d3ab524c08a$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $ba0a6d3ab524c08a$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $ba0a6d3ab524c08a$var$findOffsetInNode(closest, coordsClosest);
}
function $ba0a6d3ab524c08a$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $ba0a6d3ab524c08a$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($ba0a6d3ab524c08a$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $ba0a6d3ab524c08a$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $ba0a6d3ab524c08a$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $ba0a6d3ab524c08a$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $ba0a6d3ab524c08a$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $ba0a6d3ab524c08a$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $ba0a6d3ab524c08a$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($ba0a6d3ab524c08a$var$inRect(coords, rect)) return $ba0a6d3ab524c08a$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $ba0a6d3ab524c08a$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $ba0a6d3ab524c08a$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$ba0a6d3ab524c08a$var$inRect(coords, box)) return null;
        elt = $ba0a6d3ab524c08a$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($ba0a6d3ab524c08a$var$safari) {
        for(let p = elt; node && p; p = $ba0a6d3ab524c08a$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $ba0a6d3ab524c08a$var$targetKludge(elt, coords);
    if (node) {
        if ($ba0a6d3ab524c08a$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($ba0a6d3ab524c08a$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $ba0a6d3ab524c08a$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $ba0a6d3ab524c08a$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $ba0a6d3ab524c08a$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $ba0a6d3ab524c08a$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($ba0a6d3ab524c08a$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $ba0a6d3ab524c08a$var$nonZero) || target.getBoundingClientRect();
}
const $ba0a6d3ab524c08a$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $ba0a6d3ab524c08a$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $ba0a6d3ab524c08a$var$webkit || $ba0a6d3ab524c08a$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($ba0a6d3ab524c08a$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $ba0a6d3ab524c08a$var$singleRect($ba0a6d3ab524c08a$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($ba0a6d3ab524c08a$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $ba0a6d3ab524c08a$var$singleRect($ba0a6d3ab524c08a$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $ba0a6d3ab524c08a$var$singleRect($ba0a6d3ab524c08a$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $ba0a6d3ab524c08a$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $ba0a6d3ab524c08a$var$flattenV($ba0a6d3ab524c08a$var$singleRect($ba0a6d3ab524c08a$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $ba0a6d3ab524c08a$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $ba0a6d3ab524c08a$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $ba0a6d3ab524c08a$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $ba0a6d3ab524c08a$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $ba0a6d3ab524c08a$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $ba0a6d3ab524c08a$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $ba0a6d3ab524c08a$var$textRange(before, $ba0a6d3ab524c08a$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $ba0a6d3ab524c08a$var$flattenV($ba0a6d3ab524c08a$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $ba0a6d3ab524c08a$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $ba0a6d3ab524c08a$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $ba0a6d3ab524c08a$var$flattenV($ba0a6d3ab524c08a$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $ba0a6d3ab524c08a$var$flattenV($ba0a6d3ab524c08a$var$singleRect(node.nodeType == 3 ? $ba0a6d3ab524c08a$var$textRange(node) : node, -side), side >= 0);
}
function $ba0a6d3ab524c08a$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $ba0a6d3ab524c08a$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $ba0a6d3ab524c08a$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $ba0a6d3ab524c08a$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $ba0a6d3ab524c08a$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $ba0a6d3ab524c08a$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $ba0a6d3ab524c08a$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $ba0a6d3ab524c08a$var$maybeRTL = /[\u0590-\u08ac]/;
function $ba0a6d3ab524c08a$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$ba0a6d3ab524c08a$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $ba0a6d3ab524c08a$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $ba0a6d3ab524c08a$var$cachedState = null;
let $ba0a6d3ab524c08a$var$cachedDir = null;
let $ba0a6d3ab524c08a$var$cachedResult = false;
function $ba0a6d3ab524c08a$var$endOfTextblock(view, state, dir) {
    if ($ba0a6d3ab524c08a$var$cachedState == state && $ba0a6d3ab524c08a$var$cachedDir == dir) return $ba0a6d3ab524c08a$var$cachedResult;
    $ba0a6d3ab524c08a$var$cachedState = state;
    $ba0a6d3ab524c08a$var$cachedDir = dir;
    return $ba0a6d3ab524c08a$var$cachedResult = dir == "up" || dir == "down" ? $ba0a6d3ab524c08a$var$endOfTextblockVertical(view, state, dir) : $ba0a6d3ab524c08a$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $ba0a6d3ab524c08a$var$NOT_DIRTY = 0, $ba0a6d3ab524c08a$var$CHILD_DIRTY = 1, $ba0a6d3ab524c08a$var$CONTENT_DIRTY = 2, $ba0a6d3ab524c08a$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $ba0a6d3ab524c08a$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $ba0a6d3ab524c08a$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $ba0a6d3ab524c08a$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $ba0a6d3ab524c08a$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $ba0a6d3ab524c08a$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $ba0a6d3ab524c08a$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $ba0a6d3ab524c08a$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $ba0a6d3ab524c08a$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($ba0a6d3ab524c08a$var$gecko || $ba0a6d3ab524c08a$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $ba0a6d3ab524c08a$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($ba0a6d3ab524c08a$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $ba0a6d3ab524c08a$var$safari) && $ba0a6d3ab524c08a$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $ba0a6d3ab524c08a$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $ba0a6d3ab524c08a$var$CONTENT_DIRTY : $ba0a6d3ab524c08a$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $ba0a6d3ab524c08a$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $ba0a6d3ab524c08a$var$CONTENT_DIRTY : $ba0a6d3ab524c08a$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $ba0a6d3ab524c08a$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $ba0a6d3ab524c08a$var$CONTENT_DIRTY : $ba0a6d3ab524c08a$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $ba0a6d3ab524c08a$var$WidgetViewDesc extends $ba0a6d3ab524c08a$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $ba0a6d3ab524c08a$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $ba0a6d3ab524c08a$var$CompositionViewDesc extends $ba0a6d3ab524c08a$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $ba0a6d3ab524c08a$var$MarkViewDesc extends $ba0a6d3ab524c08a$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $jcs10.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $ba0a6d3ab524c08a$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $ba0a6d3ab524c08a$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $ba0a6d3ab524c08a$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $ba0a6d3ab524c08a$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $ba0a6d3ab524c08a$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $ba0a6d3ab524c08a$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $ba0a6d3ab524c08a$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $ba0a6d3ab524c08a$var$NodeViewDesc extends $ba0a6d3ab524c08a$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $jcs10.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $ba0a6d3ab524c08a$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $ba0a6d3ab524c08a$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $ba0a6d3ab524c08a$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $ba0a6d3ab524c08a$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $jcs10.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $ba0a6d3ab524c08a$var$NOT_DIRTY && node.eq(this.node) && $ba0a6d3ab524c08a$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $ba0a6d3ab524c08a$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $ba0a6d3ab524c08a$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $jcs10.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $ba0a6d3ab524c08a$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $ba0a6d3ab524c08a$var$renderDescs(this.contentDOM, this.children, view);
            if ($ba0a6d3ab524c08a$var$ios) $ba0a6d3ab524c08a$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $eCBI9.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $ba0a6d3ab524c08a$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $ba0a6d3ab524c08a$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $ba0a6d3ab524c08a$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $ba0a6d3ab524c08a$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($ba0a6d3ab524c08a$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $ba0a6d3ab524c08a$var$patchOuterDeco(this.dom, this.nodeDOM, $ba0a6d3ab524c08a$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $ba0a6d3ab524c08a$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $ba0a6d3ab524c08a$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $ba0a6d3ab524c08a$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $ba0a6d3ab524c08a$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $ba0a6d3ab524c08a$var$TextViewDesc extends $ba0a6d3ab524c08a$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $ba0a6d3ab524c08a$var$NODE_DIRTY || this.dirty != $ba0a6d3ab524c08a$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $ba0a6d3ab524c08a$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $ba0a6d3ab524c08a$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $ba0a6d3ab524c08a$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $ba0a6d3ab524c08a$var$TrailingHackViewDesc extends $ba0a6d3ab524c08a$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $ba0a6d3ab524c08a$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $ba0a6d3ab524c08a$var$CustomNodeViewDesc extends $ba0a6d3ab524c08a$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $ba0a6d3ab524c08a$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $ba0a6d3ab524c08a$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $ba0a6d3ab524c08a$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $ba0a6d3ab524c08a$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $ba0a6d3ab524c08a$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $ba0a6d3ab524c08a$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $ba0a6d3ab524c08a$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$ba0a6d3ab524c08a$var$OuterDecoLevel.prototype = Object.create(null);
const $ba0a6d3ab524c08a$var$noDeco = [
    new $ba0a6d3ab524c08a$var$OuterDecoLevel
];
function $ba0a6d3ab524c08a$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $ba0a6d3ab524c08a$var$noDeco;
    let top = needsWrap ? $ba0a6d3ab524c08a$var$noDeco[0] : new $ba0a6d3ab524c08a$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $ba0a6d3ab524c08a$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $ba0a6d3ab524c08a$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $ba0a6d3ab524c08a$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $ba0a6d3ab524c08a$var$noDeco && curComputed == $ba0a6d3ab524c08a$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $ba0a6d3ab524c08a$var$noDeco[0];
                curDOM = parent;
            }
        }
        $ba0a6d3ab524c08a$var$patchAttributes(curDOM, prev || $ba0a6d3ab524c08a$var$noDeco[0], deco);
    }
    return curDOM;
}
function $ba0a6d3ab524c08a$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $ba0a6d3ab524c08a$var$applyOuterDeco(dom, deco, node) {
    return $ba0a6d3ab524c08a$var$patchOuterDeco(dom, dom, $ba0a6d3ab524c08a$var$noDeco, $ba0a6d3ab524c08a$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $ba0a6d3ab524c08a$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $ba0a6d3ab524c08a$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $ba0a6d3ab524c08a$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $ba0a6d3ab524c08a$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $ba0a6d3ab524c08a$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $ba0a6d3ab524c08a$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $ba0a6d3ab524c08a$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $ba0a6d3ab524c08a$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $ba0a6d3ab524c08a$var$NODE_DIRTY && $ba0a6d3ab524c08a$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $ba0a6d3ab524c08a$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $ba0a6d3ab524c08a$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$ba0a6d3ab524c08a$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $ba0a6d3ab524c08a$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $ba0a6d3ab524c08a$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $ba0a6d3ab524c08a$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $ba0a6d3ab524c08a$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $ba0a6d3ab524c08a$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($ba0a6d3ab524c08a$var$safari || $ba0a6d3ab524c08a$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $ba0a6d3ab524c08a$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $ba0a6d3ab524c08a$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $ba0a6d3ab524c08a$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $ba0a6d3ab524c08a$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $ba0a6d3ab524c08a$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($ba0a6d3ab524c08a$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $ba0a6d3ab524c08a$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $ba0a6d3ab524c08a$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $ba0a6d3ab524c08a$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $ba0a6d3ab524c08a$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($ba0a6d3ab524c08a$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $eCBI9.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $ba0a6d3ab524c08a$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $eCBI9.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $ba0a6d3ab524c08a$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $ba0a6d3ab524c08a$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $ba0a6d3ab524c08a$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $ba0a6d3ab524c08a$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $ba0a6d3ab524c08a$var$syncNodeSelection(view, sel);
    if (!$ba0a6d3ab524c08a$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $ba0a6d3ab524c08a$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $ba0a6d3ab524c08a$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $ba0a6d3ab524c08a$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($ba0a6d3ab524c08a$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $eCBI9.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $ba0a6d3ab524c08a$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $ba0a6d3ab524c08a$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($ba0a6d3ab524c08a$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $ba0a6d3ab524c08a$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $ba0a6d3ab524c08a$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $ba0a6d3ab524c08a$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $ba0a6d3ab524c08a$var$brokenSelectBetweenUneditable = $ba0a6d3ab524c08a$var$safari || $ba0a6d3ab524c08a$var$chrome && $ba0a6d3ab524c08a$var$chrome_version < 63;
function $ba0a6d3ab524c08a$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($ba0a6d3ab524c08a$var$safari && after && after.contentEditable == "false") return $ba0a6d3ab524c08a$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $ba0a6d3ab524c08a$var$setEditable(after);
        else if (before) return $ba0a6d3ab524c08a$var$setEditable(before);
    }
}
function $ba0a6d3ab524c08a$var$setEditable(element) {
    element.contentEditable = "true";
    if ($ba0a6d3ab524c08a$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $ba0a6d3ab524c08a$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $ba0a6d3ab524c08a$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$ba0a6d3ab524c08a$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $ba0a6d3ab524c08a$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $ba0a6d3ab524c08a$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $ba0a6d3ab524c08a$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $eCBI9.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $ba0a6d3ab524c08a$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $ba0a6d3ab524c08a$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $ba0a6d3ab524c08a$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $ba0a6d3ab524c08a$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $eCBI9.TextSelection).between($anchor, $head, bias);
}
function $ba0a6d3ab524c08a$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $ba0a6d3ab524c08a$var$hasSelection(view);
}
function $ba0a6d3ab524c08a$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $ba0a6d3ab524c08a$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $ba0a6d3ab524c08a$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $ba0a6d3ab524c08a$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $eCBI9.Selection).findFrom($start, dir);
}
function $ba0a6d3ab524c08a$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $ba0a6d3ab524c08a$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $eCBI9.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $ba0a6d3ab524c08a$var$apply(view, new (0, $eCBI9.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $ba0a6d3ab524c08a$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $eCBI9.NodeSelection)) return $ba0a6d3ab524c08a$var$apply(view, next);
            return false;
        } else if (!($ba0a6d3ab524c08a$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $eCBI9.NodeSelection).isSelectable(node)) return $ba0a6d3ab524c08a$var$apply(view, new (0, $eCBI9.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($ba0a6d3ab524c08a$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $ba0a6d3ab524c08a$var$apply(view, new (0, $eCBI9.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $eCBI9.NodeSelection) && sel.node.isInline) return $ba0a6d3ab524c08a$var$apply(view, new (0, $eCBI9.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $ba0a6d3ab524c08a$var$moveSelectionBlock(view.state, dir);
        if (next) return $ba0a6d3ab524c08a$var$apply(view, next);
        return false;
    }
}
function $ba0a6d3ab524c08a$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $ba0a6d3ab524c08a$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $ba0a6d3ab524c08a$var$skipIgnoredNodesBefore(view) : $ba0a6d3ab524c08a$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $ba0a6d3ab524c08a$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($ba0a6d3ab524c08a$var$gecko && node.nodeType == 1 && offset < $ba0a6d3ab524c08a$var$nodeLen(node) && $ba0a6d3ab524c08a$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($ba0a6d3ab524c08a$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($ba0a6d3ab524c08a$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $ba0a6d3ab524c08a$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $ba0a6d3ab524c08a$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $ba0a6d3ab524c08a$var$nodeLen(node);
            }
        }
    }
    if (force) $ba0a6d3ab524c08a$var$setSelFocus(view, node, offset);
    else if (moveNode) $ba0a6d3ab524c08a$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $ba0a6d3ab524c08a$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $ba0a6d3ab524c08a$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($ba0a6d3ab524c08a$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($ba0a6d3ab524c08a$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $ba0a6d3ab524c08a$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $ba0a6d3ab524c08a$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $ba0a6d3ab524c08a$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $ba0a6d3ab524c08a$var$setSelFocus(view, moveNode, moveOffset);
}
function $ba0a6d3ab524c08a$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $ba0a6d3ab524c08a$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$ba0a6d3ab524c08a$var$hasBlockDesc(node)){
        offset = $ba0a6d3ab524c08a$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $ba0a6d3ab524c08a$var$textNodeBefore(node, offset) {
    while(node && !offset && !$ba0a6d3ab524c08a$var$hasBlockDesc(node)){
        offset = $ba0a6d3ab524c08a$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $ba0a6d3ab524c08a$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $ba0a6d3ab524c08a$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $ba0a6d3ab524c08a$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($ba0a6d3ab524c08a$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $ba0a6d3ab524c08a$var$selectionToDOM(view);
    }, 50);
}
function $ba0a6d3ab524c08a$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($ba0a6d3ab524c08a$var$chrome || $ba0a6d3ab524c08a$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $ba0a6d3ab524c08a$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $eCBI9.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($ba0a6d3ab524c08a$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $ba0a6d3ab524c08a$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $eCBI9.NodeSelection)) return $ba0a6d3ab524c08a$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $eCBI9.AllSelection) ? (0, $eCBI9.Selection).near(side, dir) : (0, $eCBI9.Selection).findFrom(side, dir);
        return beyond ? $ba0a6d3ab524c08a$var$apply(view, beyond) : false;
    }
    return false;
}
function $ba0a6d3ab524c08a$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $eCBI9.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $ba0a6d3ab524c08a$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $ba0a6d3ab524c08a$var$safariDownArrowBug(view) {
    if (!$ba0a6d3ab524c08a$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $ba0a6d3ab524c08a$var$switchEditable(view, child, "true");
        setTimeout(()=>$ba0a6d3ab524c08a$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $ba0a6d3ab524c08a$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $ba0a6d3ab524c08a$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $ba0a6d3ab524c08a$var$getMods(event);
    if (code == 8 || $ba0a6d3ab524c08a$var$mac && code == 72 && mods == "c") return $ba0a6d3ab524c08a$var$stopNativeHorizontalDelete(view, -1) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $ba0a6d3ab524c08a$var$mac && code == 68 && mods == "c") return $ba0a6d3ab524c08a$var$stopNativeHorizontalDelete(view, 1) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $ba0a6d3ab524c08a$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $ba0a6d3ab524c08a$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $ba0a6d3ab524c08a$var$selectHorizontally(view, dir, mods) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $ba0a6d3ab524c08a$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $ba0a6d3ab524c08a$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $ba0a6d3ab524c08a$var$selectHorizontally(view, dir, mods) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $ba0a6d3ab524c08a$var$mac && code == 80 && mods == "c") return $ba0a6d3ab524c08a$var$selectVertically(view, -1, mods) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $ba0a6d3ab524c08a$var$mac && code == 78 && mods == "c") return $ba0a6d3ab524c08a$var$safariDownArrowBug(view) || $ba0a6d3ab524c08a$var$selectVertically(view, 1, mods) || $ba0a6d3ab524c08a$var$skipIgnoredNodes(view, 1);
    else if (mods == ($ba0a6d3ab524c08a$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $ba0a6d3ab524c08a$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $jcs10.DOMSerializer).fromSchema(view.state.schema);
    let doc = $ba0a6d3ab524c08a$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $ba0a6d3ab524c08a$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $ba0a6d3ab524c08a$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $jcs10.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $jcs10.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $ba0a6d3ab524c08a$var$readHTML(html);
        if ($ba0a6d3ab524c08a$var$webkit) $ba0a6d3ab524c08a$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $jcs10.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$ba0a6d3ab524c08a$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $ba0a6d3ab524c08a$var$addContext($ba0a6d3ab524c08a$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $jcs10.Slice).maxOpen($ba0a6d3ab524c08a$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $ba0a6d3ab524c08a$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $ba0a6d3ab524c08a$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $ba0a6d3ab524c08a$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $ba0a6d3ab524c08a$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $ba0a6d3ab524c08a$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $ba0a6d3ab524c08a$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $jcs10.Fragment).from(result);
    }
    return fragment;
}
function $ba0a6d3ab524c08a$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $jcs10.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $ba0a6d3ab524c08a$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $ba0a6d3ab524c08a$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $jcs10.Fragment).from($ba0a6d3ab524c08a$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $ba0a6d3ab524c08a$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $ba0a6d3ab524c08a$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $jcs10.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $ba0a6d3ab524c08a$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $ba0a6d3ab524c08a$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $jcs10.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $ba0a6d3ab524c08a$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $jcs10.Slice)($ba0a6d3ab524c08a$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $jcs10.Slice)($ba0a6d3ab524c08a$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $ba0a6d3ab524c08a$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $ba0a6d3ab524c08a$var$_detachedDoc = null;
function $ba0a6d3ab524c08a$var$detachedDoc() {
    return $ba0a6d3ab524c08a$var$_detachedDoc || ($ba0a6d3ab524c08a$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $ba0a6d3ab524c08a$var$_policy = null;
function $ba0a6d3ab524c08a$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$ba0a6d3ab524c08a$var$_policy) $ba0a6d3ab524c08a$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $ba0a6d3ab524c08a$var$_policy.createHTML(html);
}
function $ba0a6d3ab524c08a$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $ba0a6d3ab524c08a$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $ba0a6d3ab524c08a$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $ba0a6d3ab524c08a$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $ba0a6d3ab524c08a$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($ba0a6d3ab524c08a$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $ba0a6d3ab524c08a$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $jcs10.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $jcs10.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $ba0a6d3ab524c08a$var$handlers = {};
const $ba0a6d3ab524c08a$var$editHandlers = {};
const $ba0a6d3ab524c08a$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $ba0a6d3ab524c08a$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $ba0a6d3ab524c08a$var$initInput(view) {
    for(let event in $ba0a6d3ab524c08a$var$handlers){
        let handler = $ba0a6d3ab524c08a$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($ba0a6d3ab524c08a$var$eventBelongsToView(view, event) && !$ba0a6d3ab524c08a$var$runCustomHandler(view, event) && (view.editable || !(event.type in $ba0a6d3ab524c08a$var$editHandlers))) handler(view, event);
        }, $ba0a6d3ab524c08a$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($ba0a6d3ab524c08a$var$safari) view.dom.addEventListener("input", ()=>null);
    $ba0a6d3ab524c08a$var$ensureListeners(view);
}
function $ba0a6d3ab524c08a$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $ba0a6d3ab524c08a$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $ba0a6d3ab524c08a$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$ba0a6d3ab524c08a$var$runCustomHandler(view, event));
    });
}
function $ba0a6d3ab524c08a$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $ba0a6d3ab524c08a$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $ba0a6d3ab524c08a$var$dispatchEvent(view, event) {
    if (!$ba0a6d3ab524c08a$var$runCustomHandler(view, event) && $ba0a6d3ab524c08a$var$handlers[event.type] && (view.editable || !(event.type in $ba0a6d3ab524c08a$var$editHandlers))) $ba0a6d3ab524c08a$var$handlers[event.type](view, event);
}
$ba0a6d3ab524c08a$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($ba0a6d3ab524c08a$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($ba0a6d3ab524c08a$var$android && $ba0a6d3ab524c08a$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($ba0a6d3ab524c08a$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $ba0a6d3ab524c08a$var$captureKeyDown(view, event)) event.preventDefault();
    else $ba0a6d3ab524c08a$var$setSelectionOrigin(view, "key");
};
$ba0a6d3ab524c08a$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$ba0a6d3ab524c08a$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($ba0a6d3ab524c08a$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $ba0a6d3ab524c08a$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $eCBI9.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $ba0a6d3ab524c08a$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $ba0a6d3ab524c08a$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $ba0a6d3ab524c08a$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $ba0a6d3ab524c08a$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $ba0a6d3ab524c08a$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $eCBI9.NodeSelection).isSelectable(node)) {
        $ba0a6d3ab524c08a$var$updateSelection(view, new (0, $eCBI9.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $ba0a6d3ab524c08a$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $eCBI9.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $eCBI9.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $ba0a6d3ab524c08a$var$updateSelection(view, (0, $eCBI9.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $ba0a6d3ab524c08a$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $ba0a6d3ab524c08a$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $ba0a6d3ab524c08a$var$selectClickedNode(view, inside) : $ba0a6d3ab524c08a$var$selectClickedLeaf(view, inside));
}
function $ba0a6d3ab524c08a$var$handleDoubleClick(view, pos, inside, event) {
    return $ba0a6d3ab524c08a$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $ba0a6d3ab524c08a$var$handleTripleClick(view, pos, inside, event) {
    return $ba0a6d3ab524c08a$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $ba0a6d3ab524c08a$var$defaultTripleClick(view, inside, event);
}
function $ba0a6d3ab524c08a$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $ba0a6d3ab524c08a$var$updateSelection(view, (0, $eCBI9.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $ba0a6d3ab524c08a$var$updateSelection(view, (0, $eCBI9.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $eCBI9.NodeSelection).isSelectable(node)) $ba0a6d3ab524c08a$var$updateSelection(view, (0, $eCBI9.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $ba0a6d3ab524c08a$var$forceDOMFlush(view) {
    return $ba0a6d3ab524c08a$var$endComposition(view);
}
const $ba0a6d3ab524c08a$var$selectNodeModifier = $ba0a6d3ab524c08a$var$mac ? "metaKey" : "ctrlKey";
$ba0a6d3ab524c08a$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $ba0a6d3ab524c08a$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $ba0a6d3ab524c08a$var$isNear(event, view.input.lastClick) && !event[$ba0a6d3ab524c08a$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($ba0a6d3ab524c08a$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $ba0a6d3ab524c08a$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $ba0a6d3ab524c08a$var$handleDoubleClick : $ba0a6d3ab524c08a$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $ba0a6d3ab524c08a$var$setSelectionOrigin(view, "pointer");
};
class $ba0a6d3ab524c08a$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$ba0a6d3ab524c08a$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $eCBI9.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $ba0a6d3ab524c08a$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $ba0a6d3ab524c08a$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$ba0a6d3ab524c08a$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($ba0a6d3ab524c08a$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $ba0a6d3ab524c08a$var$setSelectionOrigin(this.view, "pointer");
        else if ($ba0a6d3ab524c08a$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $ba0a6d3ab524c08a$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $ba0a6d3ab524c08a$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $ba0a6d3ab524c08a$var$updateSelection(this.view, (0, $eCBI9.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $ba0a6d3ab524c08a$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $ba0a6d3ab524c08a$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$ba0a6d3ab524c08a$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $ba0a6d3ab524c08a$var$forceDOMFlush(view);
    $ba0a6d3ab524c08a$var$setSelectionOrigin(view, "pointer");
};
$ba0a6d3ab524c08a$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $ba0a6d3ab524c08a$var$setSelectionOrigin(view, "pointer");
};
$ba0a6d3ab524c08a$var$handlers.contextmenu = (view)=>$ba0a6d3ab524c08a$var$forceDOMFlush(view);
function $ba0a6d3ab524c08a$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($ba0a6d3ab524c08a$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $ba0a6d3ab524c08a$var$timeoutComposition = $ba0a6d3ab524c08a$var$android ? 5000 : -1;
$ba0a6d3ab524c08a$var$editHandlers.compositionstart = $ba0a6d3ab524c08a$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $eCBI9.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $ba0a6d3ab524c08a$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $ba0a6d3ab524c08a$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($ba0a6d3ab524c08a$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $ba0a6d3ab524c08a$var$scheduleComposeEnd(view, $ba0a6d3ab524c08a$var$timeoutComposition);
};
$ba0a6d3ab524c08a$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $ba0a6d3ab524c08a$var$scheduleComposeEnd(view, 20);
    }
};
function $ba0a6d3ab524c08a$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$ba0a6d3ab524c08a$var$endComposition(view), delay);
}
function $ba0a6d3ab524c08a$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $ba0a6d3ab524c08a$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $ba0a6d3ab524c08a$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $ba0a6d3ab524c08a$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $ba0a6d3ab524c08a$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $ba0a6d3ab524c08a$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $ba0a6d3ab524c08a$var$endComposition(view, restarting = false) {
    if ($ba0a6d3ab524c08a$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $ba0a6d3ab524c08a$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $ba0a6d3ab524c08a$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $ba0a6d3ab524c08a$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $ba0a6d3ab524c08a$var$brokenClipboardAPI = $ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version < 15 || $ba0a6d3ab524c08a$var$ios && $ba0a6d3ab524c08a$var$webkit_version < 604;
$ba0a6d3ab524c08a$var$handlers.copy = $ba0a6d3ab524c08a$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $ba0a6d3ab524c08a$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $ba0a6d3ab524c08a$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $ba0a6d3ab524c08a$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $ba0a6d3ab524c08a$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $ba0a6d3ab524c08a$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $ba0a6d3ab524c08a$var$doPaste(view, target.value, null, plain, event);
        else $ba0a6d3ab524c08a$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $ba0a6d3ab524c08a$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $ba0a6d3ab524c08a$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $jcs10.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $ba0a6d3ab524c08a$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $ba0a6d3ab524c08a$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$ba0a6d3ab524c08a$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$ba0a6d3ab524c08a$var$android) return;
    let data = $ba0a6d3ab524c08a$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $ba0a6d3ab524c08a$var$doPaste(view, $ba0a6d3ab524c08a$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $ba0a6d3ab524c08a$var$capturePaste(view, event);
};
class $ba0a6d3ab524c08a$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $ba0a6d3ab524c08a$var$dragCopyModifier = $ba0a6d3ab524c08a$var$mac ? "altKey" : "ctrlKey";
function $ba0a6d3ab524c08a$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$ba0a6d3ab524c08a$var$dragCopyModifier];
}
$ba0a6d3ab524c08a$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($ba0a6d3ab524c08a$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $eCBI9.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $eCBI9.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $eCBI9.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $ba0a6d3ab524c08a$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$ba0a6d3ab524c08a$var$chrome || $ba0a6d3ab524c08a$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($ba0a6d3ab524c08a$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$ba0a6d3ab524c08a$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $ba0a6d3ab524c08a$var$Dragging(slice, $ba0a6d3ab524c08a$var$dragMoves(view, event), node);
};
$ba0a6d3ab524c08a$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$ba0a6d3ab524c08a$var$editHandlers.dragover = $ba0a6d3ab524c08a$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$ba0a6d3ab524c08a$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($ba0a6d3ab524c08a$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $ba0a6d3ab524c08a$var$parseFromClipboard(view, $ba0a6d3ab524c08a$var$getText(event.dataTransfer), $ba0a6d3ab524c08a$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $ba0a6d3ab524c08a$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $jcs10.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $cMB55.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $eCBI9.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $eCBI9.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($ba0a6d3ab524c08a$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$ba0a6d3ab524c08a$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $ba0a6d3ab524c08a$var$selectionToDOM(view);
        }, 20);
    }
};
$ba0a6d3ab524c08a$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$ba0a6d3ab524c08a$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($ba0a6d3ab524c08a$var$chrome && $ba0a6d3ab524c08a$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $ba0a6d3ab524c08a$var$editHandlers)$ba0a6d3ab524c08a$var$handlers[prop] = $ba0a6d3ab524c08a$var$editHandlers[prop];
function $ba0a6d3ab524c08a$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $ba0a6d3ab524c08a$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $ba0a6d3ab524c08a$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $ba0a6d3ab524c08a$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $ba0a6d3ab524c08a$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $ba0a6d3ab524c08a$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $ba0a6d3ab524c08a$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $ba0a6d3ab524c08a$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $ba0a6d3ab524c08a$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $ba0a6d3ab524c08a$var$InlineType && $ba0a6d3ab524c08a$var$compareObjs(this.attrs, other.attrs) && $ba0a6d3ab524c08a$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $ba0a6d3ab524c08a$var$InlineType;
    }
    destroy() {}
}
class $ba0a6d3ab524c08a$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $ba0a6d3ab524c08a$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $ba0a6d3ab524c08a$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $ba0a6d3ab524c08a$var$NodeType && $ba0a6d3ab524c08a$var$compareObjs(this.attrs, other.attrs) && $ba0a6d3ab524c08a$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $ba0a6d3ab524c08a$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $ba0a6d3ab524c08a$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $ba0a6d3ab524c08a$export$10e30b733df217ea(pos, pos, new $ba0a6d3ab524c08a$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $ba0a6d3ab524c08a$export$10e30b733df217ea(from, to, new $ba0a6d3ab524c08a$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $ba0a6d3ab524c08a$export$10e30b733df217ea(from, to, new $ba0a6d3ab524c08a$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $ba0a6d3ab524c08a$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $ba0a6d3ab524c08a$var$WidgetType;
    }
}
const $ba0a6d3ab524c08a$var$none = [], $ba0a6d3ab524c08a$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $ba0a6d3ab524c08a$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $ba0a6d3ab524c08a$var$none;
        this.children = children.length ? children : $ba0a6d3ab524c08a$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $ba0a6d3ab524c08a$var$buildTree(decorations, doc, 0, $ba0a6d3ab524c08a$var$noSpec) : $ba0a6d3ab524c08a$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $ba0a6d3ab524c08a$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $ba0a6d3ab524c08a$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $ba0a6d3ab524c08a$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $ba0a6d3ab524c08a$export$93bf62eb445cec98(newLocal.sort($ba0a6d3ab524c08a$var$byPos), $ba0a6d3ab524c08a$var$none) : $ba0a6d3ab524c08a$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $ba0a6d3ab524c08a$var$empty) return $ba0a6d3ab524c08a$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $ba0a6d3ab524c08a$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $ba0a6d3ab524c08a$var$buildTree(found, childNode, baseOffset + 1, $ba0a6d3ab524c08a$var$noSpec));
            childIndex += 3;
        });
        let local = $ba0a6d3ab524c08a$var$moveSpans(childIndex ? $ba0a6d3ab524c08a$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $ba0a6d3ab524c08a$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($ba0a6d3ab524c08a$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $ba0a6d3ab524c08a$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $ba0a6d3ab524c08a$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $ba0a6d3ab524c08a$export$93bf62eb445cec98(local, children) : $ba0a6d3ab524c08a$var$empty;
    }
    forChild(offset, node) {
        if (this == $ba0a6d3ab524c08a$var$empty) return this;
        if (node.isLeaf) return $ba0a6d3ab524c08a$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $ba0a6d3ab524c08a$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $ba0a6d3ab524c08a$export$93bf62eb445cec98(local.sort($ba0a6d3ab524c08a$var$byPos), $ba0a6d3ab524c08a$var$none);
            return child ? new $ba0a6d3ab524c08a$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $ba0a6d3ab524c08a$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $ba0a6d3ab524c08a$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $ba0a6d3ab524c08a$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $ba0a6d3ab524c08a$var$empty) return $ba0a6d3ab524c08a$var$none;
        if (node.inlineContent || !this.local.some($ba0a6d3ab524c08a$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $ba0a6d3ab524c08a$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $ba0a6d3ab524c08a$export$93bf62eb445cec98.empty = new $ba0a6d3ab524c08a$export$93bf62eb445cec98([], []);
/**
@internal
*/ $ba0a6d3ab524c08a$export$93bf62eb445cec98.removeOverlap = $ba0a6d3ab524c08a$var$removeOverlap;
const $ba0a6d3ab524c08a$var$empty = $ba0a6d3ab524c08a$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $ba0a6d3ab524c08a$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $ba0a6d3ab524c08a$var$noSpec));
        return $ba0a6d3ab524c08a$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $ba0a6d3ab524c08a$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $ba0a6d3ab524c08a$var$empty) continue;
            if (result instanceof $ba0a6d3ab524c08a$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $ba0a6d3ab524c08a$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $ba0a6d3ab524c08a$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $ba0a6d3ab524c08a$var$removeOverlap(sorted ? result : result.sort($ba0a6d3ab524c08a$var$byPos)) : $ba0a6d3ab524c08a$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $ba0a6d3ab524c08a$var$empty;
            case 1:
                return members[0];
            default:
                return new $ba0a6d3ab524c08a$var$DecorationGroup(members.every((m)=>m instanceof $ba0a6d3ab524c08a$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $ba0a6d3ab524c08a$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $ba0a6d3ab524c08a$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $ba0a6d3ab524c08a$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $ba0a6d3ab524c08a$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $ba0a6d3ab524c08a$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $ba0a6d3ab524c08a$export$93bf62eb445cec98(newLocal.sort($ba0a6d3ab524c08a$var$byPos), children);
}
function $ba0a6d3ab524c08a$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $ba0a6d3ab524c08a$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $ba0a6d3ab524c08a$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $ba0a6d3ab524c08a$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $ba0a6d3ab524c08a$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $ba0a6d3ab524c08a$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $ba0a6d3ab524c08a$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $ba0a6d3ab524c08a$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $ba0a6d3ab524c08a$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $ba0a6d3ab524c08a$var$moveSpans(hasNulls ? $ba0a6d3ab524c08a$var$withoutNulls(spans) : spans, -offset).sort($ba0a6d3ab524c08a$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $ba0a6d3ab524c08a$export$93bf62eb445cec98(locals, children) : $ba0a6d3ab524c08a$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $ba0a6d3ab524c08a$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $ba0a6d3ab524c08a$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $ba0a6d3ab524c08a$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $ba0a6d3ab524c08a$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $ba0a6d3ab524c08a$var$insertAhead(array, i, deco) {
    while(i < array.length && $ba0a6d3ab524c08a$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $ba0a6d3ab524c08a$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $ba0a6d3ab524c08a$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($ba0a6d3ab524c08a$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $ba0a6d3ab524c08a$var$DecorationGroup.from(found);
}
const $ba0a6d3ab524c08a$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $ba0a6d3ab524c08a$var$useCharData = $ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11;
class $ba0a6d3ab524c08a$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $ba0a6d3ab524c08a$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $ba0a6d3ab524c08a$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($ba0a6d3ab524c08a$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $ba0a6d3ab524c08a$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$ba0a6d3ab524c08a$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $ba0a6d3ab524c08a$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $ba0a6d3ab524c08a$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $ba0a6d3ab524c08a$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $ba0a6d3ab524c08a$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $ba0a6d3ab524c08a$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($ba0a6d3ab524c08a$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $ba0a6d3ab524c08a$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $ba0a6d3ab524c08a$var$selectionCollapsed(sel) && (readSel = $ba0a6d3ab524c08a$var$selectionFromDOM(view)) && readSel.eq((0, $eCBI9.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $ba0a6d3ab524c08a$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $ba0a6d3ab524c08a$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $ba0a6d3ab524c08a$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $ba0a6d3ab524c08a$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $ba0a6d3ab524c08a$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $ba0a6d3ab524c08a$var$cssChecked = new WeakMap();
let $ba0a6d3ab524c08a$var$cssCheckWarned = false;
function $ba0a6d3ab524c08a$var$checkCSS(view) {
    if ($ba0a6d3ab524c08a$var$cssChecked.has(view)) return;
    $ba0a6d3ab524c08a$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $ba0a6d3ab524c08a$var$gecko;
        if ($ba0a6d3ab524c08a$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $ba0a6d3ab524c08a$var$cssCheckWarned = true;
    }
}
function $ba0a6d3ab524c08a$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($ba0a6d3ab524c08a$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $ba0a6d3ab524c08a$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $ba0a6d3ab524c08a$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $ba0a6d3ab524c08a$var$rangeToSelectionRange(view, found) : null;
}
function $ba0a6d3ab524c08a$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $ba0a6d3ab524c08a$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$ba0a6d3ab524c08a$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($ba0a6d3ab524c08a$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $jcs10.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $ba0a6d3ab524c08a$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $ba0a6d3ab524c08a$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($ba0a6d3ab524c08a$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $ba0a6d3ab524c08a$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $ba0a6d3ab524c08a$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $ba0a6d3ab524c08a$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $ba0a6d3ab524c08a$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($ba0a6d3ab524c08a$var$chrome && $ba0a6d3ab524c08a$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $ba0a6d3ab524c08a$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $ba0a6d3ab524c08a$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($ba0a6d3ab524c08a$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $ba0a6d3ab524c08a$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$ba0a6d3ab524c08a$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $eCBI9.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $ba0a6d3ab524c08a$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $eCBI9.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($ba0a6d3ab524c08a$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && (nextSel = (0, $eCBI9.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head > $from.pos) && view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $ba0a6d3ab524c08a$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $ba0a6d3ab524c08a$var$keyEvent(8, "Backspace")))) {
        if ($ba0a6d3ab524c08a$var$android && $ba0a6d3ab524c08a$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($ba0a6d3ab524c08a$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($ba0a6d3ab524c08a$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $ba0a6d3ab524c08a$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($ba0a6d3ab524c08a$var$ie && $ba0a6d3ab524c08a$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$ba0a6d3ab524c08a$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $ba0a6d3ab524c08a$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $ba0a6d3ab524c08a$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($ba0a6d3ab524c08a$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $ba0a6d3ab524c08a$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $ba0a6d3ab524c08a$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $ba0a6d3ab524c08a$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $ba0a6d3ab524c08a$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $jcs10.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $ba0a6d3ab524c08a$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $ba0a6d3ab524c08a$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($ba0a6d3ab524c08a$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $ba0a6d3ab524c08a$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $ba0a6d3ab524c08a$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $ba0a6d3ab524c08a$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $ba0a6d3ab524c08a$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $ba0a6d3ab524c08a$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $ba0a6d3ab524c08a$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $ba0a6d3ab524c08a$export$5d42ca91c11c9e4d = $ba0a6d3ab524c08a$var$parseFromClipboard;
/**
@internal
*/ const $ba0a6d3ab524c08a$export$76b14d3c719c32fc = $ba0a6d3ab524c08a$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $ba0a6d3ab524c08a$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $ba0a6d3ab524c08a$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($ba0a6d3ab524c08a$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $ba0a6d3ab524c08a$var$getEditable(this);
        $ba0a6d3ab524c08a$var$updateCursorWrapper(this);
        this.nodeViews = $ba0a6d3ab524c08a$var$buildNodeViews(this);
        this.docView = $ba0a6d3ab524c08a$var$docViewDesc(this.state.doc, $ba0a6d3ab524c08a$var$computeDocDeco(this), $ba0a6d3ab524c08a$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $ba0a6d3ab524c08a$var$DOMObserver(this, (from, to, typeOver, added)=>$ba0a6d3ab524c08a$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $ba0a6d3ab524c08a$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $ba0a6d3ab524c08a$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($ba0a6d3ab524c08a$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $ba0a6d3ab524c08a$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $ba0a6d3ab524c08a$var$buildNodeViews(this);
            if ($ba0a6d3ab524c08a$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $ba0a6d3ab524c08a$var$ensureListeners(this);
        this.editable = $ba0a6d3ab524c08a$var$getEditable(this);
        $ba0a6d3ab524c08a$var$updateCursorWrapper(this);
        let innerDeco = $ba0a6d3ab524c08a$var$viewDecorations(this), outerDeco = $ba0a6d3ab524c08a$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $ba0a6d3ab524c08a$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($ba0a6d3ab524c08a$var$ie || $ba0a6d3ab524c08a$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $ba0a6d3ab524c08a$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $ba0a6d3ab524c08a$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $ba0a6d3ab524c08a$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $ba0a6d3ab524c08a$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $ba0a6d3ab524c08a$var$anchorInRightPlace(this))) $ba0a6d3ab524c08a$var$selectionToDOM(this, forceSelUpdate);
            else {
                $ba0a6d3ab524c08a$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $ba0a6d3ab524c08a$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $eCBI9.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $ba0a6d3ab524c08a$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $ba0a6d3ab524c08a$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $ba0a6d3ab524c08a$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $eCBI9.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($ba0a6d3ab524c08a$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $ba0a6d3ab524c08a$var$focusPreventScroll(this.dom);
        $ba0a6d3ab524c08a$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $ba0a6d3ab524c08a$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $ba0a6d3ab524c08a$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $ba0a6d3ab524c08a$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $ba0a6d3ab524c08a$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $ba0a6d3ab524c08a$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $ba0a6d3ab524c08a$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $ba0a6d3ab524c08a$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $ba0a6d3ab524c08a$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $ba0a6d3ab524c08a$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $ba0a6d3ab524c08a$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $ba0a6d3ab524c08a$var$safari && this.root.nodeType === 11 && $ba0a6d3ab524c08a$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $ba0a6d3ab524c08a$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $ba0a6d3ab524c08a$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $ba0a6d3ab524c08a$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $ba0a6d3ab524c08a$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $ba0a6d3ab524c08a$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $ba0a6d3ab524c08a$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $ba0a6d3ab524c08a$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $ba0a6d3ab524c08a$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $ba0a6d3ab524c08a$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $ba0a6d3ab524c08a$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});


parcelRegister("bu3v1", function(module, exports) {
$parcel$export(module.exports, "keymap", () => (parcelRequire("7kaZl")).keymap);
// keymap/index.ts
parcelRequire("7kaZl");

});
parcelRegister("7kaZl", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $5552ecb6cb5b53c9$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $5552ecb6cb5b53c9$export$53f558754f8b9fd1);

var $fTPR4 = parcelRequire("fTPR4");

var $eCBI9 = parcelRequire("eCBI9");
const $5552ecb6cb5b53c9$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $5552ecb6cb5b53c9$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($5552ecb6cb5b53c9$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $5552ecb6cb5b53c9$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$5552ecb6cb5b53c9$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $5552ecb6cb5b53c9$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $5552ecb6cb5b53c9$export$5043418e2ef368d5(bindings) {
    return new (0, $eCBI9.Plugin)({
        props: {
            handleKeyDown: $5552ecb6cb5b53c9$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $5552ecb6cb5b53c9$export$53f558754f8b9fd1(bindings) {
    let map = $5552ecb6cb5b53c9$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $fTPR4.keyName)(event), baseName, direct = map[$5552ecb6cb5b53c9$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$5552ecb6cb5b53c9$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $fTPR4.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$5552ecb6cb5b53c9$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});
parcelRegister("fTPR4", function(module, exports) {

$parcel$export(module.exports, "base", () => $b9343761c2df1e0b$export$e2253033e6e1df16);
$parcel$export(module.exports, "keyName", () => $b9343761c2df1e0b$export$fb33aafd75404f4c);
var $b9343761c2df1e0b$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $b9343761c2df1e0b$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $b9343761c2df1e0b$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $b9343761c2df1e0b$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $b9343761c2df1e0b$var$i = 0; $b9343761c2df1e0b$var$i < 10; $b9343761c2df1e0b$var$i++)$b9343761c2df1e0b$export$e2253033e6e1df16[48 + $b9343761c2df1e0b$var$i] = $b9343761c2df1e0b$export$e2253033e6e1df16[96 + $b9343761c2df1e0b$var$i] = String($b9343761c2df1e0b$var$i);
// The function keys
for(var $b9343761c2df1e0b$var$i = 1; $b9343761c2df1e0b$var$i <= 24; $b9343761c2df1e0b$var$i++)$b9343761c2df1e0b$export$e2253033e6e1df16[$b9343761c2df1e0b$var$i + 111] = "F" + $b9343761c2df1e0b$var$i;
// And the alphabetic keys
for(var $b9343761c2df1e0b$var$i = 65; $b9343761c2df1e0b$var$i <= 90; $b9343761c2df1e0b$var$i++){
    $b9343761c2df1e0b$export$e2253033e6e1df16[$b9343761c2df1e0b$var$i] = String.fromCharCode($b9343761c2df1e0b$var$i + 32);
    $b9343761c2df1e0b$export$fba63a578e423eb[$b9343761c2df1e0b$var$i] = String.fromCharCode($b9343761c2df1e0b$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $b9343761c2df1e0b$var$code in $b9343761c2df1e0b$export$e2253033e6e1df16)if (!$b9343761c2df1e0b$export$fba63a578e423eb.hasOwnProperty($b9343761c2df1e0b$var$code)) $b9343761c2df1e0b$export$fba63a578e423eb[$b9343761c2df1e0b$var$code] = $b9343761c2df1e0b$export$e2253033e6e1df16[$b9343761c2df1e0b$var$code];
function $b9343761c2df1e0b$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $b9343761c2df1e0b$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $b9343761c2df1e0b$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $b9343761c2df1e0b$export$fba63a578e423eb : $b9343761c2df1e0b$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});



parcelRegister("jJg9y", function(module, exports) {
$parcel$export(module.exports, "DOMParser", () => (parcelRequire("jcs10")).DOMParser);
$parcel$export(module.exports, "DOMSerializer", () => (parcelRequire("jcs10")).DOMSerializer);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("jcs10")).Fragment);
$parcel$export(module.exports, "Node", () => (parcelRequire("jcs10")).Node);
$parcel$export(module.exports, "Schema", () => (parcelRequire("jcs10")).Schema);
$parcel$export(module.exports, "Slice", () => (parcelRequire("jcs10")).Slice);
// model/index.ts
parcelRequire("jcs10");

});

parcelRegister("optiF", function(module, exports) {
$parcel$export(module.exports, "canJoin", () => (parcelRequire("cMB55")).canJoin);
$parcel$export(module.exports, "canSplit", () => (parcelRequire("cMB55")).canSplit);
$parcel$export(module.exports, "findWrapping", () => (parcelRequire("cMB55")).findWrapping);
$parcel$export(module.exports, "joinPoint", () => (parcelRequire("cMB55")).joinPoint);
$parcel$export(module.exports, "liftTarget", () => (parcelRequire("cMB55")).liftTarget);
$parcel$export(module.exports, "ReplaceAroundStep", () => (parcelRequire("cMB55")).ReplaceAroundStep);
$parcel$export(module.exports, "ReplaceStep", () => (parcelRequire("cMB55")).ReplaceStep);
$parcel$export(module.exports, "Transform", () => (parcelRequire("cMB55")).Transform);
// transform/index.ts
parcelRequire("cMB55");

});

parcelRegister("i1bXU", function(module, exports) {
$parcel$export(module.exports, "createParagraphNear", () => (parcelRequire("g6HTq")).createParagraphNear);
$parcel$export(module.exports, "deleteSelection", () => (parcelRequire("g6HTq")).deleteSelection);
$parcel$export(module.exports, "exitCode", () => (parcelRequire("g6HTq")).exitCode);
$parcel$export(module.exports, "joinBackward", () => (parcelRequire("g6HTq")).joinBackward);
$parcel$export(module.exports, "joinDown", () => (parcelRequire("g6HTq")).joinDown);
$parcel$export(module.exports, "joinForward", () => (parcelRequire("g6HTq")).joinForward);
$parcel$export(module.exports, "joinTextblockBackward", () => (parcelRequire("g6HTq")).joinTextblockBackward);
$parcel$export(module.exports, "joinTextblockForward", () => (parcelRequire("g6HTq")).joinTextblockForward);
$parcel$export(module.exports, "joinUp", () => (parcelRequire("g6HTq")).joinUp);
$parcel$export(module.exports, "lift", () => (parcelRequire("g6HTq")).lift);
$parcel$export(module.exports, "liftEmptyBlock", () => (parcelRequire("g6HTq")).liftEmptyBlock);
$parcel$export(module.exports, "newlineInCode", () => (parcelRequire("g6HTq")).newlineInCode);
$parcel$export(module.exports, "selectNodeBackward", () => (parcelRequire("g6HTq")).selectNodeBackward);
$parcel$export(module.exports, "selectNodeForward", () => (parcelRequire("g6HTq")).selectNodeForward);
$parcel$export(module.exports, "selectParentNode", () => (parcelRequire("g6HTq")).selectParentNode);
$parcel$export(module.exports, "selectTextblockEnd", () => (parcelRequire("g6HTq")).selectTextblockEnd);
$parcel$export(module.exports, "selectTextblockStart", () => (parcelRequire("g6HTq")).selectTextblockStart);
$parcel$export(module.exports, "setBlockType", () => (parcelRequire("g6HTq")).setBlockType);
$parcel$export(module.exports, "wrapIn", () => (parcelRequire("g6HTq")).wrapIn);
// commands/index.ts
parcelRequire("g6HTq");

});
parcelRegister("g6HTq", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $bb9f4121d6df54db$export$e9a518a637d1e641);
$parcel$export(module.exports, "joinBackward", () => $bb9f4121d6df54db$export$979097b097459299);
$parcel$export(module.exports, "joinTextblockBackward", () => $bb9f4121d6df54db$export$1dce4f5c74f5f90f);
$parcel$export(module.exports, "joinTextblockForward", () => $bb9f4121d6df54db$export$e796bb96d22be2cd);
$parcel$export(module.exports, "selectNodeBackward", () => $bb9f4121d6df54db$export$52b8a4af68d19794);
$parcel$export(module.exports, "joinForward", () => $bb9f4121d6df54db$export$bf432e340007f9ef);
$parcel$export(module.exports, "selectNodeForward", () => $bb9f4121d6df54db$export$5835b52680b80cfd);
$parcel$export(module.exports, "joinUp", () => $bb9f4121d6df54db$export$4bb15e6d4372b393);
$parcel$export(module.exports, "joinDown", () => $bb9f4121d6df54db$export$8dd967a262b064bb);
$parcel$export(module.exports, "lift", () => $bb9f4121d6df54db$export$590e8b2c435046d9);
$parcel$export(module.exports, "newlineInCode", () => $bb9f4121d6df54db$export$a5d02b4b65e94f91);
$parcel$export(module.exports, "exitCode", () => $bb9f4121d6df54db$export$634b78845598ff5b);
$parcel$export(module.exports, "createParagraphNear", () => $bb9f4121d6df54db$export$d0f80ac1b4510888);
$parcel$export(module.exports, "liftEmptyBlock", () => $bb9f4121d6df54db$export$a3574cc681852c08);
$parcel$export(module.exports, "selectParentNode", () => $bb9f4121d6df54db$export$a37f6aaa9169911d);
$parcel$export(module.exports, "selectTextblockStart", () => $bb9f4121d6df54db$export$c3a64f3c9604a1b1);
$parcel$export(module.exports, "selectTextblockEnd", () => $bb9f4121d6df54db$export$a66c1876556415e5);
$parcel$export(module.exports, "wrapIn", () => $bb9f4121d6df54db$export$6e5e3c49755affd0);
$parcel$export(module.exports, "setBlockType", () => $bb9f4121d6df54db$export$36987f561c736aad);

var $cMB55 = parcelRequire("cMB55");

var $jcs10 = parcelRequire("jcs10");

var $eCBI9 = parcelRequire("eCBI9");
/**
Delete the selection, if there is one.
*/ const $bb9f4121d6df54db$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $bb9f4121d6df54db$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $bb9f4121d6df54db$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $bb9f4121d6df54db$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $bb9f4121d6df54db$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $cMB55.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($bb9f4121d6df54db$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($bb9f4121d6df54db$var$textblockAt(before, "end") || (0, $eCBI9.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $cMB55.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $jcs10.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($bb9f4121d6df54db$var$textblockAt(before, "end") ? (0, $eCBI9.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $eCBI9.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $bb9f4121d6df54db$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $bb9f4121d6df54db$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $bb9f4121d6df54db$var$findCutBefore($cursor);
    return $cut ? $bb9f4121d6df54db$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $bb9f4121d6df54db$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $bb9f4121d6df54db$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $bb9f4121d6df54db$var$findCutAfter($cursor);
    return $cut ? $bb9f4121d6df54db$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $bb9f4121d6df54db$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $cMB55.replaceStep)(state.doc, beforePos, afterPos, (0, $jcs10.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $cMB55.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $eCBI9.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $bb9f4121d6df54db$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $bb9f4121d6df54db$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $bb9f4121d6df54db$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $eCBI9.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $eCBI9.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $bb9f4121d6df54db$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $bb9f4121d6df54db$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $bb9f4121d6df54db$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $bb9f4121d6df54db$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $bb9f4121d6df54db$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($bb9f4121d6df54db$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($bb9f4121d6df54db$var$textblockAt(after, "start") || (0, $eCBI9.NodeSelection).isSelectable(after))) {
        let delStep = (0, $cMB55.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $jcs10.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($bb9f4121d6df54db$var$textblockAt(after, "start") ? (0, $eCBI9.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $eCBI9.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $bb9f4121d6df54db$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $bb9f4121d6df54db$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $eCBI9.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $eCBI9.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $bb9f4121d6df54db$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $bb9f4121d6df54db$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $eCBI9.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $cMB55.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $cMB55.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $eCBI9.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $bb9f4121d6df54db$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $eCBI9.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $cMB55.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $cMB55.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $bb9f4121d6df54db$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $cMB55.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $bb9f4121d6df54db$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $bb9f4121d6df54db$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $bb9f4121d6df54db$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $bb9f4121d6df54db$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $eCBI9.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $bb9f4121d6df54db$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $eCBI9.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $bb9f4121d6df54db$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $eCBI9.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $bb9f4121d6df54db$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $cMB55.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $cMB55.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $bb9f4121d6df54db$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $eCBI9.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $cMB55.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $bb9f4121d6df54db$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $eCBI9.TextSelection) || state.selection instanceof (0, $eCBI9.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $cMB55.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $cMB55.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $bb9f4121d6df54db$export$e99155638ff4dff0 = $bb9f4121d6df54db$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $bb9f4121d6df54db$export$eeb429476568b72b = (state, dispatch)=>{
    return $bb9f4121d6df54db$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $bb9f4121d6df54db$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $eCBI9.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $bb9f4121d6df54db$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $eCBI9.AllSelection)(state.doc)));
    return true;
};
function $bb9f4121d6df54db$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $cMB55.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $bb9f4121d6df54db$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $bb9f4121d6df54db$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $jcs10.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $jcs10.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $jcs10.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $cMB55.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $jcs10.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $cMB55.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $eCBI9.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $cMB55.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $bb9f4121d6df54db$var$textblockAt(after, "start", true) && $bb9f4121d6df54db$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $jcs10.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $jcs10.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $cMB55.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $jcs10.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $bb9f4121d6df54db$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $eCBI9.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $bb9f4121d6df54db$export$c3a64f3c9604a1b1 = $bb9f4121d6df54db$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $bb9f4121d6df54db$export$a66c1876556415e5 = $bb9f4121d6df54db$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $bb9f4121d6df54db$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $cMB55.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $bb9f4121d6df54db$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $bb9f4121d6df54db$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $bb9f4121d6df54db$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $eCBI9.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $eCBI9.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $bb9f4121d6df54db$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$bb9f4121d6df54db$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $bb9f4121d6df54db$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $bb9f4121d6df54db$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $cMB55.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $bb9f4121d6df54db$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $bb9f4121d6df54db$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $bb9f4121d6df54db$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $bb9f4121d6df54db$var$backspace = $bb9f4121d6df54db$export$146a774cdef7663a($bb9f4121d6df54db$export$e9a518a637d1e641, $bb9f4121d6df54db$export$979097b097459299, $bb9f4121d6df54db$export$52b8a4af68d19794);
let $bb9f4121d6df54db$var$del = $bb9f4121d6df54db$export$146a774cdef7663a($bb9f4121d6df54db$export$e9a518a637d1e641, $bb9f4121d6df54db$export$bf432e340007f9ef, $bb9f4121d6df54db$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $bb9f4121d6df54db$export$eb36e8971b04df36 = {
    "Enter": $bb9f4121d6df54db$export$146a774cdef7663a($bb9f4121d6df54db$export$a5d02b4b65e94f91, $bb9f4121d6df54db$export$d0f80ac1b4510888, $bb9f4121d6df54db$export$a3574cc681852c08, $bb9f4121d6df54db$export$e99155638ff4dff0),
    "Mod-Enter": $bb9f4121d6df54db$export$634b78845598ff5b,
    "Backspace": $bb9f4121d6df54db$var$backspace,
    "Mod-Backspace": $bb9f4121d6df54db$var$backspace,
    "Shift-Backspace": $bb9f4121d6df54db$var$backspace,
    "Delete": $bb9f4121d6df54db$var$del,
    "Mod-Delete": $bb9f4121d6df54db$var$del,
    "Mod-a": $bb9f4121d6df54db$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $bb9f4121d6df54db$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $bb9f4121d6df54db$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $bb9f4121d6df54db$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $bb9f4121d6df54db$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $bb9f4121d6df54db$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $bb9f4121d6df54db$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $bb9f4121d6df54db$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $bb9f4121d6df54db$export$c3a64f3c9604a1b1,
    "Ctrl-e": $bb9f4121d6df54db$export$a66c1876556415e5
};
for(let key in $bb9f4121d6df54db$export$eb36e8971b04df36)$bb9f4121d6df54db$export$f292ad8dbd5063c8[key] = $bb9f4121d6df54db$export$eb36e8971b04df36[key];
const $bb9f4121d6df54db$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $bb9f4121d6df54db$export$4a0c2b85b1f0a889 = $bb9f4121d6df54db$var$mac ? $bb9f4121d6df54db$export$f292ad8dbd5063c8 : $bb9f4121d6df54db$export$eb36e8971b04df36;

});


parcelRegister("53jUT", function(module, exports) {
$parcel$export(module.exports, "liftListItem", () => (parcelRequire("cWB7z")).liftListItem);
$parcel$export(module.exports, "sinkListItem", () => (parcelRequire("cWB7z")).sinkListItem);
$parcel$export(module.exports, "wrapInList", () => (parcelRequire("cWB7z")).wrapInList);
// schema-list/index.ts
parcelRequire("cWB7z");

});
parcelRegister("cWB7z", function(module, exports) {

$parcel$export(module.exports, "wrapInList", () => $96c7b2502c1f43c7$export$a8aef45c6262afee);
$parcel$export(module.exports, "liftListItem", () => $96c7b2502c1f43c7$export$e74cd5adb935a538);
$parcel$export(module.exports, "sinkListItem", () => $96c7b2502c1f43c7$export$dd505f850a3798a4);

var $cMB55 = parcelRequire("cMB55");

var $jcs10 = parcelRequire("jcs10");

var $eCBI9 = parcelRequire("eCBI9");
const $96c7b2502c1f43c7$var$olDOM = [
    "ol",
    0
], $96c7b2502c1f43c7$var$ulDOM = [
    "ul",
    0
], $96c7b2502c1f43c7$var$liDOM = [
    "li",
    0
];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/ const $96c7b2502c1f43c7$export$a5dc81035676e7a = {
    attrs: {
        order: {
            default: 1,
            validate: "number"
        }
    },
    parseDOM: [
        {
            tag: "ol",
            getAttrs (dom) {
                return {
                    order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
                };
            }
        }
    ],
    toDOM (node) {
        return node.attrs.order == 1 ? $96c7b2502c1f43c7$var$olDOM : [
            "ol",
            {
                start: node.attrs.order
            },
            0
        ];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/ const $96c7b2502c1f43c7$export$a140c94e5ea26bee = {
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM () {
        return $96c7b2502c1f43c7$var$ulDOM;
    }
};
/**
A list item (`<li>`) spec.
*/ const $96c7b2502c1f43c7$export$76c7e83ecc9cdf05 = {
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM () {
        return $96c7b2502c1f43c7$var$liDOM;
    },
    defining: true
};
function $96c7b2502c1f43c7$var$add(obj, props) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    for(let prop in props)copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/ function $96c7b2502c1f43c7$export$fa2e7d3d1550c2ea(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: $96c7b2502c1f43c7$var$add($96c7b2502c1f43c7$export$a5dc81035676e7a, {
            content: "list_item+",
            group: listGroup
        }),
        bullet_list: $96c7b2502c1f43c7$var$add($96c7b2502c1f43c7$export$a140c94e5ea26bee, {
            content: "list_item+",
            group: listGroup
        }),
        list_item: $96c7b2502c1f43c7$var$add($96c7b2502c1f43c7$export$76c7e83ecc9cdf05, {
            content: itemContent
        })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/ function $96c7b2502c1f43c7$export$a8aef45c6262afee(listType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to);
        if (!range) return false;
        let tr = dispatch ? state.tr : null;
        if (!$96c7b2502c1f43c7$export$e4d3cb74b660c6e9(tr, range, listType, attrs)) return false;
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Try to wrap the given node range in a list of the given type.
Return `true` when this is possible, `false` otherwise. When `tr`
is non-null, the wrapping is added to that transaction. When it is
`null`, the function only queries whether the wrapping is
possible.
*/ function $96c7b2502c1f43c7$export$e4d3cb74b660c6e9(tr, range, listType, attrs = null) {
    let doJoin = false, outerRange = range, doc = range.$from.doc;
    // This is at the top of an existing list item
    if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
        // Don't do anything if this is the top of the list
        if (range.$from.index(range.depth - 1) == 0) return false;
        let $insert = doc.resolve(range.start - 2);
        outerRange = new (0, $jcs10.NodeRange)($insert, $insert, range.depth);
        if (range.endIndex < range.parent.childCount) range = new (0, $jcs10.NodeRange)(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
        doJoin = true;
    }
    let wrap = (0, $cMB55.findWrapping)(outerRange, listType, attrs, range);
    if (!wrap) return false;
    if (tr) $96c7b2502c1f43c7$var$doWrapInList(tr, range, wrap, doJoin, listType);
    return true;
}
function $96c7b2502c1f43c7$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $jcs10.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $jcs10.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $cMB55.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $jcs10.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type == listType) found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $cMB55.canSplit)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/ function $96c7b2502c1f43c7$export$e920ee2eb756d384(itemType, itemAttrs) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to, node: node } = state.selection;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType) return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $jcs10.Fragment).empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)wrap = (0, $jcs10.Fragment).from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $jcs10.Fragment).from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new (0, $jcs10.Slice)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos)=>{
                    if (sel > -1) return false;
                    if (node.isTextblock && node.content.size == 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $eCBI9.Selection).near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [
            itemAttrs ? {
                type: itemType,
                attrs: itemAttrs
            } : null,
            {
                type: nextType
            }
        ] : undefined;
        if (!(0, $cMB55.canSplit)(tr.doc, $from.pos, 2, types)) return false;
        if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/ function $96c7b2502c1f43c7$export$265ad35055c66d75(itemType, itemAttrs) {
    let split = $96c7b2502c1f43c7$export$e920ee2eb756d384(itemType, itemAttrs);
    return (state, dispatch)=>{
        return split(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/ function $96c7b2502c1f43c7$export$e74cd5adb935a538(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        if (!dispatch) return true;
        if ($from.node(range.depth - 1).type == itemType) return $96c7b2502c1f43c7$var$liftToOuterList(state, dispatch, itemType, range);
        else return $96c7b2502c1f43c7$var$liftOutOfList(state, dispatch, range);
    };
}
function $96c7b2502c1f43c7$var$liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new (0, $cMB55.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $jcs10.NodeRange)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $cMB55.liftTarget)(range);
    if (target == null) return false;
    tr.lift(range, target);
    let $after = tr.doc.resolve(tr.mapping.map(end, -1) - 1);
    if ((0, $cMB55.canJoin)(tr.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type) tr.join($after.pos);
    dispatch(tr.scrollIntoView());
    return true;
}
function $96c7b2502c1f43c7$var$liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for(let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? (0, $jcs10.Fragment).empty : (0, $jcs10.Fragment).from(list)))) return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new (0, $cMB55.ReplaceAroundStep)(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new (0, $jcs10.Slice)((atStart ? (0, $jcs10.Fragment).empty : (0, $jcs10.Fragment).from(list.copy((0, $jcs10.Fragment).empty))).append(atEnd ? (0, $jcs10.Fragment).empty : (0, $jcs10.Fragment).from(list.copy((0, $jcs10.Fragment).empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/ function $96c7b2502c1f43c7$export$dd505f850a3798a4(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        let startIndex = range.startIndex;
        if (startIndex == 0) return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType) return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = (0, $jcs10.Fragment).from(nestedBefore ? itemType.create() : null);
            let slice = new (0, $jcs10.Slice)((0, $jcs10.Fragment).from(itemType.create(null, (0, $jcs10.Fragment).from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new (0, $cMB55.ReplaceAroundStep)(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
        }
        return true;
    };
}

});



parcelRegister("9BoH8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fdab99a56f86ca7$export$626064c5f1b71dc);

var $aZja8 = parcelRequire("aZja8");

var $hvxib = parcelRequire("hvxib");

var $1e0DR = parcelRequire("1e0DR");

var $isg2Q = parcelRequire("isg2Q");

var $dfxk6 = parcelRequire("dfxk6");

var $f50Qv = parcelRequire("f50Qv");

var $iDfSp = parcelRequire("iDfSp");

var $gues3 = parcelRequire("gues3");

var $4a0Co = parcelRequire("4a0Co");

var $7qAJ4 = parcelRequire("7qAJ4");

var $1k2XZ = parcelRequire("1k2XZ");

var $g63HU = parcelRequire("g63HU");

var $5fDRi = parcelRequire("5fDRi");

var $7Eoiy = parcelRequire("7Eoiy");

var $bMG7S = parcelRequire("bMG7S");

var $jxZ8N = parcelRequire("jxZ8N");

var $bVmeV = parcelRequire("bVmeV");

var $dr7xH = parcelRequire("dr7xH");

var $2F1WD = parcelRequire("2F1WD");
/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */ const $6fdab99a56f86ca7$export$626064c5f1b71dc = (0, $aZja8.Extension).create({
    name: 'starterKit',
    addExtensions () {
        const extensions = [];
        if (this.options.bold !== false) extensions.push((0, $1e0DR.Bold).configure(this.options.bold));
        if (this.options.blockquote !== false) extensions.push((0, $hvxib.Blockquote).configure(this.options.blockquote));
        if (this.options.bulletList !== false) extensions.push((0, $isg2Q.BulletList).configure(this.options.bulletList));
        if (this.options.code !== false) extensions.push((0, $dfxk6.Code).configure(this.options.code));
        if (this.options.codeBlock !== false) extensions.push((0, $f50Qv.CodeBlock).configure(this.options.codeBlock));
        if (this.options.document !== false) extensions.push((0, $iDfSp.Document).configure(this.options.document));
        if (this.options.dropcursor !== false) extensions.push((0, $gues3.Dropcursor).configure(this.options.dropcursor));
        if (this.options.gapcursor !== false) extensions.push((0, $4a0Co.Gapcursor).configure(this.options.gapcursor));
        if (this.options.hardBreak !== false) extensions.push((0, $7qAJ4.HardBreak).configure(this.options.hardBreak));
        if (this.options.heading !== false) extensions.push((0, $1k2XZ.Heading).configure(this.options.heading));
        if (this.options.history !== false) extensions.push((0, $g63HU.History).configure(this.options.history));
        if (this.options.horizontalRule !== false) extensions.push((0, $5fDRi.HorizontalRule).configure(this.options.horizontalRule));
        if (this.options.italic !== false) extensions.push((0, $7Eoiy.Italic).configure(this.options.italic));
        if (this.options.listItem !== false) extensions.push((0, $bMG7S.ListItem).configure(this.options.listItem));
        if (this.options.orderedList !== false) extensions.push((0, $jxZ8N.OrderedList).configure(this.options.orderedList));
        if (this.options.paragraph !== false) extensions.push((0, $bVmeV.Paragraph).configure(this.options.paragraph));
        if (this.options.strike !== false) extensions.push((0, $dr7xH.Strike).configure(this.options.strike));
        if (this.options.text !== false) extensions.push((0, $2F1WD.Text).configure(this.options.text));
        return extensions;
    }
});

});
parcelRegister("hvxib", function(module, exports) {

$parcel$export(module.exports, "Blockquote", () => $cbef2816b48e1a49$export$29a7a275fe11687);

var $aZja8 = parcelRequire("aZja8");
/**
 * Matches a blockquote to a `>` as input.
 */ const $cbef2816b48e1a49$export$55b9391925fcc072 = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */ const $cbef2816b48e1a49$export$29a7a275fe11687 = (0, $aZja8.Node).create({
    name: 'blockquote',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseHTML () {
        return [
            {
                tag: 'blockquote'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'blockquote',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBlockquote: ()=>({ commands: commands })=>{
                    return commands.wrapIn(this.name);
                },
            toggleBlockquote: ()=>({ commands: commands })=>{
                    return commands.toggleWrap(this.name);
                },
            unsetBlockquote: ()=>({ commands: commands })=>{
                    return commands.lift(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-b': ()=>this.editor.commands.toggleBlockquote()
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.wrappingInputRule)({
                find: $cbef2816b48e1a49$export$55b9391925fcc072,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("1e0DR", function(module, exports) {

$parcel$export(module.exports, "Bold", () => $0e4798bd316ce7f7$export$95aa4184327d6b72);

var $aZja8 = parcelRequire("aZja8");
/**
 * Matches bold text via `**` as input.
 */ const $0e4798bd316ce7f7$export$73ba4776eeca629e = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */ const $0e4798bd316ce7f7$export$47b75d481b90409 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */ const $0e4798bd316ce7f7$export$79cd1d2695dae26d = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */ const $0e4798bd316ce7f7$export$9b623891dbc7bd12 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */ const $0e4798bd316ce7f7$export$95aa4184327d6b72 = (0, $aZja8.Mark).create({
    name: 'bold',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'strong'
            },
            {
                tag: 'b',
                getAttrs: (node)=>node.style.fontWeight !== 'normal' && null
            },
            {
                style: 'font-weight=400',
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: 'font-weight',
                getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'strong',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBold: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleBold: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetBold: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-b': ()=>this.editor.commands.toggleBold(),
            'Mod-B': ()=>this.editor.commands.toggleBold()
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.markInputRule)({
                find: $0e4798bd316ce7f7$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $aZja8.markInputRule)({
                find: $0e4798bd316ce7f7$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $aZja8.markPasteRule)({
                find: $0e4798bd316ce7f7$export$47b75d481b90409,
                type: this.type
            }),
            (0, $aZja8.markPasteRule)({
                find: $0e4798bd316ce7f7$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("isg2Q", function(module, exports) {

$parcel$export(module.exports, "BulletList", () => $d6f749acac60e5d5$export$546f606c73d35982);

var $aZja8 = parcelRequire("aZja8");
const $d6f749acac60e5d5$var$ListItemName = 'listItem';
const $d6f749acac60e5d5$var$TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */ const $d6f749acac60e5d5$export$55b9391925fcc072 = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */ const $d6f749acac60e5d5$export$546f606c73d35982 = (0, $aZja8.Node).create({
    name: 'bulletList',
    addOptions () {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: 'block list',
    content () {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML () {
        return [
            {
                tag: 'ul'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'ul',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleBulletList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($d6f749acac60e5d5$var$ListItemName, this.editor.getAttributes($d6f749acac60e5d5$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-8': ()=>this.editor.commands.toggleBulletList()
        };
    },
    addInputRules () {
        let inputRule = (0, $aZja8.wrappingInputRule)({
            find: $d6f749acac60e5d5$export$55b9391925fcc072,
            type: this.type
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $aZja8.wrappingInputRule)({
            find: $d6f749acac60e5d5$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: ()=>{
                return this.editor.getAttributes($d6f749acac60e5d5$var$TextStyleName);
            },
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});

});

parcelRegister("dfxk6", function(module, exports) {

$parcel$export(module.exports, "Code", () => $9a56865da957c263$export$52f0f02147b12c03);

var $aZja8 = parcelRequire("aZja8");
/**
 * Regular expressions to match inline code blocks enclosed in backticks.
 *  It matches:
 *     - An opening backtick, followed by
 *     - Any text that doesn't include a backtick (captured for marking), followed by
 *     - A closing backtick.
 *  This ensures that any text between backticks is formatted as code,
 *  regardless of the surrounding characters (exception being another backtick).
 */ const $9a56865da957c263$export$55b9391925fcc072 = /(^|[^`])`([^`]+)`(?!`)/;
/**
 * Matches inline code while pasting.
 */ const $9a56865da957c263$export$4ed30f8936af1979 = /(^|[^`])`([^`]+)`(?!`)/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */ const $9a56865da957c263$export$52f0f02147b12c03 = (0, $aZja8.Mark).create({
    name: 'code',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    excludes: '_',
    code: true,
    exitable: true,
    parseHTML () {
        return [
            {
                tag: 'code'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'code',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setCode: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleCode: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetCode: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-e': ()=>this.editor.commands.toggleCode()
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.markInputRule)({
                find: $9a56865da957c263$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $aZja8.markPasteRule)({
                find: $9a56865da957c263$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("f50Qv", function(module, exports) {

$parcel$export(module.exports, "CodeBlock", () => $afa7fa981875ed57$export$6c415d1fdae3dfdb);

var $aZja8 = parcelRequire("aZja8");
parcelRequire("goWEd");
var $eCBI9 = parcelRequire("eCBI9");
/**
 * Matches a code block with backticks.
 */ const $afa7fa981875ed57$export$4f70c75119de8367 = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */ const $afa7fa981875ed57$export$ab3d90a1a99abb84 = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */ const $afa7fa981875ed57$export$6c415d1fdae3dfdb = (0, $aZja8.Node).create({
    name: 'codeBlock',
    addOptions () {
        return {
            languageClassPrefix: 'language-',
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            defaultLanguage: null,
            HTMLAttributes: {}
        };
    },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    addAttributes () {
        return {
            language: {
                default: this.options.defaultLanguage,
                parseHTML: (element)=>{
                    var _a;
                    const { languageClassPrefix: languageClassPrefix } = this.options;
                    const classNames = [
                        ...((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []
                    ];
                    const languages = classNames.filter((className)=>className.startsWith(languageClassPrefix)).map((className)=>className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) return null;
                    return language;
                },
                rendered: false
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'pre',
                preserveWhitespace: 'full'
            }
        ];
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        return [
            'pre',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            [
                'code',
                {
                    class: node.attrs.language ? this.options.languageClassPrefix + node.attrs.language : null
                },
                0
            ]
        ];
    },
    addCommands () {
        return {
            setCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.setNode(this.name, attributes);
                },
            toggleCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.toggleNode(this.name, 'paragraph', attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Alt-c': ()=>this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: ()=>{
                const { empty: empty, $anchor: $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) return false;
                if (isAtStart || !$anchor.parent.textContent.length) return this.editor.commands.clearNodes();
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor: editor })=>{
                if (!this.options.exitOnTripleEnter) return false;
                const { state: state } = editor;
                const { selection: selection } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');
                if (!isAtEnd || !endsWithDoubleNewline) return false;
                return editor.chain().command(({ tr: tr })=>{
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                }).exitCode().run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor: editor })=>{
                if (!this.options.exitOnArrowDown) return false;
                const { state: state } = editor;
                const { selection: selection, doc: doc } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) return false;
                const after = $from.after();
                if (after === undefined) return false;
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) return editor.commands.command(({ tr: tr })=>{
                    tr.setSelection((0, $eCBI9.Selection).near(doc.resolve(after)));
                    return true;
                });
                return editor.commands.exitCode();
            }
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.textblockTypeInputRule)({
                find: $afa7fa981875ed57$export$4f70c75119de8367,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            }),
            (0, $aZja8.textblockTypeInputRule)({
                find: $afa7fa981875ed57$export$ab3d90a1a99abb84,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            })
        ];
    },
    addProseMirrorPlugins () {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new (0, $eCBI9.Plugin)({
                key: new (0, $eCBI9.PluginKey)('codeBlockVSCodeHandler'),
                props: {
                    handlePaste: (view, event)=>{
                        if (!event.clipboardData) return false;
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) return false;
                        const text = event.clipboardData.getData('text/plain');
                        const vscode = event.clipboardData.getData('vscode-editor-data');
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) return false;
                        const { tr: tr, schema: schema } = view.state;
                        // prepare a text node
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        const textNode = schema.text(text.replace(/\r\n?/g, '\n'));
                        // create a code block with the text node
                        // replace selection with the code block
                        tr.replaceSelectionWith(this.type.create({
                            language: language
                        }, textNode));
                        if (tr.selection.$from.parent.type !== this.type) // put cursor inside the newly created code block
                        tr.setSelection((0, $eCBI9.TextSelection).near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta('paste', true);
                        view.dispatch(tr);
                        return true;
                    }
                }
            })
        ];
    }
});

});

parcelRegister("iDfSp", function(module, exports) {

$parcel$export(module.exports, "Document", () => $d9082f4b42cd5dd1$export$b34a105447964f9f);

var $aZja8 = parcelRequire("aZja8");
/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */ const $d9082f4b42cd5dd1$export$b34a105447964f9f = (0, $aZja8.Node).create({
    name: 'doc',
    topNode: true,
    content: 'block+'
});

});

parcelRegister("gues3", function(module, exports) {

$parcel$export(module.exports, "Dropcursor", () => $c00aa871387be693$export$bc16731f26f3900d);

var $aZja8 = parcelRequire("aZja8");
parcelRequire("gsrXM");
var $kkNAl = parcelRequire("kkNAl");
/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */ const $c00aa871387be693$export$bc16731f26f3900d = (0, $aZja8.Extension).create({
    name: 'dropCursor',
    addOptions () {
        return {
            color: 'currentColor',
            width: 1,
            class: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $kkNAl.dropCursor)(this.options)
        ];
    }
});

});
parcelRegister("gsrXM", function(module, exports) {
$parcel$export(module.exports, "dropCursor", () => (parcelRequire("kkNAl")).dropCursor);
// dropcursor/index.ts
parcelRequire("kkNAl");

});
parcelRegister("kkNAl", function(module, exports) {

$parcel$export(module.exports, "dropCursor", () => $ecdc2381f897475d$export$b8e3092a3bfa2062);

var $eCBI9 = parcelRequire("eCBI9");

var $cMB55 = parcelRequire("cMB55");
/**
Create a plugin that, when added to a ProseMirror instance,
causes a decoration to show up at the drop position when something
is dragged over the editor.

Nodes may add a `disableDropCursor` property to their spec to
control the showing of a drop cursor inside them. This may be a
boolean or a function, which will be called with a view and a
position, and should return a boolean.
*/ function $ecdc2381f897475d$export$b8e3092a3bfa2062(options = {}) {
    return new (0, $eCBI9.Plugin)({
        view (editorView) {
            return new $ecdc2381f897475d$var$DropCursorView(editorView, options);
        }
    });
}
class $ecdc2381f897475d$var$DropCursorView {
    constructor(editorView, options){
        var _a;
        this.editorView = editorView;
        this.cursorPos = null;
        this.element = null;
        this.timeout = -1;
        this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
        this.color = options.color === false ? undefined : options.color || "black";
        this.class = options.class;
        this.handlers = [
            "dragover",
            "dragend",
            "drop",
            "dragleave"
        ].map((name)=>{
            let handler = (e)=>{
                this[name](e);
            };
            editorView.dom.addEventListener(name, handler);
            return {
                name: name,
                handler: handler
            };
        });
    }
    destroy() {
        this.handlers.forEach(({ name: name, handler: handler })=>this.editorView.dom.removeEventListener(name, handler));
    }
    update(editorView, prevState) {
        if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
            if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);
            else this.updateOverlay();
        }
    }
    setCursor(pos) {
        if (pos == this.cursorPos) return;
        this.cursorPos = pos;
        if (pos == null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        } else this.updateOverlay();
    }
    updateOverlay() {
        let $pos = this.editorView.state.doc.resolve(this.cursorPos);
        let isBlock = !$pos.parent.inlineContent, rect;
        if (isBlock) {
            let before = $pos.nodeBefore, after = $pos.nodeAfter;
            if (before || after) {
                let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                if (node) {
                    let nodeRect = node.getBoundingClientRect();
                    let top = before ? nodeRect.bottom : nodeRect.top;
                    if (before && after) top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
                    rect = {
                        left: nodeRect.left,
                        right: nodeRect.right,
                        top: top - this.width / 2,
                        bottom: top + this.width / 2
                    };
                }
            }
        }
        if (!rect) {
            let coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = {
                left: coords.left - this.width / 2,
                right: coords.left + this.width / 2,
                top: coords.top,
                bottom: coords.bottom
            };
        }
        let parent = this.editorView.dom.offsetParent;
        if (!this.element) {
            this.element = parent.appendChild(document.createElement("div"));
            if (this.class) this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
            if (this.color) this.element.style.backgroundColor = this.color;
        }
        this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
        this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
        let parentLeft, parentTop;
        if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
            parentLeft = -pageXOffset;
            parentTop = -pageYOffset;
        } else {
            let rect = parent.getBoundingClientRect();
            parentLeft = rect.left - parent.scrollLeft;
            parentTop = rect.top - parent.scrollTop;
        }
        this.element.style.left = rect.left - parentLeft + "px";
        this.element.style.top = rect.top - parentTop + "px";
        this.element.style.width = rect.right - rect.left + "px";
        this.element.style.height = rect.bottom - rect.top + "px";
    }
    scheduleRemoval(timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>this.setCursor(null), timeout);
    }
    dragover(event) {
        if (!this.editorView.editable) return;
        let pos = this.editorView.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
        let disableDropCursor = node && node.type.spec.disableDropCursor;
        let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
        if (pos && !disabled) {
            let target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                let point = (0, $cMB55.dropPoint)(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (point != null) target = point;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    }
    dragend() {
        this.scheduleRemoval(20);
    }
    drop() {
        this.scheduleRemoval(20);
    }
    dragleave(event) {
        if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
    }
}

});



parcelRegister("4a0Co", function(module, exports) {

$parcel$export(module.exports, "Gapcursor", () => $3078935b6ad3e80d$export$79c3dcaa03287f63);

var $aZja8 = parcelRequire("aZja8");
parcelRequire("jTywz");
var $dgQ4J = parcelRequire("dgQ4J");
/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */ const $3078935b6ad3e80d$export$79c3dcaa03287f63 = (0, $aZja8.Extension).create({
    name: 'gapCursor',
    addProseMirrorPlugins () {
        return [
            (0, $dgQ4J.gapCursor)()
        ];
    },
    extendNodeSchema (extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        return {
            allowGapCursor: (_a = (0, $aZja8.callOrReturn)((0, $aZja8.getExtensionField)(extension, 'allowGapCursor', context))) !== null && _a !== void 0 ? _a : null
        };
    }
});

});
parcelRegister("jTywz", function(module, exports) {
$parcel$export(module.exports, "gapCursor", () => (parcelRequire("dgQ4J")).gapCursor);
// gapcursor/index.ts
parcelRequire("dgQ4J");

});
parcelRegister("dgQ4J", function(module, exports) {

$parcel$export(module.exports, "gapCursor", () => $9a952a11b6025d05$export$54f46a1492d5247);

var $7kaZl = parcelRequire("7kaZl");

var $eCBI9 = parcelRequire("eCBI9");

var $jcs10 = parcelRequire("jcs10");

var $fYi0r = parcelRequire("fYi0r");
/**
Gap cursor selections are represented using this class. Its
`$anchor` and `$head` properties both point at the cursor position.
*/ class $9a952a11b6025d05$export$3d3d259665dcb4d4 extends (0, $eCBI9.Selection) {
    /**
    Create a gap cursor.
    */ constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        let $pos = doc.resolve(mapping.map(this.head));
        return $9a952a11b6025d05$export$3d3d259665dcb4d4.valid($pos) ? new $9a952a11b6025d05$export$3d3d259665dcb4d4($pos) : (0, $eCBI9.Selection).near($pos);
    }
    content() {
        return (0, $jcs10.Slice).empty;
    }
    eq(other) {
        return other instanceof $9a952a11b6025d05$export$3d3d259665dcb4d4 && other.head == this.head;
    }
    toJSON() {
        return {
            type: "gapcursor",
            pos: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
        return new $9a952a11b6025d05$export$3d3d259665dcb4d4(doc.resolve(json.pos));
    }
    /**
    @internal
    */ getBookmark() {
        return new $9a952a11b6025d05$var$GapBookmark(this.anchor);
    }
    /**
    @internal
    */ static valid($pos) {
        let parent = $pos.parent;
        if (parent.isTextblock || !$9a952a11b6025d05$var$closedBefore($pos) || !$9a952a11b6025d05$var$closedAfter($pos)) return false;
        let override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        let deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    /**
    @internal
    */ static findGapCursorFrom($pos, dir, mustMove = false) {
        search: for(;;){
            if (!mustMove && $9a952a11b6025d05$export$3d3d259665dcb4d4.valid($pos)) return $pos;
            let pos = $pos.pos, next = null;
            // Scan up from this position
            for(let d = $pos.depth;; d--){
                let parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) return null;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($9a952a11b6025d05$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                let inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !(0, $eCBI9.NodeSelection).isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($9a952a11b6025d05$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            return null;
        }
    }
}
$9a952a11b6025d05$export$3d3d259665dcb4d4.prototype.visible = false;
$9a952a11b6025d05$export$3d3d259665dcb4d4.findFrom = $9a952a11b6025d05$export$3d3d259665dcb4d4.findGapCursorFrom;
(0, $eCBI9.Selection).jsonID("gapcursor", $9a952a11b6025d05$export$3d3d259665dcb4d4);
class $9a952a11b6025d05$var$GapBookmark {
    constructor(pos){
        this.pos = pos;
    }
    map(mapping) {
        return new $9a952a11b6025d05$var$GapBookmark(mapping.map(this.pos));
    }
    resolve(doc) {
        let $pos = doc.resolve(this.pos);
        return $9a952a11b6025d05$export$3d3d259665dcb4d4.valid($pos) ? new $9a952a11b6025d05$export$3d3d259665dcb4d4($pos) : (0, $eCBI9.Selection).near($pos);
    }
}
function $9a952a11b6025d05$var$closedBefore($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.index(d), parent = $pos.node(d);
        // At the start of this parent, look at next one
        if (index == 0) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        // See if the node before (or its first ancestor) is closed
        for(let before = parent.child(index - 1);; before = before.lastChild){
            if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) return true;
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return true;
}
function $9a952a11b6025d05$var$closedAfter($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.indexAfter(d), parent = $pos.node(d);
        if (index == parent.childCount) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        for(let after = parent.child(index);; after = after.firstChild){
            if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) return true;
            if (after.inlineContent) return false;
        }
    }
    return true;
}
/**
Create a gap cursor plugin. When enabled, this will capture clicks
near and arrow-key-motion past places that don't have a normally
selectable position nearby, and create a gap cursor selection for
them. The cursor is drawn as an element with class
`ProseMirror-gapcursor`. You can either include
`style/gapcursor.css` from the package's directory or add your own
styles to make it visible.
*/ function $9a952a11b6025d05$export$54f46a1492d5247() {
    return new (0, $eCBI9.Plugin)({
        props: {
            decorations: $9a952a11b6025d05$var$drawGapCursor,
            createSelectionBetween (_view, $anchor, $head) {
                return $anchor.pos == $head.pos && $9a952a11b6025d05$export$3d3d259665dcb4d4.valid($head) ? new $9a952a11b6025d05$export$3d3d259665dcb4d4($head) : null;
            },
            handleClick: $9a952a11b6025d05$var$handleClick,
            handleKeyDown: $9a952a11b6025d05$var$handleKeyDown,
            handleDOMEvents: {
                beforeinput: $9a952a11b6025d05$var$beforeinput
            }
        }
    });
}
const $9a952a11b6025d05$var$handleKeyDown = (0, $7kaZl.keydownHandler)({
    "ArrowLeft": $9a952a11b6025d05$var$arrow("horiz", -1),
    "ArrowRight": $9a952a11b6025d05$var$arrow("horiz", 1),
    "ArrowUp": $9a952a11b6025d05$var$arrow("vert", -1),
    "ArrowDown": $9a952a11b6025d05$var$arrow("vert", 1)
});
function $9a952a11b6025d05$var$arrow(axis, dir) {
    const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
    return function(state, dispatch, view) {
        let sel = state.selection;
        let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
        if (sel instanceof (0, $eCBI9.TextSelection)) {
            if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
            mustMove = false;
            $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
        }
        let $found = $9a952a11b6025d05$export$3d3d259665dcb4d4.findGapCursorFrom($start, dir, mustMove);
        if (!$found) return false;
        if (dispatch) dispatch(state.tr.setSelection(new $9a952a11b6025d05$export$3d3d259665dcb4d4($found)));
        return true;
    };
}
function $9a952a11b6025d05$var$handleClick(view, pos, event) {
    if (!view || !view.editable) return false;
    let $pos = view.state.doc.resolve(pos);
    if (!$9a952a11b6025d05$export$3d3d259665dcb4d4.valid($pos)) return false;
    let clickPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (clickPos && clickPos.inside > -1 && (0, $eCBI9.NodeSelection).isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
    view.dispatch(view.state.tr.setSelection(new $9a952a11b6025d05$export$3d3d259665dcb4d4($pos)));
    return true;
}
// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function $9a952a11b6025d05$var$beforeinput(view, event) {
    if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof $9a952a11b6025d05$export$3d3d259665dcb4d4)) return false;
    let { $from: $from } = view.state.selection;
    let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
    if (!insert) return false;
    let frag = (0, $jcs10.Fragment).empty;
    for(let i = insert.length - 1; i >= 0; i--)frag = (0, $jcs10.Fragment).from(insert[i].createAndFill(null, frag));
    let tr = view.state.tr.replace($from.pos, $from.pos, new (0, $jcs10.Slice)(frag, 0, 0));
    tr.setSelection((0, $eCBI9.TextSelection).near(tr.doc.resolve($from.pos + 1)));
    view.dispatch(tr);
    return false;
}
function $9a952a11b6025d05$var$drawGapCursor(state) {
    if (!(state.selection instanceof $9a952a11b6025d05$export$3d3d259665dcb4d4)) return null;
    let node = document.createElement("div");
    node.className = "ProseMirror-gapcursor";
    return (0, $fYi0r.DecorationSet).create(state.doc, [
        (0, $fYi0r.Decoration).widget(state.selection.head, node, {
            key: "gapcursor"
        })
    ]);
}

});



parcelRegister("7qAJ4", function(module, exports) {

$parcel$export(module.exports, "HardBreak", () => $56877317cc67ef12$export$d3d3fac13fa635d9);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */ const $56877317cc67ef12$export$d3d3fac13fa635d9 = (0, $aZja8.Node).create({
    name: 'hardBreak',
    addOptions () {
        return {
            keepMarks: true,
            HTMLAttributes: {}
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    linebreakReplacement: true,
    parseHTML () {
        return [
            {
                tag: 'br'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'br',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    renderText () {
        return '\n';
    },
    addCommands () {
        return {
            setHardBreak: ()=>({ commands: commands, chain: chain, state: state, editor: editor })=>{
                    return commands.first([
                        ()=>commands.exitCode(),
                        ()=>commands.command(()=>{
                                const { selection: selection, storedMarks: storedMarks } = state;
                                if (selection.$from.parent.type.spec.isolating) return false;
                                const { keepMarks: keepMarks } = this.options;
                                const { splittableMarks: splittableMarks } = editor.extensionManager;
                                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                                return chain().insertContent({
                                    type: this.name
                                }).command(({ tr: tr, dispatch: dispatch })=>{
                                    if (dispatch && marks && keepMarks) {
                                        const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                                        tr.ensureMarks(filteredMarks);
                                    }
                                    return true;
                                }).run();
                            })
                    ]);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Enter': ()=>this.editor.commands.setHardBreak(),
            'Shift-Enter': ()=>this.editor.commands.setHardBreak()
        };
    }
});

});

parcelRegister("1k2XZ", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $0f69f5d271082b2b$export$a8a3e93435678ff9);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */ const $0f69f5d271082b2b$export$a8a3e93435678ff9 = (0, $aZja8.Node).create({
    name: 'heading',
    addOptions () {
        return {
            levels: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            HTMLAttributes: {}
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes () {
        return {
            level: {
                default: 1,
                rendered: false
            }
        };
    },
    parseHTML () {
        return this.options.levels.map((level)=>({
                tag: `h${level}`,
                attrs: {
                    level: level
                }
            }));
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel ? node.attrs.level : this.options.levels[0];
        return [
            `h${level}`,
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.setNode(this.name, attributes);
                },
            toggleHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.toggleNode(this.name, 'paragraph', attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return this.options.levels.reduce((items, level)=>({
                ...items,
                [`Mod-Alt-${level}`]: ()=>this.editor.commands.toggleHeading({
                        level: level
                    })
            }), {});
    },
    addInputRules () {
        return this.options.levels.map((level)=>{
            return (0, $aZja8.textblockTypeInputRule)({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level: level
                }
            });
        });
    }
});

});

parcelRegister("g63HU", function(module, exports) {

$parcel$export(module.exports, "History", () => $bb80150fae6e668f$export$84202caead5689ba);

var $aZja8 = parcelRequire("aZja8");
parcelRequire("caxdi");
var $86wdU = parcelRequire("86wdU");
/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */ const $bb80150fae6e668f$export$84202caead5689ba = (0, $aZja8.Extension).create({
    name: 'history',
    addOptions () {
        return {
            depth: 100,
            newGroupDelay: 500
        };
    },
    addCommands () {
        return {
            undo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $86wdU.undo)(state, dispatch);
                },
            redo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $86wdU.redo)(state, dispatch);
                }
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $86wdU.history)(this.options)
        ];
    },
    addKeyboardShortcuts () {
        return {
            'Mod-z': ()=>this.editor.commands.undo(),
            'Shift-Mod-z': ()=>this.editor.commands.redo(),
            'Mod-y': ()=>this.editor.commands.redo(),
            // Russian keyboard layouts
            "Mod-\u044F": ()=>this.editor.commands.undo(),
            "Shift-Mod-\u044F": ()=>this.editor.commands.redo()
        };
    }
});

});
parcelRegister("caxdi", function(module, exports) {
$parcel$export(module.exports, "history", () => (parcelRequire("86wdU")).history);
$parcel$export(module.exports, "redo", () => (parcelRequire("86wdU")).redo);
$parcel$export(module.exports, "undo", () => (parcelRequire("86wdU")).undo);
// history/index.ts
parcelRequire("86wdU");

});
parcelRegister("86wdU", function(module, exports) {

$parcel$export(module.exports, "history", () => $5e67e129aac1036e$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $5e67e129aac1036e$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $5e67e129aac1036e$export$1688e416fee0a49e);

var $3yL6f = parcelRequire("3yL6f");

var $cMB55 = parcelRequire("cMB55");

var $eCBI9 = parcelRequire("eCBI9");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $5e67e129aac1036e$var$max_empty_items = 500;
class $5e67e129aac1036e$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $5e67e129aac1036e$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $5e67e129aac1036e$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $5e67e129aac1036e$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $5e67e129aac1036e$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $5e67e129aac1036e$var$DEPTH_OVERFLOW) {
            oldItems = $5e67e129aac1036e$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $5e67e129aac1036e$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $cMB55.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $5e67e129aac1036e$var$Branch(this.items.append(array.map((map)=>new $5e67e129aac1036e$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $5e67e129aac1036e$var$Item(map, step, selection));
            } else rebasedItems.push(new $5e67e129aac1036e$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $5e67e129aac1036e$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $5e67e129aac1036e$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $5e67e129aac1036e$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $5e67e129aac1036e$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $5e67e129aac1036e$var$Branch((0, $3yL6f.default).from(items.reverse()), events);
    }
}
$5e67e129aac1036e$var$Branch.empty = new $5e67e129aac1036e$var$Branch((0, $3yL6f.default).empty, 0);
function $5e67e129aac1036e$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $5e67e129aac1036e$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $5e67e129aac1036e$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $5e67e129aac1036e$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $5e67e129aac1036e$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $5e67e129aac1036e$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($5e67e129aac1036e$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($5e67e129aac1036e$var$closeHistoryKey)) history = new $5e67e129aac1036e$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($5e67e129aac1036e$var$historyKey)) {
        if (appended.getMeta($5e67e129aac1036e$var$historyKey).redo) return new $5e67e129aac1036e$var$HistoryState(history.done.addTransform(tr, undefined, options, $5e67e129aac1036e$var$mustPreserveItems(state)), history.undone, $5e67e129aac1036e$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $5e67e129aac1036e$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $5e67e129aac1036e$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$5e67e129aac1036e$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $5e67e129aac1036e$var$mapRanges(history.prevRanges, tr.mapping) : $5e67e129aac1036e$var$rangesFor(tr.mapping.maps);
        return new $5e67e129aac1036e$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $5e67e129aac1036e$var$mustPreserveItems(state)), $5e67e129aac1036e$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $5e67e129aac1036e$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $5e67e129aac1036e$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $5e67e129aac1036e$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $5e67e129aac1036e$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $5e67e129aac1036e$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $5e67e129aac1036e$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $5e67e129aac1036e$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $5e67e129aac1036e$var$histTransaction(history, state, redo) {
    let preserveItems = $5e67e129aac1036e$var$mustPreserveItems(state);
    let histOptions = $5e67e129aac1036e$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $5e67e129aac1036e$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($5e67e129aac1036e$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $5e67e129aac1036e$var$cachedPreserveItems = false, $5e67e129aac1036e$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $5e67e129aac1036e$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($5e67e129aac1036e$var$cachedPreserveItemsPlugins != plugins) {
        $5e67e129aac1036e$var$cachedPreserveItems = false;
        $5e67e129aac1036e$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $5e67e129aac1036e$var$cachedPreserveItems = true;
            break;
        }
    }
    return $5e67e129aac1036e$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $5e67e129aac1036e$export$181a649d919c589e(tr) {
    return tr.setMeta($5e67e129aac1036e$var$closeHistoryKey, true);
}
const $5e67e129aac1036e$var$historyKey = new (0, $eCBI9.PluginKey)("history");
const $5e67e129aac1036e$var$closeHistoryKey = new (0, $eCBI9.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $5e67e129aac1036e$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $eCBI9.Plugin)({
        key: $5e67e129aac1036e$var$historyKey,
        state: {
            init () {
                return new $5e67e129aac1036e$var$HistoryState($5e67e129aac1036e$var$Branch.empty, $5e67e129aac1036e$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $5e67e129aac1036e$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $5e67e129aac1036e$export$21f930c44940fd98 : inputType == "historyRedo" ? $5e67e129aac1036e$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $5e67e129aac1036e$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $5e67e129aac1036e$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $5e67e129aac1036e$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $5e67e129aac1036e$export$21f930c44940fd98 = $5e67e129aac1036e$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $5e67e129aac1036e$export$1688e416fee0a49e = $5e67e129aac1036e$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $5e67e129aac1036e$export$24b5d280435f3a3f = $5e67e129aac1036e$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $5e67e129aac1036e$export$3774e54bae7be19b = $5e67e129aac1036e$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $5e67e129aac1036e$export$f8a176c2b9a10bdb(state) {
    let hist = $5e67e129aac1036e$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $5e67e129aac1036e$export$3ffe6b288e7d941b(state) {
    let hist = $5e67e129aac1036e$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("3yL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $297915219bfd3ec1$export$2e2bcd8739ae039);
var $297915219bfd3ec1$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $297915219bfd3ec1$var$RopeSequence = function RopeSequence() {};
$297915219bfd3ec1$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $297915219bfd3ec1$var$RopeSequence.from(other);
    return !this.length && other || other.length < $297915219bfd3ec1$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $297915219bfd3ec1$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$297915219bfd3ec1$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $297915219bfd3ec1$var$RopeSequence.from(other).append(this);
};
$297915219bfd3ec1$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $297915219bfd3ec1$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$297915219bfd3ec1$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $297915219bfd3ec1$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$297915219bfd3ec1$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$297915219bfd3ec1$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$297915219bfd3ec1$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$297915219bfd3ec1$var$RopeSequence.from = function from(values) {
    if (values instanceof $297915219bfd3ec1$var$RopeSequence) return values;
    return values && values.length ? new $297915219bfd3ec1$var$Leaf(values) : $297915219bfd3ec1$var$RopeSequence.empty;
};
var $297915219bfd3ec1$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $297915219bfd3ec1$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $297915219bfd3ec1$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($297915219bfd3ec1$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$297915219bfd3ec1$var$RopeSequence.empty = new $297915219bfd3ec1$var$Leaf([]);
var $297915219bfd3ec1$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($297915219bfd3ec1$var$RopeSequence);
var $297915219bfd3ec1$export$2e2bcd8739ae039 = $297915219bfd3ec1$var$RopeSequence;

});




parcelRegister("5fDRi", function(module, exports) {

$parcel$export(module.exports, "HorizontalRule", () => $3d2d458ed50f968e$export$841e9c95e6429474);

var $aZja8 = parcelRequire("aZja8");
parcelRequire("goWEd");
var $eCBI9 = parcelRequire("eCBI9");
/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */ const $3d2d458ed50f968e$export$841e9c95e6429474 = (0, $aZja8.Node).create({
    name: 'horizontalRule',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: 'block',
    parseHTML () {
        return [
            {
                tag: 'hr'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'hr',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    addCommands () {
        return {
            setHorizontalRule: ()=>({ chain: chain, state: state })=>{
                    const { selection: selection } = state;
                    const { $from: $originFrom, $to: $originTo } = selection;
                    const currentChain = chain();
                    if ($originFrom.parentOffset === 0) currentChain.insertContentAt({
                        from: Math.max($originFrom.pos - 1, 0),
                        to: $originTo.pos
                    }, {
                        type: this.name
                    });
                    else if ((0, $aZja8.isNodeSelection)(selection)) currentChain.insertContentAt($originTo.pos, {
                        type: this.name
                    });
                    else currentChain.insertContent({
                        type: this.name
                    });
                    return currentChain// set cursor after horizontal rule
                    .command(({ tr: tr, dispatch: dispatch })=>{
                        var _a;
                        if (dispatch) {
                            const { $to: $to } = tr.selection;
                            const posAfter = $to.end();
                            if ($to.nodeAfter) {
                                if ($to.nodeAfter.isTextblock) tr.setSelection((0, $eCBI9.TextSelection).create(tr.doc, $to.pos + 1));
                                else if ($to.nodeAfter.isBlock) tr.setSelection((0, $eCBI9.NodeSelection).create(tr.doc, $to.pos));
                                else tr.setSelection((0, $eCBI9.TextSelection).create(tr.doc, $to.pos));
                            } else {
                                // add node after horizontal rule if it’s the end of the document
                                const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                                if (node) {
                                    tr.insert(posAfter, node);
                                    tr.setSelection((0, $eCBI9.TextSelection).create(tr.doc, posAfter + 1));
                                }
                            }
                            tr.scrollIntoView();
                        }
                        return true;
                    }).run();
                }
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.nodeInputRule)({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("7Eoiy", function(module, exports) {

$parcel$export(module.exports, "Italic", () => $591f1df0587baa37$export$1cfcf4275506b1c6);

var $aZja8 = parcelRequire("aZja8");
/**
 * Matches an italic to a *italic* on input.
 */ const $591f1df0587baa37$export$73ba4776eeca629e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */ const $591f1df0587baa37$export$47b75d481b90409 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */ const $591f1df0587baa37$export$79cd1d2695dae26d = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */ const $591f1df0587baa37$export$9b623891dbc7bd12 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */ const $591f1df0587baa37$export$1cfcf4275506b1c6 = (0, $aZja8.Mark).create({
    name: 'italic',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'em'
            },
            {
                tag: 'i',
                getAttrs: (node)=>node.style.fontStyle !== 'normal' && null
            },
            {
                style: 'font-style=normal',
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: 'font-style=italic'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'em',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setItalic: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleItalic: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetItalic: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-i': ()=>this.editor.commands.toggleItalic(),
            'Mod-I': ()=>this.editor.commands.toggleItalic()
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.markInputRule)({
                find: $591f1df0587baa37$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $aZja8.markInputRule)({
                find: $591f1df0587baa37$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $aZja8.markPasteRule)({
                find: $591f1df0587baa37$export$47b75d481b90409,
                type: this.type
            }),
            (0, $aZja8.markPasteRule)({
                find: $591f1df0587baa37$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("bMG7S", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $8944dac20303e869$export$a7b06bfba60a8a78);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $8944dac20303e869$export$a7b06bfba60a8a78 = (0, $aZja8.Node).create({
    name: 'listItem',
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: 'bulletList',
            orderedListTypeName: 'orderedList'
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML () {
        return [
            {
                tag: 'li'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'li',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});

});

parcelRegister("jxZ8N", function(module, exports) {

$parcel$export(module.exports, "OrderedList", () => $e3b086b4f9892248$export$547f885a1fca4e31);

var $aZja8 = parcelRequire("aZja8");
const $e3b086b4f9892248$var$ListItemName = 'listItem';
const $e3b086b4f9892248$var$TextStyleName = 'textStyle';
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */ const $e3b086b4f9892248$export$55b9391925fcc072 = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $e3b086b4f9892248$export$547f885a1fca4e31 = (0, $aZja8.Node).create({
    name: 'orderedList',
    addOptions () {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: 'block list',
    content () {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes () {
        return {
            start: {
                default: 1,
                parseHTML: (element)=>{
                    return element.hasAttribute('start') ? parseInt(element.getAttribute('start') || '', 10) : 1;
                }
            },
            type: {
                default: null,
                parseHTML: (element)=>element.getAttribute('type')
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'ol'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        const { start: start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1 ? [
            'ol',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, attributesWithoutStart),
            0
        ] : [
            'ol',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleOrderedList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($e3b086b4f9892248$var$ListItemName, this.editor.getAttributes($e3b086b4f9892248$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-7': ()=>this.editor.commands.toggleOrderedList()
        };
    },
    addInputRules () {
        let inputRule = (0, $aZja8.wrappingInputRule)({
            find: $e3b086b4f9892248$export$55b9391925fcc072,
            type: this.type,
            getAttributes: (match)=>({
                    start: +match[1]
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1]
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $aZja8.wrappingInputRule)({
            find: $e3b086b4f9892248$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: (match)=>({
                    start: +match[1],
                    ...this.editor.getAttributes($e3b086b4f9892248$var$TextStyleName)
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1],
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});

});

parcelRegister("bVmeV", function(module, exports) {

$parcel$export(module.exports, "Paragraph", () => $8ae644f3d1de8538$export$358a232cca1ab2ac);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */ const $8ae644f3d1de8538$export$358a232cca1ab2ac = (0, $aZja8.Node).create({
    name: 'paragraph',
    priority: 1000,
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML () {
        return [
            {
                tag: 'p'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'p',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setParagraph: ()=>({ commands: commands })=>{
                    return commands.setNode(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Alt-0': ()=>this.editor.commands.setParagraph()
        };
    }
});

});

parcelRegister("dr7xH", function(module, exports) {

$parcel$export(module.exports, "Strike", () => $9c83a5c3e31c42f0$export$97176b8d51d2058f);

var $aZja8 = parcelRequire("aZja8");
/**
 * Matches a strike to a ~~strike~~ on input.
 */ const $9c83a5c3e31c42f0$export$55b9391925fcc072 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */ const $9c83a5c3e31c42f0$export$4ed30f8936af1979 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */ const $9c83a5c3e31c42f0$export$97176b8d51d2058f = (0, $aZja8.Mark).create({
    name: 'strike',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 's'
            },
            {
                tag: 'del'
            },
            {
                tag: 'strike'
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: (style)=>style.includes('line-through') ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            's',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setStrike: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleStrike: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetStrike: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-s': ()=>this.editor.commands.toggleStrike()
        };
    },
    addInputRules () {
        return [
            (0, $aZja8.markInputRule)({
                find: $9c83a5c3e31c42f0$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $aZja8.markPasteRule)({
                find: $9c83a5c3e31c42f0$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("2F1WD", function(module, exports) {

$parcel$export(module.exports, "Text", () => $1f00eb4d3071b944$export$5f1af8db9871e1d6);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */ const $1f00eb4d3071b944$export$5f1af8db9871e1d6 = (0, $aZja8.Node).create({
    name: 'text',
    group: 'inline'
});

});


parcelRegister("8kCkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $610decce81386284$export$741ee5bff4f2bc22);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create underline text.
 * @see https://www.tiptap.dev/api/marks/underline
 */ const $610decce81386284$export$741ee5bff4f2bc22 = (0, $aZja8.Mark).create({
    name: 'underline',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'u'
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: (style)=>style.includes('underline') ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'u',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setUnderline: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleUnderline: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetUnderline: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-u': ()=>this.editor.commands.toggleUnderline(),
            'Mod-U': ()=>this.editor.commands.toggleUnderline()
        };
    }
});

});

parcelRegister("9KTUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a3c83f8689d52d$export$54eb3b8088f84d2b);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create subscript text.
 * @see https://www.tiptap.dev/api/marks/subscript
 */ const $71a3c83f8689d52d$export$54eb3b8088f84d2b = (0, $aZja8.Mark).create({
    name: 'subscript',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'sub'
            },
            {
                style: 'vertical-align',
                getAttrs (value) {
                    // Don’t match this rule if the vertical align isn’t sub.
                    if (value !== 'sub') return false;
                    // If it falls through we’ll match, and this mark will be applied.
                    return null;
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'sub',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setSubscript: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleSubscript: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetSubscript: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-,': ()=>this.editor.commands.toggleSubscript()
        };
    }
});

});

parcelRegister("dVG9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2414d04911638f6$export$a4eac561e2e9d419);

var $aZja8 = parcelRequire("aZja8");
/**
 * This extension allows you to create superscript text.
 * @see https://www.tiptap.dev/api/marks/superscript
 */ const $a2414d04911638f6$export$a4eac561e2e9d419 = (0, $aZja8.Mark).create({
    name: 'superscript',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'sup'
            },
            {
                style: 'vertical-align',
                getAttrs (value) {
                    // Don’t match this rule if the vertical align isn’t super.
                    if (value !== 'super') return false;
                    // If it falls through we’ll match, and this mark will be applied.
                    return null;
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'sup',
            (0, $aZja8.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setSuperscript: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleSuperscript: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetSuperscript: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-.': ()=>this.editor.commands.toggleSuperscript()
        };
    }
});

});

parcelRegister("1Vkfg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextBackground = void 0;

var $aZja8 = parcelRequire("aZja8");
// const inputRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))$/gm
// const pasteRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))/gm
var $166ad19422a4df7b$var$classPrefix = 'tt-bg-';
var $166ad19422a4df7b$var$classRegex = new RegExp("^" + $166ad19422a4df7b$var$classPrefix + "(.+)$");
function $166ad19422a4df7b$var$extractClass(element) {
    for(var i = 0; i < element.classList.length; ++i){
        var match = $166ad19422a4df7b$var$classRegex.exec(element.classList[i]);
        if (match) return match[1];
    }
    return null;
}
function $166ad19422a4df7b$var$renderClass(c) {
    return $166ad19422a4df7b$var$classPrefix + c;
}
var $166ad19422a4df7b$var$TextBackgroundMark = "textBackground";
module.exports.TextBackground = $aZja8.Mark.create({
    name: $166ad19422a4df7b$var$TextBackgroundMark,
    defaultOptions: {
        HTMLAttributes: {},
        color: null
    },
    addAttributes: function() {
        return {
            color: {
                default: null,
                parseHTML: function(element) {
                    var color = $166ad19422a4df7b$var$extractClass(element);
                    if (!color) return false;
                    return {
                        color: color
                    };
                },
                renderHTML: function(attributes) {
                    if (!attributes.color) return false;
                    return {
                        'class': $166ad19422a4df7b$var$renderClass(attributes.color)
                    };
                }
            }
        };
    },
    parseHTML: function() {
        return [
            {
                tag: 'span',
                getAttrs: function(element) {
                    var color = $166ad19422a4df7b$var$extractClass(element);
                    if (!color) return false;
                    return {
                        color: color
                    };
                }
            }
        ];
    },
    renderHTML: function(_a) {
        var HTMLAttributes = _a.HTMLAttributes;
        return [
            'span',
            $aZja8.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands: function() {
        return {
            setTextBackground: function(color) {
                return function(_a) {
                    var commands = _a.commands;
                    return commands.setMark($166ad19422a4df7b$var$TextBackgroundMark, {
                        color: color
                    });
                };
            },
            toggleTextBackground: function(color) {
                return function(_a) {
                    var commands = _a.commands;
                    return commands.toggleMark($166ad19422a4df7b$var$TextBackgroundMark, {
                        color: color
                    });
                };
            },
            unsetTextBackground: function() {
                return function(_a) {
                    var commands = _a.commands;
                    return commands.unsetMark($166ad19422a4df7b$var$TextBackgroundMark);
                };
            }
        };
    }
});

});

parcelRegister("5RaIK", function(module, exports) {

$parcel$export(module.exports, "BubbleLikeMenu", () => $443a37ea81b24dec$export$c13c4924e7ea7e17);

var $aZja8 = parcelRequire("aZja8");

var $eCBI9 = parcelRequire("eCBI9");

var $cWT2k = parcelRequire("cWT2k");
const $443a37ea81b24dec$export$c13c4924e7ea7e17 = (0, $aZja8.Extension).create({
    name: 'bubbleLikeMenu',
    defaultOptions: {
        tippyOptions: {},
        key: 'bubbleLikeMenu',
        shouldShow: null,
        updateContent: null,
        createContent: null
    },
    addProseMirrorPlugins () {
        return [
            $443a37ea81b24dec$export$dae87683a1524a47({
                key: this.options.key,
                editor: this.editor,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow,
                updateContent: this.options.updateContent,
                createContent: this.options.createContent
            })
        ];
    }
});
class $443a37ea81b24dec$export$7ed9269e10b237b1 {
    constructor({ editor: editor, view: view, tippyOptions: tippyOptions, shouldShow: shouldShow, updateContent: updateContent, createContent: createContent }){
        this.preventHide = false;
        this.tippyGetReferenceClientRect = null;
        this.tippy = null;
        this.shouldShow = ({ state: state, from: from, to: to })=>{
            const { doc: doc, selection: selection } = state;
            const { empty: empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && (0, $aZja8.isTextSelection)(state.selection);
            return !(empty || isEmptyTextBlock);
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.dragstartHandler = ()=>{
            this.hide();
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            const tippyElement = this.tippy ? this.tippy.popper : null;
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = tippyElement === null || tippyElement === void 0 ? void 0 : tippyElement.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            this.hide();
        };
        this.editor = editor;
        this.view = view;
        this.updateContent = updateContent;
        this.tippyOptions = Object.assign({
            duration: 0,
            interactive: true,
            trigger: 'manual',
            placement: 'top',
            hideOnClick: 'toggle'
        }, tippyOptions);
        if (createContent) this.tippyOptions.content = createContent;
        const onShown = this.tippyOptions.onShown;
        this.tippyOptions.onShown = (instance)=>{
            if (onShown) onShown(instance);
            instance.popper.addEventListener('mousedown', this.mousedownHandler, {
                capture: true
            });
            this.updateContentSafe(instance.popper);
        };
        const onHide = this.tippyOptions.onHide;
        this.tippyOptions.onHide = (instance)=>{
            if (onHide) onHide(instance);
            instance.popper.removeEventListener('mousedown', this.mousedownHandler);
        };
        if (shouldShow) this.shouldShow = shouldShow;
        this.view.dom.addEventListener('dragstart', this.dragstartHandler);
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
    }
    update(view, oldState) {
        const { state: state, composing: composing } = view;
        const { doc: doc, selection: selection } = state;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (composing || isSame) return;
        // support for CellSelections
        const { ranges: ranges } = selection;
        const from = Math.min(...ranges.map((range)=>range.$from.pos));
        const to = Math.max(...ranges.map((range)=>range.$to.pos));
        const shouldShow = this.shouldShow({
            editor: this.editor,
            view: view,
            state: state,
            oldState: oldState,
            from: from,
            to: to
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        this.tippyGetReferenceClientRect = ()=>{
            if ((0, $aZja8.isNodeSelection)(state.selection)) {
                const node = view.nodeDOM(from);
                if (node) return node.getBoundingClientRect();
            }
            return (0, $aZja8.posToDOMRect)(view, from, to);
        };
        this.show();
    }
    show() {
        if (!this.tippy) this.tippy = (0, $cWT2k.default)(this.view.dom, this.tippyOptions);
        if (this.tippyGetReferenceClientRect) this.tippy.setProps({
            getReferenceClientRect: this.tippyGetReferenceClientRect
        });
        this.updateContentSafe(this.tippy.popper);
        this.tippy.show();
    }
    updateContentSafe(element) {
        if (this.updateContent) this.updateContent(element);
    }
    hide() {
        if (this.tippy) {
            this.tippy.hide();
            this.tippy.destroy();
            this.tippy = null;
        }
    }
    destroy() {
        this.hide();
        this.view.dom.removeEventListener('dragstart', this.dragstartHandler);
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const $443a37ea81b24dec$export$dae87683a1524a47 = (options)=>{
    return new (0, $eCBI9.Plugin)({
        key: typeof options.key === 'string' ? new (0, $eCBI9.PluginKey)(options.key) : options.key,
        view: (view)=>new $443a37ea81b24dec$export$7ed9269e10b237b1(Object.assign({
                view: view
            }, options))
    });
};

});
parcelRegister("cWT2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d597e9f629510a$export$2e2bcd8739ae039);
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $95UXI = parcelRequire("95UXI");
var $kW6Zp = parcelRequire("kW6Zp");
var $96d597e9f629510a$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $96d597e9f629510a$var$BOX_CLASS = "tippy-box";
var $96d597e9f629510a$var$CONTENT_CLASS = "tippy-content";
var $96d597e9f629510a$var$BACKDROP_CLASS = "tippy-backdrop";
var $96d597e9f629510a$var$ARROW_CLASS = "tippy-arrow";
var $96d597e9f629510a$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $96d597e9f629510a$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $96d597e9f629510a$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $96d597e9f629510a$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $96d597e9f629510a$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $96d597e9f629510a$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $96d597e9f629510a$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $96d597e9f629510a$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $96d597e9f629510a$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $96d597e9f629510a$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $96d597e9f629510a$var$normalizeToArray(value) {
    return [].concat(value);
}
function $96d597e9f629510a$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $96d597e9f629510a$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $96d597e9f629510a$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $96d597e9f629510a$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $96d597e9f629510a$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $96d597e9f629510a$var$div() {
    return document.createElement('div');
}
function $96d597e9f629510a$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $96d597e9f629510a$var$isType(value, type);
    });
}
function $96d597e9f629510a$var$isNodeList(value) {
    return $96d597e9f629510a$var$isType(value, 'NodeList');
}
function $96d597e9f629510a$var$isMouseEvent(value) {
    return $96d597e9f629510a$var$isType(value, 'MouseEvent');
}
function $96d597e9f629510a$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $96d597e9f629510a$var$getArrayOfElements(value) {
    if ($96d597e9f629510a$var$isElement(value)) return [
        value
    ];
    if ($96d597e9f629510a$var$isNodeList(value)) return $96d597e9f629510a$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $96d597e9f629510a$var$arrayFrom(document.querySelectorAll(value));
}
function $96d597e9f629510a$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $96d597e9f629510a$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $96d597e9f629510a$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $96d597e9f629510a$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $96d597e9f629510a$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $96d597e9f629510a$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $96d597e9f629510a$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $96d597e9f629510a$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $96d597e9f629510a$var$currentInput = {
    isTouch: false
};
var $96d597e9f629510a$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $96d597e9f629510a$var$onDocumentTouchStart() {
    if ($96d597e9f629510a$var$currentInput.isTouch) return;
    $96d597e9f629510a$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $96d597e9f629510a$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $96d597e9f629510a$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $96d597e9f629510a$var$lastMouseMoveTime < 20) {
        $96d597e9f629510a$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $96d597e9f629510a$var$onDocumentMouseMove);
    }
    $96d597e9f629510a$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $96d597e9f629510a$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($96d597e9f629510a$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $96d597e9f629510a$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $96d597e9f629510a$var$onDocumentTouchStart, $96d597e9f629510a$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $96d597e9f629510a$var$onWindowBlur);
}
var $96d597e9f629510a$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $96d597e9f629510a$var$isIE11 = $96d597e9f629510a$var$isBrowser ? !!window.msCrypto : false;
function $96d597e9f629510a$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $96d597e9f629510a$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $96d597e9f629510a$var$getDevMessage(message) {
    return $96d597e9f629510a$var$clean("\n  %ctippy.js\n\n  %c" + $96d597e9f629510a$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $96d597e9f629510a$var$getFormattedMessage(message) {
    return [
        $96d597e9f629510a$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $96d597e9f629510a$var$visitedMessages;
function $96d597e9f629510a$var$resetVisitedMessages() {
    $96d597e9f629510a$var$visitedMessages = new Set();
}
function $96d597e9f629510a$var$warnWhen(condition, message) {
    if (condition && !$96d597e9f629510a$var$visitedMessages.has(message)) {
        var _console;
        $96d597e9f629510a$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $96d597e9f629510a$var$getFormattedMessage(message));
    }
}
function $96d597e9f629510a$var$errorWhen(condition, message) {
    if (condition && !$96d597e9f629510a$var$visitedMessages.has(message)) {
        var _console2;
        $96d597e9f629510a$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $96d597e9f629510a$var$getFormattedMessage(message));
    }
}
function $96d597e9f629510a$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $96d597e9f629510a$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $96d597e9f629510a$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $96d597e9f629510a$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $96d597e9f629510a$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $96d597e9f629510a$var$defaultProps = Object.assign({
    appendTo: $96d597e9f629510a$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $96d597e9f629510a$var$pluginProps, $96d597e9f629510a$var$renderProps);
var $96d597e9f629510a$var$defaultKeys = Object.keys($96d597e9f629510a$var$defaultProps);
var $96d597e9f629510a$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $96d597e9f629510a$var$defaultProps[key] = partialProps[key];
    });
};
function $96d597e9f629510a$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $96d597e9f629510a$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $96d597e9f629510a$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($96d597e9f629510a$var$getExtendedPassedProps(Object.assign({}, $96d597e9f629510a$var$defaultProps, {
        plugins: plugins
    }))) : $96d597e9f629510a$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $96d597e9f629510a$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $96d597e9f629510a$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $96d597e9f629510a$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $96d597e9f629510a$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $96d597e9f629510a$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $96d597e9f629510a$var$removeProperties($96d597e9f629510a$var$defaultProps, Object.keys($96d597e9f629510a$var$pluginProps));
        var didPassUnknownProp = !$96d597e9f629510a$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $96d597e9f629510a$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $96d597e9f629510a$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $96d597e9f629510a$var$dangerouslySetInnerHTML(element, html) {
    element[$96d597e9f629510a$var$innerHTML()] = html;
}
function $96d597e9f629510a$var$createArrowElement(value) {
    var arrow = $96d597e9f629510a$var$div();
    if (value === true) arrow.className = $96d597e9f629510a$var$ARROW_CLASS;
    else {
        arrow.className = $96d597e9f629510a$var$SVG_ARROW_CLASS;
        if ($96d597e9f629510a$var$isElement(value)) arrow.appendChild(value);
        else $96d597e9f629510a$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $96d597e9f629510a$var$setContent(content, props) {
    if ($96d597e9f629510a$var$isElement(props.content)) {
        $96d597e9f629510a$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $96d597e9f629510a$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $96d597e9f629510a$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $96d597e9f629510a$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($96d597e9f629510a$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($96d597e9f629510a$var$ARROW_CLASS) || node.classList.contains($96d597e9f629510a$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($96d597e9f629510a$var$BACKDROP_CLASS);
        })
    };
}
function $96d597e9f629510a$var$render(instance) {
    var popper = $96d597e9f629510a$var$div();
    var box = $96d597e9f629510a$var$div();
    box.className = $96d597e9f629510a$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $96d597e9f629510a$var$div();
    content.className = $96d597e9f629510a$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $96d597e9f629510a$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $96d597e9f629510a$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $96d597e9f629510a$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($96d597e9f629510a$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($96d597e9f629510a$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$96d597e9f629510a$var$render.$$tippy = true;
var $96d597e9f629510a$var$idCounter = 1;
var $96d597e9f629510a$var$mouseMoveListeners = []; // Used by `hideAll()`
var $96d597e9f629510a$var$mountedInstances = [];
function $96d597e9f629510a$var$createTippy(reference, passedProps) {
    var props = $96d597e9f629510a$var$evaluateProps(reference, Object.assign({}, $96d597e9f629510a$var$defaultProps, $96d597e9f629510a$var$getExtendedPassedProps($96d597e9f629510a$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $96d597e9f629510a$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $96d597e9f629510a$var$idCounter++;
    var popperInstance = null;
    var plugins = $96d597e9f629510a$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $96d597e9f629510a$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $96d597e9f629510a$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $96d597e9f629510a$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $96d597e9f629510a$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $96d597e9f629510a$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $96d597e9f629510a$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $96d597e9f629510a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $96d597e9f629510a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $96d597e9f629510a$var$mouseMoveListeners = $96d597e9f629510a$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($96d597e9f629510a$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $96d597e9f629510a$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($96d597e9f629510a$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $96d597e9f629510a$var$actualContains(el, actualTarget);
        })) {
            if ($96d597e9f629510a$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $96d597e9f629510a$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $96d597e9f629510a$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $96d597e9f629510a$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $96d597e9f629510a$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $96d597e9f629510a$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $96d597e9f629510a$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $96d597e9f629510a$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $96d597e9f629510a$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $96d597e9f629510a$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $96d597e9f629510a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $96d597e9f629510a$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($96d597e9f629510a$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $96d597e9f629510a$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $96d597e9f629510a$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($96d597e9f629510a$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $96d597e9f629510a$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $96d597e9f629510a$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $kW6Zp.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $96d597e9f629510a$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $96d597e9f629510a$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $96d597e9f629510a$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($96d597e9f629510a$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $96d597e9f629510a$var$evaluateProps(reference, Object.assign({}, prevProps, $96d597e9f629510a$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $96d597e9f629510a$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $96d597e9f629510a$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $96d597e9f629510a$var$currentInput.isTouch && !instance.props.touch;
        var duration = $96d597e9f629510a$var$getValueAtIndexOrReturn(instance.props.duration, 0, $96d597e9f629510a$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $96d597e9f629510a$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $96d597e9f629510a$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $96d597e9f629510a$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $96d597e9f629510a$var$pushIfUnique($96d597e9f629510a$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $96d597e9f629510a$var$getValueAtIndexOrReturn(instance.props.duration, 1, $96d597e9f629510a$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $96d597e9f629510a$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $96d597e9f629510a$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $96d597e9f629510a$var$pushIfUnique($96d597e9f629510a$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $96d597e9f629510a$var$mountedInstances = $96d597e9f629510a$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $96d597e9f629510a$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $96d597e9f629510a$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $96d597e9f629510a$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $96d597e9f629510a$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $96d597e9f629510a$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $96d597e9f629510a$var$isElement(targets) ? instances[0] : instances;
}
$96d597e9f629510a$var$tippy.defaultProps = $96d597e9f629510a$var$defaultProps;
$96d597e9f629510a$var$tippy.setDefaultProps = $96d597e9f629510a$var$setDefaultProps;
$96d597e9f629510a$var$tippy.currentInput = $96d597e9f629510a$var$currentInput;
var $96d597e9f629510a$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $96d597e9f629510a$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $96d597e9f629510a$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $96d597e9f629510a$var$applyStylesModifier = Object.assign({}, (0, $95UXI.default), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $96d597e9f629510a$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $96d597e9f629510a$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $96d597e9f629510a$var$tippy($96d597e9f629510a$var$div(), Object.assign({}, $96d597e9f629510a$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $96d597e9f629510a$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $96d597e9f629510a$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $96d597e9f629510a$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $96d597e9f629510a$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $96d597e9f629510a$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $96d597e9f629510a$var$tippy(targets, parentProps);
    var normalizedReturnValue = $96d597e9f629510a$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $96d597e9f629510a$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($96d597e9f629510a$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $96d597e9f629510a$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $96d597e9f629510a$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $96d597e9f629510a$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $96d597e9f629510a$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $96d597e9f629510a$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $96d597e9f629510a$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $96d597e9f629510a$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $96d597e9f629510a$var$createBackdropElement() {
    var backdrop = $96d597e9f629510a$var$div();
    backdrop.className = $96d597e9f629510a$var$BACKDROP_CLASS;
    $96d597e9f629510a$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $96d597e9f629510a$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $96d597e9f629510a$var$activeInstances = [];
function $96d597e9f629510a$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $96d597e9f629510a$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $96d597e9f629510a$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $96d597e9f629510a$var$storeMouseCoords);
}
function $96d597e9f629510a$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $96d597e9f629510a$var$storeMouseCoords);
}
var $96d597e9f629510a$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $96d597e9f629510a$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $96d597e9f629510a$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $96d597e9f629510a$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $96d597e9f629510a$var$activeInstances = $96d597e9f629510a$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($96d597e9f629510a$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $96d597e9f629510a$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($96d597e9f629510a$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($96d597e9f629510a$var$isMouseEvent(event)) $96d597e9f629510a$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $96d597e9f629510a$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $96d597e9f629510a$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $96d597e9f629510a$var$getInlineBoundingClientRect($96d597e9f629510a$var$getBasePlacement(placement), reference.getBoundingClientRect(), $96d597e9f629510a$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($96d597e9f629510a$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($96d597e9f629510a$var$isMouseEvent(event)) {
                    var rects = $96d597e9f629510a$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $96d597e9f629510a$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $96d597e9f629510a$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $96d597e9f629510a$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $96d597e9f629510a$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $96d597e9f629510a$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$96d597e9f629510a$var$tippy.setDefaultProps({
    render: $96d597e9f629510a$var$render
});
var $96d597e9f629510a$export$2e2bcd8739ae039 = $96d597e9f629510a$var$tippy;

});
parcelRegister("95UXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f0c43095e21a1f$export$2e2bcd8739ae039);

var $7tQ4A = parcelRequire("7tQ4A");

var $cLFsU = parcelRequire("cLFsU");
// and applies them to the HTMLElements such as popper and arrow
function $69f0c43095e21a1f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $cLFsU.isHTMLElement)(element) || !(0, $7tQ4A.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $69f0c43095e21a1f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $cLFsU.isHTMLElement)(element) || !(0, $7tQ4A.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $69f0c43095e21a1f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $69f0c43095e21a1f$var$applyStyles,
    effect: $69f0c43095e21a1f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("7tQ4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5723a26b716d63fa$export$2e2bcd8739ae039);
function $5723a26b716d63fa$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cLFsU", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $94ba09f2c8044cfd$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $94ba09f2c8044cfd$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $94ba09f2c8044cfd$export$af51f0f06c0f328a);

var $7lQvJ = parcelRequire("7lQvJ");
function $94ba09f2c8044cfd$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7lQvJ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $94ba09f2c8044cfd$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7lQvJ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $94ba09f2c8044cfd$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7lQvJ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("7lQvJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a33a20f53bc749$export$2e2bcd8739ae039);
function $55a33a20f53bc749$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("kW6Zp", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $f3dea566b7f1e793$export$8f7491d57c8f97a9);

var $kAUT8 = parcelRequire("kAUT8");

var $67ILb = parcelRequire("67ILb");

var $3o4Ng = parcelRequire("3o4Ng");

var $aIPox = parcelRequire("aIPox");

var $95UXI = parcelRequire("95UXI");

var $34YXr = parcelRequire("34YXr");

var $8FLi1 = parcelRequire("8FLi1");

var $aaoDf = parcelRequire("aaoDf");

var $1vpAW = parcelRequire("1vpAW");

var $hwyo6 = parcelRequire("hwyo6");


var $f3dea566b7f1e793$export$d34966752335dd47 = [
    (0, $67ILb.default),
    (0, $3o4Ng.default),
    (0, $aIPox.default),
    (0, $95UXI.default),
    (0, $34YXr.default),
    (0, $8FLi1.default),
    (0, $aaoDf.default),
    (0, $1vpAW.default),
    (0, $hwyo6.default)
];
var $f3dea566b7f1e793$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $kAUT8.popperGenerator)({
    defaultModifiers: $f3dea566b7f1e793$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("kAUT8", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $efe34c471ec30379$export$ed5e13716264f202);

var $lNqIj = parcelRequire("lNqIj");

var $cqcuU = parcelRequire("cqcuU");

var $79g4w = parcelRequire("79g4w");

var $17M7a = parcelRequire("17M7a");

var $D10wd = parcelRequire("D10wd");

var $bS4Sy = parcelRequire("bS4Sy");

var $cUL1j = parcelRequire("cUL1j");


var $cLFsU = parcelRequire("cLFsU");
var $efe34c471ec30379$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $efe34c471ec30379$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $efe34c471ec30379$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $efe34c471ec30379$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $efe34c471ec30379$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $cLFsU.isElement)(reference) ? (0, $79g4w.default)(reference) : reference.contextElement ? (0, $79g4w.default)(reference.contextElement) : [],
                    popper: (0, $79g4w.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $D10wd.default)((0, $cUL1j.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$efe34c471ec30379$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $lNqIj.default)(reference, (0, $17M7a.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $cqcuU.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bS4Sy.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$efe34c471ec30379$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $efe34c471ec30379$export$8f7491d57c8f97a9 = /*#__PURE__*/ $efe34c471ec30379$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lNqIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde2e55b973075c8$export$2e2bcd8739ae039);

var $b3mjl = parcelRequire("b3mjl");

var $2xTAn = parcelRequire("2xTAn");

var $7tQ4A = parcelRequire("7tQ4A");

var $cLFsU = parcelRequire("cLFsU");

var $471vU = parcelRequire("471vU");

var $dAPdu = parcelRequire("dAPdu");

var $5tiuD = parcelRequire("5tiuD");

var $Q1foT = parcelRequire("Q1foT");
function $fde2e55b973075c8$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $Q1foT.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $Q1foT.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $fde2e55b973075c8$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $cLFsU.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $cLFsU.isHTMLElement)(offsetParent) && $fde2e55b973075c8$var$isElementScaled(offsetParent);
    var documentElement = (0, $dAPdu.default)(offsetParent);
    var rect = (0, $b3mjl.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $7tQ4A.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $5tiuD.default)(documentElement)) scroll = (0, $2xTAn.default)(offsetParent);
        if ((0, $cLFsU.isHTMLElement)(offsetParent)) {
            offsets = (0, $b3mjl.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $471vU.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("b3mjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c1480242d71058$export$2e2bcd8739ae039);

var $cLFsU = parcelRequire("cLFsU");

var $Q1foT = parcelRequire("Q1foT");

var $7lQvJ = parcelRequire("7lQvJ");

var $1CObK = parcelRequire("1CObK");
function $80c1480242d71058$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $cLFsU.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $Q1foT.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $Q1foT.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $cLFsU.isElement)(element) ? (0, $7lQvJ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $1CObK.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("Q1foT", function(module, exports) {

$parcel$export(module.exports, "max", () => $09c5d32681a7bcbd$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $09c5d32681a7bcbd$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $09c5d32681a7bcbd$export$2077e0241d6afd3c);
var $09c5d32681a7bcbd$export$8960430cfd85939f = Math.max;
var $09c5d32681a7bcbd$export$96ec731ed4dcb222 = Math.min;
var $09c5d32681a7bcbd$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("1CObK", function(module, exports) {

$parcel$export(module.exports, "default", () => $12f0456aa1b56bf8$export$2e2bcd8739ae039);

var $fsZQw = parcelRequire("fsZQw");
function $12f0456aa1b56bf8$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fsZQw.default)());
}

});
parcelRegister("fsZQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42971dffcdc8ce2$export$2e2bcd8739ae039);
function $b42971dffcdc8ce2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("2xTAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da9c804afd0121f$export$2e2bcd8739ae039);

var $7cNZt = parcelRequire("7cNZt");

var $7lQvJ = parcelRequire("7lQvJ");

var $cLFsU = parcelRequire("cLFsU");

var $bPkPD = parcelRequire("bPkPD");
function $1da9c804afd0121f$export$2e2bcd8739ae039(node) {
    if (node === (0, $7lQvJ.default)(node) || !(0, $cLFsU.isHTMLElement)(node)) return (0, $7cNZt.default)(node);
    else return (0, $bPkPD.default)(node);
}

});
parcelRegister("7cNZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f06e780b3588bc$export$2e2bcd8739ae039);

var $7lQvJ = parcelRequire("7lQvJ");
function $53f06e780b3588bc$export$2e2bcd8739ae039(node) {
    var win = (0, $7lQvJ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("bPkPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $89c49de102a28394$export$2e2bcd8739ae039);
function $89c49de102a28394$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("471vU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe8fd7714389130$export$2e2bcd8739ae039);

var $b3mjl = parcelRequire("b3mjl");

var $dAPdu = parcelRequire("dAPdu");

var $7cNZt = parcelRequire("7cNZt");
function $2fe8fd7714389130$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $b3mjl.default)((0, $dAPdu.default)(element)).left + (0, $7cNZt.default)(element).scrollLeft;
}

});
parcelRegister("dAPdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e565dae7f69e7fa$export$2e2bcd8739ae039);

var $cLFsU = parcelRequire("cLFsU");
function $9e565dae7f69e7fa$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $cLFsU.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("5tiuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbe018e387716c3$export$2e2bcd8739ae039);

var $5dfDY = parcelRequire("5dfDY");
function $3fbe018e387716c3$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5dfDY.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5dfDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cba4d2d9d239100$export$2e2bcd8739ae039);

var $7lQvJ = parcelRequire("7lQvJ");
function $3cba4d2d9d239100$export$2e2bcd8739ae039(element) {
    return (0, $7lQvJ.default)(element).getComputedStyle(element);
}

});



parcelRegister("cqcuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b19b7b603cf079$export$2e2bcd8739ae039);

var $b3mjl = parcelRequire("b3mjl");
function $90b19b7b603cf079$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $b3mjl.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("79g4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5345d732097201e6$export$2e2bcd8739ae039);

var $8HWuY = parcelRequire("8HWuY");

var $dgsUJ = parcelRequire("dgsUJ");

var $7lQvJ = parcelRequire("7lQvJ");

var $5tiuD = parcelRequire("5tiuD");
function $5345d732097201e6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $8HWuY.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7lQvJ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $5tiuD.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5345d732097201e6$export$2e2bcd8739ae039((0, $dgsUJ.default)(target)));
}

});
parcelRegister("8HWuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $656fb7760eb90d58$export$2e2bcd8739ae039);

var $dgsUJ = parcelRequire("dgsUJ");

var $5tiuD = parcelRequire("5tiuD");

var $7tQ4A = parcelRequire("7tQ4A");

var $cLFsU = parcelRequire("cLFsU");
function $656fb7760eb90d58$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $7tQ4A.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $cLFsU.isHTMLElement)(node) && (0, $5tiuD.default)(node)) return node;
    return $656fb7760eb90d58$export$2e2bcd8739ae039((0, $dgsUJ.default)(node));
}

});
parcelRegister("dgsUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8332b61d28cdf0$export$2e2bcd8739ae039);

var $7tQ4A = parcelRequire("7tQ4A");

var $dAPdu = parcelRequire("dAPdu");

var $cLFsU = parcelRequire("cLFsU");
function $9a8332b61d28cdf0$export$2e2bcd8739ae039(element) {
    if ((0, $7tQ4A.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $cLFsU.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $dAPdu.default)(element) // fallback
    );
}

});



parcelRegister("17M7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1bc46e9e03d49a$export$2e2bcd8739ae039);

var $7lQvJ = parcelRequire("7lQvJ");

var $7tQ4A = parcelRequire("7tQ4A");

var $5dfDY = parcelRequire("5dfDY");

var $cLFsU = parcelRequire("cLFsU");

var $cvDZf = parcelRequire("cvDZf");

var $dgsUJ = parcelRequire("dgsUJ");

var $fsZQw = parcelRequire("fsZQw");
function $0d1bc46e9e03d49a$var$getTrueOffsetParent(element) {
    if (!(0, $cLFsU.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5dfDY.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $0d1bc46e9e03d49a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fsZQw.default)());
    var isIE = /Trident/i.test((0, $fsZQw.default)());
    if (isIE && (0, $cLFsU.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5dfDY.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $dgsUJ.default)(element);
    if ((0, $cLFsU.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $cLFsU.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $7tQ4A.default)(currentNode)) < 0){
        var css = (0, $5dfDY.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $0d1bc46e9e03d49a$export$2e2bcd8739ae039(element) {
    var window = (0, $7lQvJ.default)(element);
    var offsetParent = $0d1bc46e9e03d49a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cvDZf.default)(offsetParent) && (0, $5dfDY.default)(offsetParent).position === 'static')offsetParent = $0d1bc46e9e03d49a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $7tQ4A.default)(offsetParent) === 'html' || (0, $7tQ4A.default)(offsetParent) === 'body' && (0, $5dfDY.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $0d1bc46e9e03d49a$var$getContainingBlock(element) || window;
}

});
parcelRegister("cvDZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $91b765db26bc9a65$export$2e2bcd8739ae039);

var $7tQ4A = parcelRequire("7tQ4A");
function $91b765db26bc9a65$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $7tQ4A.default)(element)) >= 0;
}

});


parcelRegister("D10wd", function(module, exports) {

$parcel$export(module.exports, "default", () => $07546cacb2bbd5e6$export$2e2bcd8739ae039);

var $cjLzb = parcelRequire("cjLzb");
function $07546cacb2bbd5e6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $07546cacb2bbd5e6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $07546cacb2bbd5e6$var$order(modifiers); // order based on phase
    return (0, $cjLzb.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cjLzb", function(module, exports) {

$parcel$export(module.exports, "top", () => $8f7c2817bfed3c93$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $8f7c2817bfed3c93$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $8f7c2817bfed3c93$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $8f7c2817bfed3c93$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $8f7c2817bfed3c93$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $8f7c2817bfed3c93$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $8f7c2817bfed3c93$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $8f7c2817bfed3c93$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $8f7c2817bfed3c93$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $8f7c2817bfed3c93$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $8f7c2817bfed3c93$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $8f7c2817bfed3c93$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $8f7c2817bfed3c93$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $8f7c2817bfed3c93$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $8f7c2817bfed3c93$export$d087d3878fdf71d5);
var $8f7c2817bfed3c93$export$1e95b668f3b82d = 'top';
var $8f7c2817bfed3c93$export$40e543e69a8b3fbb = 'bottom';
var $8f7c2817bfed3c93$export$79ffe56a765070d2 = 'right';
var $8f7c2817bfed3c93$export$eabcd2c8791e7bf4 = 'left';
var $8f7c2817bfed3c93$export$dfb5619354ba860 = 'auto';
var $8f7c2817bfed3c93$export$aec2ce47c367b8c3 = [
    $8f7c2817bfed3c93$export$1e95b668f3b82d,
    $8f7c2817bfed3c93$export$40e543e69a8b3fbb,
    $8f7c2817bfed3c93$export$79ffe56a765070d2,
    $8f7c2817bfed3c93$export$eabcd2c8791e7bf4
];
var $8f7c2817bfed3c93$export$b3571188c770cc5a = 'start';
var $8f7c2817bfed3c93$export$bd5df0f255a350f8 = 'end';
var $8f7c2817bfed3c93$export$390fd549c5303b4d = 'clippingParents';
var $8f7c2817bfed3c93$export$d7b7311ec04a3e8f = 'viewport';
var $8f7c2817bfed3c93$export$ae5ab1c730825774 = 'popper';
var $8f7c2817bfed3c93$export$ca50aac9f3ba507f = 'reference';
var $8f7c2817bfed3c93$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8f7c2817bfed3c93$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8f7c2817bfed3c93$export$b3571188c770cc5a,
        placement + "-" + $8f7c2817bfed3c93$export$bd5df0f255a350f8
    ]);
}, []);
var $8f7c2817bfed3c93$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8f7c2817bfed3c93$export$aec2ce47c367b8c3, [
    $8f7c2817bfed3c93$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8f7c2817bfed3c93$export$b3571188c770cc5a,
        placement + "-" + $8f7c2817bfed3c93$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8f7c2817bfed3c93$export$421679a7c3d56e = 'beforeRead';
var $8f7c2817bfed3c93$export$aafa59e2e03f2942 = 'read';
var $8f7c2817bfed3c93$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $8f7c2817bfed3c93$export$c65e99957a05207c = 'beforeMain';
var $8f7c2817bfed3c93$export$f22da7240b7add18 = 'main';
var $8f7c2817bfed3c93$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8f7c2817bfed3c93$export$8d4d2d70e7d46032 = 'beforeWrite';
var $8f7c2817bfed3c93$export$68d8715fc104d294 = 'write';
var $8f7c2817bfed3c93$export$70a6e5159acce2e6 = 'afterWrite';
var $8f7c2817bfed3c93$export$d087d3878fdf71d5 = [
    $8f7c2817bfed3c93$export$421679a7c3d56e,
    $8f7c2817bfed3c93$export$aafa59e2e03f2942,
    $8f7c2817bfed3c93$export$6964f6c886723980,
    $8f7c2817bfed3c93$export$c65e99957a05207c,
    $8f7c2817bfed3c93$export$f22da7240b7add18,
    $8f7c2817bfed3c93$export$bab79516f2d662fe,
    $8f7c2817bfed3c93$export$8d4d2d70e7d46032,
    $8f7c2817bfed3c93$export$68d8715fc104d294,
    $8f7c2817bfed3c93$export$70a6e5159acce2e6
];

});


parcelRegister("bS4Sy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a4885b8ea1a4665$export$2e2bcd8739ae039);
function $8a4885b8ea1a4665$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("cUL1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $966f303579d96cdf$export$2e2bcd8739ae039);
function $966f303579d96cdf$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("67ILb", function(module, exports) {

$parcel$export(module.exports, "default", () => $47561deb4941edd4$export$2e2bcd8739ae039);

var $7lQvJ = parcelRequire("7lQvJ");
var $47561deb4941edd4$var$passive = {
    passive: true
};
function $47561deb4941edd4$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7lQvJ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $47561deb4941edd4$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $47561deb4941edd4$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $47561deb4941edd4$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $47561deb4941edd4$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $47561deb4941edd4$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $47561deb4941edd4$var$effect,
    data: {}
};

});

parcelRegister("3o4Ng", function(module, exports) {

$parcel$export(module.exports, "default", () => $277754e01efc7f33$export$2e2bcd8739ae039);

var $1Qfmd = parcelRequire("1Qfmd");
function $277754e01efc7f33$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $1Qfmd.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $277754e01efc7f33$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $277754e01efc7f33$var$popperOffsets,
    data: {}
};

});
parcelRegister("1Qfmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $15768f6ff2fe818f$export$2e2bcd8739ae039);

var $78gT4 = parcelRequire("78gT4");

var $02m1U = parcelRequire("02m1U");

var $bR5Ka = parcelRequire("bR5Ka");

var $cjLzb = parcelRequire("cjLzb");
function $15768f6ff2fe818f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $78gT4.default)(placement) : null;
    var variation = placement ? (0, $02m1U.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cjLzb.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cjLzb.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cjLzb.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cjLzb.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $bR5Ka.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cjLzb.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cjLzb.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("78gT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $53166131c5076ad6$export$2e2bcd8739ae039);

function $53166131c5076ad6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("02m1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $007146b47a42ba95$export$2e2bcd8739ae039);
function $007146b47a42ba95$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("bR5Ka", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1919838fbf6ae4$export$2e2bcd8739ae039);
function $8a1919838fbf6ae4$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("aIPox", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce5e1606862a0f7$export$2e2bcd8739ae039);

var $cjLzb = parcelRequire("cjLzb");

var $17M7a = parcelRequire("17M7a");

var $7lQvJ = parcelRequire("7lQvJ");

var $dAPdu = parcelRequire("dAPdu");

var $5dfDY = parcelRequire("5dfDY");

var $78gT4 = parcelRequire("78gT4");

var $02m1U = parcelRequire("02m1U");

var $Q1foT = parcelRequire("Q1foT");
var $7ce5e1606862a0f7$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7ce5e1606862a0f7$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $Q1foT.round)(x * dpr) / dpr || 0,
        y: (0, $Q1foT.round)(y * dpr) / dpr || 0
    };
}
function $7ce5e1606862a0f7$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cjLzb.left);
    var sideY = (0, $cjLzb.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $17M7a.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7lQvJ.default)(popper)) {
            offsetParent = (0, $dAPdu.default)(popper);
            if ((0, $5dfDY.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cjLzb.top) || (placement === (0, $cjLzb.left) || placement === (0, $cjLzb.right)) && variation === (0, $cjLzb.end)) {
            sideY = (0, $cjLzb.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cjLzb.left) || (placement === (0, $cjLzb.top) || placement === (0, $cjLzb.bottom)) && variation === (0, $cjLzb.end)) {
            sideX = (0, $cjLzb.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7ce5e1606862a0f7$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7ce5e1606862a0f7$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7lQvJ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $7ce5e1606862a0f7$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $78gT4.default)(state.placement),
        variation: (0, $02m1U.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7ce5e1606862a0f7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7ce5e1606862a0f7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7ce5e1606862a0f7$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $7ce5e1606862a0f7$var$computeStyles,
    data: {}
};

});

parcelRegister("34YXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e107bc9593c0b6$export$2e2bcd8739ae039);

var $78gT4 = parcelRequire("78gT4");

var $cjLzb = parcelRequire("cjLzb");
function $23e107bc9593c0b6$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $78gT4.default)(placement);
    var invertDistance = [
        (0, $cjLzb.left),
        (0, $cjLzb.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cjLzb.left),
        (0, $cjLzb.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $23e107bc9593c0b6$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cjLzb.placements).reduce(function(acc, placement) {
        acc[placement] = $23e107bc9593c0b6$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $23e107bc9593c0b6$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $23e107bc9593c0b6$var$offset
};

});

parcelRegister("8FLi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6506d5cdbbf093dc$export$2e2bcd8739ae039);

var $gakQ0 = parcelRequire("gakQ0");

var $78gT4 = parcelRequire("78gT4");

var $1Bupq = parcelRequire("1Bupq");

var $lsXzy = parcelRequire("lsXzy");

var $2ysUd = parcelRequire("2ysUd");

var $cjLzb = parcelRequire("cjLzb");

var $02m1U = parcelRequire("02m1U");
function $6506d5cdbbf093dc$var$getExpandedFallbackPlacements(placement) {
    if ((0, $78gT4.default)(placement) === (0, $cjLzb.auto)) return [];
    var oppositePlacement = (0, $gakQ0.default)(placement);
    return [
        (0, $1Bupq.default)(placement),
        oppositePlacement,
        (0, $1Bupq.default)(oppositePlacement)
    ];
}
function $6506d5cdbbf093dc$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $78gT4.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $gakQ0.default)(preferredPlacement)
    ] : $6506d5cdbbf093dc$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $78gT4.default)(placement) === (0, $cjLzb.auto) ? (0, $2ysUd.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $78gT4.default)(placement);
        var isStartVariation = (0, $02m1U.default)(placement) === (0, $cjLzb.start);
        var isVertical = [
            (0, $cjLzb.top),
            (0, $cjLzb.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $lsXzy.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cjLzb.right) : (0, $cjLzb.left) : isStartVariation ? (0, $cjLzb.bottom) : (0, $cjLzb.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $gakQ0.default)(mainVariationSide);
        var altVariationSide = (0, $gakQ0.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6506d5cdbbf093dc$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6506d5cdbbf093dc$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("gakQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc4dbe79b7753e0a$export$2e2bcd8739ae039);
var $bc4dbe79b7753e0a$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $bc4dbe79b7753e0a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $bc4dbe79b7753e0a$var$hash[matched];
    });
}

});

parcelRegister("1Bupq", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b0d5c808756827$export$2e2bcd8739ae039);
var $12b0d5c808756827$var$hash = {
    start: 'end',
    end: 'start'
};
function $12b0d5c808756827$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $12b0d5c808756827$var$hash[matched];
    });
}

});

parcelRegister("lsXzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa0a6c5f5a461a37$export$2e2bcd8739ae039);

var $272Xv = parcelRequire("272Xv");

var $dAPdu = parcelRequire("dAPdu");

var $b3mjl = parcelRequire("b3mjl");

var $1Qfmd = parcelRequire("1Qfmd");

var $lsAMT = parcelRequire("lsAMT");

var $cjLzb = parcelRequire("cjLzb");

var $cLFsU = parcelRequire("cLFsU");

var $5wu79 = parcelRequire("5wu79");

var $c3YXK = parcelRequire("c3YXK");
function $fa0a6c5f5a461a37$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cjLzb.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cjLzb.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cjLzb.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5wu79.default)(typeof padding !== 'number' ? padding : (0, $c3YXK.default)(padding, (0, $cjLzb.basePlacements)));
    var altContext = elementContext === (0, $cjLzb.popper) ? (0, $cjLzb.reference) : (0, $cjLzb.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $272Xv.default)((0, $cLFsU.isElement)(element) ? element : element.contextElement || (0, $dAPdu.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $b3mjl.default)(state.elements.reference);
    var popperOffsets = (0, $1Qfmd.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $lsAMT.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cjLzb.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cjLzb.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cjLzb.right),
                (0, $cjLzb.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cjLzb.top),
                (0, $cjLzb.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("272Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $189e87c1e660e834$export$2e2bcd8739ae039);

var $cjLzb = parcelRequire("cjLzb");

var $6E48a = parcelRequire("6E48a");

var $5y0Dc = parcelRequire("5y0Dc");

var $79g4w = parcelRequire("79g4w");

var $17M7a = parcelRequire("17M7a");

var $dAPdu = parcelRequire("dAPdu");

var $5dfDY = parcelRequire("5dfDY");

var $cLFsU = parcelRequire("cLFsU");

var $b3mjl = parcelRequire("b3mjl");

var $dgsUJ = parcelRequire("dgsUJ");

var $cbP5d = parcelRequire("cbP5d");

var $7tQ4A = parcelRequire("7tQ4A");

var $lsAMT = parcelRequire("lsAMT");

var $Q1foT = parcelRequire("Q1foT");
function $189e87c1e660e834$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $b3mjl.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $189e87c1e660e834$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cjLzb.viewport) ? (0, $lsAMT.default)((0, $6E48a.default)(element, strategy)) : (0, $cLFsU.isElement)(clippingParent) ? $189e87c1e660e834$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $lsAMT.default)((0, $5y0Dc.default)((0, $dAPdu.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $189e87c1e660e834$var$getClippingParents(element) {
    var clippingParents = (0, $79g4w.default)((0, $dgsUJ.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5dfDY.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $cLFsU.isHTMLElement)(element) ? (0, $17M7a.default)(element) : element;
    if (!(0, $cLFsU.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $cLFsU.isElement)(clippingParent) && (0, $cbP5d.default)(clippingParent, clipperElement) && (0, $7tQ4A.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $189e87c1e660e834$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $189e87c1e660e834$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $189e87c1e660e834$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $Q1foT.max)(rect.top, accRect.top);
        accRect.right = (0, $Q1foT.min)(rect.right, accRect.right);
        accRect.bottom = (0, $Q1foT.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $Q1foT.max)(rect.left, accRect.left);
        return accRect;
    }, $189e87c1e660e834$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("6E48a", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d69aec61f5e6214$export$2e2bcd8739ae039);

var $7lQvJ = parcelRequire("7lQvJ");

var $dAPdu = parcelRequire("dAPdu");

var $471vU = parcelRequire("471vU");

var $1CObK = parcelRequire("1CObK");
function $4d69aec61f5e6214$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7lQvJ.default)(element);
    var html = (0, $dAPdu.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $1CObK.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $471vU.default)(element),
        y: y
    };
}

});

parcelRegister("5y0Dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a09e13c456aec8$export$2e2bcd8739ae039);

var $dAPdu = parcelRequire("dAPdu");

var $5dfDY = parcelRequire("5dfDY");

var $471vU = parcelRequire("471vU");

var $7cNZt = parcelRequire("7cNZt");

var $Q1foT = parcelRequire("Q1foT");
function $40a09e13c456aec8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $dAPdu.default)(element);
    var winScroll = (0, $7cNZt.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $Q1foT.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $Q1foT.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $471vU.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5dfDY.default)(body || html).direction === 'rtl') x += (0, $Q1foT.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("cbP5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfe2322d1e0fcf2$export$2e2bcd8739ae039);

var $cLFsU = parcelRequire("cLFsU");
function $8dfe2322d1e0fcf2$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $cLFsU.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("lsAMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f8bfbb8ed9989e$export$2e2bcd8739ae039);
function $f9f8bfbb8ed9989e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5wu79", function(module, exports) {

$parcel$export(module.exports, "default", () => $40574d03eda15c34$export$2e2bcd8739ae039);

var $k9pet = parcelRequire("k9pet");
function $40574d03eda15c34$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $k9pet.default)(), paddingObject);
}

});
parcelRegister("k9pet", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab8388d9e15ab76$export$2e2bcd8739ae039);
function $eab8388d9e15ab76$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("c3YXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c850dc653de5e13$export$2e2bcd8739ae039);
function $8c850dc653de5e13$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("2ysUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc52dd2df8272d4$export$2e2bcd8739ae039);

var $02m1U = parcelRequire("02m1U");

var $cjLzb = parcelRequire("cjLzb");

var $lsXzy = parcelRequire("lsXzy");

var $78gT4 = parcelRequire("78gT4");
function $1dc52dd2df8272d4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cjLzb.placements) : _options$allowedAutoP;
    var variation = (0, $02m1U.default)(placement);
    var placements = variation ? flipVariations ? (0, $cjLzb.variationPlacements) : (0, $cjLzb.variationPlacements).filter(function(placement) {
        return (0, $02m1U.default)(placement) === variation;
    }) : (0, $cjLzb.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $lsXzy.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $78gT4.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("aaoDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $766df1f043d04f67$export$2e2bcd8739ae039);

var $cjLzb = parcelRequire("cjLzb");

var $78gT4 = parcelRequire("78gT4");

var $bR5Ka = parcelRequire("bR5Ka");

var $9wpL4 = parcelRequire("9wpL4");

var $5plfC = parcelRequire("5plfC");

var $cqcuU = parcelRequire("cqcuU");

var $17M7a = parcelRequire("17M7a");

var $lsXzy = parcelRequire("lsXzy");

var $02m1U = parcelRequire("02m1U");

var $k9pet = parcelRequire("k9pet");

var $Q1foT = parcelRequire("Q1foT");
function $766df1f043d04f67$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $lsXzy.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $78gT4.default)(state.placement);
    var variation = (0, $02m1U.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $bR5Ka.default)(basePlacement);
    var altAxis = (0, $9wpL4.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cjLzb.top) : (0, $cjLzb.left);
        var altSide = mainAxis === 'y' ? (0, $cjLzb.bottom) : (0, $cjLzb.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cjLzb.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cjLzb.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $cqcuU.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $k9pet.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5plfC.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $17M7a.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5plfC.within)(tether ? (0, $Q1foT.min)(min, tetherMin) : min, offset, tether ? (0, $Q1foT.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cjLzb.top) : (0, $cjLzb.left);
        var _altSide = mainAxis === 'x' ? (0, $cjLzb.bottom) : (0, $cjLzb.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cjLzb.top),
            (0, $cjLzb.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5plfC.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $5plfC.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $766df1f043d04f67$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $766df1f043d04f67$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("9wpL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeb154675569e6d$export$2e2bcd8739ae039);
function $6eeb154675569e6d$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("5plfC", function(module, exports) {

$parcel$export(module.exports, "within", () => $3effc5872924051f$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3effc5872924051f$export$86c8af6d3ef0b4a);

var $Q1foT = parcelRequire("Q1foT");
function $3effc5872924051f$export$f28d906d67a997f3(min, value, max) {
    return (0, $Q1foT.max)(min, (0, $Q1foT.min)(value, max));
}
function $3effc5872924051f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3effc5872924051f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("1vpAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $118c8a4c7a8f9b97$export$2e2bcd8739ae039);

var $78gT4 = parcelRequire("78gT4");

var $cqcuU = parcelRequire("cqcuU");

var $cbP5d = parcelRequire("cbP5d");

var $17M7a = parcelRequire("17M7a");

var $bR5Ka = parcelRequire("bR5Ka");

var $5plfC = parcelRequire("5plfC");

var $5wu79 = parcelRequire("5wu79");

var $c3YXK = parcelRequire("c3YXK");

var $cjLzb = parcelRequire("cjLzb");
var $118c8a4c7a8f9b97$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5wu79.default)(typeof padding !== 'number' ? padding : (0, $c3YXK.default)(padding, (0, $cjLzb.basePlacements)));
};
function $118c8a4c7a8f9b97$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $78gT4.default)(state.placement);
    var axis = (0, $bR5Ka.default)(basePlacement);
    var isVertical = [
        (0, $cjLzb.left),
        (0, $cjLzb.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $118c8a4c7a8f9b97$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $cqcuU.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cjLzb.top) : (0, $cjLzb.left);
    var maxProp = axis === 'y' ? (0, $cjLzb.bottom) : (0, $cjLzb.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $17M7a.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5plfC.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $118c8a4c7a8f9b97$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $cbP5d.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $118c8a4c7a8f9b97$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $118c8a4c7a8f9b97$var$arrow,
    effect: $118c8a4c7a8f9b97$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("hwyo6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc201985d9992457$export$2e2bcd8739ae039);

var $cjLzb = parcelRequire("cjLzb");

var $lsXzy = parcelRequire("lsXzy");
function $cc201985d9992457$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $cc201985d9992457$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cjLzb.top),
        (0, $cjLzb.right),
        (0, $cjLzb.bottom),
        (0, $cjLzb.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $cc201985d9992457$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $lsXzy.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $lsXzy.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $cc201985d9992457$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $cc201985d9992457$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $cc201985d9992457$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $cc201985d9992457$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $cc201985d9992457$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $cc201985d9992457$var$hide
};

});





parcelRegister("h5I8q", function(module, exports) {
/*! JsRender v1.0.15: http://jsviews.com/#jsrender */ /*! **VERSION FOR WEB** (For NODE.JS see http://jsviews.com/download/jsrender-node.js) */ /*
 * Best-of-breed templating in browser or on Node.js.
 * Does not require jQuery, or HTML DOM
 * Integrates with JsViews (http://jsviews.com/#jsviews)
 *
 * Copyright 2024, Boris Moore
 * Released under the MIT License.
 */ //jshint -W018, -W041, -W120
(function(factory, global) {
    // global var is the this object, which is window when running in the usual browser environment
    var $ = global.jQuery;
    module.exports = $ ? factory(global, $) : function($) {
        if ($ && !$.fn) throw "Provide jQuery or null";
        return factory(global, $);
    };
})(// factory (for jsrender.js)
function(global, $) {
    "use strict";
    //========================== Top-level vars ==========================
    // global var is the this object, which is window when running in the usual browser environment
    var setGlobals = $ === false; // Only set globals if script block in browser (not AMD and not CommonJS)
    $ = $ && $.fn ? $ : global.jQuery; // $ is jQuery passed in by CommonJS loader (Browserify), or global jQuery.
    var versionNumber = "v1.0.15", jsvStoreName, rTag, rTmplString, topView, $views, $expando, _ocp = "_ocp", $isFunction, $isArray, $templates, $converters, $helpers, $tags, $sub, $subSettings, $subSettingsAdvanced, $viewsSettings, delimOpenChar0, delimOpenChar1, delimCloseChar0, delimCloseChar1, linkChar, setting, baseOnError, isRenderCall, rNewLine = /[ \t]*(\r\n|\n|\r)/g, rUnescapeQuotes = /\\(['"\\])/g, rEscapeQuotes = /['"\\]/g, rBuildHash = /(?:\x08|^)(onerror:)?(?:(~?)(([\w$.]+):)?([^\x08]+))\x08(,)?([^\x08]+)/gi, rTestElseIf = /^if\s/, rFirstElem = /<(\w+)[>\s]/, rAttrEncode = /[\x00`><"'&=]/g, rIsHtml = /[\x00`><\"'&=]/, rHasHandlers = /^on[A-Z]|^convert(Back)?$/, rWrappedInViewMarker = /^\#\d+_`[\s\S]*\/\d+_`$/, rHtmlEncode = rAttrEncode, rDataEncode = /[&<>]/g, rDataUnencode = /&(amp|gt|lt);/g, rBracketQuote = /\[['"]?|['"]?\]/g, viewId = 0, charEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\x00": "&#0;",
        "'": "&#39;",
        '"': "&#34;",
        "`": "&#96;",
        "=": "&#61;"
    }, charsFromEntities = {
        amp: "&",
        gt: ">",
        lt: "<"
    }, HTML = "html", STRING = "string", OBJECT = "object", tmplAttr = "data-jsv-tmpl", jsvTmpl = "jsvTmpl", indexStr = "For #index in nested block use #getIndex().", cpFnStore = {}, $render = {}, jsr = global.jsrender, jsrToJq = jsr && $ && !$.render, jsvStores = {
        template: {
            compile: compileTmpl
        },
        tag: {
            compile: compileTag
        },
        viewModel: {
            compile: compileViewModel
        },
        helper: {},
        converter: {}
    };
    // views object ($.views if jQuery is loaded, jsrender.views if no jQuery, e.g. in Node.js)
    $views = {
        jsviews: versionNumber,
        sub: {
            // subscription, e.g. JsViews integration
            rPath: /^(!*?)(?:null|true|false|\d[\d.]*|([\w$]+|\.|~([\w$]+)|#(view|([\w$]+))?)([\w$.^]*?)(?:[.[^]([\w$]+)\]?)?)$/g,
            //        not                               object     helper    view  viewProperty pathTokens      leafToken
            rPrm: /(\()(?=\s*\()|(?:([([])\s*)?(?:(\^?)(~?[\w$.^]+)?\s*((\+\+|--)|\+|-|~(?![\w$])|&&|\|\||===|!==|==|!=|<=|>=|[<>%*:?\/]|(=))\s*|(!*?(@)?[#~]?[\w$.^]+)([([])?)|(,\s*)|(?:(\()\s*)?\\?(?:(')|("))|(?:\s*(([)\]])(?=[.^]|\s*$|[^([])|[)\]])([([]?))|(\s+)/g,
            //   lftPrn0           lftPrn         bound     path               operator     err                                          eq      path2 late            prn      comma  lftPrn2          apos quot        rtPrn  rtPrnDot                  prn2     space
            View: View,
            Err: JsViewsError,
            tmplFn: tmplFn,
            parse: parseParams,
            extend: $extend,
            extendCtx: extendCtx,
            syntaxErr: syntaxError,
            onStore: {
                template: function(name, item) {
                    if (item === null) delete $render[name];
                    else if (name) $render[name] = item;
                }
            },
            addSetting: addSetting,
            settings: {
                allowCode: false
            },
            advSet: noop,
            _thp: tagHandlersFromProps,
            _gm: getMethod,
            _tg: function() {},
            _cnvt: convertVal,
            _tag: renderTag,
            _er: error,
            _err: onRenderError,
            _cp: retVal,
            _sq: function(token) {
                if (token === "constructor") syntaxError("");
                return token;
            }
        },
        settings: {
            delimiters: $viewsDelimiters,
            advanced: function(value) {
                return value ? ($extend($subSettingsAdvanced, value), $sub.advSet(), $viewsSettings) : $subSettingsAdvanced;
            }
        },
        map: dataMap // If jsObservable loaded first, use that definition of dataMap
    };
    function getDerivedMethod(baseMethod, method) {
        return function() {
            var ret, tag = this, prevBase = tag.base;
            tag.base = baseMethod; // Within method call, calling this.base will call the base method
            ret = method.apply(tag, arguments); // Call the method
            tag.base = prevBase; // Replace this.base to be the base method of the previous call, for chained calls
            return ret;
        };
    }
    function getMethod(baseMethod, method) {
        // For derived methods (or handlers declared declaratively as in {{:foo onChange=~fooChanged}} replace by a derived method, to allow using this.base(...)
        // or this.baseApply(arguments) to call the base implementation. (Equivalent to this._super(...) and this._superApply(arguments) in jQuery UI)
        if ($isFunction(method)) {
            method = getDerivedMethod(!baseMethod ? noop // no base method implementation, so use noop as base method
             : baseMethod._d ? baseMethod // baseMethod is a derived method, so use it
             : getDerivedMethod(noop, baseMethod), method);
            method._d = (baseMethod && baseMethod._d || 0) + 1; // Add flag for derived method (incremented for derived of derived...)
        }
        return method;
    }
    function tagHandlersFromProps(tag, tagCtx) {
        var prop, props = tagCtx.props;
        for(prop in props)if (rHasHandlers.test(prop) && !(tag[prop] && tag[prop].fix)) tag[prop] = prop !== "convert" ? getMethod(tag.constructor.prototype[prop], props[prop]) : props[prop];
    }
    function retVal(val) {
        return val;
    }
    function noop() {
        return "";
    }
    function dbgBreak(val) {
        // Usage examples: {{dbg:...}}, {{:~dbg(...)}}, {{dbg .../}}, {^{for ... onAfterLink=~dbg}} etc.
        try {
            console.log("JsRender dbg breakpoint: " + val);
            throw "dbg breakpoint"; // To break here, stop on caught exceptions.
        } catch (e) {}
        return this.base ? this.baseApply(arguments) : val;
    }
    function JsViewsError(message) {
        // Error exception type for JsViews/JsRender
        // Override of $.views.sub.Error is possible
        this.name = ($.link ? "JsViews" : "JsRender") + " Error";
        this.message = message || this.name;
    }
    function $extend(target, source) {
        if (target) {
            for(var name in source)target[name] = source[name];
            return target;
        }
    }
    (JsViewsError.prototype = new Error()).constructor = JsViewsError;
    //========================== Top-level functions ==========================
    //===================
    // views.delimiters
    //===================
    /**
	* Set the tag opening and closing delimiters and 'link' character. Default is "{{", "}}" and "^"
	* openChars, closeChars: opening and closing strings, each with two characters
	* $.views.settings.delimiters(...)
	*
	* @param {string}   openChars
	* @param {string}   [closeChars]
	* @param {string}   [link]
	* @returns {Settings}
	*
	* Get delimiters
	* delimsArray = $.views.settings.delimiters()
	*
	* @returns {string[]}
	*/ function $viewsDelimiters(openChars, closeChars, link) {
        if (!openChars) return $subSettings.delimiters;
        if ($isArray(openChars)) return $viewsDelimiters.apply($views, openChars);
        linkChar = link ? link[0] : linkChar;
        if (!/^(\W|_){5}$/.test(openChars + closeChars + linkChar)) error("Invalid delimiters"); // Must be non-word characters, and openChars and closeChars must each be length 2
        delimOpenChar0 = openChars[0];
        delimOpenChar1 = openChars[1];
        delimCloseChar0 = closeChars[0];
        delimCloseChar1 = closeChars[1];
        $subSettings.delimiters = [
            delimOpenChar0 + delimOpenChar1,
            delimCloseChar0 + delimCloseChar1,
            linkChar
        ];
        // Escape the characters - since they could be regex special characters
        openChars = "\\" + delimOpenChar0 + "(\\" + linkChar + ")?\\" + delimOpenChar1; // Default is "{^{"
        closeChars = "\\" + delimCloseChar0 + "\\" + delimCloseChar1; // Default is "}}"
        // Build regex with new delimiters
        //          [tag    (followed by / space or })  or cvtr+colon or html or code] followed by space+params then convertBack?
        rTag = "(?:(\\w+(?=[\\/\\s\\" + delimCloseChar0 + "]))|(\\w+)?(:)|(>)|(\\*))\\s*((?:[^\\" + delimCloseChar0 + "]|\\" + delimCloseChar0 + "(?!\\" + delimCloseChar1 + "))*?)";
        // Make rTag available to JsViews (or other components) for parsing binding expressions
        $sub.rTag = "(?:" + rTag + ")";
        //                        { ^? {   tag+params slash?  or closingTag                                                   or comment
        rTag = new RegExp("(?:" + openChars + rTag + "(\\/)?|\\" + delimOpenChar0 + "(\\" + linkChar + ")?\\" + delimOpenChar1 + "(?:(?:\\/(\\w+))\\s*|!--[\\s\\S]*?--))" + closeChars, "g");
        // Default:  bind     tagName         cvt   cln html code    params            slash   bind2         closeBlk  comment
        //      /(?:{(\^)?{(?:(\w+(?=[\/\s}]))|(\w+)?(:)|(>)|(\*))\s*((?:[^}]|}(?!}))*?)(\/)?|{(\^)?{(?:(?:\/(\w+))\s*|!--[\s\S]*?--))}}
        $sub.rTmpl = new RegExp("^\\s|\\s$|<.*>|([^\\\\]|^)[{}]|" + openChars + ".*" + closeChars);
        // $sub.rTmpl looks for initial or final white space, html tags or { or } char not preceded by \\, or JsRender tags {{xxx}}.
        // Each of these strings are considered NOT to be jQuery selectors
        return $viewsSettings;
    }
    //=========
    // View.get
    //=========
    function getView(inner, type) {
        if (!type && inner !== true) {
            // view.get(type)
            type = inner;
            inner = undefined;
        }
        var views, i, l, found, view = this, root = type === "root";
        // view.get("root") returns view.root, view.get() returns view.parent, view.get(true) returns view.views[0].
        if (inner) {
            // Go through views - this one, and all nested ones, depth-first - and return first one with given type.
            // If type is undefined, i.e. view.get(true), return first child view.
            found = type && view.type === type && view;
            if (!found) {
                views = view.views;
                if (view._.useKey) for(i in views){
                    if (found = type ? views[i].get(inner, type) : views[i]) break;
                }
                else for(i = 0, l = views.length; !found && i < l; i++)found = type ? views[i].get(inner, type) : views[i];
            }
        } else if (root) // Find root view. (view whose parent is top view)
        found = view.root;
        else if (type) while(view && !found){
            // Go through views - this one, and all parent ones - and return first one with given type.
            found = view.type === type ? view : undefined;
            view = view.parent;
        }
        else found = view.parent;
        return found || undefined;
    }
    function getNestedIndex() {
        var view = this.get("item");
        return view ? view.index : undefined;
    }
    getNestedIndex.depends = function() {
        return [
            this.get("item"),
            "index"
        ];
    };
    function getIndex() {
        return this.index;
    }
    getIndex.depends = "index";
    //==================
    // View.ctxPrm, etc.
    //==================
    /* Internal private: view._getOb() */ function getPathObject(ob, path, ltOb, fn) {
        // Iterate through path to late paths: @a.b.c paths
        // Return "" (or noop if leaf is a function @a.b.c(...) ) if intermediate object not yet available
        var prevOb, tokens, l, i = 0;
        if (ltOb === 1) {
            fn = 1;
            ltOb = undefined;
        }
        // Paths like ^a^b^c or ~^a^b^c will not throw if an object in path is undefined.
        if (path) {
            tokens = path.split(".");
            l = tokens.length;
            for(; ob && i < l; i++){
                prevOb = ob;
                ob = tokens[i] ? ob[tokens[i]] : ob;
            }
        }
        if (ltOb) ltOb.lt = ltOb.lt || i < l; // If i < l there was an object in the path not yet available
        return ob === undefined ? fn ? noop : "" : fn ? function() {
            return ob.apply(prevOb, arguments);
        } : ob;
    }
    function contextParameter(key, value, get) {
        // Helper method called as view.ctxPrm(key) for helpers or template parameters ~foo - from compiled template or from context callback
        var wrapped, deps, res, obsCtxPrm, tagElse, callView, newRes, storeView = this, isUpdate = !isRenderCall && arguments.length > 1, store = storeView.ctx;
        if (key) {
            if (!storeView._) {
                tagElse = storeView.index;
                storeView = storeView.tag;
            }
            callView = storeView;
            if (store && store.hasOwnProperty(key) || (store = $helpers).hasOwnProperty(key)) {
                res = store[key];
                if (key === "tag" || key === "tagCtx" || key === "root" || key === "parentTags") return res;
            } else store = undefined;
            if (!isRenderCall && storeView.tagCtx || storeView.linked) {
                if (!res || !res._cxp) {
                    // Not a contextual parameter
                    // Set storeView to tag (if this is a tag.ctxPrm() call) or to root view ("data" view of linked template)
                    storeView = storeView.tagCtx || $isFunction(res) ? storeView // Is a tag, not a view, or is a computed contextual parameter, so scope to the callView, not the 'scope view'
                     : (storeView = storeView.scope || storeView, !storeView.isTop && storeView.ctx.tag // If this view is in a tag, set storeView to the tag
                     || storeView);
                    if (res !== undefined && storeView.tagCtx) // If storeView is a tag, but the contextual parameter has been set at at higher level (e.g. helpers)...
                    storeView = storeView.tagCtx.view.scope; // then move storeView to the outer level (scope of tag container view)
                    store = storeView._ocps;
                    res = store && store.hasOwnProperty(key) && store[key] || res;
                    if (!(res && res._cxp) && (get || isUpdate)) {
                        // Create observable contextual parameter
                        (store || (storeView._ocps = storeView._ocps || {}))[key] = res = [
                            {
                                _ocp: res,
                                _vw: callView,
                                _key: key
                            }
                        ];
                        res._cxp = {
                            path: _ocp,
                            ind: 0,
                            updateValue: function(val, path) {
                                $.observable(res[0]).setProperty(_ocp, val); // Set the value (res[0]._ocp)
                                return this;
                            }
                        };
                    }
                }
                if (obsCtxPrm = res && res._cxp) {
                    // If this helper resource is an observable contextual parameter
                    if (arguments.length > 2) {
                        deps = res[1] ? $sub._ceo(res[1].deps) : [
                            _ocp
                        ]; // fn deps (with any exprObs cloned using $sub._ceo)
                        deps.unshift(res[0]); // view
                        deps._cxp = obsCtxPrm;
                        // In a context callback for a contextual param, we set get = true, to get ctxPrm [view, dependencies...] array - needed for observe call
                        return deps;
                    }
                    tagElse = obsCtxPrm.tagElse;
                    newRes = res[1] // linkFn for compiled expression
                     ? obsCtxPrm.tag && obsCtxPrm.tag.cvtArgs ? obsCtxPrm.tag.cvtArgs(tagElse, 1)[obsCtxPrm.ind] // = tag.bndArgs() - for tag contextual parameter
                     : res[1](res[0].data, res[0], $sub) // = fn(data, view, $sub) for compiled binding expression
                     : res[0]._ocp; // Observable contextual parameter (uninitialized, or initialized as static expression, so no path dependencies)
                    if (isUpdate) {
                        $sub._ucp(key, value, storeView, obsCtxPrm); // Update observable contextual parameter
                        return storeView;
                    }
                    res = newRes;
                }
            }
            if (res && $isFunction(res)) {
                // If a helper is of type function we will wrap it, so if called with no this pointer it will be called with the
                // view as 'this' context. If the helper ~foo() was in a data-link expression, the view will have a 'temporary' linkCtx property too.
                // Note that helper functions on deeper paths will have specific this pointers, from the preceding path.
                // For example, ~util.foo() will have the ~util object as 'this' pointer
                wrapped = function() {
                    return res.apply(!this || this === global ? callView : this, arguments);
                };
                $extend(wrapped, res); // Attach same expandos (if any) to the wrapped function
            }
            return wrapped || res;
        }
    }
    /* Internal private: view._getTmpl() */ function getTemplate(tmpl) {
        return tmpl && (tmpl.fn ? tmpl : this.getRsc("templates", tmpl) || $templates(tmpl)); // not yet compiled
    }
    //==============
    // views._cnvt
    //==============
    function convertVal(converter, view, tagCtx, onError) {
        // Called from compiled template code for {{:}}
        // self is template object or linkCtx object
        var tag, linkCtx, value, argsLen, bindTo, // If tagCtx is an integer, then it is the key for the compiled function to return the boundTag tagCtx
        boundTag = typeof tagCtx === "number" && view.tmpl.bnds[tagCtx - 1];
        if (onError === undefined && boundTag && boundTag._lr) onError = "";
        if (onError !== undefined) tagCtx = onError = {
            props: {},
            args: [
                onError
            ]
        };
        else if (boundTag) tagCtx = boundTag(view.data, view, $sub);
        boundTag = boundTag._bd && boundTag;
        if (converter || boundTag) {
            linkCtx = view._lc; // For data-link="{cvt:...}"... See onDataLinkedTagChange
            tag = linkCtx && linkCtx.tag;
            tagCtx.view = view;
            if (!tag) {
                tag = $extend(new $sub._tg(), {
                    _: {
                        bnd: boundTag,
                        unlinked: true,
                        lt: tagCtx.lt // If a late path @some.path has not returned @some object, mark tag as late
                    },
                    inline: !linkCtx,
                    tagName: ":",
                    convert: converter,
                    onArrayChange: true,
                    flow: true,
                    tagCtx: tagCtx,
                    tagCtxs: [
                        tagCtx
                    ],
                    _is: "tag"
                });
                argsLen = tagCtx.args.length;
                if (argsLen > 1) {
                    bindTo = tag.bindTo = [];
                    while(argsLen--)bindTo.unshift(argsLen); // Bind to all the arguments - generate bindTo array: [0,1,2...]
                }
                if (linkCtx) {
                    linkCtx.tag = tag;
                    tag.linkCtx = linkCtx;
                }
                tagCtx.ctx = extendCtx(tagCtx.ctx, (linkCtx ? linkCtx.view : view).ctx);
                tagHandlersFromProps(tag, tagCtx);
            }
            tag._er = onError && value;
            tag.ctx = tagCtx.ctx || tag.ctx || {};
            tagCtx.ctx = undefined;
            value = tag.cvtArgs()[0]; // If there is a convertBack but no convert, converter will be "true"
            tag._er = onError && value;
        } else value = tagCtx.args[0];
        // Call onRender (used by JsViews if present, to add binding annotations around rendered content)
        value = boundTag && view._.onRender ? view._.onRender(value, view, tag) : value;
        return value != undefined ? value : "";
    }
    function convertArgs(tagElse, bound) {
        var l, key, boundArgs, args, bindFrom, tag, converter, tagCtx = this;
        if (tagCtx.tagName) {
            tag = tagCtx;
            tagCtx = (tag.tagCtxs || [
                tagCtx
            ])[tagElse || 0];
            if (!tagCtx) return;
        } else tag = tagCtx.tag;
        bindFrom = tag.bindFrom;
        args = tagCtx.args;
        if ((converter = tag.convert) && typeof converter === STRING) converter = converter === "true" ? undefined : tagCtx.view.getRsc("converters", converter) || error("Unknown converter: '" + converter + "'");
        if (converter && !bound) args = args.slice(); // the copied array with the converted value. But we do not modify the value of tag.tagCtx.args[0] (the original args array)
        if (bindFrom) {
            boundArgs = [];
            l = bindFrom.length;
            while(l--){
                key = bindFrom[l];
                boundArgs.unshift(argOrProp(tagCtx, key));
            }
            if (bound) args = boundArgs; // Call to bndArgs() - returns the boundArgs
        }
        if (converter) {
            converter = converter.apply(tag, boundArgs || args);
            if (converter === undefined) return args; // Returning undefined from a converter is equivalent to not having a converter.
            bindFrom = bindFrom || [
                0
            ];
            l = bindFrom.length;
            if (!$isArray(converter) || converter.arg0 !== false && (l === 1 || converter.length !== l || converter.arg0)) {
                converter = [
                    converter
                ]; // Returning converter as first arg, even if converter value is an array
                bindFrom = [
                    0
                ];
                l = 1;
            }
            if (bound) args = converter; // The array of values returned from the converter
            else while(l--){
                key = bindFrom[l];
                if (+key === key) args[key] = converter[l];
            }
        }
        return args;
    }
    function argOrProp(context, key) {
        context = context[+key === key ? "args" : "props"];
        return context && context[key];
    }
    function convertBoundArgs(tagElse) {
        return this.cvtArgs(tagElse, 1);
    }
    //=============
    // views.tag
    //=============
    /* view.getRsc() */ function getResource(resourceType, itemName) {
        var res, store, view = this;
        if (typeof itemName === STRING) {
            while(res === undefined && view){
                store = view.tmpl && view.tmpl[resourceType];
                res = store && store[itemName];
                view = view.parent;
            }
            return res || $views[resourceType][itemName];
        }
    }
    function renderTag(tagName, parentView, tmpl, tagCtxs, isUpdate, onError) {
        function bindToOrBindFrom(type) {
            var bindArray = tag[type];
            if (bindArray !== undefined) {
                bindArray = $isArray(bindArray) ? bindArray : [
                    bindArray
                ];
                m = bindArray.length;
                while(m--){
                    key = bindArray[m];
                    if (!isNaN(parseInt(key))) bindArray[m] = parseInt(key); // Convert "0" to 0, etc.
                }
            }
            return bindArray || [
                0
            ];
        }
        parentView = parentView || topView;
        var tag, tagDef, template, tags, attr, parentTag, l, m, n, itemRet, tagCtx, tagCtxCtx, ctxPrm, bindTo, bindFrom, initVal, content, callInit, mapDef, thisMap, args, bdArgs, props, tagDataMap, contentCtx, key, bindFromLength, bindToLength, linkedElement, defaultCtx, i = 0, ret = "", linkCtx = parentView._lc || false, ctx = parentView.ctx, parentTmpl = tmpl || parentView.tmpl, // If tagCtxs is an integer, then it is the key for the compiled function to return the boundTag tagCtxs
        boundTag = typeof tagCtxs === "number" && parentView.tmpl.bnds[tagCtxs - 1];
        if (tagName._is === "tag") {
            tag = tagName;
            tagName = tag.tagName;
            tagCtxs = tag.tagCtxs;
            template = tag.template;
        } else {
            tagDef = parentView.getRsc("tags", tagName) || error("Unknown tag: {{" + tagName + "}} ");
            template = tagDef.template;
        }
        if (onError === undefined && boundTag && (boundTag._lr = tagDef.lateRender && boundTag._lr !== false || boundTag._lr)) onError = ""; // If lateRender, set temporary onError, to skip initial rendering (and render just "")
        if (onError !== undefined) {
            ret += onError;
            tagCtxs = onError = [
                {
                    props: {},
                    args: [],
                    params: {
                        props: {}
                    }
                }
            ];
        } else if (boundTag) tagCtxs = boundTag(parentView.data, parentView, $sub);
        l = tagCtxs.length;
        for(; i < l; i++){
            tagCtx = tagCtxs[i];
            content = tagCtx.tmpl;
            if (!linkCtx || !linkCtx.tag || i && !linkCtx.tag.inline || tag._er || content && +content === content) {
                // Initialize tagCtx
                // For block tags, tagCtx.tmpl is an integer > 0
                if (content && parentTmpl.tmpls) tagCtx.tmpl = tagCtx.content = parentTmpl.tmpls[content - 1]; // Set the tmpl property to the content of the block tag
                tagCtx.index = i;
                tagCtx.ctxPrm = contextParameter;
                tagCtx.render = renderContent;
                tagCtx.cvtArgs = convertArgs;
                tagCtx.bndArgs = convertBoundArgs;
                tagCtx.view = parentView;
                tagCtx.ctx = extendCtx(extendCtx(tagCtx.ctx, tagDef && tagDef.ctx), ctx); // Clone and extend parentView.ctx
            }
            if (tmpl = tagCtx.props.tmpl) {
                // If the tmpl property is overridden, set the value (when initializing, or, in case of binding: ^tmpl=..., when updating)
                tagCtx.tmpl = parentView._getTmpl(tmpl);
                tagCtx.content = tagCtx.content || tagCtx.tmpl;
            }
            if (!tag) {
                // This will only be hit for initial tagCtx (not for {{else}}) - if the tag instance does not exist yet
                // If the tag has not already been instantiated, we will create a new instance.
                // ~tag will access the tag, even within the rendering of the template content of this tag.
                // From child/descendant tags, can access using ~tag.parent, or ~parentTags.tagName
                tag = new tagDef._ctr();
                callInit = !!tag.init;
                tag.parent = parentTag = ctx && ctx.tag;
                tag.tagCtxs = tagCtxs;
                if (linkCtx) {
                    tag.inline = false;
                    linkCtx.tag = tag;
                }
                tag.linkCtx = linkCtx;
                if (tag._.bnd = boundTag || linkCtx.fn) {
                    // Bound if {^{tag...}} or data-link="{tag...}"
                    tag._.ths = tagCtx.params.props["this"]; // Tag has a this=expr binding, to get javascript reference to tag instance
                    tag._.lt = tagCtxs.lt; // If a late path @some.path has not returned @some object, mark tag as late
                    tag._.arrVws = {};
                } else if (tag.dataBoundOnly) error(tagName + " must be data-bound:\n{^{" + tagName + "}}");
            //TODO better perf for childTags() - keep child tag.tags array, (and remove child, when disposed)
            // tag.tags = [];
            } else if (linkCtx && linkCtx.fn._lr) callInit = !!tag.init;
            tagDataMap = tag.dataMap;
            tagCtx.tag = tag;
            if (tagDataMap && tagCtxs) tagCtx.map = tagCtxs[i].map; // Copy over the compiled map instance from the previous tagCtxs to the refreshed ones
            if (!tag.flow) {
                tagCtxCtx = tagCtx.ctx = tagCtx.ctx || {};
                // tags hash: tag.ctx.tags, merged with parentView.ctx.tags,
                tags = tag.parents = tagCtxCtx.parentTags = ctx && extendCtx(tagCtxCtx.parentTags, ctx.parentTags) || {};
                if (parentTag) tags[parentTag.tagName] = parentTag;
                tags[tag.tagName] = tagCtxCtx.tag = tag;
                tagCtxCtx.tagCtx = tagCtx;
            }
        }
        if (!(tag._er = onError)) {
            tagHandlersFromProps(tag, tagCtxs[0]);
            tag.rendering = {
                rndr: tag.rendering
            }; // Provide object for state during render calls to tag and elses. (Used by {{if}} and {{for}}...)
            for(i = 0; i < l; i++){
                tagCtx = tag.tagCtx = tagCtxs[i];
                props = tagCtx.props;
                tag.ctx = tagCtx.ctx;
                if (!i) {
                    if (callInit) {
                        tag.init(tagCtx, linkCtx, tag.ctx);
                        callInit = undefined;
                    }
                    if (!tagCtx.args.length && tagCtx.argDefault !== false && tag.argDefault !== false) {
                        tagCtx.args = args = [
                            tagCtx.view.data
                        ]; // Missing first arg defaults to the current data context
                        tagCtx.params.args = [
                            "#data"
                        ];
                    }
                    bindTo = bindToOrBindFrom("bindTo");
                    if (tag.bindTo !== undefined) tag.bindTo = bindTo;
                    if (tag.bindFrom !== undefined) tag.bindFrom = bindToOrBindFrom("bindFrom");
                    else if (tag.bindTo) tag.bindFrom = tag.bindTo = bindTo;
                    bindFrom = tag.bindFrom || bindTo;
                    bindToLength = bindTo.length;
                    bindFromLength = bindFrom.length;
                    if (tag._.bnd && (linkedElement = tag.linkedElement)) {
                        tag.linkedElement = linkedElement = $isArray(linkedElement) ? linkedElement : [
                            linkedElement
                        ];
                        if (bindToLength !== linkedElement.length) error("linkedElement not same length as bindTo");
                    }
                    if (linkedElement = tag.linkedCtxParam) {
                        tag.linkedCtxParam = linkedElement = $isArray(linkedElement) ? linkedElement : [
                            linkedElement
                        ];
                        if (bindFromLength !== linkedElement.length) error("linkedCtxParam not same length as bindFrom/bindTo");
                    }
                    if (bindFrom) {
                        tag._.fromIndex = {}; // Hash of bindFrom index which has same path value as bindTo index. fromIndex = tag._.fromIndex[toIndex]
                        tag._.toIndex = {}; // Hash of bindFrom index which has same path value as bindTo index. fromIndex = tag._.fromIndex[toIndex]
                        n = bindFromLength;
                        while(n--){
                            key = bindFrom[n];
                            m = bindToLength;
                            while(m--)if (key === bindTo[m]) {
                                tag._.fromIndex[m] = n;
                                tag._.toIndex[n] = m;
                            }
                        }
                    }
                    if (linkCtx) // Set attr on linkCtx to ensure outputting to the correct target attribute.
                    // Setting either linkCtx.attr or this.attr in the init() allows per-instance choice of target attrib.
                    linkCtx.attr = tag.attr = linkCtx.attr || tag.attr || linkCtx._dfAt;
                    attr = tag.attr;
                    tag._.noVws = attr && attr !== HTML;
                }
                args = tag.cvtArgs(i);
                if (tag.linkedCtxParam) {
                    bdArgs = tag.cvtArgs(i, 1);
                    m = bindFromLength;
                    defaultCtx = tag.constructor.prototype.ctx;
                    while(m--)if (ctxPrm = tag.linkedCtxParam[m]) {
                        key = bindFrom[m];
                        initVal = bdArgs[m];
                        // Create tag contextual parameter
                        tagCtx.ctx[ctxPrm] = $sub._cp(defaultCtx && initVal === undefined ? defaultCtx[ctxPrm] : initVal, initVal !== undefined && argOrProp(tagCtx.params, key), tagCtx.view, tag._.bnd && {
                            tag: tag,
                            cvt: tag.convert,
                            ind: m,
                            tagElse: i
                        });
                    }
                }
                if ((mapDef = props.dataMap || tagDataMap) && (args.length || props.dataMap)) {
                    thisMap = tagCtx.map;
                    if (!thisMap || thisMap.src !== args[0] || isUpdate) {
                        if (thisMap && thisMap.src) thisMap.unmap(); // only called if observable map - not when only used in JsRender, e.g. by {{props}}
                        mapDef.map(args[0], tagCtx, thisMap, !tag._.bnd);
                        thisMap = tagCtx.map;
                    }
                    args = [
                        thisMap.tgt
                    ];
                }
                itemRet = undefined;
                if (tag.render) {
                    itemRet = tag.render.apply(tag, args);
                    if (parentView.linked && itemRet && !rWrappedInViewMarker.test(itemRet)) {
                        // When a tag renders content from the render method, with data linking then we need to wrap with view markers, if absent,
                        // to provide a contentView for the tag, which will correctly dispose bindings if deleted. The 'tmpl' for this view will
                        // be a dumbed-down template which will always return the itemRet string (no matter what the data is). The itemRet string
                        // is not compiled as template markup, so can include "{{" or "}}" without triggering syntax errors
                        tmpl = {
                            links: []
                        };
                        tmpl.render = tmpl.fn = function() {
                            return itemRet;
                        };
                        itemRet = renderWithViews(tmpl, parentView.data, undefined, true, parentView, undefined, undefined, tag);
                    }
                }
                if (!args.length) args = [
                    parentView
                ]; // no arguments - (e.g. {{else}}) get data context from view.
                if (itemRet === undefined) {
                    contentCtx = args[0]; // Default data context for wrapped block content is the first argument
                    if (tag.contentCtx) contentCtx = tag.contentCtx === true ? parentView : tag.contentCtx(contentCtx);
                    itemRet = tagCtx.render(contentCtx, true) || (isUpdate ? undefined : "");
                }
                ret = ret ? ret + (itemRet || "") : itemRet !== undefined ? "" + itemRet : undefined; // If no return value from render, and no template/content tagCtx.render(...), return undefined
            }
            tag.rendering = tag.rendering.rndr; // Remove tag.rendering object (if this is outermost render call. (In case of nested calls)
        }
        tag.tagCtx = tagCtxs[0];
        tag.ctx = tag.tagCtx.ctx;
        if (tag._.noVws && tag.inline) // inline tag with attr set to "text" will insert HTML-encoded content - as if it was element-based innerText
        ret = attr === "text" ? $converters.html(ret) : "";
        return boundTag && parentView._.onRender ? parentView._.onRender(ret, parentView, tag) : ret;
    }
    //=================
    // View constructor
    //=================
    function View(context, type, parentView, data, template, key, onRender, contentTmpl) {
        // Constructor for view object in view hierarchy. (Augmented by JsViews if JsViews is loaded)
        var views, parentView_, tag, self_, self = this, isArray = type === "array";
        // If the data is an array, this is an 'array view' with a views array for each child 'item view'
        // If the data is not an array, this is an 'item view' with a views 'hash' object for any child nested views
        self.content = contentTmpl;
        self.views = isArray ? [] : {};
        self.data = data;
        self.tmpl = template;
        self_ = self._ = {
            key: 0,
            // ._.useKey is non zero if is not an 'array view' (owning a data array). Use this as next key for adding to child views hash
            useKey: isArray ? 0 : 1,
            id: "" + viewId++,
            onRender: onRender,
            bnds: {}
        };
        self.linked = !!onRender;
        self.type = type || "top";
        if (type) self.cache = {
            _ct: $subSettings._cchCt
        }; // Used for caching results of computed properties and helpers (view.getCache)
        if (!parentView || parentView.type === "top") (self.ctx = context || {}).root = self.data;
        if (self.parent = parentView) {
            self.root = parentView.root || self; // view whose parent is top view
            views = parentView.views;
            parentView_ = parentView._;
            self.isTop = parentView_.scp; // Is top content view of a link("#container", ...) call
            self.scope = (!context.tag || context.tag === parentView.ctx.tag) && !self.isTop && parentView.scope || self;
            // Scope for contextParams - closest non flow tag ancestor or root view
            if (parentView_.useKey) {
                // Parent is not an 'array view'. Add this view to its views object
                // self._key = is the key in the parent view hash
                views[self_.key = "_" + parentView_.useKey++] = self;
                self.index = indexStr;
                self.getIndex = getNestedIndex;
            } else if (views.length === (self_.key = self.index = key)) views.push(self); // Adding to end of views array. (Using push when possible - better perf than splice)
            else views.splice(key, 0, self); // Inserting in views array
            // If no context was passed in, use parent context
            // If context was passed in, it should have been merged already with parent context
            self.ctx = context || parentView.ctx;
        } else if (type) self.root = self; // view whose parent is top view
    }
    View.prototype = {
        get: getView,
        getIndex: getIndex,
        ctxPrm: contextParameter,
        getRsc: getResource,
        _getTmpl: getTemplate,
        _getOb: getPathObject,
        getCache: function(key) {
            if ($subSettings._cchCt > this.cache._ct) this.cache = {
                _ct: $subSettings._cchCt
            };
            return this.cache[key] !== undefined ? this.cache[key] : this.cache[key] = cpFnStore[key](this.data, this, $sub);
        },
        _is: "view"
    };
    //====================================================
    // Registration
    //====================================================
    function compileChildResources(parentTmpl) {
        var storeName, storeNames, resources;
        for(storeName in jsvStores){
            storeNames = storeName + "s";
            if (parentTmpl[storeNames]) {
                resources = parentTmpl[storeNames]; // Resources not yet compiled
                parentTmpl[storeNames] = {}; // Remove uncompiled resources
                $views[storeNames](resources, parentTmpl); // Add back in the compiled resources
            }
        }
    }
    //===============
    // compileTag
    //===============
    function compileTag(name, tagDef, parentTmpl) {
        var tmpl, baseTag, prop, compiledDef = new $sub._tg();
        function Tag() {
            var tag = this;
            tag._ = {
                unlinked: true
            };
            tag.inline = true;
            tag.tagName = name;
        }
        if ($isFunction(tagDef)) // Simple tag declared as function. No presenter instantation.
        tagDef = {
            depends: tagDef.depends,
            render: tagDef
        };
        else if (typeof tagDef === STRING) tagDef = {
            template: tagDef
        };
        if (baseTag = tagDef.baseTag) {
            tagDef.flow = !!tagDef.flow; // Set flow property, so defaults to false even if baseTag has flow=true
            baseTag = typeof baseTag === STRING ? parentTmpl && parentTmpl.tags[baseTag] || $tags[baseTag] : baseTag;
            if (!baseTag) error('baseTag: "' + tagDef.baseTag + '" not found');
            compiledDef = $extend(compiledDef, baseTag);
            for(prop in tagDef)compiledDef[prop] = getMethod(baseTag[prop], tagDef[prop]);
        } else compiledDef = $extend(compiledDef, tagDef);
        // Tag declared as object, used as the prototype for tag instantiation (control/presenter)
        if ((tmpl = compiledDef.template) !== undefined) compiledDef.template = typeof tmpl === STRING ? $templates[tmpl] || $templates(tmpl) : tmpl;
        (Tag.prototype = compiledDef).constructor = compiledDef._ctr = Tag;
        if (parentTmpl) compiledDef._parentTmpl = parentTmpl;
        return compiledDef;
    }
    function baseApply(args) {
        // In derived method (or handler declared declaratively as in {{:foo onChange=~fooChanged}} can call base method,
        // using this.baseApply(arguments) (Equivalent to this._superApply(arguments) in jQuery UI)
        return this.base.apply(this, args);
    }
    //===============
    // compileTmpl
    //===============
    function compileTmpl(name, tmpl, parentTmpl, options) {
        // tmpl is either a template object, a selector for a template script block, or the name of a compiled template
        //==== nested functions ====
        function lookupTemplate(value) {
            // If value is of type string - treat as selector, or name of compiled template
            // Return the template object, if already compiled, or the markup string
            var currentName, tmpl;
            if (typeof value === STRING || value.nodeType > 0 && (elem = value)) {
                if (!elem) {
                    if (/^\.?\/[^\\:*?"<>]*$/.test(value)) {
                        // value="./some/file.html" (or "/some/file.html")
                        // If the template is not named, use "./some/file.html" as name.
                        if (tmpl = $templates[name = name || value]) value = tmpl;
                        else // BROWSER-SPECIFIC CODE (not on Node.js):
                        // Look for server-generated script block with id "./some/file.html"
                        elem = document.getElementById(value);
                    } else if (value.charAt(0) === "#") elem = document.getElementById(value.slice(1));
                    if (!elem && $.fn && !$sub.rTmpl.test(value)) try {
                        elem = $(value, document)[0]; // if jQuery is loaded, test for selector returning elements, and get first element
                    } catch (e) {}
                     // END BROWSER-SPECIFIC CODE
                } //BROWSER-SPECIFIC CODE
                if (elem) {
                    if (elem.tagName !== "SCRIPT") error(value + ": Use script block, not " + elem.tagName);
                    if (options) // We will compile a new template using the markup in the script element
                    value = elem.innerHTML;
                    else {
                        // We will cache a single copy of the compiled template, and associate it with the name
                        // (renaming from a previous name if there was one).
                        currentName = elem.getAttribute(tmplAttr);
                        if (currentName) {
                            if (currentName !== jsvTmpl) {
                                value = $templates[currentName];
                                delete $templates[currentName];
                            } else if ($.fn) value = $.data(elem)[jsvTmpl]; // Get cached compiled template
                        }
                        if (!currentName || !value) {
                            name = name || ($.fn ? jsvTmpl : value);
                            value = compileTmpl(name, elem.innerHTML, parentTmpl, options);
                        }
                        value.tmplName = name = name || currentName;
                        if (name !== jsvTmpl) $templates[name] = value;
                        elem.setAttribute(tmplAttr, name);
                        if ($.fn) $.data(elem, jsvTmpl, value);
                    }
                } // END BROWSER-SPECIFIC CODE
                elem = undefined;
            } else if (!value.fn) value = undefined;
            return value;
        }
        var elem, compiledTmpl, tmplOrMarkup = tmpl = tmpl || "";
        $sub._html = $converters.html;
        //==== Compile the template ====
        if (options === 0) {
            options = undefined;
            tmplOrMarkup = lookupTemplate(tmplOrMarkup); // Top-level compile so do a template lookup
        }
        // If options, then this was already compiled from a (script) element template declaration.
        // If not, then if tmpl is a template object, use it for options
        options = options || (tmpl.markup ? tmpl.bnds ? $extend({}, tmpl) : tmpl : {});
        options.tmplName = options.tmplName || name || "unnamed";
        if (parentTmpl) options._parentTmpl = parentTmpl;
        // If tmpl is not a markup string or a selector string, then it must be a template object
        // In that case, get it from the markup property of the object
        if (!tmplOrMarkup && tmpl.markup && (tmplOrMarkup = lookupTemplate(tmpl.markup)) && tmplOrMarkup.fn) // If the string references a compiled template object, need to recompile to merge any modified options
        tmplOrMarkup = tmplOrMarkup.markup;
        if (tmplOrMarkup !== undefined) {
            if (tmplOrMarkup.render || tmpl.render) // tmpl is already compiled, so use it
            {
                if (tmplOrMarkup.tmpls) compiledTmpl = tmplOrMarkup;
            } else {
                // tmplOrMarkup is a markup string, not a compiled template
                // Create template object
                tmpl = tmplObject(tmplOrMarkup, options);
                // Compile to AST and then to compiled function
                tmplFn(tmplOrMarkup.replace(rEscapeQuotes, "\\$&"), tmpl);
            }
            if (!compiledTmpl) {
                compiledTmpl = $extend(function() {
                    return compiledTmpl.render.apply(compiledTmpl, arguments);
                }, tmpl);
                compileChildResources(compiledTmpl);
            }
            return compiledTmpl;
        }
    }
    //==== /end of function compileTmpl ====
    //=================
    // compileViewModel
    //=================
    function getDefaultVal(defaultVal, data) {
        return $isFunction(defaultVal) ? defaultVal.call(data) : defaultVal;
    }
    function addParentRef(ob, ref, parent) {
        Object.defineProperty(ob, ref, {
            value: parent,
            configurable: true
        });
    }
    function compileViewModel(name, type) {
        var i, constructor, parent, viewModels = this, getters = type.getters, extend = type.extend, id = type.id, proto = $.extend({
            _is: name || "unnamed",
            unmap: unmap,
            merge: merge
        }, extend), args = "", cnstr = "", getterCount = getters ? getters.length : 0, $observable1 = $.observable, getterNames = {};
        function JsvVm(args) {
            constructor.apply(this, args);
        }
        function vm() {
            return new JsvVm(arguments);
        }
        function iterate(data, action) {
            var getterType, defaultVal, prop, ob, parentRef, j = 0;
            for(; j < getterCount; j++){
                prop = getters[j];
                getterType = undefined;
                if (typeof prop !== STRING) {
                    getterType = prop;
                    prop = getterType.getter;
                    parentRef = getterType.parentRef;
                }
                if ((ob = data[prop]) === undefined && getterType && (defaultVal = getterType.defaultVal) !== undefined) ob = getDefaultVal(defaultVal, data);
                action(ob, getterType && viewModels[getterType.type], prop, parentRef);
            }
        }
        function map(data) {
            data = typeof data === STRING ? JSON.parse(data) // Accept JSON string
             : data; // or object/array
            var l, prop, childOb, parentRef, j = 0, ob = data, arr = [];
            if ($isArray(data)) {
                data = data || [];
                l = data.length;
                for(; j < l; j++)arr.push(this.map(data[j]));
                arr._is = name;
                arr.unmap = unmap;
                arr.merge = merge;
                return arr;
            }
            if (data) {
                iterate(data, function(ob, viewModel) {
                    if (viewModel) ob = viewModel.map(ob);
                    arr.push(ob);
                });
                ob = this.apply(this, arr); // Instantiate this View Model, passing getters args array to constructor
                j = getterCount;
                while(j--){
                    childOb = arr[j];
                    parentRef = getters[j].parentRef;
                    if (parentRef && childOb && childOb.unmap) {
                        if ($isArray(childOb)) {
                            l = childOb.length;
                            while(l--)addParentRef(childOb[l], parentRef, ob);
                        } else addParentRef(childOb, parentRef, ob);
                    }
                }
                for(prop in data)if (prop !== $expando && !getterNames[prop]) ob[prop] = data[prop];
            }
            return ob;
        }
        function merge(data, parent, parentRef) {
            data = typeof data === STRING ? JSON.parse(data) // Accept JSON string
             : data; // or object/array
            var j, l, m, prop, mod, found, assigned, ob, newModArr, childOb, k = 0, model = this;
            if ($isArray(model)) {
                assigned = {};
                newModArr = [];
                l = data.length;
                m = model.length;
                for(; k < l; k++){
                    ob = data[k];
                    found = false;
                    for(j = 0; j < m && !found; j++){
                        if (assigned[j]) continue;
                        mod = model[j];
                        if (id) assigned[j] = found = typeof id === STRING ? ob[id] && (getterNames[id] ? mod[id]() : mod[id]) === ob[id] : id(mod, ob);
                    }
                    if (found) {
                        mod.merge(ob);
                        newModArr.push(mod);
                    } else {
                        newModArr.push(childOb = vm.map(ob));
                        if (parentRef) addParentRef(childOb, parentRef, parent);
                    }
                }
                if ($observable1) $observable1(model).refresh(newModArr, true);
                else model.splice.apply(model, [
                    0,
                    model.length
                ].concat(newModArr));
                return;
            }
            iterate(data, function(ob, viewModel, getter, parentRef) {
                if (viewModel) model[getter]().merge(ob, model, parentRef); // Update typed property
                else if (model[getter]() !== ob) model[getter](ob); // Update non-typed property
            });
            for(prop in data)if (prop !== $expando && !getterNames[prop]) model[prop] = data[prop];
        }
        function unmap() {
            var ob, prop, getterType, arr, value, k = 0, model = this;
            function unmapArray(modelArr) {
                var arr = [], i = 0, l = modelArr.length;
                for(; i < l; i++)arr.push(modelArr[i].unmap());
                return arr;
            }
            if ($isArray(model)) return unmapArray(model);
            ob = {};
            for(; k < getterCount; k++){
                prop = getters[k];
                getterType = undefined;
                if (typeof prop !== STRING) {
                    getterType = prop;
                    prop = getterType.getter;
                }
                value = model[prop]();
                ob[prop] = getterType && value && viewModels[getterType.type] ? $isArray(value) ? unmapArray(value) : value.unmap() : value;
            }
            for(prop in model)if (model.hasOwnProperty(prop) && (prop.charAt(0) !== "_" || !getterNames[prop.slice(1)]) && prop !== $expando && !$isFunction(model[prop])) ob[prop] = model[prop];
            return ob;
        }
        JsvVm.prototype = proto;
        for(i = 0; i < getterCount; i++)(function(getter) {
            getter = getter.getter || getter;
            getterNames[getter] = i + 1;
            var privField = "_" + getter;
            args += (args ? "," : "") + getter;
            cnstr += "this." + privField + " = " + getter + ";\n";
            proto[getter] = proto[getter] || function(val) {
                if (!arguments.length) return this[privField]; // If there is no argument, use as a getter
                if ($observable1) $observable1(this).setProperty(getter, val);
                else this[privField] = val;
            };
            if ($observable1) proto[getter].set = proto[getter].set || function(val) {
                this[privField] = val; // Setter called by observable property change
            };
        })(getters[i]);
        // Constructor for new viewModel instance.
        cnstr = new Function(args, cnstr);
        constructor = function() {
            cnstr.apply(this, arguments);
            // Pass additional parentRef str and parent obj to have a parentRef pointer on instance
            if (parent = arguments[getterCount + 1]) addParentRef(this, arguments[getterCount], parent);
        };
        constructor.prototype = proto;
        proto.constructor = constructor;
        vm.map = map;
        vm.getters = getters;
        vm.extend = extend;
        vm.id = id;
        return vm;
    }
    function tmplObject(markup, options) {
        // Template object constructor
        var htmlTag, wrapMap = $subSettingsAdvanced._wm || {}, tmpl = {
            tmpls: [],
            links: {},
            bnds: [],
            _is: "template",
            render: renderContent
        };
        if (options) tmpl = $extend(tmpl, options);
        tmpl.markup = markup;
        if (!tmpl.htmlTag) {
            // Set tmpl.tag to the top-level HTML tag used in the template, if any...
            htmlTag = rFirstElem.exec(markup);
            tmpl.htmlTag = htmlTag ? htmlTag[1].toLowerCase() : "";
        }
        htmlTag = wrapMap[tmpl.htmlTag];
        if (htmlTag && htmlTag !== wrapMap.div) // When using JsViews, we trim templates which are inserted into HTML contexts where text nodes are not rendered (i.e. not 'Phrasing Content').
        // Currently not trimmed for <li> tag. (Not worth adding perf cost)
        tmpl.markup = $.trim(tmpl.markup);
        return tmpl;
    }
    //==============
    // registerStore
    //==============
    /**
* Internal. Register a store type (used for template, tags, helpers, converters)
*/ function registerStore(storeName, storeSettings) {
        /**
* Generic store() function to register item, named item, or hash of items
* Also used as hash to store the registered items
* Used as implementation of $.templates(), $.views.templates(), $.views.tags(), $.views.helpers() and $.views.converters()
*
* @param {string|hash} name         name - or selector, in case of $.templates(). Or hash of items
* @param {any}         [item]       (e.g. markup for named template)
* @param {template}    [parentTmpl] For item being registered as private resource of template
* @returns {any|$.views} item, e.g. compiled template - or $.views in case of registering hash of items
*/ function theStore(name, item, parentTmpl) {
            // The store is also the function used to add items to the store. e.g. $.templates, or $.views.tags
            // For store of name 'thing', Call as:
            //    $.views.things(items[, parentTmpl]),
            // or $.views.things(name[, item, parentTmpl])
            var compile, itemName, thisStore, cnt, onStore = $sub.onStore[storeName];
            if (name && typeof name === OBJECT && !name.nodeType && !name.markup && !name.getTgt && !(storeName === "viewModel" && name.getters || name.extend)) {
                // Call to $.views.things(items[, parentTmpl]),
                // Adding items to the store
                // If name is a hash, then item is parentTmpl. Iterate over hash and call store for key.
                for(itemName in name)theStore(itemName, name[itemName], item);
                return item || $views;
            }
            // Adding a single unnamed item to the store
            if (name && typeof name !== STRING) {
                parentTmpl = item;
                item = name;
                name = undefined;
            }
            thisStore = parentTmpl ? storeName === "viewModel" ? parentTmpl : parentTmpl[storeNames] = parentTmpl[storeNames] || {} : theStore;
            compile = storeSettings.compile;
            if (item === undefined) {
                item = compile ? name : thisStore[name];
                name = undefined;
            }
            if (item === null) // If item is null, delete this entry
            {
                if (name) delete thisStore[name];
            } else {
                if (compile) {
                    item = compile.call(thisStore, name, item, parentTmpl, 0) || {};
                    item._is = storeName; // Only do this for compiled objects (tags, templates...)
                }
                if (name) thisStore[name] = item;
            }
            if (onStore) // e.g. JsViews integration
            onStore(name, item, parentTmpl, compile);
            return item;
        }
        var storeNames = storeName + "s";
        $views[storeNames] = theStore;
    }
    /**
* Add settings such as:
* $.views.settings.allowCode(true)
* @param {boolean} value
* @returns {Settings}
*
* allowCode = $.views.settings.allowCode()
* @returns {boolean}
*/ function addSetting(st) {
        $viewsSettings[st] = $viewsSettings[st] || function(value) {
            return arguments.length ? ($subSettings[st] = value, $viewsSettings) : $subSettings[st];
        };
    }
    //========================
    // dataMap for render only
    //========================
    function dataMap(mapDef) {
        function Map(source, options) {
            this.tgt = mapDef.getTgt(source, options);
            options.map = this;
        }
        if ($isFunction(mapDef)) // Simple map declared as function
        mapDef = {
            getTgt: mapDef
        };
        if (mapDef.baseMap) mapDef = $extend($extend({}, mapDef.baseMap), mapDef);
        mapDef.map = function(source, options) {
            return new Map(source, options);
        };
        return mapDef;
    }
    //==============
    // renderContent
    //==============
    /** Render the template as a string, using the specified data and helpers/context
* $("#tmpl").render(), tmpl.render(), tagCtx.render(), $.render.namedTmpl()
*
* @param {any}        data
* @param {hash}       [context]           helpers or context
* @param {boolean}    [noIteration]
* @param {View}       [parentView]        internal
* @param {string}     [key]               internal
* @param {function}   [onRender]          internal
* @returns {string}   rendered template   internal
*/ function renderContent(data, context, noIteration, parentView, key, onRender) {
        var i, l, tag, tmpl, tagCtx, isTopRenderCall, prevData, prevIndex, view = parentView, result = "";
        if (context === true) {
            noIteration = context; // passing boolean as second param - noIteration
            context = undefined;
        } else if (typeof context !== OBJECT) context = undefined; // context must be a boolean (noIteration) or a plain object
        if (tag = this.tag) {
            // This is a call from renderTag or tagCtx.render(...)
            tagCtx = this;
            view = view || tagCtx.view;
            tmpl = view._getTmpl(tag.template || tagCtx.tmpl);
            if (!arguments.length) data = tag.contentCtx && $isFunction(tag.contentCtx) ? data = tag.contentCtx(data) : view; // Default data context for wrapped block content is the first argument
        } else // This is a template.render(...) call
        tmpl = this;
        if (tmpl) {
            if (!parentView && data && data._is === "view") view = data; // When passing in a view to render or link (and not passing in a parent view) use the passed-in view as parentView
            if (view && data === view) // Inherit the data from the parent view.
            data = view.data;
            isTopRenderCall = !view;
            isRenderCall = isRenderCall || isTopRenderCall;
            if (isTopRenderCall) (context = context || {}).root = data; // Provide ~root as shortcut to top-level data.
            if (!isRenderCall || $subSettingsAdvanced.useViews || tmpl.useViews || view && view !== topView) result = renderWithViews(tmpl, data, context, noIteration, view, key, onRender, tag);
            else {
                if (view) {
                    prevData = view.data;
                    prevIndex = view.index;
                    view.index = indexStr;
                } else {
                    view = topView;
                    prevData = view.data;
                    view.data = data;
                    view.ctx = context;
                }
                if ($isArray(data) && !noIteration) // Create a view for the array, whose child views correspond to each data item. (Note: if key and parentView are passed in
                // along with parent view, treat as insert -e.g. from view.addViews - so parentView is already the view item for array)
                for(i = 0, l = data.length; i < l; i++){
                    view.index = i;
                    view.data = data[i];
                    result += tmpl.fn(data[i], view, $sub);
                }
                else {
                    view.data = data;
                    result += tmpl.fn(data, view, $sub);
                }
                view.data = prevData;
                view.index = prevIndex;
            }
            if (isTopRenderCall) isRenderCall = undefined;
        }
        return result;
    }
    function renderWithViews(tmpl, data, context, noIteration, view, key, onRender, tag) {
        // Render template against data as a tree of subviews (nested rendered template instances), or as a string (top-level template).
        // If the data is the parent view, treat as noIteration, re-render with the same data context.
        // tmpl can be a string (e.g. rendered by a tag.render() method), or a compiled template.
        var i, l, newView, childView, itemResult, swapContent, contentTmpl, outerOnRender, tmplName, itemVar, newCtx, tagCtx, noLinking, result = "";
        if (tag) {
            // This is a call from renderTag or tagCtx.render(...)
            tmplName = tag.tagName;
            tagCtx = tag.tagCtx;
            context = context ? extendCtx(context, tag.ctx) : tag.ctx;
            if (tmpl === view.content) contentTmpl = tmpl !== view.ctx._wrp // We are rendering the #content
             ? view.ctx._wrp // #content was the tagCtx.props.tmpl wrapper of the block content - so within this view, #content will now be the view.ctx._wrp block content
             : undefined; // #content was the view.ctx._wrp block content - so within this view, there is no longer any #content to wrap.
            else if (tmpl !== tagCtx.content) {
                if (tmpl === tag.template) {
                    contentTmpl = tagCtx.tmpl; // Set #content to block content (or wrapped block content if tagCtx.props.tmpl is set)
                    context._wrp = tagCtx.content; // Pass wrapped block content to nested views
                } else contentTmpl = tagCtx.content || view.content; // Set #content to wrapped block content
            } else contentTmpl = view.content; // Nested views inherit same wrapped #content property
            if (tagCtx.props.link === false) {
                // link=false setting on block tag
                // We will override inherited value of link by the explicit setting link=false taken from props
                // The child views of an unlinked view are also unlinked. So setting child back to true will not have any effect.
                context = context || {};
                context.link = false;
            }
        }
        if (view) {
            onRender = onRender || view._.onRender;
            noLinking = context && context.link === false;
            if (noLinking && view._.nl) onRender = undefined;
            context = extendCtx(context, view.ctx);
            tagCtx = !tag && view.tag ? view.tag.tagCtxs[view.tagElse] : tagCtx;
        }
        if (itemVar = tagCtx && tagCtx.props.itemVar) {
            if (itemVar[0] !== "~") syntaxError("Use itemVar='~myItem'");
            itemVar = itemVar.slice(1);
        }
        if (key === true) {
            swapContent = true;
            key = 0;
        }
        // If link===false, do not call onRender, so no data-linking marker nodes
        if (onRender && tag && tag._.noVws) onRender = undefined;
        outerOnRender = onRender;
        if (onRender === true) {
            // Used by view.refresh(). Don't create a new wrapper view.
            outerOnRender = undefined;
            onRender = view._.onRender;
        }
        // Set additional context on views created here, (as modified context inherited from the parent, and to be inherited by child views)
        context = tmpl.helpers ? extendCtx(tmpl.helpers, context) : context;
        newCtx = context;
        if ($isArray(data) && !noIteration) {
            // Create a view for the array, whose child views correspond to each data item. (Note: if key and view are passed in
            // along with parent view, treat as insert -e.g. from view.addViews - so view is already the view item for array)
            newView = swapContent ? view : key !== undefined && view || new View(context, "array", view, data, tmpl, key, onRender, contentTmpl);
            newView._.nl = noLinking;
            if (view && view._.useKey) {
                // Parent is not an 'array view'
                newView._.bnd = !tag || tag._.bnd && tag; // For array views that are data bound for collection change events, set the
                // view._.bnd property to true for top-level link() or data-link="{for}", or to the tag instance for a data-bound tag, e.g. {^{for ...}}
                newView.tag = tag;
            }
            for(i = 0, l = data.length; i < l; i++){
                // Create a view for each data item.
                childView = new View(newCtx, "item", newView, data[i], tmpl, (key || 0) + i, onRender, newView.content);
                if (itemVar) (childView.ctx = $extend({}, newCtx))[itemVar] = $sub._cp(data[i], "#data", childView);
                itemResult = tmpl.fn(data[i], childView, $sub);
                result += newView._.onRender ? newView._.onRender(itemResult, childView) : itemResult;
            }
        } else {
            // Create a view for singleton data object. The type of the view will be the tag name, e.g. "if" or "mytag" except for
            // "item", "array" and "data" views. A "data" view is from programmatic render(object) against a 'singleton'.
            newView = swapContent ? view : new View(newCtx, tmplName || "data", view, data, tmpl, key, onRender, contentTmpl);
            if (itemVar) (newView.ctx = $extend({}, newCtx))[itemVar] = $sub._cp(data, "#data", newView);
            newView.tag = tag;
            newView._.nl = noLinking;
            result += tmpl.fn(data, newView, $sub);
        }
        if (tag) {
            newView.tagElse = tagCtx.index;
            tagCtx.contentView = newView;
        }
        return outerOnRender ? outerOnRender(result, newView) : result;
    }
    //===========================
    // Build and compile template
    //===========================
    // Generate a reusable function that will serve to render a template against data
    // (Compile AST then build template function)
    function onRenderError(e, view, fallback) {
        var message = fallback !== undefined ? $isFunction(fallback) ? fallback.call(view.data, e, view) : fallback || "" : "{Error: " + (e.message || e) + "}";
        if ($subSettings.onError && (fallback = $subSettings.onError.call(view.data, e, fallback && message, view)) !== undefined) message = fallback; // There is a settings.debugMode(handler) onError override. Call it, and use return value (if any) to replace message
        return view && !view._lc ? $converters.html(message) : message; // For data-link=\"{... onError=...}"... See onDataLinkedTagChange
    }
    function error(message) {
        throw new $sub.Err(message);
    }
    function syntaxError(message) {
        error("Syntax error\n" + message);
    }
    function tmplFn(markup, tmpl, isLinkExpr, convertBack, hasElse) {
        // Compile markup to AST (abtract syntax tree) then build the template function code from the AST nodes
        // Used for compiling templates, and also by JsViews to build functions for data link expressions
        //==== nested functions ====
        function pushprecedingContent(shift) {
            shift -= loc;
            if (shift) content.push(markup.substr(loc, shift).replace(rNewLine, "\\n"));
        }
        function blockTagCheck(tagName, block) {
            if (tagName) {
                tagName += '}}';
                //			'{{include}} block has {{/for}} with no open {{for}}'
                syntaxError((block ? '{{' + block + '}} block has {{/' + tagName + ' without {{' + tagName : 'Unmatched or missing {{/' + tagName) + ', in template:\n' + markup);
            }
        }
        function parseTag(all, bind, tagName, converter, colon, html, codeTag, params, slash, bind2, closeBlock, index) {
            /*

     bind     tagName         cvt   cln html code    params            slash   bind2         closeBlk  comment
/(?:{(\^)?{(?:(\w+(?=[\/\s}]))|(\w+)?(:)|(>)|(\*))\s*((?:[^}]|}(?!}))*?)(\/)?|{(\^)?{(?:(?:\/(\w+))\s*|!--[\s\S]*?--))}}/g

(?:
  {(\^)?{            bind
  (?:
    (\w+             tagName
      (?=[\/\s}])
    )
    |
    (\w+)?(:)        converter colon
    |
    (>)              html
    |
    (\*)             codeTag
  )
  \s*
  (                  params
    (?:[^}]|}(?!}))*?
  )
  (\/)?              slash
  |
  {(\^)?{            bind2
  (?:
    (?:\/(\w+))\s*   closeBlock
    |
    !--[\s\S]*?--    comment
  )
)
}}/g

*/ if (codeTag && bind || slash && !tagName || params && params.slice(-1) === ":" || bind2) syntaxError(all);
            // Build abstract syntax tree (AST): [tagName, converter, params, content, hash, bindings, contentMarkup]
            if (html) {
                colon = ":";
                converter = HTML;
            }
            slash = slash || isLinkExpr && !hasElse;
            var late, openTagName, isLateOb, pathBindings = (bind || isLinkExpr) && [
                []
            ], props = "", args = "", ctxProps = "", paramsArgs = "", paramsProps = "", paramsCtxProps = "", onError = "", useTrigger = "", // Block tag if not self-closing and not {{:}} or {{>}} (special case) and not a data-link expression
            block = !slash && !colon;
            //==== nested helper function ====
            tagName = tagName || (params = params || "#data", colon); // {{:}} is equivalent to {{:#data}}
            pushprecedingContent(index);
            loc = index + all.length; // location marker - parsed up to here
            if (codeTag) {
                if (allowCode) content.push([
                    "*",
                    "\n" + params.replace(/^:/, "ret+= ").replace(rUnescapeQuotes, "$1") + ";\n"
                ]);
            } else if (tagName) {
                if (tagName === "else") {
                    if (rTestElseIf.test(params)) syntaxError('For "{{else if expr}}" use "{{else expr}}"');
                    pathBindings = current[9] && [
                        []
                    ];
                    current[10] = markup.substring(current[10], index); // contentMarkup for block tag
                    openTagName = current[11] || current[0] || syntaxError("Mismatched: " + all);
                    // current[0] is tagName, but for {{else}} nodes, current[11] is tagName of preceding open tag
                    current = stack.pop();
                    content = current[2];
                    block = true;
                }
                if (params) // remove newlines from the params string, to avoid compiled code errors for unterminated strings
                parseParams(params.replace(rNewLine, " "), pathBindings, tmpl, isLinkExpr).replace(rBuildHash, function(all, onerror, isCtxPrm, key, keyToken, keyValue, arg, param) {
                    if (key === "this:") keyValue = "undefined"; // this=some.path is always a to parameter (one-way), so don't need to compile/evaluate some.path initialization
                    if (param) isLateOb = isLateOb || param[0] === "@";
                    key = "'" + keyToken + "':";
                    if (arg) {
                        args += isCtxPrm + keyValue + ",";
                        paramsArgs += "'" + param + "',";
                    } else if (isCtxPrm) {
                        ctxProps += key + 'j._cp(' + keyValue + ',"' + param + '",view),';
                        // Compiled code for evaluating tagCtx on a tag will have: ctx:{'foo':j._cp(compiledExpr, "expr", view)}
                        paramsCtxProps += key + "'" + param + "',";
                    } else if (onerror) onError += keyValue;
                    else {
                        if (keyToken === "trigger") useTrigger += keyValue;
                        if (keyToken === "lateRender") late = param !== "false"; // Render after first pass
                        props += key + keyValue + ",";
                        paramsProps += key + "'" + param + "',";
                        hasHandlers = hasHandlers || rHasHandlers.test(keyToken);
                    }
                    return "";
                }).slice(0, -1);
                if (pathBindings && pathBindings[0]) pathBindings.pop(); // Remove the binding that was prepared for next arg. (There is always an extra one ready).
                newNode = [
                    tagName,
                    converter || !!convertBack || hasHandlers || "",
                    block && [],
                    parsedParam(paramsArgs || (tagName === ":" ? "'#data'," : ""), paramsProps, paramsCtxProps),
                    parsedParam(args || (tagName === ":" ? "data," : ""), props, ctxProps),
                    onError,
                    useTrigger,
                    late,
                    isLateOb,
                    pathBindings || 0
                ];
                content.push(newNode);
                if (block) {
                    stack.push(current);
                    current = newNode;
                    current[10] = loc; // Store current location of open tag, to be able to add contentMarkup when we reach closing tag
                    current[11] = openTagName; // Used for checking syntax (matching close tag)
                }
            } else if (closeBlock) {
                blockTagCheck(closeBlock !== current[0] && closeBlock !== current[11] && closeBlock, current[0]); // Check matching close tag name
                current[10] = markup.substring(current[10], index); // contentMarkup for block tag
                current = stack.pop();
            }
            blockTagCheck(!current && closeBlock);
            content = current[2];
        }
        //==== /end of nested functions ====
        var i, result, newNode, hasHandlers, bindings, allowCode = $subSettings.allowCode || tmpl && tmpl.allowCode || $viewsSettings.allowCode === true, astTop = [], loc = 0, stack = [], content = astTop, current = [
            ,
            ,
            astTop
        ];
        if (allowCode && tmpl._is) tmpl.allowCode = allowCode;
        //TODO	result = tmplFnsCache[markup]; // Only cache if template is not named and markup length < ...,
        //and there are no bindings or subtemplates?? Consider standard optimization for data-link="a.b.c"
        //		if (result) {
        //			tmpl.fn = result;
        //		} else {
        //		result = markup;
        if (isLinkExpr) {
            if (convertBack !== undefined) markup = markup.slice(0, -convertBack.length - 2) + delimCloseChar0;
            markup = delimOpenChar0 + markup + delimCloseChar1;
        }
        blockTagCheck(stack[0] && stack[0][2].pop()[0]);
        // Build the AST (abstract syntax tree) under astTop
        markup.replace(rTag, parseTag);
        pushprecedingContent(markup.length);
        if (loc = astTop[astTop.length - 1]) blockTagCheck(typeof loc !== STRING && +loc[10] === loc[10] && loc[0]);
        //			result = tmplFnsCache[markup] = buildCode(astTop, tmpl);
        //		}
        if (isLinkExpr) {
            result = buildCode(astTop, markup, isLinkExpr);
            bindings = [];
            i = astTop.length;
            while(i--)bindings.unshift(astTop[i][9]); // With data-link expressions, pathBindings array for tagCtx[i] is astTop[i][9]
            setPaths(result, bindings);
        } else result = buildCode(astTop, tmpl);
        return result;
    }
    function setPaths(fn, pathsArr) {
        var key, paths, i = 0, l = pathsArr.length;
        fn.deps = [];
        fn.paths = []; // The array of path binding (array/dictionary)s for each tag/else block's args and props
        for(; i < l; i++){
            fn.paths.push(paths = pathsArr[i]);
            for(key in paths)if (key !== "_jsvto" && paths.hasOwnProperty(key) && paths[key].length && !paths[key].skp) fn.deps = fn.deps.concat(paths[key]); // deps is the concatenation of the paths arrays for the different bindings
        }
    }
    function parsedParam(args, props, ctx) {
        return [
            args.slice(0, -1),
            props.slice(0, -1),
            ctx.slice(0, -1)
        ];
    }
    function paramStructure(paramCode, paramVals) {
        return '\n\tparams:{args:[' + paramCode[0] + '],\n\tprops:{' + paramCode[1] + '}' + (paramCode[2] ? ',\n\tctx:{' + paramCode[2] + '}' : "") + '},\n\targs:[' + paramVals[0] + '],\n\tprops:{' + paramVals[1] + '}' + (paramVals[2] ? ',\n\tctx:{' + paramVals[2] + '}' : "");
    }
    function parseParams(params, pathBindings, tmpl, isLinkExpr) {
        function parseTokens(all, lftPrn0, lftPrn, bound, path, operator, err, eq, path2, late, prn, comma, lftPrn2, apos, quot, rtPrn, rtPrnDot, prn2, space, index, full) {
            // /(\()(?=\s*\()|(?:([([])\s*)?(?:(\^?)(~?[\w$.^]+)?\s*((\+\+|--)|\+|-|~(?![\w$])|&&|\|\||===|!==|==|!=|<=|>=|[<>%*:?\/]|(=))\s*|(!*?(@)?[#~]?[\w$.^]+)([([])?)|(,\s*)|(?:(\()\s*)?\\?(?:(')|("))|(?:\s*(([)\]])(?=[.^]|\s*$|[^([])|[)\]])([([]?))|(\s+)/g,
            //lftPrn0           lftPrn         bound     path               operator     err                                          eq      path2 late            prn      comma  lftPrn2          apos quot        rtPrn  rtPrnDot                  prn2     space
            // (left paren? followed by (path? followed by operator) or (path followed by paren?)) or comma or apos or quot or right paren or space
            function parsePath(allPath, not, object, helper, view, viewProperty, pathTokens, leafToken) {
                // /^(!*?)(?:null|true|false|\d[\d.]*|([\w$]+|\.|~([\w$]+)|#(view|([\w$]+))?)([\w$.^]*?)(?:[.[^]([\w$]+)\]?)?)$/g,
                //    not                               object     helper    view  viewProperty pathTokens      leafToken
                subPath = object === ".";
                if (object) {
                    path = path.slice(not.length);
                    if (/^\.?constructor$/.test(leafToken || path)) syntaxError(allPath);
                    if (!subPath) {
                        allPath = (late // late path @a.b.c: not throw on 'property of undefined' if a undefined, and will use _getOb() after linking to resolve late.
                         ? (isLinkExpr ? '' : '(ltOb.lt=ltOb.lt||') + '(ob=' : "") + (helper ? 'view.ctxPrm("' + helper + '")' : view ? "view" : "data") + (late ? ')===undefined' + (isLinkExpr ? '' : ')') + '?"":view._getOb(ob,"' : "") + (leafToken ? (viewProperty ? "." + viewProperty : helper ? "" : view ? "" : "." + object) + (pathTokens || "") : (leafToken = helper ? "" : view ? viewProperty || "" : object, ""));
                        allPath = allPath + (leafToken ? "." + leafToken : "");
                        allPath = not + (allPath.slice(0, 9) === "view.data" ? allPath.slice(5) // convert #view.data... to data...
                         : allPath) + (late ? (isLinkExpr ? '"' : '",ltOb') + (prn ? ',1)' : ')') : "");
                    }
                    if (bindings) {
                        binds = named === "_linkTo" ? bindto = pathBindings._jsvto = pathBindings._jsvto || [] : bndCtx.bd;
                        if (theOb = subPath && binds[binds.length - 1]) {
                            if (theOb._cpfn) {
                                while(theOb.sb)theOb = theOb.sb;
                                if (theOb.prm) {
                                    if (theOb.bnd) path = "^" + path.slice(1);
                                    theOb.sb = path;
                                    theOb.bnd = theOb.bnd || path[0] === "^";
                                }
                            }
                        } else binds.push(path);
                        if (prn && !subPath) {
                            pathStart[fnDp] = ind;
                            compiledPathStart[fnDp] = compiledPath[fnDp].length;
                        }
                    }
                }
                return allPath;
            }
            //bound = bindings && bound;
            if (bound && !eq) path = bound + path; // e.g. some.fn(...)^some.path - so here path is "^some.path"
            operator = operator || "";
            lftPrn2 = lftPrn2 || "";
            lftPrn = lftPrn || lftPrn0 || lftPrn2;
            path = path || path2;
            if (late && (late = !/\)|]/.test(full[index - 1]))) path = path.slice(1).split(".").join("^"); // Late path @z.b.c. Use "^" rather than "." to ensure that deep binding will be used
            // Could do this - but not worth perf cost?? :-
            // if (!path.lastIndexOf("#data.", 0)) { path = path.slice(6); } // If path starts with "#data.", remove that.
            prn = prn || prn2 || "";
            var expr, binds, theOb, newOb, subPath, lftPrnFCall, ret, ind = index;
            if (!aposed && !quoted) {
                if (err) syntaxError(params);
                if (rtPrnDot && bindings) {
                    // This is a binding to a path in which an object is returned by a helper/data function/expression, e.g. foo()^x.y or (a?b:c)^x.y
                    // We create a compiled function to get the object instance (which will be called when the dependent data of the subexpression changes,
                    // to return the new object, and trigger re-binding of the subsequent path)
                    expr = pathStart[fnDp - 1];
                    if (full.length - 1 > ind - (expr || 0)) {
                        expr = $.trim(full.slice(expr, ind + all.length));
                        binds = bindto || bndStack[fnDp - 1].bd;
                        // Insert exprOb object, to be used during binding to return the computed object
                        theOb = binds[binds.length - 1];
                        if (theOb && theOb.prm) {
                            while(theOb.sb && theOb.sb.prm)theOb = theOb.sb;
                            newOb = theOb.sb = {
                                path: theOb.sb,
                                bnd: theOb.bnd
                            };
                        } else binds.push(newOb = {
                            path: binds.pop()
                        }); // Insert exprOb object, to be used during binding to return the computed object
                        if (theOb && theOb.sb === newOb) {
                            compiledPath[fnDp] = compiledPath[fnDp - 1].slice(theOb._cpPthSt) + compiledPath[fnDp];
                            compiledPath[fnDp - 1] = compiledPath[fnDp - 1].slice(0, theOb._cpPthSt);
                        }
                        newOb._cpPthSt = compiledPathStart[fnDp - 1];
                        newOb._cpKey = expr;
                        compiledPath[fnDp] += full.slice(prevIndex, index);
                        prevIndex = index;
                        newOb._cpfn = cpFnStore[expr] = cpFnStore[expr] || // Compiled function for computed value: get from store, or compile and store
                        new Function("data,view,j", "//" + expr + "\nvar v;\nreturn ((v=" + compiledPath[fnDp] + (rtPrn === "]" ? ")]" : rtPrn) + ")!=null?v:null);");
                        compiledPath[fnDp - 1] += fnCall[prnDp] && $subSettingsAdvanced.cache ? "view.getCache(\"" + expr.replace(rEscapeQuotes, "\\$&") + "\"" : compiledPath[fnDp];
                        newOb.prm = bndCtx.bd;
                        newOb.bnd = newOb.bnd || newOb.path && newOb.path.indexOf("^") >= 0;
                    }
                    compiledPath[fnDp] = "";
                }
                if (prn === "[") prn = "[j._sq(";
                if (lftPrn === "[") lftPrn = "[j._sq(";
            }
            ret = aposed ? (aposed = !apos, aposed ? all : lftPrn2 + '"') : quoted ? (quoted = !quot, quoted ? all : lftPrn2 + '"') : (lftPrn ? (prnStack[++prnDp] = true, prnInd[prnDp] = 0, bindings && (pathStart[fnDp++] = ind++, bndCtx = bndStack[fnDp] = {
                bd: []
            }, compiledPath[fnDp] = "", compiledPathStart[fnDp] = 1), lftPrn // Left paren, (not a function call paren)
            ) : "") + (space ? prnDp ? "" // A space within parens or within function call parens, so not a separator for tag args
             : (paramIndex = full.slice(paramIndex, ind), named ? (named = boundName = bindto = false, "\b") : "\b,") + paramIndex + (paramIndex = ind + all.length, bindings && pathBindings.push(bndCtx.bd = []), "\b") : eq ? (fnDp && syntaxError(params), bindings && pathBindings.pop(), named = "_" + path, boundName = bound, paramIndex = ind + all.length, bindings && (bindings = bndCtx.bd = pathBindings[named] = [], bindings.skp = !bound), path + ':') : path ? path.split("^").join(".").replace($sub.rPath, parsePath) + (prn || operator) : operator ? operator : rtPrn ? rtPrn === "]" ? ")]" : ")" : comma ? (fnCall[prnDp] || syntaxError(params), "," // We don't allow top-level literal arrays or objects
            ) : lftPrn0 ? "" : (aposed = apos, quoted = quot, '"'));
            if (!aposed && !quoted) {
                if (rtPrn) {
                    fnCall[prnDp] = false;
                    prnDp--;
                }
            }
            if (bindings) {
                if (!aposed && !quoted) {
                    if (rtPrn) {
                        if (prnStack[prnDp + 1]) {
                            bndCtx = bndStack[--fnDp];
                            prnStack[prnDp + 1] = false;
                        }
                        prnStart = prnInd[prnDp + 1];
                    }
                    if (prn) {
                        prnInd[prnDp + 1] = compiledPath[fnDp].length + (lftPrn ? 1 : 0);
                        if (path || rtPrn) {
                            bndCtx = bndStack[++fnDp] = {
                                bd: []
                            };
                            prnStack[prnDp + 1] = true;
                        }
                    }
                }
                compiledPath[fnDp] = (compiledPath[fnDp] || "") + full.slice(prevIndex, index);
                prevIndex = index + all.length;
                if (!aposed && !quoted) {
                    if (lftPrnFCall = lftPrn && prnStack[prnDp + 1]) {
                        compiledPath[fnDp - 1] += lftPrn;
                        compiledPathStart[fnDp - 1]++;
                    }
                    if (prn === "(" && subPath && !newOb) {
                        compiledPath[fnDp] = compiledPath[fnDp - 1].slice(prnStart) + compiledPath[fnDp];
                        compiledPath[fnDp - 1] = compiledPath[fnDp - 1].slice(0, prnStart);
                    }
                }
                compiledPath[fnDp] += lftPrnFCall ? ret.slice(1) : ret;
            }
            if (!aposed && !quoted && prn) {
                prnDp++;
                if (path && prn === "(") fnCall[prnDp] = true;
            }
            if (!aposed && !quoted && prn2) {
                if (bindings) compiledPath[fnDp] += prn;
                ret += prn;
            }
            return ret;
        }
        var named, bindto, boundName, result, quoted, aposed, bindings = pathBindings && pathBindings[0], bndCtx = {
            bd: bindings
        }, bndStack = {
            0: bndCtx
        }, paramIndex = 0, // The following are used for tracking path parsing including nested paths, such as "a.b(c^d + (e))^f", and chained computed paths such as
        // "a.b().c^d().e.f().g" - which has four chained paths, "a.b()", "^c.d()", ".e.f()" and ".g"
        prnDp = 0, fnDp = 0, prnInd = {}, prnStart = 0, prnStack = {}, fnCall = {}, pathStart = {}, compiledPathStart = {
            0: 0
        }, compiledPath = {
            0: ""
        }, prevIndex = 0;
        if (params[0] === "@") params = params.replace(rBracketQuote, ".");
        result = (params + (tmpl ? " " : "")).replace($sub.rPrm, parseTokens);
        if (bindings) result = compiledPath[0];
        return !prnDp && result || syntaxError(params); // Syntax error if unbalanced parens in params expression
    }
    function buildCode(ast, tmpl, isLinkExpr) {
        // Build the template function code from the AST nodes, and set as property on the passed-in template object
        // Used for compiling templates, and also by JsViews to build functions for data link expressions
        var i, node, tagName, converter, tagCtx, hasTag, hasEncoder, getsVal, hasCnvt, useCnvt, tmplBindings, pathBindings, params, boundOnErrStart, boundOnErrEnd, tagRender, nestedTmpls, tmplName, nestedTmpl, tagAndElses, content, markup, nextIsElse, oldCode, isElse, isGetVal, tagCtxFn, onError, tagStart, trigger, lateRender, retStrOpen, retStrClose, tmplBindingKey = 0, useViews = $subSettingsAdvanced.useViews || tmpl.useViews || tmpl.tags || tmpl.templates || tmpl.helpers || tmpl.converters, code = "", tmplOptions = {}, l = ast.length;
        if (typeof tmpl === STRING) {
            tmplName = isLinkExpr ? 'data-link="' + tmpl.replace(rNewLine, " ").slice(1, -1) + '"' : tmpl;
            tmpl = 0;
        } else {
            tmplName = tmpl.tmplName || "unnamed";
            if (tmpl.allowCode) tmplOptions.allowCode = true;
            if (tmpl.debug) tmplOptions.debug = true;
            tmplBindings = tmpl.bnds;
            nestedTmpls = tmpl.tmpls;
        }
        for(i = 0; i < l; i++){
            // AST nodes: [0: tagName, 1: converter, 2: content, 3: params, 4: code, 5: onError, 6: trigger, 7:pathBindings, 8: contentMarkup]
            node = ast[i];
            // Add newline for each callout to t() c() etc. and each markup string
            if (typeof node === STRING) // a markup string to be inserted
            code += '+"' + node + '"';
            else {
                // a compiled tag expression to be inserted
                tagName = node[0];
                if (tagName === "*") // Code tag: {{* }}
                code += ";\n" + node[1] + "\nret=ret";
                else {
                    converter = node[1];
                    content = !isLinkExpr && node[2];
                    tagCtx = paramStructure(node[3], params = node[4]);
                    trigger = node[6];
                    lateRender = node[7];
                    if (node[8]) {
                        retStrOpen = "\nvar ob,ltOb={},ctxs=";
                        retStrClose = ";\nctxs.lt=ltOb.lt;\nreturn ctxs;";
                    } else {
                        retStrOpen = "\nreturn ";
                        retStrClose = "";
                    }
                    markup = node[10] && node[10].replace(rUnescapeQuotes, "$1");
                    if (isElse = tagName === "else") {
                        if (pathBindings) pathBindings.push(node[9]);
                    } else {
                        onError = node[5] || $subSettings.debugMode !== false && "undefined"; // If debugMode not false, set default onError handler on tag to "undefined" (see onRenderError)
                        if (tmplBindings && (pathBindings = node[9])) {
                            pathBindings = [
                                pathBindings
                            ];
                            tmplBindingKey = tmplBindings.push(1); // Add placeholder in tmplBindings for compiled function
                        }
                    }
                    useViews = useViews || params[1] || params[2] || pathBindings || /view.(?!index)/.test(params[0]);
                    // useViews is for perf optimization. For render() we only use views if necessary - for the more advanced scenarios.
                    // We use views if there are props, contextual properties or args with #... (other than #index) - but you can force
                    // using the full view infrastructure, (and pay a perf price) by opting in: Set useViews: true on the template, manually...
                    if (isGetVal = tagName === ":") {
                        if (converter) tagName = converter === HTML ? ">" : converter + tagName;
                    } else {
                        if (content) {
                            // Create template object for nested template
                            nestedTmpl = tmplObject(markup, tmplOptions);
                            nestedTmpl.tmplName = tmplName + "/" + tagName;
                            // Compile to AST and then to compiled function
                            nestedTmpl.useViews = nestedTmpl.useViews || useViews;
                            buildCode(content, nestedTmpl);
                            useViews = nestedTmpl.useViews;
                            nestedTmpls.push(nestedTmpl);
                        }
                        if (!isElse) {
                            // This is not an else tag.
                            tagAndElses = tagName;
                            useViews = useViews || tagName && (!$tags[tagName] || !$tags[tagName].flow);
                            // Switch to a new code string for this bound tag (and its elses, if it has any) - for returning the tagCtxs array
                            oldCode = code;
                            code = "";
                        }
                        nextIsElse = ast[i + 1];
                        nextIsElse = nextIsElse && nextIsElse[0] === "else";
                    }
                    tagStart = onError ? ";\ntry{\nret+=" : "\n+";
                    boundOnErrStart = "";
                    boundOnErrEnd = "";
                    if (isGetVal && (pathBindings || trigger || converter && converter !== HTML || lateRender)) {
                        // For convertVal we need a compiled function to return the new tagCtx(s)
                        tagCtxFn = new Function("data,view,j", "// " + tmplName + " " + ++tmplBindingKey + " " + tagName + retStrOpen + "{" + tagCtx + "};" + retStrClose);
                        tagCtxFn._er = onError;
                        tagCtxFn._tag = tagName;
                        tagCtxFn._bd = !!pathBindings; // data-linked tag {^{.../}}
                        tagCtxFn._lr = lateRender;
                        if (isLinkExpr) return tagCtxFn;
                        setPaths(tagCtxFn, pathBindings);
                        tagRender = 'c("' + converter + '",view,';
                        useCnvt = true;
                        boundOnErrStart = tagRender + tmplBindingKey + ",";
                        boundOnErrEnd = ")";
                    }
                    code += isGetVal ? (isLinkExpr ? (onError ? "try{\n" : "") + "return " : tagStart) + (useCnvt // Call _cnvt if there is a converter: {{cnvt: ... }} or {^{cnvt: ... }}
                     ? (useCnvt = undefined, useViews = hasCnvt = true, tagRender + (tagCtxFn ? (tmplBindings[tmplBindingKey - 1] = tagCtxFn, tmplBindingKey // Store the compiled tagCtxFn in tmpl.bnds, and pass the key to convertVal()
                    ) : "{" + tagCtx + "}") + ")") : tagName === ">" ? (hasEncoder = true, "h(" + params[0] + ")") : (getsVal = true, "((v=" + params[0] + ')!=null?v:' + (isLinkExpr ? 'null)' : '"")'))) : (hasTag = true, "\n{view:view,content:false,tmpl:" // Add this tagCtx to the compiled code for the tagCtxs to be passed to renderTag()
                     + (content ? nestedTmpls.length : "false") + "," // For block tags, pass in the key (nestedTmpls.length) to the nested content template
                     + tagCtx + "},");
                    if (tagAndElses && !nextIsElse) {
                        // This is a data-link expression or an inline tag without any elses, or the last {{else}} of an inline tag
                        // We complete the code for returning the tagCtxs array
                        code = "[" + code.slice(0, -1) + "]";
                        tagRender = 't("' + tagAndElses + '",view,this,';
                        if (isLinkExpr || pathBindings) {
                            // This is a bound tag (data-link expression or inline bound tag {^{tag ...}}) so we store a compiled tagCtxs function in tmp.bnds
                            code = new Function("data,view,j", " // " + tmplName + " " + tmplBindingKey + " " + tagAndElses + retStrOpen + code + retStrClose);
                            code._er = onError;
                            code._tag = tagAndElses;
                            if (pathBindings) setPaths(tmplBindings[tmplBindingKey - 1] = code, pathBindings);
                            code._lr = lateRender;
                            if (isLinkExpr) return code; // For a data-link expression we return the compiled tagCtxs function
                            boundOnErrStart = tagRender + tmplBindingKey + ",undefined,";
                            boundOnErrEnd = ")";
                        }
                        // This is the last {{else}} for an inline tag.
                        // For a bound tag, pass the tagCtxs fn lookup key to renderTag.
                        // For an unbound tag, include the code directly for evaluating tagCtxs array
                        code = oldCode + tagStart + tagRender + (pathBindings && tmplBindingKey || code) + ")";
                        pathBindings = 0;
                        tagAndElses = 0;
                    }
                    if (onError && !nextIsElse) {
                        useViews = true;
                        code += ';\n}catch(e){ret' + (isLinkExpr ? "urn " : "+=") + boundOnErrStart + 'j._err(e,view,' + onError + ')' + boundOnErrEnd + ';}' + (isLinkExpr ? "" : '\nret=ret');
                    }
                }
            }
        }
        // Include only the var references that are needed in the code
        code = "// " + tmplName + (tmplOptions.debug ? "\ndebugger;" : "") + "\nvar v" + (hasTag ? ",t=j._tag" : "" // has tag
        ) + (hasCnvt ? ",c=j._cnvt" : "" // converter
        ) + (hasEncoder ? ",h=j._html" : "" // html converter
        ) + (isLinkExpr ? (node[8] // late @... path?
         ? ", ob" : "") + ";\n" : ',ret=""') + code + (isLinkExpr ? "\n" : ";\nreturn ret;");
        try {
            code = new Function("data,view,j", code);
        } catch (e) {
            syntaxError("Compiled template code:\n\n" + code + '\n: "' + (e.message || e) + '"');
        }
        if (tmpl) {
            tmpl.fn = code;
            tmpl.useViews = !!useViews;
        }
        return code;
    }
    //==========
    // Utilities
    //==========
    // Merge objects, in particular contexts which inherit from parent contexts
    function extendCtx(context, parentContext) {
        // Return copy of parentContext, unless context is defined and is different, in which case return a new merged context
        // If neither context nor parentContext are defined, return undefined
        return context && context !== parentContext ? parentContext ? $extend($extend({}, parentContext), context) : context : parentContext && $extend({}, parentContext);
    }
    function getTargetProps(source, tagCtx) {
        // this pointer is theMap - which has tagCtx.props too
        // arguments: tagCtx.args.
        var key, prop, map = tagCtx.map, propsArr = map && map.propsArr;
        if (!propsArr) {
            propsArr = [];
            if (typeof source === OBJECT || $isFunction(source)) for(key in source){
                prop = source[key];
                if (key !== $expando && source.hasOwnProperty(key) && (!tagCtx.props.noFunctions || !$.isFunction(prop))) propsArr.push({
                    key: key,
                    prop: prop
                });
            }
            if (map) map.propsArr = map.options && propsArr; // If bound {^{props}} and not isRenderCall, store propsArr on map (map.options is defined only for bound, && !isRenderCall)
        }
        return getTargetSorted(propsArr, tagCtx); // Obtains map.tgt, by filtering, sorting and splicing the full propsArr
    }
    function getTargetSorted(value, tagCtx) {
        // getTgt
        var mapped, start, end, tag = tagCtx.tag, props = tagCtx.props, propParams = tagCtx.params.props, filter = props.filter, sort = props.sort, directSort = sort === true, step = parseInt(props.step), reverse = props.reverse ? -1 : 1;
        if (!$isArray(value)) return value;
        if (directSort || sort && typeof sort === STRING) {
            // Temporary mapped array holds objects with index and sort-value
            mapped = value.map(function(item, i) {
                item = directSort ? item : getPathObject(item, sort);
                return {
                    i: i,
                    v: typeof item === STRING ? item.toLowerCase() : item
                };
            });
            // Sort mapped array
            mapped.sort(function(a, b) {
                return a.v > b.v ? reverse : a.v < b.v ? -reverse : 0;
            });
            // Map to new array with resulting order
            value = mapped.map(function(item) {
                return value[item.i];
            });
        } else if ((sort || reverse < 0) && !tag.dataMap) value = value.slice(); // Clone array first if not already a new array
        if ($isFunction(sort)) value = value.sort(function() {
            return sort.apply(tagCtx, arguments);
        });
        if (reverse < 0 && (!sort || $isFunction(sort))) value = value.reverse();
        if (value.filter && filter) {
            value = value.filter(filter, tagCtx);
            if (tagCtx.tag.onFilter) tagCtx.tag.onFilter(tagCtx);
        }
        if (propParams.sorted) {
            mapped = sort || reverse < 0 ? value : value.slice();
            if (tag.sorted) $.observable(tag.sorted).refresh(mapped); // Note that this might cause the start and end props to be modified - e.g. by pager tag control
            else tagCtx.map.sorted = mapped;
        }
        start = props.start; // Get current value - after possible changes triggered by tag.sorted refresh() above
        end = props.end;
        if (propParams.start && start === undefined || propParams.end && end === undefined) start = end = 0;
        if (!isNaN(start) || !isNaN(end)) {
            start = +start || 0;
            end = end === undefined || end > value.length ? value.length : +end;
            value = value.slice(start, end);
        }
        if (step > 1) {
            start = 0;
            end = value.length;
            mapped = [];
            for(; start < end; start += step)mapped.push(value[start]);
            value = mapped;
        }
        if (propParams.paged && tag.paged) $observable(tag.paged).refresh(value);
        return value;
    }
    /** Render the template as a string, using the specified data and helpers/context
* $("#tmpl").render()
*
* @param {any}        data
* @param {hash}       [helpersOrContext]
* @param {boolean}    [noIteration]
* @returns {string}   rendered template
*/ function $fnRender(data, context, noIteration) {
        var tmplElem = this.jquery && (this[0] || error('Unknown template')), tmpl = tmplElem.getAttribute(tmplAttr);
        return renderContent.call(tmpl && $.data(tmplElem)[jsvTmpl] || $templates(tmplElem), data, context, noIteration);
    }
    //========================== Register converters ==========================
    function getCharEntity(ch) {
        // Get character entity for HTML, Attribute and optional data encoding
        return charEntities[ch] || (charEntities[ch] = "&#" + ch.charCodeAt(0) + ";");
    }
    function getCharFromEntity(match, token) {
        // Get character from HTML entity, for optional data unencoding
        return charsFromEntities[token] || "";
    }
    function htmlEncode(text) {
        // HTML encode: Replace < > & ' " ` etc. by corresponding entities.
        return text != undefined ? rIsHtml.test(text) && ("" + text).replace(rHtmlEncode, getCharEntity) || text : "";
    }
    function dataEncode(text) {
        // Encode just < > and & - intended for 'safe data' along with {{:}} rather than {{>}}
        return typeof text === STRING ? text.replace(rDataEncode, getCharEntity) : text;
    }
    function dataUnencode(text) {
        // Unencode just < > and & - intended for 'safe data' along with {{:}} rather than {{>}}
        return typeof text === STRING ? text.replace(rDataUnencode, getCharFromEntity) : text;
    }
    //========================== Initialize ==========================
    $sub = $views.sub;
    $viewsSettings = $views.settings;
    if (!(jsr || $ && $.render)) {
        // JsRender/JsViews not already loaded (or loaded without jQuery, and we are now moving from jsrender namespace to jQuery namepace)
        for(jsvStoreName in jsvStores)registerStore(jsvStoreName, jsvStores[jsvStoreName]);
        $converters = $views.converters;
        $helpers = $views.helpers;
        $tags = $views.tags;
        $sub._tg.prototype = {
            baseApply: baseApply,
            cvtArgs: convertArgs,
            bndArgs: convertBoundArgs,
            ctxPrm: contextParameter
        };
        topView = $sub.topView = new View();
        //BROWSER-SPECIFIC CODE
        if ($) {
            ////////////////////////////////////////////////////////////////////////////////////////////////
            // jQuery (= $) is loaded
            $.fn.render = $fnRender;
            $expando = $.expando;
            if ($.observable) {
                if (versionNumber !== (versionNumber = $.views.jsviews)) // Different version of jsRender was loaded
                throw "jquery.observable.js requires jsrender.js " + versionNumber;
                $extend($sub, $.views.sub); // jquery.observable.js was loaded before jsrender.js
                $views.map = $.views.map;
            }
        } else {
            ////////////////////////////////////////////////////////////////////////////////////////////////
            // jQuery is not loaded.
            $ = {};
            if (setGlobals) global.jsrender = $; // We are loading jsrender.js from a script element, not AMD or CommonJS, so set global
            // Error warning if jsrender.js is used as template engine on Node.js (e.g. Express or Hapi...)
            // Use jsrender-node.js instead...
            $.renderFile = $.__express = $.compile = function() {
                throw "Node.js: use npm jsrender, or jsrender-node.js";
            };
            //END BROWSER-SPECIFIC CODE
            $.isFunction = function(ob) {
                return typeof ob === "function";
            };
            $.isArray = Array.isArray || function(obj) {
                return ({}).toString.call(obj) === "[object Array]";
            };
            $sub._jq = function(jq) {
                if (jq !== $) {
                    $extend(jq, $); // map over from jsrender namespace to jQuery namespace
                    $ = jq;
                    $.fn.render = $fnRender;
                    delete $.jsrender;
                    $expando = $.expando;
                }
            };
            $.jsrender = versionNumber;
        }
        $subSettings = $sub.settings;
        $subSettings.allowCode = false;
        $isFunction = $.isFunction;
        $.render = $render;
        $.views = $views;
        $.templates = $templates = $views.templates;
        for(setting in $subSettings)addSetting(setting);
        /**
	* $.views.settings.debugMode(true)
	* @param {boolean} debugMode
	* @returns {Settings}
	*
	* debugMode = $.views.settings.debugMode()
	* @returns {boolean}
	*/ ($viewsSettings.debugMode = function(debugMode) {
            return debugMode === undefined ? $subSettings.debugMode : ($subSettings._clFns && $subSettings._clFns(), $subSettings.debugMode = debugMode, $subSettings.onError = typeof debugMode === STRING ? function() {
                return debugMode;
            } : $isFunction(debugMode) ? debugMode : undefined, $viewsSettings);
        })(false); // jshint ignore:line
        $subSettingsAdvanced = $subSettings.advanced = {
            cache: true,
            useViews: false,
            _jsv: false // For global access to JsViews store
        };
        //========================== Register tags ==========================
        $tags({
            "if": {
                render: function(val) {
                    // This function is called once for {{if}} and once for each {{else}}.
                    // We will use the tag.rendering object for carrying rendering state across the calls.
                    // If not done (a previous block has not been rendered), look at expression for this block and render the block if expression is truthy
                    // Otherwise return ""
                    var self = this, tagCtx = self.tagCtx, ret = self.rendering.done || !val && (tagCtx.args.length || !tagCtx.index) ? "" : (self.rendering.done = true, self.selected = tagCtx.index, undefined); // Test is satisfied, so render content on current context
                    return ret;
                },
                contentCtx: true,
                flow: true
            },
            "for": {
                sortDataMap: dataMap(getTargetSorted),
                init: function(val, cloned) {
                    this.setDataMap(this.tagCtxs);
                },
                render: function(val) {
                    // This function is called once for {{for}} and once for each {{else}}.
                    // We will use the tag.rendering object for carrying rendering state across the calls.
                    var value, filter, srtField, isArray, i, sorted, end, step, self = this, tagCtx = self.tagCtx, range = tagCtx.argDefault === false, props = tagCtx.props, iterate = range || tagCtx.args.length, result = "", done = 0;
                    if (!self.rendering.done) {
                        value = iterate ? val : tagCtx.view.data; // For the final else, defaults to current data without iteration.
                        if (range) {
                            range = props.reverse ? "unshift" : "push";
                            end = +props.end;
                            step = +props.step || 1;
                            value = []; // auto-create integer array scenario of {{for start=xxx end=yyy}}
                            for(i = +props.start || 0; (end - i) * step > 0; i += step)value[range](i);
                        }
                        if (value !== undefined) {
                            isArray = $isArray(value);
                            result += tagCtx.render(value, !iterate || props.noIteration);
                            // Iterates if data is an array, except on final else - or if noIteration property
                            // set to true. (Use {{include}} to compose templates without array iteration)
                            done += isArray ? value.length : 1;
                        }
                        if (self.rendering.done = done) self.selected = tagCtx.index;
                    // If nothing was rendered we will look at the next {{else}}. Otherwise, we are done.
                    }
                    return result;
                },
                setDataMap: function(tagCtxs) {
                    var tagCtx, props, paramsProps, self = this, l = tagCtxs.length;
                    while(l--){
                        tagCtx = tagCtxs[l];
                        props = tagCtx.props;
                        paramsProps = tagCtx.params.props;
                        tagCtx.argDefault = props.end === undefined || tagCtx.args.length > 0; // Default to #data except for auto-create range scenario {{for start=xxx end=yyy step=zzz}}
                        props.dataMap = tagCtx.argDefault !== false && $isArray(tagCtx.args[0]) && (paramsProps.sort || paramsProps.start || paramsProps.end || paramsProps.step || paramsProps.filter || paramsProps.reverse || props.sort || props.start || props.end || props.step || props.filter || props.reverse) && self.sortDataMap;
                    }
                },
                flow: true
            },
            props: {
                baseTag: "for",
                dataMap: dataMap(getTargetProps),
                init: noop,
                flow: true
            },
            include: {
                flow: true
            },
            "*": {
                // {{* code... }} - Ignored if template.allowCode and $.views.settings.allowCode are false. Otherwise include code in compiled template
                render: retVal,
                flow: true
            },
            ":*": {
                // {{:* returnedExpression }} - Ignored if template.allowCode and $.views.settings.allowCode are false. Otherwise include code in compiled template
                render: retVal,
                flow: true
            },
            dbg: $helpers.dbg = $converters.dbg = dbgBreak // Register {{dbg/}}, {{dbg:...}} and ~dbg() to throw and catch, as breakpoints for debugging.
        });
        $converters({
            html: htmlEncode,
            attr: htmlEncode,
            encode: dataEncode,
            unencode: dataUnencode,
            url: function(text) {
                // URL encoding helper.
                return text != undefined ? encodeURI("" + text) : text === null ? text : ""; // null returns null, e.g. to remove attribute. undefined returns ""
            }
        });
    }
    //========================== Define default delimiters ==========================
    $subSettings = $sub.settings;
    $isArray = ($ || jsr).isArray;
    $viewsSettings.delimiters("{{", "}}", "^");
    if (jsrToJq) jsr.views.sub._jq($);
    return $ || jsr;
}, window);

});


var $hzVqu = parcelRequire("hzVqu");
parcelRequire("bNuNE");

var $6YELt = parcelRequire("6YELt");

var $fJMvN = parcelRequire("fJMvN");

var $3Cbif = parcelRequire("3Cbif");

var $6WhLd = parcelRequire("6WhLd");

var $3zknA = parcelRequire("3zknA");

var $j7etR = parcelRequire("j7etR");

var $hzVqu = parcelRequire("hzVqu");
class $daa5e4a06b00f78d$export$2e2bcd8739ae039 {
    constructor(file){
        this.file = file;
        this.progressListener = null;
        this.xhr = null;
    }
    get type() {
        return this.file.type;
    }
    get size() {
        return this.file.size;
    }
    get name() {
        return this.file.name;
    }
    cancel() {
        if (this.xhr != null) this.xhr.abort();
    }
    doUpload(url) {
        return new Promise((resolve, reject)=>{
            const formData = new FormData();
            // add assoc key values, this will be posts values
            formData.append("file", this.file, this.name);
            formData.append("upload_file", "true");
            this.xhr = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).ajax({
                type: "POST",
                url: url,
                xhr: ()=>{
                    const myXhr = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).ajaxSettings.xhr();
                    if (myXhr.upload) myXhr.upload.addEventListener('progress', this.progressHandling.bind(this), false);
                    return myXhr;
                },
                success: function(data) {
                    resolve(data);
                },
                error: function(error) {
                    reject(error);
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false
            });
        });
    }
    progressHandling(event) {
        if (this.progressListener == null) return;
        let position = event.loaded || event.position;
        let total = event.total;
        this.progressListener(position, total);
    }
}


const $d90a0f0c20124a5e$var$ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};
function $d90a0f0c20124a5e$export$4cf11838cdc2a8a8(string) {
    return String(string).replace(/[&<>"'`=\/]/g, function(s) {
        return $d90a0f0c20124a5e$var$ENTITIES[s];
    });
}



var $az74n = parcelRequire("az74n");

(parcelRequire("h5I8q"))((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))));
// const log = console.log;
const $5c068f572b6fdaf9$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).noop;
function $5c068f572b6fdaf9$var$_joinLowerCaseStartingLinesOfText(plainText) {
    const lines = [];
    let line = '';
    for(let i = 0; i < plainText.length; ++i){
        const ch = plainText[i];
        if (ch === '\r') continue;
        if (ch === '\n') {
            lines.push(line);
            line = '';
        } else line += ch;
    }
    if (line.length > 0) lines.push(line);
    $5c068f572b6fdaf9$var$_joinLowerCaseStartingLinesOfArray(lines);
    return lines.join('\n');
}
function $5c068f572b6fdaf9$var$_joinLowerCaseStartingLinesOfArray(lines) {
    const lowerCaseStartTester = $5c068f572b6fdaf9$var$_lowerCaseStartTester();
    for(let ri = lines.length - 1; ri > 0; --ri){
        const line = lines[ri];
        if (lines[ri - 1].length > 0 && lowerCaseStartTester(line)) {
            lines[ri - 1] += ' ' + line;
            lines.splice(ri, 1);
        }
    }
    return lines;
}
function $5c068f572b6fdaf9$var$_lowerCaseStartTester() {
    const firstSymbolGetter = /^\s*(.)/;
    return function(s) {
        if (s === null || s.length === 0) return false;
        const match = firstSymbolGetter.exec(s);
        if (match) {
            const firstChar = match[1];
            return firstChar !== firstChar.toUpperCase();
        }
        return false;
    };
}
function $5c068f572b6fdaf9$var$_dashRegex() {
    const e = $5c068f572b6fdaf9$var$_escapeRegexPattern;
    /// /[‐‑‒–—―]+/
    return new RegExp('[' + [
        "\u2010",
        "\u2011",
        '-',
        "\u2012",
        "\u2013",
        "\u2014",
        "\u2015",
        "\u2212"
    ].map(e).join('') + ']+');
}
function $5c068f572b6fdaf9$var$_escapeRegex(s) {
    if (s !== null && s.length > 0) return new RegExp($5c068f572b6fdaf9$var$_escapeRegexPattern(s));
    return null;
}
function $5c068f572b6fdaf9$var$_escapeRegexPattern(s) {
    if (s !== null && s.length > 0) return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    return s;
}
const $5c068f572b6fdaf9$var$LIST_ITEM_TMPL = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="fl-form-cards__li" data-card="{{:index}}">
    <div class="fl-form-cards__card panel">
        <div class="fl-form-cards__index"></div>
        <div class="fl-form-cards__faces row">
            {{if card}}<input type="hidden" name="cards[{{:index}}].card" value="{{:card}}">{{/if}}
            {{if version}}<input type="hidden" name="cards[{{:index}}].version" value="{{:version}}">{{/if}}
            <div class="col-md-6 fl-form-cards__face-side">
                    <div class="fl-form-cards__side-input">
                        <input type="hidden" name="cards[{{:index}}].faceH"  value="{{:faceH}}">
                        <textarea class="form-control fl-form-cards__face-text {{if faceError}}is-invalid{{/if}}" style="display: none;" name="cards[{{:index}}].face" placeholder="{{>~l18n.get('packEditor.card.term.placeholder')}}" data-autoresize rows="1">{{>face}}</textarea>
                        {{if faceError}}<div class="invalid-feedback">{{>faceError}}</div>{{/if}}
                        
                        {{if faceAudio}}<div class="fl-form-cards__side-audio">
                                    <input type="hidden" name="cards[{{:index}}].faceAudio" value="{{attr:faceAudio}}">
                                    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
                                    <audio src="{{attr:faceAudioSrc}}"></audio>
                                </div>{{/if}}
                    </div>
                    {{if faceImage}}<div class="fl-form-cards__side-picture">
                            <input type="hidden" name="cards[{{:index}}].faceImage" value="{{attr:faceImage}}">
                            <img src="{{attr:faceImageSrc}}" alt="">
                        </div>{{/if}}
                    <div class="fl-form-cards__face-buttons">
                        <button type="button" class="btn btn-sm" data-handler="selectFaceImage"><span class="fc fc-image"></span></button>
                        <button type="button" class="btn btn-sm" data-handler="selectFaceAudio"><span class="far fa-microphone"></span></button>
                    </div>
            </div>
            <div class="col-md-6 fl-form-cards__back-side fl-form-cards__back-side--sm-bl">
                    <div class="fl-form-cards__side-input">
                        <input type="hidden" name="cards[{{:index}}].backH"  value="{{:backH}}">
                        <textarea class="form-control fl-form-cards__back-text {{if backError}}is-invalid{{/if}}" style="display: none;" name="cards[{{:index}}].back" placeholder="{{>~l18n.get('packEditor.card.def.placeholder')}}" data-autoresize rows="1">{{>back}}</textarea>
                        {{if backError}}<div class="invalid-feedback">{{>backError}}</div>{{/if}}
                        
                        {{if backAudio}}
                                <div class="fl-form-cards__side-audio">
                                    <input type="hidden" name="cards[{{:index}}].backAudio" value="{{attr:backAudio}}">
                                    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
                                    <audio src="{{attr:backAudioSrc}}"></audio>
                                </div>
                        {{/if}}
                    </div>
                    {{if backImage}}
                        <div class="fl-form-cards__side-picture">
                            <input type="hidden" name="cards[{{:index}}].backImage" value="{{attr:backImage}}">
                            <img src="{{attr:backImageSrc}}" alt="">
                        </div>
                    {{/if}}
                    <div class="fl-form-cards__back-buttons">
                        <button type="button" class="btn btn-sm" data-handler="selectBackImage"><span class="fc fc-image"></span></button>
                        <button type="button" class="btn btn-sm" data-handler="selectBackAudio"><span class="far fa-microphone"></span></button>
                    </div>
            </div>
        </div>
    </div>
    <div class="fl-form-cards__delete">
        <button type="button" class="btn btn-lg btn-default text-muted" data-handler="remove" title="Remove this card"><span class="far fa-times-circle"></span></button>
    </div>
</div>
`);
function $5c068f572b6fdaf9$var$textareaLength(jqTextarea) {
    const val = jqTextarea.val();
    return typeof val === 'string' ? val.length : 0;
}
class $5c068f572b6fdaf9$var$ListEditor {
    constructor(l18n){
        this.l18n = l18n;
        this.list = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#cardList');
        this.seed = 0;
        this.bubbleMenuPlace = null;
        const self = this;
        this.list.on('hastext', 'textarea', ()=>this.countCards()).on('notext', 'textarea', ()=>this.countCards()).on('click', 'button[data-handler=remove]', function() {
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).closest('div.fl-form-cards__li');
            li.slideUp(li.remove.bind(li));
        }).on('click', 'button[data-handler=selectFaceImage]', function() {
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).closest('div.fl-form-cards__li');
            self.selectFaceImage(li.data('card'));
        }).on('click', 'button[data-handler=selectFaceAudio]', function() {
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).closest('div.fl-form-cards__li');
            self.selectFaceAudio(li.data('card'));
        }).on('click', 'button[data-handler=selectBackImage]', function() {
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).closest('div.fl-form-cards__li');
            self.selectBackImage(li.data('card'));
        }).on('click', 'button[data-handler=selectBackAudio]', function() {
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).closest('div.fl-form-cards__li');
            self.selectBackAudio(li.data('card'));
        }).on('click', 'button[data-handler=playAudio]', function() {
            const button = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this);
            const audio = button.parent().find('audio').get(0);
            if (!button.data('subscribed')) {
                const toggle = function() {
                    button.find('span').toggleClass('fa-play-circle fa-pause-circle text-success');
                };
                audio.addEventListener('pause', ()=>{
                    $5c068f572b6fdaf9$var$log('paused');
                    toggle();
                });
                audio.addEventListener('play', ()=>{
                    $5c068f572b6fdaf9$var$log('play');
                    toggle();
                });
                button.data('subscribed', true);
            }
            if (audio.paused) audio.play();
            else audio.pause();
        }).on('input', 'textarea', function(e) {
            (0, $fJMvN.textareaAutoresizeOne)(e.currentTarget);
        }).on('focus', 'textarea', function(e) {
            (0, $fJMvN.textareaAutoresizeOne)(e.currentTarget);
        });
        this.onCardChange = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).noop;
        this.selectAudioModal_recordingOff = `
                    <span class="far fa-microphone"></span><br>
                    <div>${this.l18n.get('packEditor.audio.record')}</div>
        `;
        this.selectAudioModal_recordingOn = `
                    <span class="far fa-microphone-alt-slash"></span><br>
                    <div data-bind="timeout"></div>
        `;
        this.selectAudioModalBody = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="position-relative">
    <button class="btn position-absolute" style="top: -1rem;right: -1rem;padding: .5em;" data-click="closeDialog"><span class="far fa-times-circle"></span></button>
    <div class="mr-4">
        <input type="file" class="d-none" accept="audio/*">

        <div class="row text-center">
        {{if canRecord}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-click="recordAudio">
                    ${this.selectAudioModal_recordingOff}
                </button>
            </div>
        {{/if}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-click="chooseAudio">
                    <span class="far fa-upload"></span><br>
                    <div>${this.l18n.get('packEditor.audio.upload')}</div>                
                </button>
            </div>
        {{if canDelete}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-danger" data-click="removeAudio" title="${this.l18n.get('packEditor.audio.remove')}">
                    <span class="far fa-trash-alt"></span><br>
                    <div>${this.l18n.get('packEditor.audio.remove')}</div>
                </button>
            </div>
        {{/if}}
        </div>
    </div>
</div>
`);
        this.cardListItemAudio = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="fl-form-cards__side-audio">
    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
    <audio></audio>
</div>
`);
    }
    countCards() {
        let cardCount = 0;
        this.listItems.each(function() {
            if ($5c068f572b6fdaf9$var$ListEditor._isListItemHasData(this)) cardCount += 1;
        });
        this.onCardChange(cardCount);
        return cardCount;
    }
    get listItems() {
        return this.list.find('div[data-card]');
    }
    static _isListItemHasDataInSide(sideDiv) {
        return $5c068f572b6fdaf9$var$textareaLength(sideDiv.find('textarea.fl-form-cards__face-text')) > 0 || sideDiv.find('.fl-form-cards__side-picture').length > 0 || sideDiv.find('.fl-form-cards__side-audio').length > 0;
    }
    static _isListItemHasData(div) {
        div = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(div);
        if ($5c068f572b6fdaf9$var$ListEditor._isListItemHasDataInSide(div.find('.fl-form-cards__face-side')) || $5c068f572b6fdaf9$var$ListEditor._isListItemHasDataInSide(div.find('.fl-form-cards__back-side'))) return true;
    }
    appendEmpty() {
        this.appendRow({});
    }
    appendRow(data) {
        data.index = this.seed++;
        const html = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))($5c068f572b6fdaf9$var$LIST_ITEM_TMPL.render(data, this));
        this.list.append(html);
        this.configureCardEditor(data.index);
    }
    configureCardEditor(id) {
        (0, $az74n.configureSideTextEditor)(document.querySelector(`textarea[name="cards[${id}].face"]`));
        (0, $az74n.configureSideTextEditor)(document.querySelector(`textarea[name="cards[${id}].back"]`));
    }
    appendRowList(rowList) {
        const postOp = [];
        const html = rowList.map((row)=>{
            row.index = this.seed++;
            postOp.push(()=>this.configureCardEditor(row.index));
            return $5c068f572b6fdaf9$var$LIST_ITEM_TMPL.render(row, this);
        }).join("");
        this.list.append(html);
        postOp.forEach((f)=>f());
    }
    removeEmptyTail() {
        const items = this.listItems;
        for(let i = items.length - 1; i >= 0; --i){
            if ($5c068f572b6fdaf9$var$ListEditor._isListItemHasData(items.get(i))) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(items.get(i)).remove();
        }
    }
    clear() {
        this.list.empty();
        this.seed = 0;
    }
    /**
     *
     * @param {int} cardIndex
     * @param {jQuery} cardSide
     * @param {String} cardSideName 'back' or 'face'
     */ _selectImageDialog(cardIndex, cardSide, cardSideName) {
        const inputPrefix = `cards[${cardIndex}].${cardSideName}`;
        const imageExists = cardSide.find('.fl-form-cards__side-picture').length > 0;
        new $5c068f572b6fdaf9$var$SelectImageDialog({
            l18n: this.l18n,
            canDelete: !!imageExists,
            remove: ()=>{
                cardSide.find('.fl-form-cards__side-picture').remove();
            },
            complete: (imageSrc, imageInput, imageString)=>{
                // result.fileInput
                cardSide.find('.fl-form-cards__side-picture').remove().end().find('.fl-form-cards__side-input').after($5c068f572b6fdaf9$var$SelectImageDialog_ListItemImage.render({
                    inputPrefix: inputPrefix,
                    src: imageSrc
                }));
                if (imageInput) {
                    imageInput = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(imageInput);
                    imageInput.attr('name', `${inputPrefix}ImageF`);
                    cardSide.find('.fl-form-cards__side-picture').append(imageInput.remove());
                    imageString = 'local';
                }
                if (imageString) cardSide.find('.fl-form-cards__side-picture').append((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(`<input type="hidden" name="${inputPrefix}Image" value="${imageString}">`));
            }
        });
    }
    /**
     *
     * @param {int} cardIndex
     * @param {jQuery} cardSide
     * @param {String} cardSideName 'back' or 'face'
     */ _selectAudioDialog(cardIndex, cardSide, cardSideName) {
        const inputPrefix = `cards[${cardIndex}].${cardSideName}`;
        const cardListItemAudio = this.cardListItemAudio;
        const audioExists = cardSide.find('.fl-form-cards__side-audio').length > 0;
        function completer(modaller, audioFileInput, audioBlob) {
            // result.fileInput
            cardSide.find('.fl-form-cards__side-audio').remove().end().find('.fl-form-cards__side-input').append(cardListItemAudio.render());
            const audioContainer = cardSide.find('.fl-form-cards__side-audio');
            if (audioFileInput) {
                audioContainer.find('audio').get(0).src = URL.createObjectURL(audioFileInput.files[0]);
                audioFileInput = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(audioFileInput);
                audioFileInput.attr('name', `${inputPrefix}AudioF`);
                audioContainer.append(audioFileInput.remove());
            }
            if (audioBlob) {
                const reader = new FileReader();
                reader.onloadend = function(event) {
                    audioContainer.find('audio').get(0).src = URL.createObjectURL(audioBlob);
                    const input = document.createElement('input');
                    input.name = `${inputPrefix}AudioB`;
                    input.type = 'hidden';
                    input.value = event.target.result;
                    audioContainer.append(input);
                };
                reader.readAsDataURL(audioBlob);
            }
            modaller.close();
        }
        const dialogOptions = {
            canDelete: audioExists,
            canRecord: 'mediaDevices' in navigator && navigator.mediaDevices != null
        };
        (0, $j7etR.default).showLocal(this.selectAudioModalBody.render(dialogOptions), (modaller)=>{
            const content = modaller.content;
            const buttonRecordingOn = this.selectAudioModal_recordingOn;
            const buttonRecordingOff = this.selectAudioModal_recordingOff;
            class RecordController {
                constructor(stream){
                    this.chunks = [];
                    this._save = false;
                    this._timerEnd = null;
                    this._timer = null;
                    this.media = new MediaRecorder(stream);
                    this.media.addEventListener("dataavailable", (event)=>{
                        this.chunks.push(event.data);
                    });
                    this.media.addEventListener("stop", (event)=>{
                        $5c068f572b6fdaf9$var$log('record stop');
                        content.find('button[data-click=recordAudio]').removeClass('btn-primary').addClass('btn-outline-secondary').empty().append(buttonRecordingOff);
                        if (this._timer != null) {
                            clearInterval(this._timer);
                            this._timer = null;
                        }
                        if (this._save) modaller.close();
                        event.target.stream.getTracks().forEach((track)=>track.stop());
                        const blob = new Blob(this.chunks, {
                            type: event.target.mimeType
                        });
                        completer(modaller, null, blob);
                    });
                    this.media.addEventListener("start", ()=>{
                        $5c068f572b6fdaf9$var$log('record start');
                        content.find('button[data-click=recordAudio]').addClass('btn-primary').removeClass('btn-outline-secondary').empty().append(buttonRecordingOn);
                        const timerPlace = content.find('div[data-bind=timeout]');
                        const timerPlaceUpdate = ()=>{
                            const left = Math.ceil((this._timerEnd - Date.now()) / 1000);
                            timerPlace.text(left + ' sec');
                        };
                        this._timer = setInterval(timerPlaceUpdate, 200);
                        timerPlaceUpdate();
                    });
                }
                start(timeout) {
                    this._timerEnd = Date.now() + timeout;
                    this.media.start();
                    setTimeout(this.complete.bind(this), timeout);
                }
                _stop() {
                    if (this.media != null) {
                        this.media.stop();
                        this.media = null;
                    }
                }
                complete() {
                    if (this.media == null) return;
                    $5c068f572b6fdaf9$var$log('complete record');
                    this._save = true;
                    this._stop();
                }
                cancel() {
                    if (this.media == null) return;
                    $5c068f572b6fdaf9$var$log('cancel record');
                    this._stop();
                }
            }
            let recorder = null;
            modaller.center();
            content.find('button[data-click=closeDialog]').click(()=>{
                if (recorder != null) recorder.cancel();
                modaller.close();
            });
            // remove previous file
            content.find('button[data-click=removeAudio]').click(()=>{
                cardSide.find('.fl-form-cards__side-audio').remove();
                if (recorder != null) recorder.cancel();
                modaller.close();
            });
            // record file
            content.find('button[data-click=recordAudio]').click(()=>{
                if (recorder === null) navigator.mediaDevices.getUserMedia({
                    audio: true
                }).then((stream)=>{
                    $5c068f572b6fdaf9$var$log('recording start');
                    recorder = new RecordController(stream);
                    recorder.start(15000);
                }, (error)=>{
                    $5c068f572b6fdaf9$var$log('recording failed', error);
                    if (error.name === 'NotAllowedError') alert('Recording not allowed. Please, allow access to the microphone for this site.');
                    error.name;
                    recorder = null;
                });
                else {
                    recorder.complete();
                    recorder = null;
                }
            });
            // load local file
            const fileInput = content.find('input[type=file]');
            fileInput.change(function() {
                if (this.files && this.files[0]) completer(modaller, this, null);
            });
            content.find('button[data-click=chooseAudio]').click(()=>{
                if (recorder != null) recorder.cancel();
                fileInput.click();
            });
        });
    }
    selectFaceImage(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__face-side`);
        this._selectImageDialog(card, cardSide, 'face');
    }
    selectBackImage(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__back-side`);
        this._selectImageDialog(card, cardSide, 'back');
    }
    selectFaceAudio(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__face-side`);
        this._selectAudioDialog(card, cardSide, 'face');
    }
    selectBackAudio(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__back-side`);
        this._selectAudioDialog(card, cardSide, 'back');
    }
}
const $5c068f572b6fdaf9$var$SelectImageDialog_ModalBody = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="position-relative">
    <button class="btn position-absolute ml-3" style="top: -1rem;right: -1rem;padding: .5em;" data-click="closeDialog"><span class="far fa-times-circle"></span></button>
    <div class="form-inline">
        
        <input type="file" class="d-none" accept="image/jpeg,image/png">

        <span class="mb-3">{{>~l18n.get('packEditor.images.search')}}</span>
        <div class="input-group mb-3 mx-3">
            <input type="text" class="form-control">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" data-click="searchImage" disabled><span class="far fa-search"></span></button>
            </div>
        </div>
        <div class="mb-3">
            <span class="mr-3">{{>~l18n.get('packEditor.images.search.or')}}</span>
            <button type="button" class="btn btn-outline-secondary" data-click="chooseImage">{{>~l18n.get('packEditor.images.upload')}}</button>
        </div>
        
        {{if canDelete}}
            <div style="flex:1;" class="text-right">
                <button type="button" class="mb-3 mr-4 btn btn-outline-danger" data-click="removeImage" title="{{>~l18n.get('packEditor.images.remove')}}"><span class="far fa-trash-alt"></span></button>
            </div>
        {{/if}}
    </div>
    <div class="fl-form-select-image-gallery"></div>
</div>
`);
const $5c068f572b6fdaf9$var$SelectImageDialog_Image = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="fl-form-select-image-gallery__image">
    <button type="button" class="btn" data-data="{{attr:data}}" data-click="selectGalleryImage">
        <img src="{{attr:src}}" alt="">
    </button>
</div>
`);
const $5c068f572b6fdaf9$var$SelectImageDialog_Empty = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="fl-form-select-image-gallery--empty">
    {{>~l18n.get('packEditor.images.emptySearch')}}
</div>
`);
const $5c068f572b6fdaf9$var$SelectImageDialog_ListItemImage = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div class="fl-form-cards__side-picture">
    <img src="{{attr:src}}" alt="">
</div>
`);
const $5c068f572b6fdaf9$var$SelectImageDialog_PackImage = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<span class="fl-va-helper"></span>
<img src="{{attr:src}}" alt="">
`);
class $5c068f572b6fdaf9$var$SelectImageDialog {
    constructor(opts){
        const renderContext = {
            l18n: opts.l18n
        };
        const canDelete = !!opts.canDelete;
        const complete = opts.complete || (0, $3zknA.noop);
        const remove = opts.remove || (0, $3zknA.noop);
        (0, $j7etR.default).showLocal($5c068f572b6fdaf9$var$SelectImageDialog_ModalBody.render({
            canDelete: canDelete
        }, renderContext), (modaller)=>{
            const content = modaller.content;
            modaller.center();
            modaller.addDialogClass('modal-lg');
            modaller.addBodyClass('pb-0');
            content.find('button[data-click=closeDialog]').click(()=>{
                modaller.close();
            });
            // remove previous file
            content.find('button[data-click=removeImage]').click(()=>{
                remove();
                modaller.close();
            });
            // search remote file
            const searchInput = content.find('input[type=text]');
            const searchButton = content.find('button[data-click=searchImage]');
            searchInput.on('textchange', function() {
                searchButton.prop('disabled', this.value.trim().length === 0);
            });
            searchInput.on('keypress', function(e) {
                if ((0, $3zknA.isEnterEvent)(e) && !searchButton.prop('disabled')) searchButton.click();
            });
            searchButton.click(function() {
                const button = new (0, $3Cbif.default)(this);
                button.progress = true;
                const params = {
                    method: 'flickr.photos.search',
                    api_key: '17d2fd46fcc0c2f65be945e5d05a01f5',
                    text: searchInput.val().trim(),
                    sort: 'relevance',
                    privacy_filter: 1,
                    safe_search: 1,
                    media: 'photos',
                    format: 'json',
                    nojsoncallback: 1,
                    per_page: 20
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).getJSON('https://api.flickr.com/services/rest/', params, (res)=>{
                    const gallery = content.find('.fl-form-select-image-gallery').empty();
                    if (res && res.photos && res.photos.pages) {
                        const html = res.photos.photo.map((el)=>{
                            return {
                                data: `flickr:${el.farm}/${el.server}/${el.id}/${el.secret}`,
                                src: `https://farm${el.farm}.staticflickr.com/${el.server}/${el.id}_${el.secret}_m.jpg`
                            };
                        }).map((el)=>$5c068f572b6fdaf9$var$SelectImageDialog_Image.render(el)).join('');
                        gallery.append(html);
                    } else gallery.append($5c068f572b6fdaf9$var$SelectImageDialog_Empty.render({}, renderContext));
                    gallery.get(0).scrollLeft = 0;
                    button.progress = false;
                    modaller.handleUpdate();
                });
            });
            content.on('click', 'button[data-click=selectGalleryImage]', function() {
                const btn = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this), data = btn.data('data'), src = btn.find('img').attr('src');
                complete(src, null, data);
                modaller.close();
            });
            // load local file
            const fileInput = content.find('input[type=file]');
            fileInput.change(function() {
                if (this.files && this.files[0]) {
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        complete(e.target.result, fileInput);
                        modaller.close();
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            });
            content.find('button[data-click=chooseImage]').click(()=>{
                fileInput.click();
            });
            modaller.addShowListener(function() {
                searchInput.focus();
            });
        });
    }
}
class $5c068f572b6fdaf9$var$TextImport {
    constructor(){
        this.mode = '';
        this.ldLine = false;
        this.ldDoubleLine = false;
        this.ldJoinLowercase = false;
        this.ldCustom = false;
        this.ldCustomSymbol = '';
        this.tdDash = false;
        this.tdTab = false;
        this.tdCustom = false;
        this.tdCustomSymbol = '';
        this.llDoubleLine = false;
        this.llJoinLowercase = false;
    }
    _createLineByLineLineReader(pairReceiver) {
        const llDoubleLine = this.llDoubleLine;
        return (textContent)=>{
            if (this.llJoinLowercase) textContent = $5c068f572b6fdaf9$var$_joinLowerCaseStartingLinesOfText(textContent);
            let key = '';
            let value = '';
            let acceptor = keyConsumer;
            let newLines = 0;
            function pushLine() {
                acceptor = keyConsumer;
                pairReceiver(key, value);
                key = '';
                value = '';
            }
            function valueConsumer(ch, newLine) {
                if (newLine && !llDoubleLine) {
                    pushLine();
                    return;
                }
                if (newLine && llDoubleLine && newLines === 2) {
                    pushLine();
                    return;
                }
                value += ch;
            }
            function keyConsumer(ch, newLine) {
                if (newLine && key.length === 0) return;
                if (newLine) acceptor = valueConsumer;
                else key += ch;
            }
            for(let i = 0; i < textContent.length; ++i){
                const ch = textContent[i];
                if (ch === '\r') continue;
                if (ch === '\n') newLines += 1;
                else newLines = 0;
                acceptor(ch, ch === '\n');
            }
            pushLine();
        };
    }
    _createEveryLineLineReader(lineReceiver) {
        const eol = /\n$/;
        const eol2 = /\n\n$/;
        const custom = this.ldCustom ? $5c068f572b6fdaf9$var$_escapeRegex(this.ldCustomSymbol) : null;
        return (textContent)=>{
            if (this.ldJoinLowercase) textContent = $5c068f572b6fdaf9$var$_joinLowerCaseStartingLinesOfText(textContent);
            let line = '';
            const lines = [];
            function pushLine(trimEndSymbols) {
                const candidate = trimEndSymbols > 0 ? line.slice(0, -trimEndSymbols) : line;
                if (candidate.length > 0) lines.push(candidate);
                line = '';
            }
            for(let i = 0; i < textContent.length; ++i){
                const ch = textContent[i];
                if (ch === '\r') continue;
                line += ch;
                if (this.ldLine && eol.test(line)) pushLine(1);
                else if (this.ldDoubleLine && eol2.test(line)) pushLine(2);
                else if (custom !== null && custom.test(line)) pushLine(this.ldCustomSymbol.length);
            }
            pushLine(0);
            lines.forEach(lineReceiver);
        };
    }
    _createEveryLinePairReader(pairReceiver) {
        const tab = this.tdTab ? /\t+/ : null;
        const dash = this.tdDash ? $5c068f572b6fdaf9$var$_dashRegex() : null;
        const custom = this.tdCustom ? $5c068f572b6fdaf9$var$_escapeRegex(this.tdCustomSymbol) : null;
        function pushPairMatch(line, match) {
            if (match === null) return false;
            const matchLength = match[0].length;
            const matchIndex = match.index;
            const key = line.substring(0, matchIndex).trim();
            const value = line.substring(matchIndex + matchLength).trim();
            if (key.length > 0 && value.length > 0) {
                pairReceiver(key, value);
                return true;
            }
            return false;
        }
        return (line)=>{
            if (tab !== null && pushPairMatch(line, tab.exec(line))) return;
            if (dash !== null && pushPairMatch(line, dash.exec(line))) return;
            if (custom !== null) pushPairMatch(line, custom.exec(line));
        };
    }
    _createTextNormalizer() {
        const ops = [];
        // trim end space
        ops.push((s)=>s.replace(/[\n\s]+$/, ''));
        // trim head space
        ops.push((s)=>s.replace(/^[\n\s]+/, ''));
        // remove new lines
        ops.push((s)=>s.replace(/\n+/, ' '));
        // remove space before comma
        ops.push((s)=>s.replace(/\s+,/, ','));
        // final
        return (s)=>{
            let out = s;
            for(let i = 0; out !== null && i < ops.length; ++i)out = ops[i](out);
            return out;
        };
    }
    parse(textContent, pairReceiver) {
        const n = this._createTextNormalizer();
        const localPairReceiver = (key, value)=>{
            const cleanKey = n(key);
            const cleanValue = n(value);
            if (cleanKey !== null && cleanKey.length > 0 && cleanValue !== null && cleanValue.length > 0) pairReceiver(cleanKey, cleanValue);
        };
        let textReader;
        switch(this.mode){
            case 'everyLine':
                const pairReader = this._createEveryLinePairReader(localPairReceiver);
                textReader = this._createEveryLineLineReader(pairReader);
                break;
            case 'lineByLine':
                textReader = this._createLineByLineLineReader(localPairReceiver);
                break;
        }
        textReader(textContent);
    }
}
const $5c068f572b6fdaf9$var$GUEST_MODAL = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
    <p class="text-center">{{>~l18n.get(messageCode)}}</p>
    <p class="text-center"><span style="margin-right: 1em;">{{>~l18n.get(buttonCode)}}</span><a href="/login" class="btn btn-primary">{{>~l18n.get('packPage.dialogs.login')}}</a></p>
`);
class $5c068f572b6fdaf9$var$PageEdit {
    constructor(props){
        if (!props.authenticated) setTimeout(()=>{
            this.showLoginDialog();
        }, 1500);
        this.l18n = (0, $6YELt.default).create(props.l18n);
        this.importText = new $5c068f572b6fdaf9$var$TextImport();
        this.importTextParsed = [];
        this.importTextPanel = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextPanel');
        this.importTextSubmit = this.importTextPanel.find('button[data-click-handler=applyTextImport]');
        this.importTextSubmit.click(this.applyTextImport.bind(this));
        this.form = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#form');
        this.formMain = this.form.find('.fl-form-main');
        this.formMainFixed = this.form.find('.fl-form-main-fixed');
        this.formMainFixedEnabled = false;
        this._configureLanguages();
        const windowScrollCheck = ()=>{
            const position = this.formMain.get(0).getBoundingClientRect();
            this._toggleMainFix(position.bottom <= 0, position);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(window).scroll(windowScrollCheck);
        windowScrollCheck();
        //>> initialize card list
        const initialCardList = props.cardList;
        const initialCardErrors = props.cardErrors || [];
        initialCardErrors.forEach((v)=>{
            initialCardList[v.index].faceError = v.face;
            initialCardList[v.index].backError = v.back;
        });
        this.listEditor = new $5c068f572b6fdaf9$var$ListEditor(this.l18n);
        this.listEditor.list.empty();
        this.listEditor.appendRowList(initialCardList);
        this.listEditor.onCardChange = (newCount)=>{
            var noticeSplit = newCount > 20;
            this.form.find('*[data-condition=packSplitter]').toggle(noticeSplit);
            if (!noticeSplit) this.form.find('input[name=split]').prop('checked', false);
        };
        this.listEditor.countCards();
        //<< initialize card list
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#moreRows').click(()=>{
            this.listEditor.appendEmpty();
            return false;
        });
        this.form.find('button[data-click=newCollection]').click(()=>{
            new (0, $6WhLd.default)({
                l18n: this.l18n,
                onComplete: (dialog)=>{
                    if (dialog.result !== null) {
                        const option = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('<option></option>');
                        option.attr('value', dialog.result.groupId);
                        option.text(dialog.result.groupName);
                        this.form.find('select[name=putToCollection]').append(option).val(dialog.result.groupId);
                    }
                }
            }).execute();
        });
        this.form.find('[data-click=selectPackThumb]').click(()=>{
            new $5c068f572b6fdaf9$var$SelectImageDialog({
                l18n: this.l18n,
                canDelete: this._hasThumbImage(),
                remove: ()=>{
                    this._clearThumbImage();
                },
                complete: (imageSrc, imageInput, imageString)=>{
                    this._setThumbImage(imageString, imageSrc, imageInput);
                }
            });
        });
        // scroll to first error
        const firstError = this.form.find('.is-invalid');
        if (firstError.length) {
            (0, $3zknA.scrollIntoView)(firstError.get(0));
            const jqWindow = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(window);
            jqWindow.scrollTop(jqWindow.scrollTop() - 100);
        }
        this.form.find('button[data-handler=submit]').prop('disabled', false);
    }
    _hasThumbImage() {
        const place = this.form.find('[data-bind=packThumb]');
        return place.children().length > 0;
    }
    _clearThumbImage() {
        const place = this.form.find('[data-bind=packThumb]');
        place.empty();
        place.parent().addClass('fl-form-main__thumb--empty');
    }
    /**
     * @param {String} imageString это локальный URI (local:-1_asdasd.png или подобное). Будет хранится в базе
     * @param {String} imageSrc это полноценный src для image
     * @param [imageInput] это input[type=file], откуда к нам попал файлик.
     * @private
     */ _setThumbImage(imageString, imageSrc, imageInput) {
        this._clearThumbImage();
        const place = this.form.find('[data-bind=packThumb]');
        // result.fileInput
        place.empty().append($5c068f572b6fdaf9$var$SelectImageDialog_PackImage.render({
            src: imageSrc
        }));
        if (imageInput) {
            imageInput = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(imageInput);
            imageInput.attr('name', `thumbF`);
            place.append(imageInput.remove());
            imageString = 'local';
        }
        if (imageString) place.append((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(`<input type="hidden" name="thumb" value="${imageString}">`));
        place.parent().removeClass('fl-form-main__thumb--empty');
    }
    _toggleMainFix(enabled, bounds) {
        if (this.formMainFixedEnabled === enabled) return;
        if (enabled) this.formMainFixed.css({
            left: bounds.left,
            width: bounds.width
        }).show();
        else this.formMainFixed.hide();
        this.formMainFixedEnabled = enabled;
    }
    _configureLanguages() {
        const locale = /(.+)-(.+)/.exec(navigator['language'] || navigator['userLanguage']);
        const userLanguage = locale && locale[1] ? locale[1] : null;
        function initSelect(select) {
            select.find('option[value=en]').remove().prependTo(select);
            if (userLanguage) select.find(`option[value=${userLanguage}]`).remove().prependTo(select);
            select.removeClass('custom-select').selectpicker("refresh");
        }
        initSelect(this.form.find('select[name=faceLocale]'));
        initSelect(this.form.find('select[name=backLocale]'));
    }
    applyTextImport() {
        if (this.importTextParsed.length > 0) {
            this.listEditor.removeEmptyTail();
            this.importTextParsed.forEach((item)=>{
                this.listEditor.appendRow({
                    face: item[0],
                    back: item[1]
                });
            });
            this.listEditor.appendEmpty();
            this.listEditor.countCards();
        }
        this.hideTextImport();
    }
    hideTextImport() {
        this.importTextPanel.hide();
        this.importTextPanel.find('input[data-import-option]').off('change');
        this.importTextPanel.find('textarea').off('textchange');
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextPreview').hide();
        this.form.show();
        return false;
    }
    showTextImport() {
        const importTextPanel = this.importTextPanel;
        importTextPanel.show();
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextContent').val('');
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextPreview').find('ul').empty().end().show();
        let previewImportRequest = 1;
        const previewImport = ()=>{
            const importText = this.importText;
            this.importTextSubmit.addClass('btn-in-progress').prop('disabled', true);
            let previewImportRequestCurrent = ++previewImportRequest;
            setTimeout(()=>{
                if (previewImportRequestCurrent !== previewImportRequest) return;
                importTextPanel.find('input[data-import-option]').each(function() {
                    const input = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this), option = input.data('import-option');
                    switch(this.type){
                        case 'checkbox':
                            importText[option] = input.is(':checked');
                            break;
                        case 'radio':
                            if (input.is(':checked')) importText[option] = input.val();
                            break;
                        default:
                            importText[option] = input.val();
                            break;
                    }
                });
                let text = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextContent').val();
                this.importTextParsed = [];
                importText.parse(text, (k, v)=>{
                    this.importTextParsed.push([
                        k,
                        v
                    ]);
                });
                let html = '';
                this.importTextParsed.forEach((item)=>{
                    html += `<li class="fl-form-cards__card panel mt-2">
<div class="fl-form-cards__faces row">
            <div class="col-md-6 fl-form-cards__face-side">
                    <div class="fl-form-cards__side-input">
                        <div>${(0, $d90a0f0c20124a5e$export$4cf11838cdc2a8a8)(item[0])}</div>
                    </div>
            </div>
            <div class="col-md-6 fl-form-cards__back-side">
                    <div class="fl-form-cards__side-input">
                        <div>${(0, $d90a0f0c20124a5e$export$4cf11838cdc2a8a8)(item[1])}</div>
                    </div>
            </div>
</div>
</li>`;
                });
                if (this.importTextParsed.length === 0 && text.length > 0) html = `<li class="text-center alert alert-info mt-3 mb-0">${this.l18n.get('packEditor.importer.preview.empty')}</li>`;
                this.importTextSubmit.removeClass('btn-in-progress').prop('disabled', this.importTextParsed.length <= 0);
                (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#importTextPreview').find('ul').html(html).end().show();
            }, 200);
        };
        importTextPanel.find('input[data-import-option]').on('change textchange', previewImport);
        importTextPanel.find('input[type=radio][data-import-option=mode]').change(function() {
            importTextPanel.removeClass('ldMode-everyLine ldMode-lineByLine').addClass('ldMode-' + (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this).val());
        });
        importTextPanel.find('textarea').on('textchange', previewImport);
        previewImport();
        this.form.hide();
        return false;
    }
    showAnkiImport() {
        const self = this;
        const template = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).templates(`
<div data-section="browse" style="display: none;">
    <p class="text-center">{{>~l18n.get('packEditor.anki.dialog.message')}}</p>
    <p class="text-center"><button class="btn btn-primary" data-handler="load">{{>~l18n.get('packEditor.anki.dialog.button')}}</button></p>
    <p class="text-left mb-0" style="font-size: .6rem; opacity: .7">{{>~l18n.get('packEditor.anki.dialog.notice1')}}</p>
    <p class="text-left mb-0" style="font-size: .6rem; opacity: .7">{{>~l18n.get('packEditor.anki.dialog.notice2')}}</p>
    <input style="display: none;" type="file" name="ankiFile"/>
</div>
<div data-section="progress" style="display: none;">
    <p class="text-center" data-bind="message"></p>
    <div style="width:100%;height: .3rem;border-radius: .1rem;background: #e6e6e6;">
        <div style="height:100%;background: #add1ec;border-radius: .1rem; width: 0;" data-bind="percent"></div>
    </div>
</div>
<div data-section="error" style="display: none;">
    <p class="alert alert-info text-center mb-0" data-bind="error">{{>~l18n.get('packEditor.anki.progress.error')}}</p>
</div>
<div data-section="success" style="display: none;">
    <p class="alert alert-info text-center mb-0" data-bind="error">{{:~l18n.get('packEditor.anki.progress.success')}}</p>
</div>
`);
        (0, $j7etR.default).showLocal(template.render({}, this), (modaller)=>{
            const dialog = modaller.content;
            const showSection = function(name) {
                dialog.find('div[data-section]').hide();
                dialog.find(`div[data-section=${name}]`).show();
            };
            showSection('browse');
            let alive = true;
            let upload = null;
            modaller.setTitle(this.l18n.get('packEditor.anki.dialog.title'));
            modaller.addHideListener(()=>{
                alive = false;
                if (upload != null) {
                    upload.cancel();
                    upload = null;
                }
            });
            const fileInput = dialog.find('input[name=ankiFile]');
            dialog.find('button[data-handler=load]').click(()=>{
                fileInput.click();
            });
            const showCloseButton = ()=>{
                modaller.addFooterButton(this.l18n.get('button.close'), 'btn btn-light', ()=>{
                    modaller.close();
                });
            };
            const progressText = (messageCode)=>{
                dialog.find('p[data-bind=message]').text(this.l18n.get(messageCode));
                dialog.find('div[data-bind=percent]').css('width', '100%');
            };
            const progressLoader = (loaded, total)=>{
                const percent = total > 0 ? 100 * loaded / total : 50;
                dialog.find('div[data-bind=percent]').css('width', percent + '%');
                if (total > 0 && loaded === total) progressText('packEditor.anki.progress.parsing');
            };
            const finishSuccess = ()=>{
                showSection('success');
                showCloseButton();
            };
            const finishError = ()=>{
                showSection('error');
                showCloseButton();
            };
            fileInput.on("change", function() {
                const file = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this)[0].files[0];
                showSection('progress');
                progressText('packEditor.anki.progress.sending');
                upload = new (0, $daa5e4a06b00f78d$export$2e2bcd8739ae039)(file);
                upload.progressListener = progressLoader;
                upload.doUpload(`${Flashcards.root}/new-pack/import-anki`).then((res)=>{
                    progressText('packEditor.anki.progress.forming');
                    if (!alive) return;
                    if (res.status !== 'ok') {
                        finishError();
                        return;
                    }
                    self.listEditor.clear();
                    res.data.cards.forEach((v)=>{
                        self.listEditor.appendRow(v);
                    });
                    self.listEditor.appendEmpty();
                    function updateTextValue(jqInput, value) {
                        const current = jqInput.val();
                        if (current.length || value === undefined || value == null || value === "") return;
                        jqInput.val(value);
                    }
                    function updateSelectValue(jqSelect, value) {
                        const current = jqSelect.val();
                        const next = jqSelect.find(`option[value=${value}]`);
                        if (current || next.length === 0) return;
                        jqSelect.val(value).selectpicker('refresh');
                    }
                    updateTextValue(self.form.find('input[name=title]'), res.data.title);
                    updateTextValue(self.form.find('textarea[name=description]'), res.data.description);
                    updateSelectValue(self.form.find('select[name=faceLocale]'), res.data.faceLocale);
                    updateSelectValue(self.form.find('select[name=backLocale]'), res.data.backLocale);
                    if (!self._hasThumbImage() && res.data.thumb && res.data.thumbSrc) self._setThumbImage(res.data.thumb, res.data.thumbSrc);
                    finishSuccess();
                }, ()=>finishError);
            });
        });
    }
    checkSubmit() {
        const cardCount = this.listEditor.countCards();
        const enoughCards = cardCount >= 2;
        const enoughCardsAlert = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#cardListError');
        // show "not enough cards" alert
        enoughCardsAlert.toggle(!enoughCards);
        this.listEditor.list.toggleClass('fl-form-cards--danger', !enoughCards);
        // scroll to error alert
        if (!enoughCards) (0, $3zknA.scrollIntoView)(this.form);
        return enoughCards;
    }
    submit() {
        if (!this.checkSubmit()) return false;
        this.form.find('button[data-handler=submit]').prop('disabled', true);
        this.form.submit();
        return true;
    }
    showLoginDialog() {
        const html = $5c068f572b6fdaf9$var$GUEST_MODAL.render({
            messageCode: 'packPage.dialogs.forbidden.createNew.text',
            buttonCode: ''
        }, this);
        (0, $j7etR.default).showLocal(html, (modaller)=>{
            modaller.setTitle(this.l18n.get('packPage.dialogs.forbidden.createNew.title'));
            modaller.disableHide();
        });
    }
}
$parcel$global.PageEdit = $5c068f572b6fdaf9$var$PageEdit;

})();
//# sourceMappingURL=PackEdit.js.map
